function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire722c"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire722c"] = parcelRequire;
}
parcelRequire.register("ih19M", function(module, exports) {
"use strict";

module.exports = (parcelRequire("0qhf8"));

});
parcelRequire.register("0qhf8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $0014624a040e5105$export$ffb0004e005737fa; }, function (v) { return $0014624a040e5105$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $0014624a040e5105$export$34b9dba7ce09269b; }, function (v) { return $0014624a040e5105$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $0014624a040e5105$export$25062201e9e25d76; }, function (v) { return $0014624a040e5105$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0014624a040e5105$export$ffb0004e005737fa;
var $0014624a040e5105$export$34b9dba7ce09269b;
var $0014624a040e5105$export$25062201e9e25d76;
"use strict";

var $bh6RR = parcelRequire("bh6RR");
var $0014624a040e5105$var$k = Symbol.for("react.element"), $0014624a040e5105$var$l = Symbol.for("react.fragment"), $0014624a040e5105$var$m = Object.prototype.hasOwnProperty, $0014624a040e5105$var$n = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0014624a040e5105$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0014624a040e5105$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0014624a040e5105$var$m.call(a, b) && !$0014624a040e5105$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0014624a040e5105$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0014624a040e5105$var$n.current
    };
}
$0014624a040e5105$export$ffb0004e005737fa = $0014624a040e5105$var$l;
$0014624a040e5105$export$34b9dba7ce09269b = $0014624a040e5105$var$q;
$0014624a040e5105$export$25062201e9e25d76 = $0014624a040e5105$var$q;

});
parcelRequire.register("bh6RR", function(module, exports) {
"use strict";

module.exports = (parcelRequire("cCfq4"));

});
parcelRequire.register("cCfq4", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $92f4fea5bc247620$export$dca3b0875bd9a954; }, function (v) { return $92f4fea5bc247620$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $92f4fea5bc247620$export$16fa2f45be04daa8; }, function (v) { return $92f4fea5bc247620$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $92f4fea5bc247620$export$ffb0004e005737fa; }, function (v) { return $92f4fea5bc247620$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $92f4fea5bc247620$export$e2c29f18771995cb; }, function (v) { return $92f4fea5bc247620$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $92f4fea5bc247620$export$221d75b3f55bb0bd; }, function (v) { return $92f4fea5bc247620$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $92f4fea5bc247620$export$5f8d39834fd61797; }, function (v) { return $92f4fea5bc247620$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $92f4fea5bc247620$export$74bf444e3cd11ea5; }, function (v) { return $92f4fea5bc247620$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $92f4fea5bc247620$export$ae55be85d98224ed; }, function (v) { return $92f4fea5bc247620$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $92f4fea5bc247620$export$e530037191fcd5d7; }, function (v) { return $92f4fea5bc247620$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $92f4fea5bc247620$export$fd42f52fd3ae1109; }, function (v) { return $92f4fea5bc247620$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $92f4fea5bc247620$export$c8a8987d4410bf2d; }, function (v) { return $92f4fea5bc247620$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $92f4fea5bc247620$export$d38cd72104c1f0e9; }, function (v) { return $92f4fea5bc247620$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $92f4fea5bc247620$export$7d1e3a5e95ceca43; }, function (v) { return $92f4fea5bc247620$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $92f4fea5bc247620$export$257a8862b851cb5b; }, function (v) { return $92f4fea5bc247620$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $92f4fea5bc247620$export$a8257692ac88316c; }, function (v) { return $92f4fea5bc247620$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $92f4fea5bc247620$export$488013bae63b21da; }, function (v) { return $92f4fea5bc247620$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $92f4fea5bc247620$export$7c73462e0d25e514; }, function (v) { return $92f4fea5bc247620$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $92f4fea5bc247620$export$7568632d0d33d16d; }, function (v) { return $92f4fea5bc247620$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $92f4fea5bc247620$export$88948ce120ea2619; }, function (v) { return $92f4fea5bc247620$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $92f4fea5bc247620$export$35808ee640e87ca7; }, function (v) { return $92f4fea5bc247620$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $92f4fea5bc247620$export$fae74005e78b1a27; }, function (v) { return $92f4fea5bc247620$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e; }, function (v) { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $92f4fea5bc247620$export$6a7bc4e911dc01cf; }, function (v) { return $92f4fea5bc247620$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $92f4fea5bc247620$export$6d9c69b0de29b591; }, function (v) { return $92f4fea5bc247620$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $92f4fea5bc247620$export$f680877a34711e37; }, function (v) { return $92f4fea5bc247620$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $92f4fea5bc247620$export$d5a552a76deda3c2; }, function (v) { return $92f4fea5bc247620$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $92f4fea5bc247620$export$aaabe4eda9ed9969; }, function (v) { return $92f4fea5bc247620$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $92f4fea5bc247620$export$e5c5a5f917a5871c; }, function (v) { return $92f4fea5bc247620$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $92f4fea5bc247620$export$1538c33de8887b59; }, function (v) { return $92f4fea5bc247620$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $92f4fea5bc247620$export$13e3392192263954; }, function (v) { return $92f4fea5bc247620$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $92f4fea5bc247620$export$b8f5890fc79d6aca; }, function (v) { return $92f4fea5bc247620$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $92f4fea5bc247620$export$60241385465d0a34; }, function (v) { return $92f4fea5bc247620$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $92f4fea5bc247620$export$306c0aa65ff9ec16; }, function (v) { return $92f4fea5bc247620$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $92f4fea5bc247620$export$7b286972b8d8ccbf; }, function (v) { return $92f4fea5bc247620$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $92f4fea5bc247620$export$83d89fbfd8236492; }, function (v) { return $92f4fea5bc247620$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $92f4fea5bc247620$export$dca3b0875bd9a954;
var $92f4fea5bc247620$export$16fa2f45be04daa8;
var $92f4fea5bc247620$export$ffb0004e005737fa;
var $92f4fea5bc247620$export$e2c29f18771995cb;
var $92f4fea5bc247620$export$221d75b3f55bb0bd;
var $92f4fea5bc247620$export$5f8d39834fd61797;
var $92f4fea5bc247620$export$74bf444e3cd11ea5;
var $92f4fea5bc247620$export$ae55be85d98224ed;
var $92f4fea5bc247620$export$e530037191fcd5d7;
var $92f4fea5bc247620$export$fd42f52fd3ae1109;
var $92f4fea5bc247620$export$c8a8987d4410bf2d;
var $92f4fea5bc247620$export$d38cd72104c1f0e9;
var $92f4fea5bc247620$export$7d1e3a5e95ceca43;
var $92f4fea5bc247620$export$257a8862b851cb5b;
var $92f4fea5bc247620$export$a8257692ac88316c;
var $92f4fea5bc247620$export$488013bae63b21da;
var $92f4fea5bc247620$export$7c73462e0d25e514;
var $92f4fea5bc247620$export$7568632d0d33d16d;
var $92f4fea5bc247620$export$88948ce120ea2619;
var $92f4fea5bc247620$export$35808ee640e87ca7;
var $92f4fea5bc247620$export$fae74005e78b1a27;
var $92f4fea5bc247620$export$dc8fbce3eb94dc1e;
var $92f4fea5bc247620$export$6a7bc4e911dc01cf;
var $92f4fea5bc247620$export$6d9c69b0de29b591;
var $92f4fea5bc247620$export$f680877a34711e37;
var $92f4fea5bc247620$export$d5a552a76deda3c2;
var $92f4fea5bc247620$export$aaabe4eda9ed9969;
var $92f4fea5bc247620$export$e5c5a5f917a5871c;
var $92f4fea5bc247620$export$1538c33de8887b59;
var $92f4fea5bc247620$export$13e3392192263954;
var $92f4fea5bc247620$export$b8f5890fc79d6aca;
var $92f4fea5bc247620$export$60241385465d0a34;
var $92f4fea5bc247620$export$306c0aa65ff9ec16;
var $92f4fea5bc247620$export$7b286972b8d8ccbf;
var $92f4fea5bc247620$export$83d89fbfd8236492;
"use strict";
var $92f4fea5bc247620$var$l = Symbol.for("react.element"), $92f4fea5bc247620$var$n = Symbol.for("react.portal"), $92f4fea5bc247620$var$p = Symbol.for("react.fragment"), $92f4fea5bc247620$var$q = Symbol.for("react.strict_mode"), $92f4fea5bc247620$var$r = Symbol.for("react.profiler"), $92f4fea5bc247620$var$t = Symbol.for("react.provider"), $92f4fea5bc247620$var$u = Symbol.for("react.context"), $92f4fea5bc247620$var$v = Symbol.for("react.forward_ref"), $92f4fea5bc247620$var$w = Symbol.for("react.suspense"), $92f4fea5bc247620$var$x = Symbol.for("react.memo"), $92f4fea5bc247620$var$y = Symbol.for("react.lazy"), $92f4fea5bc247620$var$z = Symbol.iterator;
function $92f4fea5bc247620$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $92f4fea5bc247620$var$z && a[$92f4fea5bc247620$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $92f4fea5bc247620$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $92f4fea5bc247620$var$C = Object.assign, $92f4fea5bc247620$var$D = {};
function $92f4fea5bc247620$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
$92f4fea5bc247620$var$E.prototype.isReactComponent = {};
$92f4fea5bc247620$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$92f4fea5bc247620$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $92f4fea5bc247620$var$F() {}
$92f4fea5bc247620$var$F.prototype = $92f4fea5bc247620$var$E.prototype;
function $92f4fea5bc247620$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
var $92f4fea5bc247620$var$H = $92f4fea5bc247620$var$G.prototype = new $92f4fea5bc247620$var$F;
$92f4fea5bc247620$var$H.constructor = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$var$C($92f4fea5bc247620$var$H, $92f4fea5bc247620$var$E.prototype);
$92f4fea5bc247620$var$H.isPureReactComponent = !0;
var $92f4fea5bc247620$var$I = Array.isArray, $92f4fea5bc247620$var$J = Object.prototype.hasOwnProperty, $92f4fea5bc247620$var$K = {
    current: null
}, $92f4fea5bc247620$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $92f4fea5bc247620$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$92f4fea5bc247620$var$J.call(b, d) && !$92f4fea5bc247620$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $92f4fea5bc247620$var$K.current
    };
}
function $92f4fea5bc247620$var$N(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $92f4fea5bc247620$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $92f4fea5bc247620$var$l;
}
function $92f4fea5bc247620$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $92f4fea5bc247620$var$P = /\/+/g;
function $92f4fea5bc247620$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $92f4fea5bc247620$var$escape("" + a.key) : b.toString(36);
}
function $92f4fea5bc247620$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $92f4fea5bc247620$var$l:
                case $92f4fea5bc247620$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $92f4fea5bc247620$var$Q(h, 0) : d, $92f4fea5bc247620$var$I(c) ? (e = "", null != a && (e = a.replace($92f4fea5bc247620$var$P, "$&/") + "/"), $92f4fea5bc247620$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($92f4fea5bc247620$var$O(c) && (c = $92f4fea5bc247620$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($92f4fea5bc247620$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($92f4fea5bc247620$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $92f4fea5bc247620$var$Q(k, g);
        h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    }
    else if (f = $92f4fea5bc247620$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $92f4fea5bc247620$var$Q(k, g++), h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $92f4fea5bc247620$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $92f4fea5bc247620$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $92f4fea5bc247620$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $92f4fea5bc247620$var$U = {
    current: null
}, $92f4fea5bc247620$var$V = {
    transition: null
}, $92f4fea5bc247620$var$W = {
    ReactCurrentDispatcher: $92f4fea5bc247620$var$U,
    ReactCurrentBatchConfig: $92f4fea5bc247620$var$V,
    ReactCurrentOwner: $92f4fea5bc247620$var$K
};
$92f4fea5bc247620$export$dca3b0875bd9a954 = {
    map: $92f4fea5bc247620$var$S,
    forEach: function(a, b, e) {
        $92f4fea5bc247620$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $92f4fea5bc247620$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $92f4fea5bc247620$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$92f4fea5bc247620$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$92f4fea5bc247620$export$16fa2f45be04daa8 = $92f4fea5bc247620$var$E;
$92f4fea5bc247620$export$ffb0004e005737fa = $92f4fea5bc247620$var$p;
$92f4fea5bc247620$export$e2c29f18771995cb = $92f4fea5bc247620$var$r;
$92f4fea5bc247620$export$221d75b3f55bb0bd = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$export$5f8d39834fd61797 = $92f4fea5bc247620$var$q;
$92f4fea5bc247620$export$74bf444e3cd11ea5 = $92f4fea5bc247620$var$w;
$92f4fea5bc247620$export$ae55be85d98224ed = $92f4fea5bc247620$var$W;
$92f4fea5bc247620$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $92f4fea5bc247620$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $92f4fea5bc247620$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$92f4fea5bc247620$var$J.call(b, f) && !$92f4fea5bc247620$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$92f4fea5bc247620$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $92f4fea5bc247620$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $92f4fea5bc247620$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$92f4fea5bc247620$export$c8a8987d4410bf2d = $92f4fea5bc247620$var$M;
$92f4fea5bc247620$export$d38cd72104c1f0e9 = function(a) {
    var b = $92f4fea5bc247620$var$M.bind(null, a);
    b.type = a;
    return b;
};
$92f4fea5bc247620$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$92f4fea5bc247620$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$v,
        render: a
    };
};
$92f4fea5bc247620$export$a8257692ac88316c = $92f4fea5bc247620$var$O;
$92f4fea5bc247620$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $92f4fea5bc247620$var$T
    };
};
$92f4fea5bc247620$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$92f4fea5bc247620$export$7568632d0d33d16d = function(a) {
    var b = $92f4fea5bc247620$var$V.transition;
    $92f4fea5bc247620$var$V.transition = {};
    try {
        a();
    } finally{
        $92f4fea5bc247620$var$V.transition = b;
    }
};
$92f4fea5bc247620$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$92f4fea5bc247620$export$35808ee640e87ca7 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useCallback(a, b);
};
$92f4fea5bc247620$export$fae74005e78b1a27 = function(a) {
    return $92f4fea5bc247620$var$U.current.useContext(a);
};
$92f4fea5bc247620$export$dc8fbce3eb94dc1e = function() {};
$92f4fea5bc247620$export$6a7bc4e911dc01cf = function(a) {
    return $92f4fea5bc247620$var$U.current.useDeferredValue(a);
};
$92f4fea5bc247620$export$6d9c69b0de29b591 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useEffect(a, b);
};
$92f4fea5bc247620$export$f680877a34711e37 = function() {
    return $92f4fea5bc247620$var$U.current.useId();
};
$92f4fea5bc247620$export$d5a552a76deda3c2 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useImperativeHandle(a, b, e);
};
$92f4fea5bc247620$export$aaabe4eda9ed9969 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useInsertionEffect(a, b);
};
$92f4fea5bc247620$export$e5c5a5f917a5871c = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useLayoutEffect(a, b);
};
$92f4fea5bc247620$export$1538c33de8887b59 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useMemo(a, b);
};
$92f4fea5bc247620$export$13e3392192263954 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useReducer(a, b, e);
};
$92f4fea5bc247620$export$b8f5890fc79d6aca = function(a) {
    return $92f4fea5bc247620$var$U.current.useRef(a);
};
$92f4fea5bc247620$export$60241385465d0a34 = function(a) {
    return $92f4fea5bc247620$var$U.current.useState(a);
};
$92f4fea5bc247620$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useSyncExternalStore(a, b, e);
};
$92f4fea5bc247620$export$7b286972b8d8ccbf = function() {
    return $92f4fea5bc247620$var$U.current.useTransition();
};
$92f4fea5bc247620$export$83d89fbfd8236492 = "18.2.0";

});




parcelRequire.register("foRq4", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b36288e2db101ba3$export$ae55be85d98224ed; }, function (v) { return $b36288e2db101ba3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $b36288e2db101ba3$export$d39a5bbd09211389; }, function (v) { return $b36288e2db101ba3$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $b36288e2db101ba3$export$882461b6382ed46c; }, function (v) { return $b36288e2db101ba3$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $b36288e2db101ba3$export$466bfc07425424d5; }, function (v) { return $b36288e2db101ba3$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b36288e2db101ba3$export$cd75ccfd720a3cd4; }, function (v) { return $b36288e2db101ba3$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $b36288e2db101ba3$export$fa8d919ba61d84db; }, function (v) { return $b36288e2db101ba3$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b36288e2db101ba3$export$757ceba2d55c277e; }, function (v) { return $b36288e2db101ba3$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $b36288e2db101ba3$export$b3890eb0ae9dca99; }, function (v) { return $b36288e2db101ba3$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $b36288e2db101ba3$export$502457920280e6be; }, function (v) { return $b36288e2db101ba3$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b36288e2db101ba3$export$c78a37762a8d58e1; }, function (v) { return $b36288e2db101ba3$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $b36288e2db101ba3$export$dc54d992c10e8a18; }, function (v) { return $b36288e2db101ba3$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $b36288e2db101ba3$export$83d89fbfd8236492; }, function (v) { return $b36288e2db101ba3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b36288e2db101ba3$export$ae55be85d98224ed;
var $b36288e2db101ba3$export$d39a5bbd09211389;
var $b36288e2db101ba3$export$882461b6382ed46c;
var $b36288e2db101ba3$export$466bfc07425424d5;
var $b36288e2db101ba3$export$cd75ccfd720a3cd4;
var $b36288e2db101ba3$export$fa8d919ba61d84db;
var $b36288e2db101ba3$export$757ceba2d55c277e;
var $b36288e2db101ba3$export$b3890eb0ae9dca99;
var $b36288e2db101ba3$export$502457920280e6be;
var $b36288e2db101ba3$export$c78a37762a8d58e1;
var $b36288e2db101ba3$export$dc54d992c10e8a18;
var $b36288e2db101ba3$export$83d89fbfd8236492;
"use strict";

var $bh6RR = parcelRequire("bh6RR");

var $4LCdk = parcelRequire("4LCdk");
function $b36288e2db101ba3$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b36288e2db101ba3$var$da = new Set, $b36288e2db101ba3$var$ea = {};
function $b36288e2db101ba3$var$fa(a, b) {
    $b36288e2db101ba3$var$ha(a, b);
    $b36288e2db101ba3$var$ha(a + "Capture", b);
}
function $b36288e2db101ba3$var$ha(a, b) {
    $b36288e2db101ba3$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$da.add(b[a]);
}
var $b36288e2db101ba3$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b36288e2db101ba3$var$ja = Object.prototype.hasOwnProperty, $b36288e2db101ba3$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b36288e2db101ba3$var$la = {}, $b36288e2db101ba3$var$ma = {};
function $b36288e2db101ba3$var$oa(a) {
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$ma, a)) return !0;
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$la, a)) return !1;
    if ($b36288e2db101ba3$var$ka.test(a)) return $b36288e2db101ba3$var$ma[a] = !0;
    $b36288e2db101ba3$var$la[a] = !0;
    return !1;
}
function $b36288e2db101ba3$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b36288e2db101ba3$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b36288e2db101ba3$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b36288e2db101ba3$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b36288e2db101ba3$var$ra = /[\-:]([a-z])/g;
function $b36288e2db101ba3$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b36288e2db101ba3$var$z.xlinkHref = new $b36288e2db101ba3$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b36288e2db101ba3$var$ta(a, b, c, d) {
    var e = $b36288e2db101ba3$var$z.hasOwnProperty(b) ? $b36288e2db101ba3$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $b36288e2db101ba3$var$qa(b, c, e, d) && (c = null), d || null === e ? $b36288e2db101ba3$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $b36288e2db101ba3$var$ua = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b36288e2db101ba3$var$va = Symbol.for("react.element"), $b36288e2db101ba3$var$wa = Symbol.for("react.portal"), $b36288e2db101ba3$var$ya = Symbol.for("react.fragment"), $b36288e2db101ba3$var$za = Symbol.for("react.strict_mode"), $b36288e2db101ba3$var$Aa = Symbol.for("react.profiler"), $b36288e2db101ba3$var$Ba = Symbol.for("react.provider"), $b36288e2db101ba3$var$Ca = Symbol.for("react.context"), $b36288e2db101ba3$var$Da = Symbol.for("react.forward_ref"), $b36288e2db101ba3$var$Ea = Symbol.for("react.suspense"), $b36288e2db101ba3$var$Fa = Symbol.for("react.suspense_list"), $b36288e2db101ba3$var$Ga = Symbol.for("react.memo"), $b36288e2db101ba3$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b36288e2db101ba3$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $b36288e2db101ba3$var$Ja = Symbol.iterator;
function $b36288e2db101ba3$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b36288e2db101ba3$var$Ja && a[$b36288e2db101ba3$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b36288e2db101ba3$var$A = Object.assign, $b36288e2db101ba3$var$La;
function $b36288e2db101ba3$var$Ma(a) {
    if (void 0 === $b36288e2db101ba3$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b36288e2db101ba3$var$La = b && b[1] || "";
    }
    return "\n" + $b36288e2db101ba3$var$La + a;
}
var $b36288e2db101ba3$var$Na = !1;
function $b36288e2db101ba3$var$Oa(a, b) {
    if (!a || $b36288e2db101ba3$var$Na) return "";
    $b36288e2db101ba3$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b36288e2db101ba3$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b36288e2db101ba3$var$Ma(a) : "";
}
function $b36288e2db101ba3$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $b36288e2db101ba3$var$Ma(a.type);
        case 16:
            return $b36288e2db101ba3$var$Ma("Lazy");
        case 13:
            return $b36288e2db101ba3$var$Ma("Suspense");
        case 19:
            return $b36288e2db101ba3$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b36288e2db101ba3$var$Oa(a.type, !1), a;
        case 11:
            return a = $b36288e2db101ba3$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $b36288e2db101ba3$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b36288e2db101ba3$var$ya:
            return "Fragment";
        case $b36288e2db101ba3$var$wa:
            return "Portal";
        case $b36288e2db101ba3$var$Aa:
            return "Profiler";
        case $b36288e2db101ba3$var$za:
            return "StrictMode";
        case $b36288e2db101ba3$var$Ea:
            return "Suspense";
        case $b36288e2db101ba3$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b36288e2db101ba3$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $b36288e2db101ba3$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $b36288e2db101ba3$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $b36288e2db101ba3$var$Ga:
            return b = a.displayName || null, null !== b ? b : $b36288e2db101ba3$var$Qa(a.type) || "Memo";
        case $b36288e2db101ba3$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $b36288e2db101ba3$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $b36288e2db101ba3$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $b36288e2db101ba3$var$Qa(b);
        case 8:
            return b === $b36288e2db101ba3$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $b36288e2db101ba3$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b36288e2db101ba3$var$Ua(a) {
    var b = $b36288e2db101ba3$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b36288e2db101ba3$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b36288e2db101ba3$var$Ua(a));
}
function $b36288e2db101ba3$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b36288e2db101ba3$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b36288e2db101ba3$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b36288e2db101ba3$var$Ya(a, b) {
    var c = b.checked;
    return $b36288e2db101ba3$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b36288e2db101ba3$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b36288e2db101ba3$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b36288e2db101ba3$var$ab(a, b) {
    b = b.checked;
    null != b && $b36288e2db101ba3$var$ta(a, "checked", b, !1);
}
function $b36288e2db101ba3$var$bb(a, b) {
    $b36288e2db101ba3$var$ab(a, b);
    var c = $b36288e2db101ba3$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b36288e2db101ba3$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b36288e2db101ba3$var$cb(a, b.type, $b36288e2db101ba3$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b36288e2db101ba3$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b36288e2db101ba3$var$cb(a, b, c) {
    if ("number" !== b || $b36288e2db101ba3$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b36288e2db101ba3$var$eb = Array.isArray;
function $b36288e2db101ba3$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b36288e2db101ba3$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b36288e2db101ba3$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b36288e2db101ba3$var$p(91));
    return $b36288e2db101ba3$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b36288e2db101ba3$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b36288e2db101ba3$var$p(92));
            if ($b36288e2db101ba3$var$eb(c)) {
                if (1 < c.length) throw Error($b36288e2db101ba3$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b36288e2db101ba3$var$Sa(c)
    };
}
function $b36288e2db101ba3$var$ib(a, b) {
    var c = $b36288e2db101ba3$var$Sa(b.value), d = $b36288e2db101ba3$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b36288e2db101ba3$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $b36288e2db101ba3$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b36288e2db101ba3$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b36288e2db101ba3$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b36288e2db101ba3$var$mb, $b36288e2db101ba3$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $b36288e2db101ba3$var$mb = $b36288e2db101ba3$var$mb || document.createElement("div");
        $b36288e2db101ba3$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b36288e2db101ba3$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b36288e2db101ba3$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b36288e2db101ba3$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b36288e2db101ba3$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b36288e2db101ba3$var$pb).forEach(function(a) {
    $b36288e2db101ba3$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b36288e2db101ba3$var$pb[b] = $b36288e2db101ba3$var$pb[a];
    });
});
function $b36288e2db101ba3$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b36288e2db101ba3$var$pb.hasOwnProperty(a) && $b36288e2db101ba3$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $b36288e2db101ba3$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b36288e2db101ba3$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b36288e2db101ba3$var$tb = $b36288e2db101ba3$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b36288e2db101ba3$var$ub(a, b) {
    if (b) {
        if ($b36288e2db101ba3$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b36288e2db101ba3$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($b36288e2db101ba3$var$p(62));
    }
}
function $b36288e2db101ba3$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b36288e2db101ba3$var$wb = null;
function $b36288e2db101ba3$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b36288e2db101ba3$var$yb = null, $b36288e2db101ba3$var$zb = null, $b36288e2db101ba3$var$Ab = null;
function $b36288e2db101ba3$var$Bb(a) {
    if (a = $b36288e2db101ba3$var$Cb(a)) {
        if ("function" !== typeof $b36288e2db101ba3$var$yb) throw Error($b36288e2db101ba3$var$p(280));
        var b = a.stateNode;
        b && (b = $b36288e2db101ba3$var$Db(b), $b36288e2db101ba3$var$yb(a.stateNode, a.type, b));
    }
}
function $b36288e2db101ba3$var$Eb(a) {
    $b36288e2db101ba3$var$zb ? $b36288e2db101ba3$var$Ab ? $b36288e2db101ba3$var$Ab.push(a) : $b36288e2db101ba3$var$Ab = [
        a
    ] : $b36288e2db101ba3$var$zb = a;
}
function $b36288e2db101ba3$var$Fb() {
    if ($b36288e2db101ba3$var$zb) {
        var a = $b36288e2db101ba3$var$zb, b = $b36288e2db101ba3$var$Ab;
        $b36288e2db101ba3$var$Ab = $b36288e2db101ba3$var$zb = null;
        $b36288e2db101ba3$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$Bb(b[a]);
    }
}
function $b36288e2db101ba3$var$Gb(a, b) {
    return a(b);
}
function $b36288e2db101ba3$var$Hb() {}
var $b36288e2db101ba3$var$Ib = !1;
function $b36288e2db101ba3$var$Jb(a, b, c) {
    if ($b36288e2db101ba3$var$Ib) return a(b, c);
    $b36288e2db101ba3$var$Ib = !0;
    try {
        return $b36288e2db101ba3$var$Gb(a, b, c);
    } finally{
        if ($b36288e2db101ba3$var$Ib = !1, null !== $b36288e2db101ba3$var$zb || null !== $b36288e2db101ba3$var$Ab) $b36288e2db101ba3$var$Hb(), $b36288e2db101ba3$var$Fb();
    }
}
function $b36288e2db101ba3$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b36288e2db101ba3$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b36288e2db101ba3$var$p(231, b, typeof c));
    return c;
}
var $b36288e2db101ba3$var$Lb = !1;
if ($b36288e2db101ba3$var$ia) try {
    var $b36288e2db101ba3$var$Mb = {};
    Object.defineProperty($b36288e2db101ba3$var$Mb, "passive", {
        get: function() {
            $b36288e2db101ba3$var$Lb = !0;
        }
    });
    window.addEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
    window.removeEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
} catch (a) {
    $b36288e2db101ba3$var$Lb = !1;
}
function $b36288e2db101ba3$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $b36288e2db101ba3$var$Ob = !1, $b36288e2db101ba3$var$Pb = null, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, $b36288e2db101ba3$var$Sb = {
    onError: function(a) {
        $b36288e2db101ba3$var$Ob = !0;
        $b36288e2db101ba3$var$Pb = a;
    }
};
function $b36288e2db101ba3$var$Tb(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Ob = !1;
    $b36288e2db101ba3$var$Pb = null;
    $b36288e2db101ba3$var$Nb.apply($b36288e2db101ba3$var$Sb, arguments);
}
function $b36288e2db101ba3$var$Ub(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Tb.apply(this, arguments);
    if ($b36288e2db101ba3$var$Ob) {
        if ($b36288e2db101ba3$var$Ob) {
            var l = $b36288e2db101ba3$var$Pb;
            $b36288e2db101ba3$var$Ob = !1;
            $b36288e2db101ba3$var$Pb = null;
        } else throw Error($b36288e2db101ba3$var$p(198));
        $b36288e2db101ba3$var$Qb || ($b36288e2db101ba3$var$Qb = !0, $b36288e2db101ba3$var$Rb = l);
    }
}
function $b36288e2db101ba3$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b36288e2db101ba3$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b36288e2db101ba3$var$Xb(a) {
    if ($b36288e2db101ba3$var$Vb(a) !== a) throw Error($b36288e2db101ba3$var$p(188));
}
function $b36288e2db101ba3$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $b36288e2db101ba3$var$Vb(a);
        if (null === b) throw Error($b36288e2db101ba3$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b36288e2db101ba3$var$Xb(e), a;
                if (f === d) return $b36288e2db101ba3$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($b36288e2db101ba3$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b36288e2db101ba3$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($b36288e2db101ba3$var$p(190));
    }
    if (3 !== c.tag) throw Error($b36288e2db101ba3$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $b36288e2db101ba3$var$Zb(a) {
    a = $b36288e2db101ba3$var$Yb(a);
    return null !== a ? $b36288e2db101ba3$var$$b(a) : null;
}
function $b36288e2db101ba3$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b36288e2db101ba3$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$ac = $4LCdk.unstable_scheduleCallback, $b36288e2db101ba3$var$bc = $4LCdk.unstable_cancelCallback, $b36288e2db101ba3$var$cc = $4LCdk.unstable_shouldYield, $b36288e2db101ba3$var$dc = $4LCdk.unstable_requestPaint, $b36288e2db101ba3$var$B = $4LCdk.unstable_now, $b36288e2db101ba3$var$ec = $4LCdk.unstable_getCurrentPriorityLevel, $b36288e2db101ba3$var$fc = $4LCdk.unstable_ImmediatePriority, $b36288e2db101ba3$var$gc = $4LCdk.unstable_UserBlockingPriority, $b36288e2db101ba3$var$hc = $4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$ic = $4LCdk.unstable_LowPriority, $b36288e2db101ba3$var$jc = $4LCdk.unstable_IdlePriority, $b36288e2db101ba3$var$kc = null, $b36288e2db101ba3$var$lc = null;
function $b36288e2db101ba3$var$mc(a) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberRoot) try {
        $b36288e2db101ba3$var$lc.onCommitFiberRoot($b36288e2db101ba3$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $b36288e2db101ba3$var$oc = Math.clz32 ? Math.clz32 : $b36288e2db101ba3$var$nc, $b36288e2db101ba3$var$pc = Math.log, $b36288e2db101ba3$var$qc = Math.LN2;
function $b36288e2db101ba3$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($b36288e2db101ba3$var$pc(a) / $b36288e2db101ba3$var$qc | 0) | 0;
}
var $b36288e2db101ba3$var$rc = 64, $b36288e2db101ba3$var$sc = 4194304;
function $b36288e2db101ba3$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $b36288e2db101ba3$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $b36288e2db101ba3$var$tc(h) : (f &= g, 0 !== f && (d = $b36288e2db101ba3$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $b36288e2db101ba3$var$tc(g) : 0 !== f && (d = $b36288e2db101ba3$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b36288e2db101ba3$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b36288e2db101ba3$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b36288e2db101ba3$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $b36288e2db101ba3$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $b36288e2db101ba3$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $b36288e2db101ba3$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b36288e2db101ba3$var$yc() {
    var a = $b36288e2db101ba3$var$rc;
    $b36288e2db101ba3$var$rc <<= 1;
    0 === ($b36288e2db101ba3$var$rc & 4194240) && ($b36288e2db101ba3$var$rc = 64);
    return a;
}
function $b36288e2db101ba3$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b36288e2db101ba3$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $b36288e2db101ba3$var$oc(b);
    a[b] = c;
}
function $b36288e2db101ba3$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $b36288e2db101ba3$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $b36288e2db101ba3$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $b36288e2db101ba3$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $b36288e2db101ba3$var$C = 0;
function $b36288e2db101ba3$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $b36288e2db101ba3$var$Ec, $b36288e2db101ba3$var$Fc, $b36288e2db101ba3$var$Gc, $b36288e2db101ba3$var$Hc, $b36288e2db101ba3$var$Ic, $b36288e2db101ba3$var$Jc = !1, $b36288e2db101ba3$var$Kc = [], $b36288e2db101ba3$var$Lc = null, $b36288e2db101ba3$var$Mc = null, $b36288e2db101ba3$var$Nc = null, $b36288e2db101ba3$var$Oc = new Map, $b36288e2db101ba3$var$Pc = new Map, $b36288e2db101ba3$var$Qc = [], $b36288e2db101ba3$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b36288e2db101ba3$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b36288e2db101ba3$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b36288e2db101ba3$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $b36288e2db101ba3$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $b36288e2db101ba3$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b36288e2db101ba3$var$Pc.delete(b.pointerId);
    }
}
function $b36288e2db101ba3$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $b36288e2db101ba3$var$Cb(b), null !== b && $b36288e2db101ba3$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b36288e2db101ba3$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b36288e2db101ba3$var$Lc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $b36288e2db101ba3$var$Mc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $b36288e2db101ba3$var$Nc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b36288e2db101ba3$var$Oc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b36288e2db101ba3$var$Pc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b36288e2db101ba3$var$Vc(a) {
    var b = $b36288e2db101ba3$var$Wc(a.target);
    if (null !== b) {
        var c = $b36288e2db101ba3$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b36288e2db101ba3$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $b36288e2db101ba3$var$Ic(a.priority, function() {
                        $b36288e2db101ba3$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b36288e2db101ba3$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b36288e2db101ba3$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $b36288e2db101ba3$var$wb = d;
            c.target.dispatchEvent(d);
            $b36288e2db101ba3$var$wb = null;
        } else return b = $b36288e2db101ba3$var$Cb(c), null !== b && $b36288e2db101ba3$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b36288e2db101ba3$var$Zc(a, b, c) {
    $b36288e2db101ba3$var$Xc(a) && c.delete(b);
}
function $b36288e2db101ba3$var$$c() {
    $b36288e2db101ba3$var$Jc = !1;
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Lc) && ($b36288e2db101ba3$var$Lc = null);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Mc) && ($b36288e2db101ba3$var$Mc = null);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Nc) && ($b36288e2db101ba3$var$Nc = null);
    $b36288e2db101ba3$var$Oc.forEach($b36288e2db101ba3$var$Zc);
    $b36288e2db101ba3$var$Pc.forEach($b36288e2db101ba3$var$Zc);
}
function $b36288e2db101ba3$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b36288e2db101ba3$var$Jc || ($b36288e2db101ba3$var$Jc = !0, $4LCdk.unstable_scheduleCallback($4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$$c)));
}
function $b36288e2db101ba3$var$bd(a) {
    function b(b) {
        return $b36288e2db101ba3$var$ad(b, a);
    }
    if (0 < $b36288e2db101ba3$var$Kc.length) {
        $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Kc[0], a);
        for(var c = 1; c < $b36288e2db101ba3$var$Kc.length; c++){
            var d = $b36288e2db101ba3$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Lc, a);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Mc, a);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Nc, a);
    $b36288e2db101ba3$var$Oc.forEach(b);
    $b36288e2db101ba3$var$Pc.forEach(b);
    for(c = 0; c < $b36288e2db101ba3$var$Qc.length; c++)d = $b36288e2db101ba3$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b36288e2db101ba3$var$Qc.length && (c = $b36288e2db101ba3$var$Qc[0], null === c.blockedOn);)$b36288e2db101ba3$var$Vc(c), null === c.blockedOn && $b36288e2db101ba3$var$Qc.shift();
}
var $b36288e2db101ba3$var$cd = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$dd = !0;
function $b36288e2db101ba3$var$ed(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$gd(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 4, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$fd(a, b, c, d) {
    if ($b36288e2db101ba3$var$dd) {
        var e = $b36288e2db101ba3$var$Yc(a, b, c, d);
        if (null === e) $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c), $b36288e2db101ba3$var$Sc(a, d);
        else if ($b36288e2db101ba3$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($b36288e2db101ba3$var$Sc(a, d), b & 4 && -1 < $b36288e2db101ba3$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $b36288e2db101ba3$var$Cb(e);
                null !== f && $b36288e2db101ba3$var$Ec(f);
                f = $b36288e2db101ba3$var$Yc(a, b, c, d);
                null === f && $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $b36288e2db101ba3$var$hd(a, b, d, null, c);
    }
}
var $b36288e2db101ba3$var$id = null;
function $b36288e2db101ba3$var$Yc(a, b, c, d) {
    $b36288e2db101ba3$var$id = null;
    a = $b36288e2db101ba3$var$xb(d);
    a = $b36288e2db101ba3$var$Wc(a);
    if (null !== a) {
        if (b = $b36288e2db101ba3$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $b36288e2db101ba3$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $b36288e2db101ba3$var$id = a;
    return null;
}
function $b36288e2db101ba3$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($b36288e2db101ba3$var$ec()){
                case $b36288e2db101ba3$var$fc:
                    return 1;
                case $b36288e2db101ba3$var$gc:
                    return 4;
                case $b36288e2db101ba3$var$hc:
                case $b36288e2db101ba3$var$ic:
                    return 16;
                case $b36288e2db101ba3$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ld = null, $b36288e2db101ba3$var$md = null;
function $b36288e2db101ba3$var$nd() {
    if ($b36288e2db101ba3$var$md) return $b36288e2db101ba3$var$md;
    var a, b = $b36288e2db101ba3$var$ld, c = b.length, d, e = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b36288e2db101ba3$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b36288e2db101ba3$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b36288e2db101ba3$var$pd() {
    return !0;
}
function $b36288e2db101ba3$var$qd() {
    return !1;
}
function $b36288e2db101ba3$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b36288e2db101ba3$var$pd : $b36288e2db101ba3$var$qd;
        this.isPropagationStopped = $b36288e2db101ba3$var$qd;
        return this;
    }
    $b36288e2db101ba3$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $b36288e2db101ba3$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $b36288e2db101ba3$var$pd);
        },
        persist: function() {},
        isPersistent: $b36288e2db101ba3$var$pd
    });
    return b;
}
var $b36288e2db101ba3$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b36288e2db101ba3$var$td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$sd), $b36288e2db101ba3$var$ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    view: 0,
    detail: 0
}), $b36288e2db101ba3$var$vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$ud), $b36288e2db101ba3$var$wd, $b36288e2db101ba3$var$xd, $b36288e2db101ba3$var$yd, $b36288e2db101ba3$var$Ad = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b36288e2db101ba3$var$yd && ($b36288e2db101ba3$var$yd && "mousemove" === a.type ? ($b36288e2db101ba3$var$wd = a.screenX - $b36288e2db101ba3$var$yd.screenX, $b36288e2db101ba3$var$xd = a.screenY - $b36288e2db101ba3$var$yd.screenY) : $b36288e2db101ba3$var$xd = $b36288e2db101ba3$var$wd = 0, $b36288e2db101ba3$var$yd = a);
        return $b36288e2db101ba3$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $b36288e2db101ba3$var$xd;
    }
}), $b36288e2db101ba3$var$Bd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ad), $b36288e2db101ba3$var$Cd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    dataTransfer: 0
}), $b36288e2db101ba3$var$Dd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Cd), $b36288e2db101ba3$var$Ed = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    relatedTarget: 0
}), $b36288e2db101ba3$var$Fd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ed), $b36288e2db101ba3$var$Gd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Hd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Gd), $b36288e2db101ba3$var$Id = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b36288e2db101ba3$var$Jd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Id), $b36288e2db101ba3$var$Kd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    data: 0
}), $b36288e2db101ba3$var$Ld = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Kd), $b36288e2db101ba3$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b36288e2db101ba3$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b36288e2db101ba3$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b36288e2db101ba3$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b36288e2db101ba3$var$Od[a]) ? !!b[a] : !1;
}
function $b36288e2db101ba3$var$zd() {
    return $b36288e2db101ba3$var$Pd;
}
var $b36288e2db101ba3$var$Qd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $b36288e2db101ba3$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b36288e2db101ba3$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b36288e2db101ba3$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b36288e2db101ba3$var$Rd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Qd), $b36288e2db101ba3$var$Sd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b36288e2db101ba3$var$Td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Sd), $b36288e2db101ba3$var$Ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd
}), $b36288e2db101ba3$var$Vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ud), $b36288e2db101ba3$var$Wd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Xd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Wd), $b36288e2db101ba3$var$Yd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b36288e2db101ba3$var$Zd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Yd), $b36288e2db101ba3$var$$d = [
    9,
    13,
    27,
    32
], $b36288e2db101ba3$var$ae = $b36288e2db101ba3$var$ia && "CompositionEvent" in window, $b36288e2db101ba3$var$be = null;
$b36288e2db101ba3$var$ia && "documentMode" in document && ($b36288e2db101ba3$var$be = document.documentMode);
var $b36288e2db101ba3$var$ce = $b36288e2db101ba3$var$ia && "TextEvent" in window && !$b36288e2db101ba3$var$be, $b36288e2db101ba3$var$de = $b36288e2db101ba3$var$ia && (!$b36288e2db101ba3$var$ae || $b36288e2db101ba3$var$be && 8 < $b36288e2db101ba3$var$be && 11 >= $b36288e2db101ba3$var$be), $b36288e2db101ba3$var$ee = String.fromCharCode(32), $b36288e2db101ba3$var$fe = !1;
function $b36288e2db101ba3$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b36288e2db101ba3$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b36288e2db101ba3$var$ie = !1;
function $b36288e2db101ba3$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $b36288e2db101ba3$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b36288e2db101ba3$var$fe = !0;
            return $b36288e2db101ba3$var$ee;
        case "textInput":
            return a = b.data, a === $b36288e2db101ba3$var$ee && $b36288e2db101ba3$var$fe ? null : a;
        default:
            return null;
    }
}
function $b36288e2db101ba3$var$ke(a, b) {
    if ($b36288e2db101ba3$var$ie) return "compositionend" === a || !$b36288e2db101ba3$var$ae && $b36288e2db101ba3$var$ge(a, b) ? (a = $b36288e2db101ba3$var$nd(), $b36288e2db101ba3$var$md = $b36288e2db101ba3$var$ld = $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b36288e2db101ba3$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b36288e2db101ba3$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b36288e2db101ba3$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $b36288e2db101ba3$var$ne(a, b, c, d) {
    $b36288e2db101ba3$var$Eb(d);
    b = $b36288e2db101ba3$var$oe(b, "onChange");
    0 < b.length && (c = new $b36288e2db101ba3$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b36288e2db101ba3$var$pe = null, $b36288e2db101ba3$var$qe = null;
function $b36288e2db101ba3$var$re(a) {
    $b36288e2db101ba3$var$se(a, 0);
}
function $b36288e2db101ba3$var$te(a) {
    var b = $b36288e2db101ba3$var$ue(a);
    if ($b36288e2db101ba3$var$Wa(b)) return a;
}
function $b36288e2db101ba3$var$ve(a, b) {
    if ("change" === a) return b;
}
var $b36288e2db101ba3$var$we = !1;
if ($b36288e2db101ba3$var$ia) {
    var $b36288e2db101ba3$var$xe;
    if ($b36288e2db101ba3$var$ia) {
        var $b36288e2db101ba3$var$ye = "oninput" in document;
        if (!$b36288e2db101ba3$var$ye) {
            var $b36288e2db101ba3$var$ze = document.createElement("div");
            $b36288e2db101ba3$var$ze.setAttribute("oninput", "return;");
            $b36288e2db101ba3$var$ye = "function" === typeof $b36288e2db101ba3$var$ze.oninput;
        }
        $b36288e2db101ba3$var$xe = $b36288e2db101ba3$var$ye;
    } else $b36288e2db101ba3$var$xe = !1;
    $b36288e2db101ba3$var$we = $b36288e2db101ba3$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $b36288e2db101ba3$var$Ae() {
    $b36288e2db101ba3$var$pe && ($b36288e2db101ba3$var$pe.detachEvent("onpropertychange", $b36288e2db101ba3$var$Be), $b36288e2db101ba3$var$qe = $b36288e2db101ba3$var$pe = null);
}
function $b36288e2db101ba3$var$Be(a) {
    if ("value" === a.propertyName && $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe)) {
        var b = [];
        $b36288e2db101ba3$var$ne(b, $b36288e2db101ba3$var$qe, a, $b36288e2db101ba3$var$xb(a));
        $b36288e2db101ba3$var$Jb($b36288e2db101ba3$var$re, b);
    }
}
function $b36288e2db101ba3$var$Ce(a, b, c) {
    "focusin" === a ? ($b36288e2db101ba3$var$Ae(), $b36288e2db101ba3$var$pe = b, $b36288e2db101ba3$var$qe = c, $b36288e2db101ba3$var$pe.attachEvent("onpropertychange", $b36288e2db101ba3$var$Be)) : "focusout" === a && $b36288e2db101ba3$var$Ae();
}
function $b36288e2db101ba3$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe);
}
function $b36288e2db101ba3$var$Ee(a, b) {
    if ("click" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b36288e2db101ba3$var$He = "function" === typeof Object.is ? Object.is : $b36288e2db101ba3$var$Ge;
function $b36288e2db101ba3$var$Ie(a, b) {
    if ($b36288e2db101ba3$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$b36288e2db101ba3$var$ja.call(b, e) || !$b36288e2db101ba3$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $b36288e2db101ba3$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b36288e2db101ba3$var$Ke(a, b) {
    var c = $b36288e2db101ba3$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b36288e2db101ba3$var$Je(c);
    }
}
function $b36288e2db101ba3$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b36288e2db101ba3$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b36288e2db101ba3$var$Me() {
    for(var a = window, b = $b36288e2db101ba3$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b36288e2db101ba3$var$Xa(a.document);
    }
    return b;
}
function $b36288e2db101ba3$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $b36288e2db101ba3$var$Oe(a) {
    var b = $b36288e2db101ba3$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $b36288e2db101ba3$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $b36288e2db101ba3$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $b36288e2db101ba3$var$Ke(c, f);
                var g = $b36288e2db101ba3$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $b36288e2db101ba3$var$Pe = $b36288e2db101ba3$var$ia && "documentMode" in document && 11 >= document.documentMode, $b36288e2db101ba3$var$Qe = null, $b36288e2db101ba3$var$Re = null, $b36288e2db101ba3$var$Se = null, $b36288e2db101ba3$var$Te = !1;
function $b36288e2db101ba3$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b36288e2db101ba3$var$Te || null == $b36288e2db101ba3$var$Qe || $b36288e2db101ba3$var$Qe !== $b36288e2db101ba3$var$Xa(d) || (d = $b36288e2db101ba3$var$Qe, "selectionStart" in d && $b36288e2db101ba3$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b36288e2db101ba3$var$Se && $b36288e2db101ba3$var$Ie($b36288e2db101ba3$var$Se, d) || ($b36288e2db101ba3$var$Se = d, d = $b36288e2db101ba3$var$oe($b36288e2db101ba3$var$Re, "onSelect"), 0 < d.length && (b = new $b36288e2db101ba3$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b36288e2db101ba3$var$Qe)));
}
function $b36288e2db101ba3$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b36288e2db101ba3$var$We = {
    animationend: $b36288e2db101ba3$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $b36288e2db101ba3$var$Ve("Animation", "AnimationIteration"),
    animationstart: $b36288e2db101ba3$var$Ve("Animation", "AnimationStart"),
    transitionend: $b36288e2db101ba3$var$Ve("Transition", "TransitionEnd")
}, $b36288e2db101ba3$var$Xe = {}, $b36288e2db101ba3$var$Ye = {};
$b36288e2db101ba3$var$ia && ($b36288e2db101ba3$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $b36288e2db101ba3$var$We.animationend.animation, delete $b36288e2db101ba3$var$We.animationiteration.animation, delete $b36288e2db101ba3$var$We.animationstart.animation), "TransitionEvent" in window || delete $b36288e2db101ba3$var$We.transitionend.transition);
function $b36288e2db101ba3$var$Ze(a) {
    if ($b36288e2db101ba3$var$Xe[a]) return $b36288e2db101ba3$var$Xe[a];
    if (!$b36288e2db101ba3$var$We[a]) return a;
    var b = $b36288e2db101ba3$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b36288e2db101ba3$var$Ye) return $b36288e2db101ba3$var$Xe[a] = b[c];
    return a;
}
var $b36288e2db101ba3$var$$e = $b36288e2db101ba3$var$Ze("animationend"), $b36288e2db101ba3$var$af = $b36288e2db101ba3$var$Ze("animationiteration"), $b36288e2db101ba3$var$bf = $b36288e2db101ba3$var$Ze("animationstart"), $b36288e2db101ba3$var$cf = $b36288e2db101ba3$var$Ze("transitionend"), $b36288e2db101ba3$var$df = new Map, $b36288e2db101ba3$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $b36288e2db101ba3$var$ff(a, b) {
    $b36288e2db101ba3$var$df.set(a, b);
    $b36288e2db101ba3$var$fa(b, [
        a
    ]);
}
for(var $b36288e2db101ba3$var$gf = 0; $b36288e2db101ba3$var$gf < $b36288e2db101ba3$var$ef.length; $b36288e2db101ba3$var$gf++){
    var $b36288e2db101ba3$var$hf = $b36288e2db101ba3$var$ef[$b36288e2db101ba3$var$gf], $b36288e2db101ba3$var$jf = $b36288e2db101ba3$var$hf.toLowerCase(), $b36288e2db101ba3$var$kf = $b36288e2db101ba3$var$hf[0].toUpperCase() + $b36288e2db101ba3$var$hf.slice(1);
    $b36288e2db101ba3$var$ff($b36288e2db101ba3$var$jf, "on" + $b36288e2db101ba3$var$kf);
}
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$$e, "onAnimationEnd");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$af, "onAnimationIteration");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$bf, "onAnimationStart");
$b36288e2db101ba3$var$ff("dblclick", "onDoubleClick");
$b36288e2db101ba3$var$ff("focusin", "onFocus");
$b36288e2db101ba3$var$ff("focusout", "onBlur");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$cf, "onTransitionEnd");
$b36288e2db101ba3$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b36288e2db101ba3$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b36288e2db101ba3$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b36288e2db101ba3$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($b36288e2db101ba3$var$lf));
function $b36288e2db101ba3$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b36288e2db101ba3$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $b36288e2db101ba3$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($b36288e2db101ba3$var$Qb) throw a = $b36288e2db101ba3$var$Rb, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, a;
}
function $b36288e2db101ba3$var$D(a, b) {
    var c = b[$b36288e2db101ba3$var$of];
    void 0 === c && (c = b[$b36288e2db101ba3$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($b36288e2db101ba3$var$pf(b, a, 2, !1), c.add(d));
}
function $b36288e2db101ba3$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $b36288e2db101ba3$var$pf(c, a, d, b);
}
var $b36288e2db101ba3$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $b36288e2db101ba3$var$sf(a) {
    if (!a[$b36288e2db101ba3$var$rf]) {
        a[$b36288e2db101ba3$var$rf] = !0;
        $b36288e2db101ba3$var$da.forEach(function(b) {
            "selectionchange" !== b && ($b36288e2db101ba3$var$mf.has(b) || $b36288e2db101ba3$var$qf(b, !1, a), $b36288e2db101ba3$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$b36288e2db101ba3$var$rf] || (b[$b36288e2db101ba3$var$rf] = !0, $b36288e2db101ba3$var$qf("selectionchange", !1, b));
    }
}
function $b36288e2db101ba3$var$pf(a, b, c, d) {
    switch($b36288e2db101ba3$var$jd(b)){
        case 1:
            var e = $b36288e2db101ba3$var$ed;
            break;
        case 4:
            e = $b36288e2db101ba3$var$gd;
            break;
        default:
            e = $b36288e2db101ba3$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b36288e2db101ba3$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b36288e2db101ba3$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b36288e2db101ba3$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b36288e2db101ba3$var$Jb(function() {
        var d = f, e = $b36288e2db101ba3$var$xb(c), g = [];
        a: {
            var h = $b36288e2db101ba3$var$df.get(a);
            if (void 0 !== h) {
                var k = $b36288e2db101ba3$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $b36288e2db101ba3$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b36288e2db101ba3$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b36288e2db101ba3$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b36288e2db101ba3$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b36288e2db101ba3$var$Vd;
                        break;
                    case $b36288e2db101ba3$var$$e:
                    case $b36288e2db101ba3$var$af:
                    case $b36288e2db101ba3$var$bf:
                        k = $b36288e2db101ba3$var$Hd;
                        break;
                    case $b36288e2db101ba3$var$cf:
                        k = $b36288e2db101ba3$var$Xd;
                        break;
                    case "scroll":
                        k = $b36288e2db101ba3$var$vd;
                        break;
                    case "wheel":
                        k = $b36288e2db101ba3$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b36288e2db101ba3$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b36288e2db101ba3$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $b36288e2db101ba3$var$Kb(w, x), null != F && t.push($b36288e2db101ba3$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $b36288e2db101ba3$var$wb && (n = c.relatedTarget || c.fromElement) && ($b36288e2db101ba3$var$Wc(n) || n[$b36288e2db101ba3$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $b36288e2db101ba3$var$Wc(n) : null, null !== n && (J = $b36288e2db101ba3$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $b36288e2db101ba3$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $b36288e2db101ba3$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $b36288e2db101ba3$var$ue(k);
                        u = null == n ? h : $b36288e2db101ba3$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $b36288e2db101ba3$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $b36288e2db101ba3$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $b36288e2db101ba3$var$vf(F))u++;
                            for(; 0 < w - u;)t = $b36288e2db101ba3$var$vf(t), w--;
                            for(; 0 < u - w;)x = $b36288e2db101ba3$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $b36288e2db101ba3$var$vf(t);
                                x = $b36288e2db101ba3$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $b36288e2db101ba3$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $b36288e2db101ba3$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $b36288e2db101ba3$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $b36288e2db101ba3$var$ve;
                else if ($b36288e2db101ba3$var$me(h)) {
                    if ($b36288e2db101ba3$var$we) na = $b36288e2db101ba3$var$Fe;
                    else {
                        na = $b36288e2db101ba3$var$De;
                        var xa = $b36288e2db101ba3$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $b36288e2db101ba3$var$Ee);
                if (na && (na = na(a, d))) {
                    $b36288e2db101ba3$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $b36288e2db101ba3$var$cb(h, "number", h.value);
            }
            xa = d ? $b36288e2db101ba3$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($b36288e2db101ba3$var$me(xa) || "true" === xa.contentEditable) $b36288e2db101ba3$var$Qe = xa, $b36288e2db101ba3$var$Re = d, $b36288e2db101ba3$var$Se = null;
                    break;
                case "focusout":
                    $b36288e2db101ba3$var$Se = $b36288e2db101ba3$var$Re = $b36288e2db101ba3$var$Qe = null;
                    break;
                case "mousedown":
                    $b36288e2db101ba3$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b36288e2db101ba3$var$Te = !1;
                    $b36288e2db101ba3$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($b36288e2db101ba3$var$Pe) break;
                case "keydown":
                case "keyup":
                    $b36288e2db101ba3$var$Ue(g, c, e);
            }
            var $a;
            if ($b36288e2db101ba3$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $b36288e2db101ba3$var$ie ? $b36288e2db101ba3$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($b36288e2db101ba3$var$de && "ko" !== c.locale && ($b36288e2db101ba3$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $b36288e2db101ba3$var$ie && ($a = $b36288e2db101ba3$var$nd()) : ($b36288e2db101ba3$var$kd = e, $b36288e2db101ba3$var$ld = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, $b36288e2db101ba3$var$ie = !0)), xa = $b36288e2db101ba3$var$oe(d, ba), 0 < xa.length && (ba = new $b36288e2db101ba3$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $b36288e2db101ba3$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $b36288e2db101ba3$var$ce ? $b36288e2db101ba3$var$je(a, c) : $b36288e2db101ba3$var$ke(a, c)) d = $b36288e2db101ba3$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $b36288e2db101ba3$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $b36288e2db101ba3$var$se(g, b);
    });
}
function $b36288e2db101ba3$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b36288e2db101ba3$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b36288e2db101ba3$var$Kb(a, c), null != f && d.unshift($b36288e2db101ba3$var$tf(a, f, e)), f = $b36288e2db101ba3$var$Kb(a, b), null != f && d.push($b36288e2db101ba3$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b36288e2db101ba3$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b36288e2db101ba3$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.unshift($b36288e2db101ba3$var$tf(c, k, h))) : e || (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.push($b36288e2db101ba3$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $b36288e2db101ba3$var$xf = /\r\n?/g, $b36288e2db101ba3$var$yf = /\u0000|\uFFFD/g;
function $b36288e2db101ba3$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($b36288e2db101ba3$var$xf, "\n").replace($b36288e2db101ba3$var$yf, "");
}
function $b36288e2db101ba3$var$Af(a, b, c) {
    b = $b36288e2db101ba3$var$zf(b);
    if ($b36288e2db101ba3$var$zf(a) !== b && c) throw Error($b36288e2db101ba3$var$p(425));
}
function $b36288e2db101ba3$var$Bf() {}
var $b36288e2db101ba3$var$Cf = null, $b36288e2db101ba3$var$Df = null;
function $b36288e2db101ba3$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b36288e2db101ba3$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $b36288e2db101ba3$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $b36288e2db101ba3$var$Hf = "function" === typeof Promise ? Promise : void 0, $b36288e2db101ba3$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b36288e2db101ba3$var$Hf ? function(a) {
    return $b36288e2db101ba3$var$Hf.resolve(null).then(a).catch($b36288e2db101ba3$var$If);
} : $b36288e2db101ba3$var$Ff;
function $b36288e2db101ba3$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $b36288e2db101ba3$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $b36288e2db101ba3$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $b36288e2db101ba3$var$bd(b);
}
function $b36288e2db101ba3$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $b36288e2db101ba3$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nf = Math.random().toString(36).slice(2), $b36288e2db101ba3$var$Of = "__reactFiber$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Pf = "__reactProps$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$uf = "__reactContainer$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$of = "__reactEvents$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Qf = "__reactListeners$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Rf = "__reactHandles$" + $b36288e2db101ba3$var$Nf;
function $b36288e2db101ba3$var$Wc(a) {
    var b = a[$b36288e2db101ba3$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b36288e2db101ba3$var$uf] || c[$b36288e2db101ba3$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b36288e2db101ba3$var$Mf(a); null !== a;){
                if (c = a[$b36288e2db101ba3$var$Of]) return c;
                a = $b36288e2db101ba3$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b36288e2db101ba3$var$Cb(a) {
    a = a[$b36288e2db101ba3$var$Of] || a[$b36288e2db101ba3$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b36288e2db101ba3$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b36288e2db101ba3$var$p(33));
}
function $b36288e2db101ba3$var$Db(a) {
    return a[$b36288e2db101ba3$var$Pf] || null;
}
var $b36288e2db101ba3$var$Sf = [], $b36288e2db101ba3$var$Tf = -1;
function $b36288e2db101ba3$var$Uf(a) {
    return {
        current: a
    };
}
function $b36288e2db101ba3$var$E(a) {
    0 > $b36288e2db101ba3$var$Tf || (a.current = $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf], $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = null, $b36288e2db101ba3$var$Tf--);
}
function $b36288e2db101ba3$var$G(a, b) {
    $b36288e2db101ba3$var$Tf++;
    $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = a.current;
    a.current = b;
}
var $b36288e2db101ba3$var$Vf = {}, $b36288e2db101ba3$var$H = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Vf), $b36288e2db101ba3$var$Wf = $b36288e2db101ba3$var$Uf(!1), $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$Vf;
function $b36288e2db101ba3$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b36288e2db101ba3$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b36288e2db101ba3$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b36288e2db101ba3$var$$f() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
}
function $b36288e2db101ba3$var$ag(a, b, c) {
    if ($b36288e2db101ba3$var$H.current !== $b36288e2db101ba3$var$Vf) throw Error($b36288e2db101ba3$var$p(168));
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
function $b36288e2db101ba3$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($b36288e2db101ba3$var$p(108, $b36288e2db101ba3$var$Ra(a) || "Unknown", e));
    return $b36288e2db101ba3$var$A({}, c, d);
}
function $b36288e2db101ba3$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b36288e2db101ba3$var$Vf;
    $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$H.current;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, $b36288e2db101ba3$var$Wf.current);
    return !0;
}
function $b36288e2db101ba3$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b36288e2db101ba3$var$p(169));
    c ? (a = $b36288e2db101ba3$var$bg(a, b, $b36288e2db101ba3$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a)) : $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
var $b36288e2db101ba3$var$eg = null, $b36288e2db101ba3$var$fg = !1, $b36288e2db101ba3$var$gg = !1;
function $b36288e2db101ba3$var$hg(a) {
    null === $b36288e2db101ba3$var$eg ? $b36288e2db101ba3$var$eg = [
        a
    ] : $b36288e2db101ba3$var$eg.push(a);
}
function $b36288e2db101ba3$var$ig(a) {
    $b36288e2db101ba3$var$fg = !0;
    $b36288e2db101ba3$var$hg(a);
}
function $b36288e2db101ba3$var$jg() {
    if (!$b36288e2db101ba3$var$gg && null !== $b36288e2db101ba3$var$eg) {
        $b36288e2db101ba3$var$gg = !0;
        var a = 0, b = $b36288e2db101ba3$var$C;
        try {
            var c = $b36288e2db101ba3$var$eg;
            for($b36288e2db101ba3$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $b36288e2db101ba3$var$eg = null;
            $b36288e2db101ba3$var$fg = !1;
        } catch (e) {
            throw null !== $b36288e2db101ba3$var$eg && ($b36288e2db101ba3$var$eg = $b36288e2db101ba3$var$eg.slice(a + 1)), $b36288e2db101ba3$var$ac($b36288e2db101ba3$var$fc, $b36288e2db101ba3$var$jg), e;
        } finally{
            $b36288e2db101ba3$var$C = b, $b36288e2db101ba3$var$gg = !1;
        }
    }
    return null;
}
var $b36288e2db101ba3$var$kg = [], $b36288e2db101ba3$var$lg = 0, $b36288e2db101ba3$var$mg = null, $b36288e2db101ba3$var$ng = 0, $b36288e2db101ba3$var$og = [], $b36288e2db101ba3$var$pg = 0, $b36288e2db101ba3$var$qg = null, $b36288e2db101ba3$var$rg = 1, $b36288e2db101ba3$var$sg = "";
function $b36288e2db101ba3$var$tg(a, b) {
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$ng;
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$mg;
    $b36288e2db101ba3$var$mg = a;
    $b36288e2db101ba3$var$ng = b;
}
function $b36288e2db101ba3$var$ug(a, b, c) {
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg;
    $b36288e2db101ba3$var$qg = a;
    var d = $b36288e2db101ba3$var$rg;
    a = $b36288e2db101ba3$var$sg;
    var e = 32 - $b36288e2db101ba3$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $b36288e2db101ba3$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $b36288e2db101ba3$var$rg = 1 << 32 - $b36288e2db101ba3$var$oc(b) + e | c << e | d;
        $b36288e2db101ba3$var$sg = f + a;
    } else $b36288e2db101ba3$var$rg = 1 << f | c << e | d, $b36288e2db101ba3$var$sg = a;
}
function $b36288e2db101ba3$var$vg(a) {
    null !== a.return && ($b36288e2db101ba3$var$tg(a, 1), $b36288e2db101ba3$var$ug(a, 1, 0));
}
function $b36288e2db101ba3$var$wg(a) {
    for(; a === $b36288e2db101ba3$var$mg;)$b36288e2db101ba3$var$mg = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null, $b36288e2db101ba3$var$ng = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null;
    for(; a === $b36288e2db101ba3$var$qg;)$b36288e2db101ba3$var$qg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$sg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$rg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null;
}
var $b36288e2db101ba3$var$xg = null, $b36288e2db101ba3$var$yg = null, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$zg = null;
function $b36288e2db101ba3$var$Ag(a, b) {
    var c = $b36288e2db101ba3$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $b36288e2db101ba3$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $b36288e2db101ba3$var$qg ? {
                id: $b36288e2db101ba3$var$rg,
                overflow: $b36288e2db101ba3$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $b36288e2db101ba3$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $b36288e2db101ba3$var$Eg(a) {
    if ($b36288e2db101ba3$var$I) {
        var b = $b36288e2db101ba3$var$yg;
        if (b) {
            var c = b;
            if (!$b36288e2db101ba3$var$Cg(a, b)) {
                if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
                b = $b36288e2db101ba3$var$Lf(c.nextSibling);
                var d = $b36288e2db101ba3$var$xg;
                b && $b36288e2db101ba3$var$Cg(a, b) ? $b36288e2db101ba3$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$xg = a);
            }
        } else {
            if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $b36288e2db101ba3$var$I = !1;
            $b36288e2db101ba3$var$xg = a;
        }
    }
}
function $b36288e2db101ba3$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b36288e2db101ba3$var$xg = a;
}
function $b36288e2db101ba3$var$Gg(a) {
    if (a !== $b36288e2db101ba3$var$xg) return !1;
    if (!$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$Fg(a), $b36288e2db101ba3$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$b36288e2db101ba3$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $b36288e2db101ba3$var$yg)) {
        if ($b36288e2db101ba3$var$Dg(a)) throw $b36288e2db101ba3$var$Hg(), Error($b36288e2db101ba3$var$p(418));
        for(; b;)$b36288e2db101ba3$var$Ag(a, b), b = $b36288e2db101ba3$var$Lf(b.nextSibling);
    }
    $b36288e2db101ba3$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b36288e2db101ba3$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b36288e2db101ba3$var$yg = null;
        }
    } else $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg ? $b36288e2db101ba3$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b36288e2db101ba3$var$Hg() {
    for(var a = $b36288e2db101ba3$var$yg; a;)a = $b36288e2db101ba3$var$Lf(a.nextSibling);
}
function $b36288e2db101ba3$var$Ig() {
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg = null;
    $b36288e2db101ba3$var$I = !1;
}
function $b36288e2db101ba3$var$Jg(a) {
    null === $b36288e2db101ba3$var$zg ? $b36288e2db101ba3$var$zg = [
        a
    ] : $b36288e2db101ba3$var$zg.push(a);
}
var $b36288e2db101ba3$var$Kg = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig;
function $b36288e2db101ba3$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $b36288e2db101ba3$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $b36288e2db101ba3$var$Mg = $b36288e2db101ba3$var$Uf(null), $b36288e2db101ba3$var$Ng = null, $b36288e2db101ba3$var$Og = null, $b36288e2db101ba3$var$Pg = null;
function $b36288e2db101ba3$var$Qg() {
    $b36288e2db101ba3$var$Pg = $b36288e2db101ba3$var$Og = $b36288e2db101ba3$var$Ng = null;
}
function $b36288e2db101ba3$var$Rg(a) {
    var b = $b36288e2db101ba3$var$Mg.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Mg);
    a._currentValue = b;
}
function $b36288e2db101ba3$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $b36288e2db101ba3$var$Tg(a, b) {
    $b36288e2db101ba3$var$Ng = a;
    $b36288e2db101ba3$var$Pg = $b36288e2db101ba3$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b36288e2db101ba3$var$Ug = !0), a.firstContext = null);
}
function $b36288e2db101ba3$var$Vg(a) {
    var b = a._currentValue;
    if ($b36288e2db101ba3$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $b36288e2db101ba3$var$Og) {
            if (null === $b36288e2db101ba3$var$Ng) throw Error($b36288e2db101ba3$var$p(308));
            $b36288e2db101ba3$var$Og = a;
            $b36288e2db101ba3$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $b36288e2db101ba3$var$Og = $b36288e2db101ba3$var$Og.next = a;
    }
    return b;
}
var $b36288e2db101ba3$var$Wg = null;
function $b36288e2db101ba3$var$Xg(a) {
    null === $b36288e2db101ba3$var$Wg ? $b36288e2db101ba3$var$Wg = [
        a
    ] : $b36288e2db101ba3$var$Wg.push(a);
}
function $b36288e2db101ba3$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $b36288e2db101ba3$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $b36288e2db101ba3$var$Zg(a, d);
}
function $b36288e2db101ba3$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $b36288e2db101ba3$var$$g = !1;
function $b36288e2db101ba3$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $b36288e2db101ba3$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b36288e2db101ba3$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b36288e2db101ba3$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($b36288e2db101ba3$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $b36288e2db101ba3$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $b36288e2db101ba3$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $b36288e2db101ba3$var$Zg(a, c);
}
function $b36288e2db101ba3$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
function $b36288e2db101ba3$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b36288e2db101ba3$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $b36288e2db101ba3$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $b36288e2db101ba3$var$A({}, q, r);
                            break a;
                        case 2:
                            $b36288e2db101ba3$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $b36288e2db101ba3$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $b36288e2db101ba3$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b36288e2db101ba3$var$p(191, e));
            e.call(d);
        }
    }
}
var $b36288e2db101ba3$var$jh = (new $bh6RR.Component).refs;
function $b36288e2db101ba3$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b36288e2db101ba3$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b36288e2db101ba3$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $b36288e2db101ba3$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$L(), e = $b36288e2db101ba3$var$lh(a), f = $b36288e2db101ba3$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$dh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, e, d), $b36288e2db101ba3$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$L(), e = $b36288e2db101ba3$var$lh(a), f = $b36288e2db101ba3$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$dh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, e, d), $b36288e2db101ba3$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $b36288e2db101ba3$var$L(), d = $b36288e2db101ba3$var$lh(a), e = $b36288e2db101ba3$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $b36288e2db101ba3$var$dh(a, e, d);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, d, c), $b36288e2db101ba3$var$eh(b, a, d));
    }
};
function $b36288e2db101ba3$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b36288e2db101ba3$var$Ie(c, d) || !$b36288e2db101ba3$var$Ie(e, f) : !0;
}
function $b36288e2db101ba3$var$ph(a, b, c) {
    var d = !1, e = $b36288e2db101ba3$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b36288e2db101ba3$var$Vg(f) : (e = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b36288e2db101ba3$var$Yf(a, e) : $b36288e2db101ba3$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b36288e2db101ba3$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b36288e2db101ba3$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b36288e2db101ba3$var$nh.enqueueReplaceState(b, b.state, null);
}
function $b36288e2db101ba3$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $b36288e2db101ba3$var$jh;
    $b36288e2db101ba3$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b36288e2db101ba3$var$Vg(f) : (f = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, e.context = $b36288e2db101ba3$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b36288e2db101ba3$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b36288e2db101ba3$var$nh.enqueueReplaceState(e, e.state, null), $b36288e2db101ba3$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $b36288e2db101ba3$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b36288e2db101ba3$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b36288e2db101ba3$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $b36288e2db101ba3$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($b36288e2db101ba3$var$p(284));
        if (!c._owner) throw Error($b36288e2db101ba3$var$p(290, a));
    }
    return a;
}
function $b36288e2db101ba3$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($b36288e2db101ba3$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $b36288e2db101ba3$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $b36288e2db101ba3$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b36288e2db101ba3$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b36288e2db101ba3$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $b36288e2db101ba3$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $b36288e2db101ba3$var$sh(a, b, c), d.return = a, d;
        d = $b36288e2db101ba3$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b36288e2db101ba3$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b36288e2db101ba3$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b36288e2db101ba3$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $b36288e2db101ba3$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c = $b36288e2db101ba3$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $b36288e2db101ba3$var$sh(a, null, b), c.return = a, c;
                case $b36288e2db101ba3$var$wa:
                    return b = $b36288e2db101ba3$var$zh(b, a.mode, c), b.return = a, b;
                case $b36288e2db101ba3$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($b36288e2db101ba3$var$eb(b) || $b36288e2db101ba3$var$Ka(b)) return b = $b36288e2db101ba3$var$Ah(b, a.mode, c, null), b.return = a, b;
            $b36288e2db101ba3$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $b36288e2db101ba3$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $b36288e2db101ba3$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($b36288e2db101ba3$var$eb(c) || $b36288e2db101ba3$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $b36288e2db101ba3$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $b36288e2db101ba3$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $b36288e2db101ba3$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($b36288e2db101ba3$var$eb(d) || $b36288e2db101ba3$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $b36288e2db101ba3$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $b36288e2db101ba3$var$Ka(h);
        if ("function" !== typeof l) throw Error($b36288e2db101ba3$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($b36288e2db101ba3$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $b36288e2db101ba3$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $b36288e2db101ba3$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $b36288e2db101ba3$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $b36288e2db101ba3$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $b36288e2db101ba3$var$ya ? (d = $b36288e2db101ba3$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b36288e2db101ba3$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $b36288e2db101ba3$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $b36288e2db101ba3$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $b36288e2db101ba3$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $b36288e2db101ba3$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($b36288e2db101ba3$var$eb(f)) return n(a, d, f, h);
            if ($b36288e2db101ba3$var$Ka(f)) return t(a, d, f, h);
            $b36288e2db101ba3$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b36288e2db101ba3$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $b36288e2db101ba3$var$Bh = $b36288e2db101ba3$var$vh(!0), $b36288e2db101ba3$var$Ch = $b36288e2db101ba3$var$vh(!1), $b36288e2db101ba3$var$Dh = {}, $b36288e2db101ba3$var$Eh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh), $b36288e2db101ba3$var$Fh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh), $b36288e2db101ba3$var$Gh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh);
function $b36288e2db101ba3$var$Hh(a) {
    if (a === $b36288e2db101ba3$var$Dh) throw Error($b36288e2db101ba3$var$p(174));
    return a;
}
function $b36288e2db101ba3$var$Ih(a, b) {
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Gh, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Fh, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, $b36288e2db101ba3$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b36288e2db101ba3$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b36288e2db101ba3$var$lb(b, a);
    }
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, b);
}
function $b36288e2db101ba3$var$Jh() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Fh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Gh);
}
function $b36288e2db101ba3$var$Kh(a) {
    $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
    var b = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
    var c = $b36288e2db101ba3$var$lb(b, a.type);
    b !== c && ($b36288e2db101ba3$var$G($b36288e2db101ba3$var$Fh, a), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, c));
}
function $b36288e2db101ba3$var$Lh(a) {
    $b36288e2db101ba3$var$Fh.current === a && ($b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Fh));
}
var $b36288e2db101ba3$var$M = $b36288e2db101ba3$var$Uf(0);
function $b36288e2db101ba3$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nh = [];
function $b36288e2db101ba3$var$Oh() {
    for(var a = 0; a < $b36288e2db101ba3$var$Nh.length; a++)$b36288e2db101ba3$var$Nh[a]._workInProgressVersionPrimary = null;
    $b36288e2db101ba3$var$Nh.length = 0;
}
var $b36288e2db101ba3$var$Ph = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$Qh = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$Rh = 0, $b36288e2db101ba3$var$N = null, $b36288e2db101ba3$var$O = null, $b36288e2db101ba3$var$P = null, $b36288e2db101ba3$var$Sh = !1, $b36288e2db101ba3$var$Th = !1, $b36288e2db101ba3$var$Uh = 0, $b36288e2db101ba3$var$Vh = 0;
function $b36288e2db101ba3$var$Q() {
    throw Error($b36288e2db101ba3$var$p(321));
}
function $b36288e2db101ba3$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b36288e2db101ba3$var$He(a[c], b[c])) return !1;
    return !0;
}
function $b36288e2db101ba3$var$Xh(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$Rh = f;
    $b36288e2db101ba3$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b36288e2db101ba3$var$Ph.current = null === a || null === a.memoizedState ? $b36288e2db101ba3$var$Yh : $b36288e2db101ba3$var$Zh;
    a = c(d, e);
    if ($b36288e2db101ba3$var$Th) {
        f = 0;
        do {
            $b36288e2db101ba3$var$Th = !1;
            $b36288e2db101ba3$var$Uh = 0;
            if (25 <= f) throw Error($b36288e2db101ba3$var$p(301));
            f += 1;
            $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = null;
            b.updateQueue = null;
            $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$$h;
            a = c(d, e);
        }while ($b36288e2db101ba3$var$Th);
    }
    $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$ai;
    b = null !== $b36288e2db101ba3$var$O && null !== $b36288e2db101ba3$var$O.next;
    $b36288e2db101ba3$var$Rh = 0;
    $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
    $b36288e2db101ba3$var$Sh = !1;
    if (b) throw Error($b36288e2db101ba3$var$p(300));
    return a;
}
function $b36288e2db101ba3$var$bi() {
    var a = 0 !== $b36288e2db101ba3$var$Uh;
    $b36288e2db101ba3$var$Uh = 0;
    return a;
}
function $b36288e2db101ba3$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState = $b36288e2db101ba3$var$P = a : $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$P.next = a;
    return $b36288e2db101ba3$var$P;
}
function $b36288e2db101ba3$var$di() {
    if (null === $b36288e2db101ba3$var$O) {
        var a = $b36288e2db101ba3$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b36288e2db101ba3$var$O.next;
    var b = null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState : $b36288e2db101ba3$var$P.next;
    if (null !== b) $b36288e2db101ba3$var$P = b, $b36288e2db101ba3$var$O = a;
    else {
        if (null === a) throw Error($b36288e2db101ba3$var$p(310));
        $b36288e2db101ba3$var$O = a;
        a = {
            memoizedState: $b36288e2db101ba3$var$O.memoizedState,
            baseState: $b36288e2db101ba3$var$O.baseState,
            baseQueue: $b36288e2db101ba3$var$O.baseQueue,
            queue: $b36288e2db101ba3$var$O.queue,
            next: null
        };
        null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState = $b36288e2db101ba3$var$P = a : $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$P.next = a;
    }
    return $b36288e2db101ba3$var$P;
}
function $b36288e2db101ba3$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b36288e2db101ba3$var$fi(a) {
    var b = $b36288e2db101ba3$var$di(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = $b36288e2db101ba3$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($b36288e2db101ba3$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $b36288e2db101ba3$var$N.lanes |= m;
                $b36288e2db101ba3$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $b36288e2db101ba3$var$He(d, b.memoizedState) || ($b36288e2db101ba3$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $b36288e2db101ba3$var$N.lanes |= f, $b36288e2db101ba3$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b36288e2db101ba3$var$gi(a) {
    var b = $b36288e2db101ba3$var$di(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b36288e2db101ba3$var$He(f, b.memoizedState) || ($b36288e2db101ba3$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b36288e2db101ba3$var$hi() {}
function $b36288e2db101ba3$var$ii(a, b) {
    var c = $b36288e2db101ba3$var$N, d = $b36288e2db101ba3$var$di(), e = b(), f = !$b36288e2db101ba3$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $b36288e2db101ba3$var$Ug = !0);
    d = d.queue;
    $b36288e2db101ba3$var$ji($b36288e2db101ba3$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $b36288e2db101ba3$var$P && $b36288e2db101ba3$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $b36288e2db101ba3$var$li(9, $b36288e2db101ba3$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $b36288e2db101ba3$var$R) throw Error($b36288e2db101ba3$var$p(349));
        0 !== ($b36288e2db101ba3$var$Rh & 30) || $b36288e2db101ba3$var$ni(c, b, e);
    }
    return e;
}
function $b36288e2db101ba3$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $b36288e2db101ba3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $b36288e2db101ba3$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $b36288e2db101ba3$var$oi(b) && $b36288e2db101ba3$var$pi(a);
}
function $b36288e2db101ba3$var$ki(a, b, c) {
    return c(function() {
        $b36288e2db101ba3$var$oi(b) && $b36288e2db101ba3$var$pi(a);
    });
}
function $b36288e2db101ba3$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$b36288e2db101ba3$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $b36288e2db101ba3$var$pi(a) {
    var b = $b36288e2db101ba3$var$Zg(a, 1);
    null !== b && $b36288e2db101ba3$var$mh(b, a, 1, -1);
}
function $b36288e2db101ba3$var$qi(a) {
    var b = $b36288e2db101ba3$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b36288e2db101ba3$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $b36288e2db101ba3$var$ri.bind(null, $b36288e2db101ba3$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b36288e2db101ba3$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b36288e2db101ba3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b36288e2db101ba3$var$si() {
    return $b36288e2db101ba3$var$di().memoizedState;
}
function $b36288e2db101ba3$var$ti(a, b, c, d) {
    var e = $b36288e2db101ba3$var$ci();
    $b36288e2db101ba3$var$N.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b36288e2db101ba3$var$ui(a, b, c, d) {
    var e = $b36288e2db101ba3$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b36288e2db101ba3$var$O) {
        var g = $b36288e2db101ba3$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $b36288e2db101ba3$var$Wh(d, g.deps)) {
            e.memoizedState = $b36288e2db101ba3$var$li(b, c, f, d);
            return;
        }
    }
    $b36288e2db101ba3$var$N.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$li(1 | b, c, f, d);
}
function $b36288e2db101ba3$var$vi(a, b) {
    return $b36288e2db101ba3$var$ti(8390656, 8, a, b);
}
function $b36288e2db101ba3$var$ji(a, b) {
    return $b36288e2db101ba3$var$ui(2048, 8, a, b);
}
function $b36288e2db101ba3$var$wi(a, b) {
    return $b36288e2db101ba3$var$ui(4, 2, a, b);
}
function $b36288e2db101ba3$var$xi(a, b) {
    return $b36288e2db101ba3$var$ui(4, 4, a, b);
}
function $b36288e2db101ba3$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b36288e2db101ba3$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b36288e2db101ba3$var$ui(4, 4, $b36288e2db101ba3$var$yi.bind(null, b, a), c);
}
function $b36288e2db101ba3$var$Ai() {}
function $b36288e2db101ba3$var$Bi(a, b) {
    var c = $b36288e2db101ba3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$Ci(a, b) {
    var c = $b36288e2db101ba3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$Di(a, b, c) {
    if (0 === ($b36288e2db101ba3$var$Rh & 21)) return a.baseState && (a.baseState = !1, $b36288e2db101ba3$var$Ug = !0), a.memoizedState = c;
    $b36288e2db101ba3$var$He(c, b) || (c = $b36288e2db101ba3$var$yc(), $b36288e2db101ba3$var$N.lanes |= c, $b36288e2db101ba3$var$hh |= c, a.baseState = !0);
    return b;
}
function $b36288e2db101ba3$var$Ei(a, b) {
    var c = $b36288e2db101ba3$var$C;
    $b36288e2db101ba3$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $b36288e2db101ba3$var$Qh.transition;
    $b36288e2db101ba3$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$Qh.transition = d;
    }
}
function $b36288e2db101ba3$var$Fi() {
    return $b36288e2db101ba3$var$di().memoizedState;
}
function $b36288e2db101ba3$var$Gi(a, b, c) {
    var d = $b36288e2db101ba3$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$Hi(a)) $b36288e2db101ba3$var$Ii(b, c);
    else if (c = $b36288e2db101ba3$var$Yg(a, b, c, d), null !== c) {
        var e = $b36288e2db101ba3$var$L();
        $b36288e2db101ba3$var$mh(c, a, d, e);
        $b36288e2db101ba3$var$Ji(c, b, d);
    }
}
function $b36288e2db101ba3$var$ri(a, b, c) {
    var d = $b36288e2db101ba3$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$Hi(a)) $b36288e2db101ba3$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($b36288e2db101ba3$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $b36288e2db101ba3$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $b36288e2db101ba3$var$Yg(a, b, e, d);
        null !== c && (e = $b36288e2db101ba3$var$L(), $b36288e2db101ba3$var$mh(c, a, d, e), $b36288e2db101ba3$var$Ji(c, b, d));
    }
}
function $b36288e2db101ba3$var$Hi(a) {
    var b = a.alternate;
    return a === $b36288e2db101ba3$var$N || null !== b && b === $b36288e2db101ba3$var$N;
}
function $b36288e2db101ba3$var$Ii(a, b) {
    $b36288e2db101ba3$var$Th = $b36288e2db101ba3$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $b36288e2db101ba3$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
var $b36288e2db101ba3$var$ai = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Q,
    useContext: $b36288e2db101ba3$var$Q,
    useEffect: $b36288e2db101ba3$var$Q,
    useImperativeHandle: $b36288e2db101ba3$var$Q,
    useInsertionEffect: $b36288e2db101ba3$var$Q,
    useLayoutEffect: $b36288e2db101ba3$var$Q,
    useMemo: $b36288e2db101ba3$var$Q,
    useReducer: $b36288e2db101ba3$var$Q,
    useRef: $b36288e2db101ba3$var$Q,
    useState: $b36288e2db101ba3$var$Q,
    useDebugValue: $b36288e2db101ba3$var$Q,
    useDeferredValue: $b36288e2db101ba3$var$Q,
    useTransition: $b36288e2db101ba3$var$Q,
    useMutableSource: $b36288e2db101ba3$var$Q,
    useSyncExternalStore: $b36288e2db101ba3$var$Q,
    useId: $b36288e2db101ba3$var$Q,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Yh = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: function(a, b) {
        $b36288e2db101ba3$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b36288e2db101ba3$var$ti(4194308, 4, $b36288e2db101ba3$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $b36288e2db101ba3$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $b36288e2db101ba3$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $b36288e2db101ba3$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $b36288e2db101ba3$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $b36288e2db101ba3$var$Gi.bind(null, $b36288e2db101ba3$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $b36288e2db101ba3$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $b36288e2db101ba3$var$qi,
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        return $b36288e2db101ba3$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$qi(!1), b = a[0];
        a = $b36288e2db101ba3$var$Ei.bind(null, a[1]);
        $b36288e2db101ba3$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $b36288e2db101ba3$var$N, e = $b36288e2db101ba3$var$ci();
        if ($b36288e2db101ba3$var$I) {
            if (void 0 === c) throw Error($b36288e2db101ba3$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $b36288e2db101ba3$var$R) throw Error($b36288e2db101ba3$var$p(349));
            0 !== ($b36288e2db101ba3$var$Rh & 30) || $b36288e2db101ba3$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $b36288e2db101ba3$var$vi($b36288e2db101ba3$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $b36288e2db101ba3$var$li(9, $b36288e2db101ba3$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $b36288e2db101ba3$var$ci(), b = $b36288e2db101ba3$var$R.identifierPrefix;
        if ($b36288e2db101ba3$var$I) {
            var c = $b36288e2db101ba3$var$sg;
            var d = $b36288e2db101ba3$var$rg;
            c = (d & ~(1 << 32 - $b36288e2db101ba3$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $b36288e2db101ba3$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $b36288e2db101ba3$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Zh = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Bi,
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$ji,
    useImperativeHandle: $b36288e2db101ba3$var$zi,
    useInsertionEffect: $b36288e2db101ba3$var$wi,
    useLayoutEffect: $b36288e2db101ba3$var$xi,
    useMemo: $b36288e2db101ba3$var$Ci,
    useReducer: $b36288e2db101ba3$var$fi,
    useRef: $b36288e2db101ba3$var$si,
    useState: function() {
        return $b36288e2db101ba3$var$fi($b36288e2db101ba3$var$ei);
    },
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$di();
        return $b36288e2db101ba3$var$Di(b, $b36288e2db101ba3$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$fi($b36288e2db101ba3$var$ei)[0], b = $b36288e2db101ba3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$hi,
    useSyncExternalStore: $b36288e2db101ba3$var$ii,
    useId: $b36288e2db101ba3$var$Fi,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$$h = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Bi,
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$ji,
    useImperativeHandle: $b36288e2db101ba3$var$zi,
    useInsertionEffect: $b36288e2db101ba3$var$wi,
    useLayoutEffect: $b36288e2db101ba3$var$xi,
    useMemo: $b36288e2db101ba3$var$Ci,
    useReducer: $b36288e2db101ba3$var$gi,
    useRef: $b36288e2db101ba3$var$si,
    useState: function() {
        return $b36288e2db101ba3$var$gi($b36288e2db101ba3$var$ei);
    },
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$di();
        return null === $b36288e2db101ba3$var$O ? b.memoizedState = a : $b36288e2db101ba3$var$Di(b, $b36288e2db101ba3$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$gi($b36288e2db101ba3$var$ei)[0], b = $b36288e2db101ba3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$hi,
    useSyncExternalStore: $b36288e2db101ba3$var$ii,
    useId: $b36288e2db101ba3$var$Fi,
    unstable_isNewReconciler: !1
};
function $b36288e2db101ba3$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $b36288e2db101ba3$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $b36288e2db101ba3$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $b36288e2db101ba3$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b36288e2db101ba3$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $b36288e2db101ba3$var$Oi(a, b, c) {
    c = $b36288e2db101ba3$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b36288e2db101ba3$var$Pi || ($b36288e2db101ba3$var$Pi = !0, $b36288e2db101ba3$var$Qi = d);
        $b36288e2db101ba3$var$Mi(a, b);
    };
    return c;
}
function $b36288e2db101ba3$var$Ri(a, b, c) {
    c = $b36288e2db101ba3$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $b36288e2db101ba3$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $b36288e2db101ba3$var$Mi(a, b);
        "function" !== typeof d && (null === $b36288e2db101ba3$var$Si ? $b36288e2db101ba3$var$Si = new Set([
            this
        ]) : $b36288e2db101ba3$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $b36288e2db101ba3$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $b36288e2db101ba3$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $b36288e2db101ba3$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $b36288e2db101ba3$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $b36288e2db101ba3$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $b36288e2db101ba3$var$ch(-1, 1), b.tag = 2, $b36288e2db101ba3$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $b36288e2db101ba3$var$Xi = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$Ug = !1;
function $b36288e2db101ba3$var$Yi(a, b, c, d) {
    b.child = null === a ? $b36288e2db101ba3$var$Ch(b, null, c, d) : $b36288e2db101ba3$var$Bh(b, a.child, c, d);
}
function $b36288e2db101ba3$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b36288e2db101ba3$var$Tg(b, e);
    d = $b36288e2db101ba3$var$Xh(a, b, c, d, f, e);
    c = $b36288e2db101ba3$var$bi();
    if (null !== a && !$b36288e2db101ba3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$$i(a, b, e);
    $b36288e2db101ba3$var$I && c && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Yi(a, b, d, e);
    return b.child;
}
function $b36288e2db101ba3$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$b36288e2db101ba3$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $b36288e2db101ba3$var$cj(a, b, f, d, e);
        a = $b36288e2db101ba3$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $b36288e2db101ba3$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $b36288e2db101ba3$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $b36288e2db101ba3$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b36288e2db101ba3$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($b36288e2db101ba3$var$Ie(f, d) && a.ref === b.ref) {
            if ($b36288e2db101ba3$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($b36288e2db101ba3$var$Ug = !0);
            else return b.lanes = a.lanes, $b36288e2db101ba3$var$$i(a, b, e);
        }
    }
    return $b36288e2db101ba3$var$dj(a, b, c, d, e);
}
function $b36288e2db101ba3$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj);
            $b36288e2db101ba3$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= d;
    $b36288e2db101ba3$var$Yi(a, b, e, c);
    return b.child;
}
function $b36288e2db101ba3$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $b36288e2db101ba3$var$dj(a, b, c, d, e) {
    var f = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current;
    f = $b36288e2db101ba3$var$Yf(b, f);
    $b36288e2db101ba3$var$Tg(b, e);
    c = $b36288e2db101ba3$var$Xh(a, b, c, d, f, e);
    d = $b36288e2db101ba3$var$bi();
    if (null !== a && !$b36288e2db101ba3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$$i(a, b, e);
    $b36288e2db101ba3$var$I && d && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Yi(a, b, c, e);
    return b.child;
}
function $b36288e2db101ba3$var$ij(a, b, c, d, e) {
    if ($b36288e2db101ba3$var$Zf(c)) {
        var f = !0;
        $b36288e2db101ba3$var$cg(b);
    } else f = !1;
    $b36288e2db101ba3$var$Tg(b, e);
    if (null === b.stateNode) $b36288e2db101ba3$var$jj(a, b), $b36288e2db101ba3$var$ph(b, c, d), $b36288e2db101ba3$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b36288e2db101ba3$var$Vg(l) : (l = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, l = $b36288e2db101ba3$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b36288e2db101ba3$var$qh(b, g, d, l);
        $b36288e2db101ba3$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$$g ? ("function" === typeof m && ($b36288e2db101ba3$var$kh(b, c, m, d), k = b.memoizedState), (h = $b36288e2db101ba3$var$$g || $b36288e2db101ba3$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $b36288e2db101ba3$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b36288e2db101ba3$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $b36288e2db101ba3$var$Vg(k) : (k = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, k = $b36288e2db101ba3$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $b36288e2db101ba3$var$qh(b, g, d, k);
        $b36288e2db101ba3$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$$g ? ("function" === typeof y && ($b36288e2db101ba3$var$kh(b, c, y, d), n = b.memoizedState), (l = $b36288e2db101ba3$var$$g || $b36288e2db101ba3$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $b36288e2db101ba3$var$kj(a, b, c, d, f, e);
}
function $b36288e2db101ba3$var$kj(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $b36288e2db101ba3$var$dg(b, c, !1), $b36288e2db101ba3$var$$i(a, b, f);
    d = b.stateNode;
    $b36288e2db101ba3$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $b36288e2db101ba3$var$Bh(b, a.child, null, f), b.child = $b36288e2db101ba3$var$Bh(b, null, h, f)) : $b36288e2db101ba3$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $b36288e2db101ba3$var$dg(b, c, !0);
    return b.child;
}
function $b36288e2db101ba3$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $b36288e2db101ba3$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b36288e2db101ba3$var$ag(a, b.context, !1);
    $b36288e2db101ba3$var$Ih(a, b.containerInfo);
}
function $b36288e2db101ba3$var$mj(a, b, c, d, e) {
    $b36288e2db101ba3$var$Ig();
    $b36288e2db101ba3$var$Jg(e);
    b.flags |= 256;
    $b36288e2db101ba3$var$Yi(a, b, c, d);
    return b.child;
}
var $b36288e2db101ba3$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b36288e2db101ba3$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $b36288e2db101ba3$var$pj(a, b, c) {
    var d = b.pendingProps, e = $b36288e2db101ba3$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, e & 1);
    if (null === a) {
        $b36288e2db101ba3$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $b36288e2db101ba3$var$qj(g, d, 0, null), a = $b36288e2db101ba3$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $b36288e2db101ba3$var$oj(c), b.memoizedState = $b36288e2db101ba3$var$nj, a) : $b36288e2db101ba3$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $b36288e2db101ba3$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $b36288e2db101ba3$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $b36288e2db101ba3$var$wh(h, f) : (f = $b36288e2db101ba3$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $b36288e2db101ba3$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $b36288e2db101ba3$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $b36288e2db101ba3$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $b36288e2db101ba3$var$rj(a, b) {
    b = $b36288e2db101ba3$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $b36288e2db101ba3$var$tj(a, b, c, d) {
    null !== d && $b36288e2db101ba3$var$Jg(d);
    $b36288e2db101ba3$var$Bh(b, a.child, null, c);
    a = $b36288e2db101ba3$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $b36288e2db101ba3$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $b36288e2db101ba3$var$Li(Error($b36288e2db101ba3$var$p(422))), $b36288e2db101ba3$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $b36288e2db101ba3$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $b36288e2db101ba3$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $b36288e2db101ba3$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $b36288e2db101ba3$var$oj(g);
        b.memoizedState = $b36288e2db101ba3$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $b36288e2db101ba3$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($b36288e2db101ba3$var$p(419));
        d = $b36288e2db101ba3$var$Li(f, d, void 0);
        return $b36288e2db101ba3$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($b36288e2db101ba3$var$Ug || h) {
        d = $b36288e2db101ba3$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $b36288e2db101ba3$var$Zg(a, e), $b36288e2db101ba3$var$mh(d, a, e, -1));
        }
        $b36288e2db101ba3$var$uj();
        d = $b36288e2db101ba3$var$Li(Error($b36288e2db101ba3$var$p(421)));
        return $b36288e2db101ba3$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $b36288e2db101ba3$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(e.nextSibling);
    $b36288e2db101ba3$var$xg = b;
    $b36288e2db101ba3$var$I = !0;
    $b36288e2db101ba3$var$zg = null;
    null !== a && ($b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg, $b36288e2db101ba3$var$rg = a.id, $b36288e2db101ba3$var$sg = a.overflow, $b36288e2db101ba3$var$qg = b);
    b = $b36288e2db101ba3$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $b36288e2db101ba3$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $b36288e2db101ba3$var$Sg(a.return, b, c);
}
function $b36288e2db101ba3$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $b36288e2db101ba3$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b36288e2db101ba3$var$Yi(a, b, d.children, c);
    d = $b36288e2db101ba3$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b36288e2db101ba3$var$wj(a, c, b);
            else if (19 === a.tag) $b36288e2db101ba3$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b36288e2db101ba3$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b36288e2db101ba3$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b36288e2db101ba3$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b36288e2db101ba3$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $b36288e2db101ba3$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $b36288e2db101ba3$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b36288e2db101ba3$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($b36288e2db101ba3$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $b36288e2db101ba3$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b36288e2db101ba3$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $b36288e2db101ba3$var$lj(b);
            $b36288e2db101ba3$var$Ig();
            break;
        case 5:
            $b36288e2db101ba3$var$Kh(b);
            break;
        case 1:
            $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$cg(b);
            break;
        case 4:
            $b36288e2db101ba3$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $b36288e2db101ba3$var$pj(a, b, c);
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1);
                a = $b36288e2db101ba3$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $b36288e2db101ba3$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $b36288e2db101ba3$var$ej(a, b, c);
    }
    return $b36288e2db101ba3$var$$i(a, b, c);
}
var $b36288e2db101ba3$var$Aj, $b36288e2db101ba3$var$Bj, $b36288e2db101ba3$var$Cj, $b36288e2db101ba3$var$Dj;
$b36288e2db101ba3$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b36288e2db101ba3$var$Bj = function() {};
$b36288e2db101ba3$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $b36288e2db101ba3$var$Ya(a, e);
                d = $b36288e2db101ba3$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $b36288e2db101ba3$var$A({}, e, {
                    value: void 0
                });
                d = $b36288e2db101ba3$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b36288e2db101ba3$var$gb(a, e);
                d = $b36288e2db101ba3$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
        }
        $b36288e2db101ba3$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b36288e2db101ba3$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b36288e2db101ba3$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b36288e2db101ba3$var$Ej(a, b) {
    if (!$b36288e2db101ba3$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b36288e2db101ba3$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $b36288e2db101ba3$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b36288e2db101ba3$var$S(b), null;
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 3:
            d = b.stateNode;
            $b36288e2db101ba3$var$Jh();
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
            $b36288e2db101ba3$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b36288e2db101ba3$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Gj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null));
            $b36288e2db101ba3$var$Bj(a, b);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 5:
            $b36288e2db101ba3$var$Lh(b);
            var e = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b36288e2db101ba3$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                    $b36288e2db101ba3$var$S(b);
                    return null;
                }
                a = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    d[$b36288e2db101ba3$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $b36288e2db101ba3$var$D("cancel", d);
                            $b36288e2db101ba3$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], d);
                            break;
                        case "source":
                            $b36288e2db101ba3$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b36288e2db101ba3$var$D("error", d);
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "details":
                            $b36288e2db101ba3$var$D("toggle", d);
                            break;
                        case "input":
                            $b36288e2db101ba3$var$Za(d, f);
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$hb(d, f), $b36288e2db101ba3$var$D("invalid", d);
                    }
                    $b36288e2db101ba3$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $b36288e2db101ba3$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $b36288e2db101ba3$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $b36288e2db101ba3$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $b36288e2db101ba3$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b36288e2db101ba3$var$Of] = b;
                    a[$b36288e2db101ba3$var$Pf] = d;
                    $b36288e2db101ba3$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $b36288e2db101ba3$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $b36288e2db101ba3$var$D("cancel", a);
                                $b36288e2db101ba3$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $b36288e2db101ba3$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $b36288e2db101ba3$var$D("error", a);
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $b36288e2db101ba3$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $b36288e2db101ba3$var$Za(a, d);
                                e = $b36288e2db101ba3$var$Ya(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $b36288e2db101ba3$var$A({}, d, {
                                    value: void 0
                                });
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$hb(a, d);
                                e = $b36288e2db101ba3$var$gb(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $b36288e2db101ba3$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $b36288e2db101ba3$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b36288e2db101ba3$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b36288e2db101ba3$var$ob(a, k) : "number" === typeof k && $b36288e2db101ba3$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b36288e2db101ba3$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $b36288e2db101ba3$var$D("scroll", a) : null != k && $b36288e2db101ba3$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $b36288e2db101ba3$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $b36288e2db101ba3$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b36288e2db101ba3$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $b36288e2db101ba3$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                c = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
                $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $b36288e2db101ba3$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$b36288e2db101ba3$var$Of] = b, b.stateNode = d;
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($b36288e2db101ba3$var$I && null !== $b36288e2db101ba3$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $b36288e2db101ba3$var$Hg(), $b36288e2db101ba3$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $b36288e2db101ba3$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($b36288e2db101ba3$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($b36288e2db101ba3$var$p(317));
                        f[$b36288e2db101ba3$var$Of] = b;
                    } else $b36288e2db101ba3$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $b36288e2db101ba3$var$S(b);
                    f = !1;
                } else null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Gj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($b36288e2db101ba3$var$M.current & 1) ? 0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 3) : $b36288e2db101ba3$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 4:
            return $b36288e2db101ba3$var$Jh(), $b36288e2db101ba3$var$Bj(a, b), null === a && $b36288e2db101ba3$var$sf(b.stateNode.containerInfo), $b36288e2db101ba3$var$S(b), null;
        case 10:
            return $b36288e2db101ba3$var$Rg(b.type._context), $b36288e2db101ba3$var$S(b), null;
        case 17:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 19:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            f = b.memoizedState;
            if (null === f) return $b36288e2db101ba3$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $b36288e2db101ba3$var$Ej(f, !1);
                else {
                    if (0 !== $b36288e2db101ba3$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $b36288e2db101ba3$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $b36288e2db101ba3$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $b36288e2db101ba3$var$B() > $b36288e2db101ba3$var$Hj && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $b36288e2db101ba3$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $b36288e2db101ba3$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$S(b), null;
                    } else 2 * $b36288e2db101ba3$var$B() - f.renderingStartTime > $b36288e2db101ba3$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $b36288e2db101ba3$var$B(), b.sibling = null, c = $b36288e2db101ba3$var$M.current, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, d ? c & 1 | 2 : c & 1), b;
            $b36288e2db101ba3$var$S(b);
            return null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($b36288e2db101ba3$var$gj & 1073741824) && ($b36288e2db101ba3$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $b36288e2db101ba3$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
}
function $b36288e2db101ba3$var$Jj(a, b) {
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $b36288e2db101ba3$var$Jh(), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $b36288e2db101ba3$var$Lh(b), null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($b36288e2db101ba3$var$p(340));
                $b36288e2db101ba3$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M), null;
        case 4:
            return $b36288e2db101ba3$var$Jh(), null;
        case 10:
            return $b36288e2db101ba3$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$Kj = !1, $b36288e2db101ba3$var$U = !1, $b36288e2db101ba3$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $b36288e2db101ba3$var$V = null;
function $b36288e2db101ba3$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $b36288e2db101ba3$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $b36288e2db101ba3$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $b36288e2db101ba3$var$W(a, b, d);
    }
}
var $b36288e2db101ba3$var$Oj = !1;
function $b36288e2db101ba3$var$Pj(a, b) {
    $b36288e2db101ba3$var$Cf = $b36288e2db101ba3$var$dd;
    a = $b36288e2db101ba3$var$Me();
    if ($b36288e2db101ba3$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $b36288e2db101ba3$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $b36288e2db101ba3$var$dd = !1;
    for($b36288e2db101ba3$var$V = b; null !== $b36288e2db101ba3$var$V;)if (b = $b36288e2db101ba3$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $b36288e2db101ba3$var$V = a;
    else for(; null !== $b36288e2db101ba3$var$V;){
        b = $b36288e2db101ba3$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $b36288e2db101ba3$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(163));
            }
        } catch (F) {
            $b36288e2db101ba3$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $b36288e2db101ba3$var$V = a;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
    n = $b36288e2db101ba3$var$Oj;
    $b36288e2db101ba3$var$Oj = !1;
    return n;
}
function $b36288e2db101ba3$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $b36288e2db101ba3$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $b36288e2db101ba3$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $b36288e2db101ba3$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $b36288e2db101ba3$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $b36288e2db101ba3$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$b36288e2db101ba3$var$Of], delete b[$b36288e2db101ba3$var$Pf], delete b[$b36288e2db101ba3$var$of], delete b[$b36288e2db101ba3$var$Qf], delete b[$b36288e2db101ba3$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $b36288e2db101ba3$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b36288e2db101ba3$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $b36288e2db101ba3$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $b36288e2db101ba3$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b36288e2db101ba3$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling;
}
function $b36288e2db101ba3$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Xj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Xj(a, b, c), a = a.sibling;
}
var $b36288e2db101ba3$var$X = null, $b36288e2db101ba3$var$Yj = !1;
function $b36288e2db101ba3$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$b36288e2db101ba3$var$ak(a, b, c), c = c.sibling;
}
function $b36288e2db101ba3$var$ak(a, b, c) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberUnmount) try {
        $b36288e2db101ba3$var$lc.onCommitFiberUnmount($b36288e2db101ba3$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Mj(c, b);
        case 6:
            var d = $b36288e2db101ba3$var$X, e = $b36288e2db101ba3$var$Yj;
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Zj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Yj = e;
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Yj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $b36288e2db101ba3$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Yj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? $b36288e2db101ba3$var$Kf(a.parentNode, c) : 1 === a.nodeType && $b36288e2db101ba3$var$Kf(a, c), $b36288e2db101ba3$var$bd(a)) : $b36288e2db101ba3$var$Kf($b36288e2db101ba3$var$X, c.stateNode));
            break;
        case 4:
            d = $b36288e2db101ba3$var$X;
            e = $b36288e2db101ba3$var$Yj;
            $b36288e2db101ba3$var$X = c.stateNode.containerInfo;
            $b36288e2db101ba3$var$Yj = !0;
            $b36288e2db101ba3$var$Zj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$b36288e2db101ba3$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $b36288e2db101ba3$var$Nj(c, b, g) : 0 !== (f & 4) && $b36288e2db101ba3$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 1:
            if (!$b36288e2db101ba3$var$U && ($b36288e2db101ba3$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $b36288e2db101ba3$var$W(c, b, h);
            }
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 21:
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($b36288e2db101ba3$var$U = (d = $b36288e2db101ba3$var$U) || null !== c.memoizedState, $b36288e2db101ba3$var$Zj(a, b, c), $b36288e2db101ba3$var$U = d) : $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        default:
            $b36288e2db101ba3$var$Zj(a, b, c);
    }
}
function $b36288e2db101ba3$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b36288e2db101ba3$var$Lj);
        b.forEach(function(b) {
            var d = $b36288e2db101ba3$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $b36288e2db101ba3$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $b36288e2db101ba3$var$X = h.stateNode;
                        $b36288e2db101ba3$var$Yj = !1;
                        break a;
                    case 3:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Yj = !0;
                        break a;
                    case 4:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $b36288e2db101ba3$var$X) throw Error($b36288e2db101ba3$var$p(160));
            $b36288e2db101ba3$var$ak(f, g, e);
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $b36288e2db101ba3$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$b36288e2db101ba3$var$ek(b, a), b = b.sibling;
}
function $b36288e2db101ba3$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4) {
                try {
                    $b36288e2db101ba3$var$Qj(3, a, a.return), $b36288e2db101ba3$var$Rj(3, a);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
                try {
                    $b36288e2db101ba3$var$Qj(5, a, a.return);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Mj(c, c.return);
            break;
        case 5:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $b36288e2db101ba3$var$ob(e, "");
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $b36288e2db101ba3$var$ab(e, f);
                    $b36288e2db101ba3$var$vb(h, g);
                    var l = $b36288e2db101ba3$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $b36288e2db101ba3$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $b36288e2db101ba3$var$nb(e, q) : "children" === m ? $b36288e2db101ba3$var$ob(e, q) : $b36288e2db101ba3$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $b36288e2db101ba3$var$bb(e, f);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $b36288e2db101ba3$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $b36288e2db101ba3$var$fb(e, !!f.multiple, f.defaultValue, !0) : $b36288e2db101ba3$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$b36288e2db101ba3$var$Pf] = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($b36288e2db101ba3$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $b36288e2db101ba3$var$bd(b.containerInfo);
            } catch (t) {
                $b36288e2db101ba3$var$W(a, a.return, t);
            }
            break;
        case 4:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            break;
        case 13:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($b36288e2db101ba3$var$gk = $b36288e2db101ba3$var$B()));
            d & 4 && $b36288e2db101ba3$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($b36288e2db101ba3$var$U = (l = $b36288e2db101ba3$var$U) || m, $b36288e2db101ba3$var$dk(b, a), $b36288e2db101ba3$var$U = l) : $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($b36288e2db101ba3$var$V = a, m = a.child; null !== m;){
                    for(q = $b36288e2db101ba3$var$V = m; null !== $b36288e2db101ba3$var$V;){
                        r = $b36288e2db101ba3$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $b36288e2db101ba3$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $b36288e2db101ba3$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $b36288e2db101ba3$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $b36288e2db101ba3$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $b36288e2db101ba3$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $b36288e2db101ba3$var$V = y) : $b36288e2db101ba3$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $b36288e2db101ba3$var$rb("display", g));
                            } catch (t) {
                                $b36288e2db101ba3$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $b36288e2db101ba3$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 4 && $b36288e2db101ba3$var$bk(a);
            break;
        case 21:
            break;
        default:
            $b36288e2db101ba3$var$dk(b, a), $b36288e2db101ba3$var$fk(a);
    }
}
function $b36288e2db101ba3$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($b36288e2db101ba3$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($b36288e2db101ba3$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($b36288e2db101ba3$var$ob(e, ""), d.flags &= -33);
                    var f = $b36288e2db101ba3$var$Vj(a);
                    $b36288e2db101ba3$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $b36288e2db101ba3$var$Vj(a);
                    $b36288e2db101ba3$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(161));
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $b36288e2db101ba3$var$ik(a, b, c) {
    $b36288e2db101ba3$var$V = a;
    $b36288e2db101ba3$var$jk(a, b, c);
}
function $b36288e2db101ba3$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $b36288e2db101ba3$var$V;){
        var e = $b36288e2db101ba3$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $b36288e2db101ba3$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $b36288e2db101ba3$var$U;
                h = $b36288e2db101ba3$var$Kj;
                var l = $b36288e2db101ba3$var$U;
                $b36288e2db101ba3$var$Kj = g;
                if (($b36288e2db101ba3$var$U = k) && !l) for($b36288e2db101ba3$var$V = e; null !== $b36288e2db101ba3$var$V;)g = $b36288e2db101ba3$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $b36288e2db101ba3$var$kk(e) : null !== k ? (k.return = g, $b36288e2db101ba3$var$V = k) : $b36288e2db101ba3$var$kk(e);
                for(; null !== f;)$b36288e2db101ba3$var$V = f, $b36288e2db101ba3$var$jk(f, b, c), f = f.sibling;
                $b36288e2db101ba3$var$V = e;
                $b36288e2db101ba3$var$Kj = h;
                $b36288e2db101ba3$var$U = l;
            }
            $b36288e2db101ba3$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $b36288e2db101ba3$var$V = f) : $b36288e2db101ba3$var$lk(a, b, c);
    }
}
function $b36288e2db101ba3$var$lk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$b36288e2db101ba3$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $b36288e2db101ba3$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $b36288e2db101ba3$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $b36288e2db101ba3$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $b36288e2db101ba3$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($b36288e2db101ba3$var$p(163));
                }
                $b36288e2db101ba3$var$U || b.flags & 512 && $b36288e2db101ba3$var$Sj(b);
            } catch (r) {
                $b36288e2db101ba3$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$hk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$kk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $b36288e2db101ba3$var$Rj(4, b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $b36288e2db101ba3$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $b36288e2db101ba3$var$Sj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $b36288e2db101ba3$var$Sj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(b, b.return, k);
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $b36288e2db101ba3$var$V = h;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
var $b36288e2db101ba3$var$mk = Math.ceil, $b36288e2db101ba3$var$nk = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$ok = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$pk = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$K = 0, $b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Y = null, $b36288e2db101ba3$var$Z = 0, $b36288e2db101ba3$var$gj = 0, $b36288e2db101ba3$var$fj = $b36288e2db101ba3$var$Uf(0), $b36288e2db101ba3$var$T = 0, $b36288e2db101ba3$var$qk = null, $b36288e2db101ba3$var$hh = 0, $b36288e2db101ba3$var$rk = 0, $b36288e2db101ba3$var$sk = 0, $b36288e2db101ba3$var$tk = null, $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$gk = 0, $b36288e2db101ba3$var$Hj = Infinity, $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Pi = !1, $b36288e2db101ba3$var$Qi = null, $b36288e2db101ba3$var$Si = null, $b36288e2db101ba3$var$wk = !1, $b36288e2db101ba3$var$xk = null, $b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = null, $b36288e2db101ba3$var$Bk = -1, $b36288e2db101ba3$var$Ck = 0;
function $b36288e2db101ba3$var$L() {
    return 0 !== ($b36288e2db101ba3$var$K & 6) ? $b36288e2db101ba3$var$B() : -1 !== $b36288e2db101ba3$var$Bk ? $b36288e2db101ba3$var$Bk : $b36288e2db101ba3$var$Bk = $b36288e2db101ba3$var$B();
}
function $b36288e2db101ba3$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($b36288e2db101ba3$var$K & 2) && 0 !== $b36288e2db101ba3$var$Z) return $b36288e2db101ba3$var$Z & -$b36288e2db101ba3$var$Z;
    if (null !== $b36288e2db101ba3$var$Kg.transition) return 0 === $b36288e2db101ba3$var$Ck && ($b36288e2db101ba3$var$Ck = $b36288e2db101ba3$var$yc()), $b36288e2db101ba3$var$Ck;
    a = $b36288e2db101ba3$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $b36288e2db101ba3$var$jd(a.type);
    return a;
}
function $b36288e2db101ba3$var$mh(a, b, c, d) {
    if (50 < $b36288e2db101ba3$var$zk) throw $b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = null, Error($b36288e2db101ba3$var$p(185));
    $b36288e2db101ba3$var$Ac(a, c, d);
    if (0 === ($b36288e2db101ba3$var$K & 2) || a !== $b36288e2db101ba3$var$R) a === $b36288e2db101ba3$var$R && (0 === ($b36288e2db101ba3$var$K & 2) && ($b36288e2db101ba3$var$rk |= c), 4 === $b36288e2db101ba3$var$T && $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$Z)), $b36288e2db101ba3$var$Ek(a, d), 1 === c && 0 === $b36288e2db101ba3$var$K && 0 === (b.mode & 1) && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
}
function $b36288e2db101ba3$var$Ek(a, b) {
    var c = a.callbackNode;
    $b36288e2db101ba3$var$wc(a, b);
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$R ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) null !== c && $b36288e2db101ba3$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $b36288e2db101ba3$var$bc(c);
        if (1 === b) 0 === a.tag ? $b36288e2db101ba3$var$ig($b36288e2db101ba3$var$Fk.bind(null, a)) : $b36288e2db101ba3$var$hg($b36288e2db101ba3$var$Fk.bind(null, a)), $b36288e2db101ba3$var$Jf(function() {
            0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
        }), c = null;
        else {
            switch($b36288e2db101ba3$var$Dc(d)){
                case 1:
                    c = $b36288e2db101ba3$var$fc;
                    break;
                case 4:
                    c = $b36288e2db101ba3$var$gc;
                    break;
                case 16:
                    c = $b36288e2db101ba3$var$hc;
                    break;
                case 536870912:
                    c = $b36288e2db101ba3$var$jc;
                    break;
                default:
                    c = $b36288e2db101ba3$var$hc;
            }
            c = $b36288e2db101ba3$var$Gk(c, $b36288e2db101ba3$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b36288e2db101ba3$var$Hk(a, b) {
    $b36288e2db101ba3$var$Bk = -1;
    $b36288e2db101ba3$var$Ck = 0;
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    var c = a.callbackNode;
    if ($b36288e2db101ba3$var$Ik() && a.callbackNode !== c) return null;
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$R ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $b36288e2db101ba3$var$Jk(a, d);
    else {
        b = d;
        var e = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 2;
        var f = $b36288e2db101ba3$var$Kk();
        if ($b36288e2db101ba3$var$R !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$Lk(a, b);
        for(;;)try {
            $b36288e2db101ba3$var$Mk();
            break;
        } catch (h) {
            $b36288e2db101ba3$var$Nk(a, h);
        }
        $b36288e2db101ba3$var$Qg();
        $b36288e2db101ba3$var$nk.current = f;
        $b36288e2db101ba3$var$K = e;
        null !== $b36288e2db101ba3$var$Y ? b = 0 : ($b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Z = 0, b = $b36288e2db101ba3$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $b36288e2db101ba3$var$xc(a), 0 !== e && (d = e, b = $b36288e2db101ba3$var$Ok(a, e)));
        if (1 === b) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, d), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
        if (6 === b) $b36288e2db101ba3$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$b36288e2db101ba3$var$Pk(e) && (b = $b36288e2db101ba3$var$Jk(a, d), 2 === b && (f = $b36288e2db101ba3$var$xc(a), 0 !== f && (d = f, b = $b36288e2db101ba3$var$Ok(a, f))), 1 === b)) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, d), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($b36288e2db101ba3$var$p(345));
                case 2:
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 3:
                    $b36288e2db101ba3$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $b36288e2db101ba3$var$gk + 500 - $b36288e2db101ba3$var$B(), 10 < b)) {
                        if (0 !== $b36288e2db101ba3$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $b36288e2db101ba3$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Qk.bind(null, a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk), b);
                        break;
                    }
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 4:
                    $b36288e2db101ba3$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $b36288e2db101ba3$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $b36288e2db101ba3$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $b36288e2db101ba3$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Qk.bind(null, a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk), d);
                        break;
                    }
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 5:
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(329));
            }
        }
    }
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    return a.callbackNode === c ? $b36288e2db101ba3$var$Hk.bind(null, a) : null;
}
function $b36288e2db101ba3$var$Ok(a, b) {
    var c = $b36288e2db101ba3$var$tk;
    a.current.memoizedState.isDehydrated && ($b36288e2db101ba3$var$Lk(a, b).flags |= 256);
    a = $b36288e2db101ba3$var$Jk(a, b);
    2 !== a && (b = $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$uk = c, null !== b && $b36288e2db101ba3$var$Gj(b));
    return a;
}
function $b36288e2db101ba3$var$Gj(a) {
    null === $b36288e2db101ba3$var$uk ? $b36288e2db101ba3$var$uk = a : $b36288e2db101ba3$var$uk.push.apply($b36288e2db101ba3$var$uk, a);
}
function $b36288e2db101ba3$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$b36288e2db101ba3$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $b36288e2db101ba3$var$Dk(a, b) {
    b &= ~$b36288e2db101ba3$var$sk;
    b &= ~$b36288e2db101ba3$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b36288e2db101ba3$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b36288e2db101ba3$var$Fk(a) {
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    $b36288e2db101ba3$var$Ik();
    var b = $b36288e2db101ba3$var$uc(a, 0);
    if (0 === (b & 1)) return $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), null;
    var c = $b36288e2db101ba3$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $b36288e2db101ba3$var$xc(a);
        0 !== d && (b = d, c = $b36288e2db101ba3$var$Ok(a, d));
    }
    if (1 === c) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, b), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
    if (6 === c) throw Error($b36288e2db101ba3$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    return null;
}
function $b36288e2db101ba3$var$Rk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    try {
        return a(b);
    } finally{
        $b36288e2db101ba3$var$K = c, 0 === $b36288e2db101ba3$var$K && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
    }
}
function $b36288e2db101ba3$var$Sk(a) {
    null !== $b36288e2db101ba3$var$xk && 0 === $b36288e2db101ba3$var$xk.tag && 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$Ik();
    var b = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    var c = $b36288e2db101ba3$var$pk.transition, d = $b36288e2db101ba3$var$C;
    try {
        if ($b36288e2db101ba3$var$pk.transition = null, $b36288e2db101ba3$var$C = 1, a) return a();
    } finally{
        $b36288e2db101ba3$var$C = d, $b36288e2db101ba3$var$pk.transition = c, $b36288e2db101ba3$var$K = b, 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
    }
}
function $b36288e2db101ba3$var$Ij() {
    $b36288e2db101ba3$var$gj = $b36288e2db101ba3$var$fj.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$fj);
}
function $b36288e2db101ba3$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b36288e2db101ba3$var$Gf(c));
    if (null !== $b36288e2db101ba3$var$Y) for(c = $b36288e2db101ba3$var$Y.return; null !== c;){
        var d = c;
        $b36288e2db101ba3$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b36288e2db101ba3$var$$f();
                break;
            case 3:
                $b36288e2db101ba3$var$Jh();
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
                $b36288e2db101ba3$var$Oh();
                break;
            case 5:
                $b36288e2db101ba3$var$Lh(d);
                break;
            case 4:
                $b36288e2db101ba3$var$Jh();
                break;
            case 13:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
                break;
            case 19:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
                break;
            case 10:
                $b36288e2db101ba3$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $b36288e2db101ba3$var$Ij();
        }
        c = c.return;
    }
    $b36288e2db101ba3$var$R = a;
    $b36288e2db101ba3$var$Y = a = $b36288e2db101ba3$var$wh(a.current, null);
    $b36288e2db101ba3$var$Z = $b36288e2db101ba3$var$gj = b;
    $b36288e2db101ba3$var$T = 0;
    $b36288e2db101ba3$var$qk = null;
    $b36288e2db101ba3$var$sk = $b36288e2db101ba3$var$rk = $b36288e2db101ba3$var$hh = 0;
    $b36288e2db101ba3$var$uk = $b36288e2db101ba3$var$tk = null;
    if (null !== $b36288e2db101ba3$var$Wg) {
        for(b = 0; b < $b36288e2db101ba3$var$Wg.length; b++)if (c = $b36288e2db101ba3$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $b36288e2db101ba3$var$Wg = null;
    }
    return a;
}
function $b36288e2db101ba3$var$Nk(a, b) {
    do {
        var c = $b36288e2db101ba3$var$Y;
        try {
            $b36288e2db101ba3$var$Qg();
            $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$ai;
            if ($b36288e2db101ba3$var$Sh) {
                for(var d = $b36288e2db101ba3$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b36288e2db101ba3$var$Sh = !1;
            }
            $b36288e2db101ba3$var$Rh = 0;
            $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
            $b36288e2db101ba3$var$Th = !1;
            $b36288e2db101ba3$var$Uh = 0;
            $b36288e2db101ba3$var$ok.current = null;
            if (null === c || null === c.return) {
                $b36288e2db101ba3$var$T = 1;
                $b36288e2db101ba3$var$qk = b;
                $b36288e2db101ba3$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $b36288e2db101ba3$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $b36288e2db101ba3$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $b36288e2db101ba3$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $b36288e2db101ba3$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $b36288e2db101ba3$var$Ti(f, l, b);
                            $b36288e2db101ba3$var$uj();
                            break a;
                        }
                        k = Error($b36288e2db101ba3$var$p(426));
                    }
                } else if ($b36288e2db101ba3$var$I && h.mode & 1) {
                    var J = $b36288e2db101ba3$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $b36288e2db101ba3$var$Wi(J, g, h, f, b);
                        $b36288e2db101ba3$var$Jg($b36288e2db101ba3$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $b36288e2db101ba3$var$Ki(k, h);
                4 !== $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 2);
                null === $b36288e2db101ba3$var$tk ? $b36288e2db101ba3$var$tk = [
                    f
                ] : $b36288e2db101ba3$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $b36288e2db101ba3$var$Oi(f, k, b);
                            $b36288e2db101ba3$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $b36288e2db101ba3$var$Si || !$b36288e2db101ba3$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $b36288e2db101ba3$var$Ri(f, h, b);
                                $b36288e2db101ba3$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $b36288e2db101ba3$var$Tk(c);
        } catch (na) {
            b = na;
            $b36288e2db101ba3$var$Y === c && null !== c && ($b36288e2db101ba3$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b36288e2db101ba3$var$Kk() {
    var a = $b36288e2db101ba3$var$nk.current;
    $b36288e2db101ba3$var$nk.current = $b36288e2db101ba3$var$ai;
    return null === a ? $b36288e2db101ba3$var$ai : a;
}
function $b36288e2db101ba3$var$uj() {
    if (0 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T || 2 === $b36288e2db101ba3$var$T) $b36288e2db101ba3$var$T = 4;
    null === $b36288e2db101ba3$var$R || 0 === ($b36288e2db101ba3$var$hh & 268435455) && 0 === ($b36288e2db101ba3$var$rk & 268435455) || $b36288e2db101ba3$var$Dk($b36288e2db101ba3$var$R, $b36288e2db101ba3$var$Z);
}
function $b36288e2db101ba3$var$Jk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 2;
    var d = $b36288e2db101ba3$var$Kk();
    if ($b36288e2db101ba3$var$R !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Lk(a, b);
    for(;;)try {
        $b36288e2db101ba3$var$Uk();
        break;
    } catch (e) {
        $b36288e2db101ba3$var$Nk(a, e);
    }
    $b36288e2db101ba3$var$Qg();
    $b36288e2db101ba3$var$K = c;
    $b36288e2db101ba3$var$nk.current = d;
    if (null !== $b36288e2db101ba3$var$Y) throw Error($b36288e2db101ba3$var$p(261));
    $b36288e2db101ba3$var$R = null;
    $b36288e2db101ba3$var$Z = 0;
    return $b36288e2db101ba3$var$T;
}
function $b36288e2db101ba3$var$Uk() {
    for(; null !== $b36288e2db101ba3$var$Y;)$b36288e2db101ba3$var$Vk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Mk() {
    for(; null !== $b36288e2db101ba3$var$Y && !$b36288e2db101ba3$var$cc();)$b36288e2db101ba3$var$Vk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Vk(a) {
    var b = $b36288e2db101ba3$var$Wk(a.alternate, a, $b36288e2db101ba3$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b36288e2db101ba3$var$Tk(a) : $b36288e2db101ba3$var$Y = b;
    $b36288e2db101ba3$var$ok.current = null;
}
function $b36288e2db101ba3$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $b36288e2db101ba3$var$Fj(c, b, $b36288e2db101ba3$var$gj), null !== c) {
                $b36288e2db101ba3$var$Y = c;
                return;
            }
        } else {
            c = $b36288e2db101ba3$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $b36288e2db101ba3$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $b36288e2db101ba3$var$T = 6;
                $b36288e2db101ba3$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $b36288e2db101ba3$var$Y = b;
            return;
        }
        $b36288e2db101ba3$var$Y = b = a;
    }while (null !== b);
    0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 5);
}
function $b36288e2db101ba3$var$Qk(a, b, c) {
    var d = $b36288e2db101ba3$var$C, e = $b36288e2db101ba3$var$pk.transition;
    try {
        $b36288e2db101ba3$var$pk.transition = null, $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$Xk(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$pk.transition = e, $b36288e2db101ba3$var$C = d;
    }
    return null;
}
function $b36288e2db101ba3$var$Xk(a, b, c, d) {
    do $b36288e2db101ba3$var$Ik();
    while (null !== $b36288e2db101ba3$var$xk);
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b36288e2db101ba3$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $b36288e2db101ba3$var$Bc(a, f);
    a === $b36288e2db101ba3$var$R && ($b36288e2db101ba3$var$Y = $b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $b36288e2db101ba3$var$wk || ($b36288e2db101ba3$var$wk = !0, $b36288e2db101ba3$var$Gk($b36288e2db101ba3$var$hc, function() {
        $b36288e2db101ba3$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $b36288e2db101ba3$var$pk.transition;
        $b36288e2db101ba3$var$pk.transition = null;
        var g = $b36288e2db101ba3$var$C;
        $b36288e2db101ba3$var$C = 1;
        var h = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 4;
        $b36288e2db101ba3$var$ok.current = null;
        $b36288e2db101ba3$var$Pj(a, c);
        $b36288e2db101ba3$var$ek(c, a);
        $b36288e2db101ba3$var$Oe($b36288e2db101ba3$var$Df);
        $b36288e2db101ba3$var$dd = !!$b36288e2db101ba3$var$Cf;
        $b36288e2db101ba3$var$Df = $b36288e2db101ba3$var$Cf = null;
        a.current = c;
        $b36288e2db101ba3$var$ik(c, a, e);
        $b36288e2db101ba3$var$dc();
        $b36288e2db101ba3$var$K = h;
        $b36288e2db101ba3$var$C = g;
        $b36288e2db101ba3$var$pk.transition = f;
    } else a.current = c;
    $b36288e2db101ba3$var$wk && ($b36288e2db101ba3$var$wk = !1, $b36288e2db101ba3$var$xk = a, $b36288e2db101ba3$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($b36288e2db101ba3$var$Si = null);
    $b36288e2db101ba3$var$mc(c.stateNode, d);
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($b36288e2db101ba3$var$Pi) throw $b36288e2db101ba3$var$Pi = !1, a = $b36288e2db101ba3$var$Qi, $b36288e2db101ba3$var$Qi = null, a;
    0 !== ($b36288e2db101ba3$var$yk & 1) && 0 !== a.tag && $b36288e2db101ba3$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $b36288e2db101ba3$var$Ak ? $b36288e2db101ba3$var$zk++ : ($b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = a) : $b36288e2db101ba3$var$zk = 0;
    $b36288e2db101ba3$var$jg();
    return null;
}
function $b36288e2db101ba3$var$Ik() {
    if (null !== $b36288e2db101ba3$var$xk) {
        var a = $b36288e2db101ba3$var$Dc($b36288e2db101ba3$var$yk), b = $b36288e2db101ba3$var$pk.transition, c = $b36288e2db101ba3$var$C;
        try {
            $b36288e2db101ba3$var$pk.transition = null;
            $b36288e2db101ba3$var$C = 16 > a ? 16 : a;
            if (null === $b36288e2db101ba3$var$xk) var d = !1;
            else {
                a = $b36288e2db101ba3$var$xk;
                $b36288e2db101ba3$var$xk = null;
                $b36288e2db101ba3$var$yk = 0;
                if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(331));
                var e = $b36288e2db101ba3$var$K;
                $b36288e2db101ba3$var$K |= 4;
                for($b36288e2db101ba3$var$V = a.current; null !== $b36288e2db101ba3$var$V;){
                    var f = $b36288e2db101ba3$var$V, g = f.child;
                    if (0 !== ($b36288e2db101ba3$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($b36288e2db101ba3$var$V = l; null !== $b36288e2db101ba3$var$V;){
                                    var m = $b36288e2db101ba3$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $b36288e2db101ba3$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $b36288e2db101ba3$var$V = q;
                                    else for(; null !== $b36288e2db101ba3$var$V;){
                                        m = $b36288e2db101ba3$var$V;
                                        var r = m.sibling, y = m.return;
                                        $b36288e2db101ba3$var$Tj(m);
                                        if (m === l) {
                                            $b36288e2db101ba3$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $b36288e2db101ba3$var$V = r;
                                            break;
                                        }
                                        $b36288e2db101ba3$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $b36288e2db101ba3$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $b36288e2db101ba3$var$V = g;
                    else b: for(; null !== $b36288e2db101ba3$var$V;){
                        f = $b36288e2db101ba3$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $b36288e2db101ba3$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $b36288e2db101ba3$var$V = x;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = f.return;
                    }
                }
                var w = a.current;
                for($b36288e2db101ba3$var$V = w; null !== $b36288e2db101ba3$var$V;){
                    g = $b36288e2db101ba3$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $b36288e2db101ba3$var$V = u;
                    else b: for(g = w; null !== $b36288e2db101ba3$var$V;){
                        h = $b36288e2db101ba3$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $b36288e2db101ba3$var$Rj(9, h);
                            }
                        } catch (na) {
                            $b36288e2db101ba3$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $b36288e2db101ba3$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $b36288e2db101ba3$var$V = F;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = h.return;
                    }
                }
                $b36288e2db101ba3$var$K = e;
                $b36288e2db101ba3$var$jg();
                if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onPostCommitFiberRoot) try {
                    $b36288e2db101ba3$var$lc.onPostCommitFiberRoot($b36288e2db101ba3$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$pk.transition = b;
        }
    }
    return !1;
}
function $b36288e2db101ba3$var$Yk(a, b, c) {
    b = $b36288e2db101ba3$var$Ki(c, b);
    b = $b36288e2db101ba3$var$Oi(a, b, 1);
    a = $b36288e2db101ba3$var$dh(a, b, 1);
    b = $b36288e2db101ba3$var$L();
    null !== a && ($b36288e2db101ba3$var$Ac(a, 1, b), $b36288e2db101ba3$var$Ek(a, b));
}
function $b36288e2db101ba3$var$W(a, b, c) {
    if (3 === a.tag) $b36288e2db101ba3$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $b36288e2db101ba3$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b36288e2db101ba3$var$Si || !$b36288e2db101ba3$var$Si.has(d))) {
                a = $b36288e2db101ba3$var$Ki(c, a);
                a = $b36288e2db101ba3$var$Ri(b, a, 1);
                b = $b36288e2db101ba3$var$dh(b, a, 1);
                a = $b36288e2db101ba3$var$L();
                null !== b && ($b36288e2db101ba3$var$Ac(b, 1, a), $b36288e2db101ba3$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $b36288e2db101ba3$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b36288e2db101ba3$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $b36288e2db101ba3$var$R === a && ($b36288e2db101ba3$var$Z & c) === c && (4 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$Z & 130023424) === $b36288e2db101ba3$var$Z && 500 > $b36288e2db101ba3$var$B() - $b36288e2db101ba3$var$gk ? $b36288e2db101ba3$var$Lk(a, 0) : $b36288e2db101ba3$var$sk |= c);
    $b36288e2db101ba3$var$Ek(a, b);
}
function $b36288e2db101ba3$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $b36288e2db101ba3$var$sc, $b36288e2db101ba3$var$sc <<= 1, 0 === ($b36288e2db101ba3$var$sc & 130023424) && ($b36288e2db101ba3$var$sc = 4194304)));
    var c = $b36288e2db101ba3$var$L();
    a = $b36288e2db101ba3$var$Zg(a, b);
    null !== a && ($b36288e2db101ba3$var$Ac(a, b, c), $b36288e2db101ba3$var$Ek(a, c));
}
function $b36288e2db101ba3$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $b36288e2db101ba3$var$Zk(a, c);
}
function $b36288e2db101ba3$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($b36288e2db101ba3$var$p(314));
    }
    null !== d && d.delete(b);
    $b36288e2db101ba3$var$Zk(a, c);
}
var $b36288e2db101ba3$var$Wk;
$b36288e2db101ba3$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b36288e2db101ba3$var$Wf.current) $b36288e2db101ba3$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $b36288e2db101ba3$var$Ug = !1, $b36288e2db101ba3$var$zj(a, b, c);
            $b36288e2db101ba3$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $b36288e2db101ba3$var$Ug = !1, $b36288e2db101ba3$var$I && 0 !== (b.flags & 1048576) && $b36288e2db101ba3$var$ug(b, $b36288e2db101ba3$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $b36288e2db101ba3$var$jj(a, b);
            a = b.pendingProps;
            var e = $b36288e2db101ba3$var$Yf(b, $b36288e2db101ba3$var$H.current);
            $b36288e2db101ba3$var$Tg(b, c);
            e = $b36288e2db101ba3$var$Xh(null, b, d, a, e, c);
            var f = $b36288e2db101ba3$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $b36288e2db101ba3$var$Zf(d) ? (f = !0, $b36288e2db101ba3$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $b36288e2db101ba3$var$ah(b), e.updater = $b36288e2db101ba3$var$nh, b.stateNode = e, e._reactInternals = b, $b36288e2db101ba3$var$rh(b, d, a, c), b = $b36288e2db101ba3$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $b36288e2db101ba3$var$I && f && $b36288e2db101ba3$var$vg(b), $b36288e2db101ba3$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $b36288e2db101ba3$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $b36288e2db101ba3$var$$k(d);
                a = $b36288e2db101ba3$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $b36288e2db101ba3$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $b36288e2db101ba3$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $b36288e2db101ba3$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $b36288e2db101ba3$var$aj(null, b, d, $b36288e2db101ba3$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($b36288e2db101ba3$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $b36288e2db101ba3$var$lj(b);
                if (null === a) throw Error($b36288e2db101ba3$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $b36288e2db101ba3$var$bh(a, b);
                $b36288e2db101ba3$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(423)), b);
                        b = $b36288e2db101ba3$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(424)), b);
                        b = $b36288e2db101ba3$var$mj(a, b, d, c, e);
                        break a;
                    } else for($b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.stateNode.containerInfo.firstChild), $b36288e2db101ba3$var$xg = b, $b36288e2db101ba3$var$I = !0, $b36288e2db101ba3$var$zg = null, c = $b36288e2db101ba3$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $b36288e2db101ba3$var$Ig();
                    if (d === e) {
                        b = $b36288e2db101ba3$var$$i(a, b, c);
                        break a;
                    }
                    $b36288e2db101ba3$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $b36288e2db101ba3$var$Kh(b), null === a && $b36288e2db101ba3$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b36288e2db101ba3$var$Ef(d, e) ? g = null : null !== f && $b36288e2db101ba3$var$Ef(d, f) && (b.flags |= 32), $b36288e2db101ba3$var$hj(a, b), $b36288e2db101ba3$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $b36288e2db101ba3$var$Eg(b), null;
        case 13:
            return $b36288e2db101ba3$var$pj(a, b, c);
        case 4:
            return $b36288e2db101ba3$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b36288e2db101ba3$var$Bh(b, null, d, c) : $b36288e2db101ba3$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$Zi(a, b, d, e, c);
        case 7:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($b36288e2db101ba3$var$He(f.value, g)) {
                        if (f.children === e.children && !$b36288e2db101ba3$var$Wf.current) {
                            b = $b36288e2db101ba3$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $b36288e2db101ba3$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $b36288e2db101ba3$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($b36288e2db101ba3$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $b36288e2db101ba3$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $b36288e2db101ba3$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $b36288e2db101ba3$var$Tg(b, c), e = $b36288e2db101ba3$var$Vg(e), d = d(e), b.flags |= 1, $b36288e2db101ba3$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $b36288e2db101ba3$var$Lg(d, b.pendingProps), e = $b36288e2db101ba3$var$Lg(d.type, e), $b36288e2db101ba3$var$aj(a, b, d, e, c);
        case 15:
            return $b36288e2db101ba3$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$jj(a, b), b.tag = 1, $b36288e2db101ba3$var$Zf(d) ? (a = !0, $b36288e2db101ba3$var$cg(b)) : a = !1, $b36288e2db101ba3$var$Tg(b, c), $b36288e2db101ba3$var$ph(b, d, e), $b36288e2db101ba3$var$rh(b, d, e, c), $b36288e2db101ba3$var$kj(null, b, d, !0, a, c);
        case 19:
            return $b36288e2db101ba3$var$yj(a, b, c);
        case 22:
            return $b36288e2db101ba3$var$ej(a, b, c);
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
};
function $b36288e2db101ba3$var$Gk(a, b) {
    return $b36288e2db101ba3$var$ac(a, b);
}
function $b36288e2db101ba3$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b36288e2db101ba3$var$Bg(a, b, c, d) {
    return new $b36288e2db101ba3$var$al(a, b, c, d);
}
function $b36288e2db101ba3$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b36288e2db101ba3$var$$k(a) {
    if ("function" === typeof a) return $b36288e2db101ba3$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b36288e2db101ba3$var$Da) return 11;
        if (a === $b36288e2db101ba3$var$Ga) return 14;
    }
    return 2;
}
function $b36288e2db101ba3$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $b36288e2db101ba3$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $b36288e2db101ba3$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b36288e2db101ba3$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b36288e2db101ba3$var$ya:
            return $b36288e2db101ba3$var$Ah(c.children, e, f, b);
        case $b36288e2db101ba3$var$za:
            g = 8;
            e |= 8;
            break;
        case $b36288e2db101ba3$var$Aa:
            return a = $b36288e2db101ba3$var$Bg(12, c, b, e | 2), a.elementType = $b36288e2db101ba3$var$Aa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ea:
            return a = $b36288e2db101ba3$var$Bg(13, c, b, e), a.elementType = $b36288e2db101ba3$var$Ea, a.lanes = f, a;
        case $b36288e2db101ba3$var$Fa:
            return a = $b36288e2db101ba3$var$Bg(19, c, b, e), a.elementType = $b36288e2db101ba3$var$Fa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ia:
            return $b36288e2db101ba3$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b36288e2db101ba3$var$Ba:
                    g = 10;
                    break a;
                case $b36288e2db101ba3$var$Ca:
                    g = 9;
                    break a;
                case $b36288e2db101ba3$var$Da:
                    g = 11;
                    break a;
                case $b36288e2db101ba3$var$Ga:
                    g = 14;
                    break a;
                case $b36288e2db101ba3$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($b36288e2db101ba3$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $b36288e2db101ba3$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b36288e2db101ba3$var$Ah(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$qj(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(22, a, d, b);
    a.elementType = $b36288e2db101ba3$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $b36288e2db101ba3$var$xh(a, b, c) {
    a = $b36288e2db101ba3$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$zh(a, b, c) {
    b = $b36288e2db101ba3$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b36288e2db101ba3$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $b36288e2db101ba3$var$zc(0);
    this.expirationTimes = $b36288e2db101ba3$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b36288e2db101ba3$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $b36288e2db101ba3$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $b36288e2db101ba3$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $b36288e2db101ba3$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $b36288e2db101ba3$var$ah(f);
    return a;
}
function $b36288e2db101ba3$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b36288e2db101ba3$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b36288e2db101ba3$var$el(a) {
    if (!a) return $b36288e2db101ba3$var$Vf;
    a = a._reactInternals;
    a: {
        if ($b36288e2db101ba3$var$Vb(a) !== a || 1 !== a.tag) throw Error($b36288e2db101ba3$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($b36288e2db101ba3$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($b36288e2db101ba3$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($b36288e2db101ba3$var$Zf(c)) return $b36288e2db101ba3$var$bg(a, c, b);
    }
    return b;
}
function $b36288e2db101ba3$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $b36288e2db101ba3$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $b36288e2db101ba3$var$el(null);
    c = a.current;
    d = $b36288e2db101ba3$var$L();
    e = $b36288e2db101ba3$var$lh(c);
    f = $b36288e2db101ba3$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $b36288e2db101ba3$var$dh(c, f, e);
    a.current.lanes = e;
    $b36288e2db101ba3$var$Ac(a, e, d);
    $b36288e2db101ba3$var$Ek(a, d);
    return a;
}
function $b36288e2db101ba3$var$gl(a, b, c, d) {
    var e = b.current, f = $b36288e2db101ba3$var$L(), g = $b36288e2db101ba3$var$lh(e);
    c = $b36288e2db101ba3$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b36288e2db101ba3$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $b36288e2db101ba3$var$dh(e, b, g);
    null !== a && ($b36288e2db101ba3$var$mh(a, e, g, f), $b36288e2db101ba3$var$eh(a, e, g));
    return g;
}
function $b36288e2db101ba3$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b36288e2db101ba3$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b36288e2db101ba3$var$jl(a, b) {
    $b36288e2db101ba3$var$il(a, b);
    (a = a.alternate) && $b36288e2db101ba3$var$il(a, b);
}
function $b36288e2db101ba3$var$kl() {
    return null;
}
var $b36288e2db101ba3$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $b36288e2db101ba3$var$ml(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$nl.prototype.render = $b36288e2db101ba3$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($b36288e2db101ba3$var$p(409));
    $b36288e2db101ba3$var$gl(a, b, null, null);
};
$b36288e2db101ba3$var$nl.prototype.unmount = $b36288e2db101ba3$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $b36288e2db101ba3$var$Sk(function() {
            $b36288e2db101ba3$var$gl(null, a, null, null);
        });
        b[$b36288e2db101ba3$var$uf] = null;
    }
};
function $b36288e2db101ba3$var$nl(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $b36288e2db101ba3$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $b36288e2db101ba3$var$Qc.length && 0 !== b && b < $b36288e2db101ba3$var$Qc[c].priority; c++);
        $b36288e2db101ba3$var$Qc.splice(c, 0, a);
        0 === c && $b36288e2db101ba3$var$Vc(a);
    }
};
function $b36288e2db101ba3$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $b36288e2db101ba3$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b36288e2db101ba3$var$ql() {}
function $b36288e2db101ba3$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $b36288e2db101ba3$var$hl(g);
                f.call(a);
            };
        }
        var g = $b36288e2db101ba3$var$fl(b, d, a, 0, null, !1, !1, "", $b36288e2db101ba3$var$ql);
        a._reactRootContainer = g;
        a[$b36288e2db101ba3$var$uf] = g.current;
        $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
        $b36288e2db101ba3$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $b36288e2db101ba3$var$hl(k);
            h.call(a);
        };
    }
    var k = $b36288e2db101ba3$var$cl(a, 0, !1, null, null, !1, !1, "", $b36288e2db101ba3$var$ql);
    a._reactRootContainer = k;
    a[$b36288e2db101ba3$var$uf] = k.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    $b36288e2db101ba3$var$Sk(function() {
        $b36288e2db101ba3$var$gl(b, k, c, d);
    });
    return k;
}
function $b36288e2db101ba3$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $b36288e2db101ba3$var$hl(g);
                h.call(a);
            };
        }
        $b36288e2db101ba3$var$gl(b, g, a, e);
    } else g = $b36288e2db101ba3$var$rl(c, b, a, e, d);
    return $b36288e2db101ba3$var$hl(g);
}
$b36288e2db101ba3$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $b36288e2db101ba3$var$tc(b.pendingLanes);
                0 !== c && ($b36288e2db101ba3$var$Cc(b, c | 1), $b36288e2db101ba3$var$Ek(b, $b36288e2db101ba3$var$B()), 0 === ($b36288e2db101ba3$var$K & 6) && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$jg()));
            }
            break;
        case 13:
            $b36288e2db101ba3$var$Sk(function() {
                var b = $b36288e2db101ba3$var$Zg(a, 1);
                if (null !== b) {
                    var c = $b36288e2db101ba3$var$L();
                    $b36288e2db101ba3$var$mh(b, a, 1, c);
                }
            }), $b36288e2db101ba3$var$jl(a, 1);
    }
};
$b36288e2db101ba3$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $b36288e2db101ba3$var$L();
            $b36288e2db101ba3$var$mh(b, a, 134217728, c);
        }
        $b36288e2db101ba3$var$jl(a, 134217728);
    }
};
$b36288e2db101ba3$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$lh(a), c = $b36288e2db101ba3$var$Zg(a, b);
        if (null !== c) {
            var d = $b36288e2db101ba3$var$L();
            $b36288e2db101ba3$var$mh(c, a, b, d);
        }
        $b36288e2db101ba3$var$jl(a, b);
    }
};
$b36288e2db101ba3$var$Hc = function() {
    return $b36288e2db101ba3$var$C;
};
$b36288e2db101ba3$var$Ic = function(a, b) {
    var c = $b36288e2db101ba3$var$C;
    try {
        return $b36288e2db101ba3$var$C = a, b();
    } finally{
        $b36288e2db101ba3$var$C = c;
    }
};
$b36288e2db101ba3$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $b36288e2db101ba3$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b36288e2db101ba3$var$Db(d);
                        if (!e) throw Error($b36288e2db101ba3$var$p(90));
                        $b36288e2db101ba3$var$Wa(d);
                        $b36288e2db101ba3$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b36288e2db101ba3$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $b36288e2db101ba3$var$fb(a, !!c.multiple, b, !1);
    }
};
$b36288e2db101ba3$var$Gb = $b36288e2db101ba3$var$Rk;
$b36288e2db101ba3$var$Hb = $b36288e2db101ba3$var$Sk;
var $b36288e2db101ba3$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $b36288e2db101ba3$var$Cb,
        $b36288e2db101ba3$var$ue,
        $b36288e2db101ba3$var$Db,
        $b36288e2db101ba3$var$Eb,
        $b36288e2db101ba3$var$Fb,
        $b36288e2db101ba3$var$Rk
    ]
}, $b36288e2db101ba3$var$ul = {
    findFiberByHostInstance: $b36288e2db101ba3$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $b36288e2db101ba3$var$vl = {
    bundleType: $b36288e2db101ba3$var$ul.bundleType,
    version: $b36288e2db101ba3$var$ul.version,
    rendererPackageName: $b36288e2db101ba3$var$ul.rendererPackageName,
    rendererConfig: $b36288e2db101ba3$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b36288e2db101ba3$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $b36288e2db101ba3$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b36288e2db101ba3$var$ul.findFiberByHostInstance || $b36288e2db101ba3$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b36288e2db101ba3$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b36288e2db101ba3$var$wl.isDisabled && $b36288e2db101ba3$var$wl.supportsFiber) try {
        $b36288e2db101ba3$var$kc = $b36288e2db101ba3$var$wl.inject($b36288e2db101ba3$var$vl), $b36288e2db101ba3$var$lc = $b36288e2db101ba3$var$wl;
    } catch (a) {}
}
$b36288e2db101ba3$export$ae55be85d98224ed = $b36288e2db101ba3$var$tl;
$b36288e2db101ba3$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b36288e2db101ba3$var$ol(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$dl(a, b, null, c);
};
$b36288e2db101ba3$export$882461b6382ed46c = function(a, b) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(299));
    var c = !1, d = "", e = $b36288e2db101ba3$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $b36288e2db101ba3$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $b36288e2db101ba3$var$ml(b);
};
$b36288e2db101ba3$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b36288e2db101ba3$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($b36288e2db101ba3$var$p(268, a));
    }
    a = $b36288e2db101ba3$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b36288e2db101ba3$export$cd75ccfd720a3cd4 = function(a) {
    return $b36288e2db101ba3$var$Sk(a);
};
$b36288e2db101ba3$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b36288e2db101ba3$var$pl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$sl(null, a, b, !0, c);
};
$b36288e2db101ba3$export$757ceba2d55c277e = function(a, b, c) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $b36288e2db101ba3$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $b36288e2db101ba3$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $b36288e2db101ba3$var$nl(b);
};
$b36288e2db101ba3$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b36288e2db101ba3$var$pl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$sl(null, a, b, !1, c);
};
$b36288e2db101ba3$export$502457920280e6be = function(a) {
    if (!$b36288e2db101ba3$var$pl(a)) throw Error($b36288e2db101ba3$var$p(40));
    return a._reactRootContainer ? ($b36288e2db101ba3$var$Sk(function() {
        $b36288e2db101ba3$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b36288e2db101ba3$var$uf] = null;
        });
    }), !0) : !1;
};
$b36288e2db101ba3$export$c78a37762a8d58e1 = $b36288e2db101ba3$var$Rk;
$b36288e2db101ba3$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b36288e2db101ba3$var$pl(c)) throw Error($b36288e2db101ba3$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b36288e2db101ba3$var$p(38));
    return $b36288e2db101ba3$var$sl(a, b, c, !1, d);
};
$b36288e2db101ba3$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("4LCdk", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8BKFp"));

});
parcelRequire.register("8BKFp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6445fa7f31ec0ca5$export$c4744153514ff05d; }, function (v) { return $6445fa7f31ec0ca5$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7; }, function (v) { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875; }, function (v) { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6445fa7f31ec0ca5$export$502329bbf4b505b1; }, function (v) { return $6445fa7f31ec0ca5$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6445fa7f31ec0ca5$export$6e3807111c4874c4; }, function (v) { return $6445fa7f31ec0ca5$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6445fa7f31ec0ca5$export$c27134553091fb3a; }, function (v) { return $6445fa7f31ec0ca5$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2; }, function (v) { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2; }, function (v) { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62; }, function (v) { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b; }, function (v) { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555; }, function (v) { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6445fa7f31ec0ca5$export$839f9183b0465a69; }, function (v) { return $6445fa7f31ec0ca5$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6445fa7f31ec0ca5$export$72fdf0e06517287b; }, function (v) { return $6445fa7f31ec0ca5$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4; }, function (v) { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1; }, function (v) { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0; }, function (v) { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f; }, function (v) { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed; }, function (v) { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6445fa7f31ec0ca5$export$cf845f2c119da08a; }, function (v) { return $6445fa7f31ec0ca5$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6445fa7f31ec0ca5$export$c4744153514ff05d;
var $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7;
var $6445fa7f31ec0ca5$export$e26fe2ed2fa76875;
var $6445fa7f31ec0ca5$export$502329bbf4b505b1;
var $6445fa7f31ec0ca5$export$6e3807111c4874c4;
var $6445fa7f31ec0ca5$export$c27134553091fb3a;
var $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2;
var $6445fa7f31ec0ca5$export$b00a404bbd5edef2;
var $6445fa7f31ec0ca5$export$8352ce38b91d0c62;
var $6445fa7f31ec0ca5$export$d66a1c1c77bd778b;
var $6445fa7f31ec0ca5$export$d3dfb8e4810cb555;
var $6445fa7f31ec0ca5$export$839f9183b0465a69;
var $6445fa7f31ec0ca5$export$72fdf0e06517287b;
var $6445fa7f31ec0ca5$export$4b844e58a3e414b4;
var $6445fa7f31ec0ca5$export$816d2913ae6b83b1;
var $6445fa7f31ec0ca5$export$61bcfe829111a1d0;
var $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f;
var $6445fa7f31ec0ca5$export$b5836b71941fa3ed;
var $6445fa7f31ec0ca5$export$cf845f2c119da08a;
"use strict";
function $6445fa7f31ec0ca5$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $6445fa7f31ec0ca5$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6445fa7f31ec0ca5$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $6445fa7f31ec0ca5$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $6445fa7f31ec0ca5$var$g(C, c)) n < e && 0 > $6445fa7f31ec0ca5$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $6445fa7f31ec0ca5$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $6445fa7f31ec0ca5$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6445fa7f31ec0ca5$var$l = performance;
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$l.now();
    };
} else {
    var $6445fa7f31ec0ca5$var$p = Date, $6445fa7f31ec0ca5$var$q = $6445fa7f31ec0ca5$var$p.now();
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$p.now() - $6445fa7f31ec0ca5$var$q;
    };
}
var $6445fa7f31ec0ca5$var$r = [], $6445fa7f31ec0ca5$var$t = [], $6445fa7f31ec0ca5$var$u = 1, $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = 3, $6445fa7f31ec0ca5$var$z = !1, $6445fa7f31ec0ca5$var$A = !1, $6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$D = "function" === typeof setTimeout ? setTimeout : null, $6445fa7f31ec0ca5$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $6445fa7f31ec0ca5$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $6445fa7f31ec0ca5$var$G(a) {
    for(var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t); null !== b;){
        if (null === b.callback) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t);
        else if (b.startTime <= a) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t), b.sortIndex = b.expirationTime, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, b);
        else break;
        b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
    }
}
function $6445fa7f31ec0ca5$var$H(a) {
    $6445fa7f31ec0ca5$var$B = !1;
    $6445fa7f31ec0ca5$var$G(a);
    if (!$6445fa7f31ec0ca5$var$A) {
        if (null !== $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r)) $6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J);
        else {
            var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== b && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, b.startTime - a);
        }
    }
}
function $6445fa7f31ec0ca5$var$J(a, b) {
    $6445fa7f31ec0ca5$var$A = !1;
    $6445fa7f31ec0ca5$var$B && ($6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1);
    $6445fa7f31ec0ca5$var$z = !0;
    var c = $6445fa7f31ec0ca5$var$y;
    try {
        $6445fa7f31ec0ca5$var$G(b);
        for($6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r); null !== $6445fa7f31ec0ca5$var$v && (!($6445fa7f31ec0ca5$var$v.expirationTime > b) || a && !$6445fa7f31ec0ca5$var$M());){
            var d = $6445fa7f31ec0ca5$var$v.callback;
            if ("function" === typeof d) {
                $6445fa7f31ec0ca5$var$v.callback = null;
                $6445fa7f31ec0ca5$var$y = $6445fa7f31ec0ca5$var$v.priorityLevel;
                var e = d($6445fa7f31ec0ca5$var$v.expirationTime <= b);
                b = $6445fa7f31ec0ca5$export$c4744153514ff05d();
                "function" === typeof e ? $6445fa7f31ec0ca5$var$v.callback = e : $6445fa7f31ec0ca5$var$v === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
                $6445fa7f31ec0ca5$var$G(b);
            } else $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
            $6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
        }
        if (null !== $6445fa7f31ec0ca5$var$v) var w = !0;
        else {
            var m = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== m && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = c, $6445fa7f31ec0ca5$var$z = !1;
    }
}
var $6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null, $6445fa7f31ec0ca5$var$L = -1, $6445fa7f31ec0ca5$var$P = 5, $6445fa7f31ec0ca5$var$Q = -1;
function $6445fa7f31ec0ca5$var$M() {
    return $6445fa7f31ec0ca5$export$c4744153514ff05d() - $6445fa7f31ec0ca5$var$Q < $6445fa7f31ec0ca5$var$P ? !1 : !0;
}
function $6445fa7f31ec0ca5$var$R() {
    if (null !== $6445fa7f31ec0ca5$var$O) {
        var a = $6445fa7f31ec0ca5$export$c4744153514ff05d();
        $6445fa7f31ec0ca5$var$Q = a;
        var b = !0;
        try {
            b = $6445fa7f31ec0ca5$var$O(!0, a);
        } finally{
            b ? $6445fa7f31ec0ca5$var$S() : ($6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null);
        }
    } else $6445fa7f31ec0ca5$var$N = !1;
}
var $6445fa7f31ec0ca5$var$S;
if ("function" === typeof $6445fa7f31ec0ca5$var$F) $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$F($6445fa7f31ec0ca5$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6445fa7f31ec0ca5$var$T = new MessageChannel, $6445fa7f31ec0ca5$var$U = $6445fa7f31ec0ca5$var$T.port2;
    $6445fa7f31ec0ca5$var$T.port1.onmessage = $6445fa7f31ec0ca5$var$R;
    $6445fa7f31ec0ca5$var$S = function() {
        $6445fa7f31ec0ca5$var$U.postMessage(null);
    };
} else $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$D($6445fa7f31ec0ca5$var$R, 0);
};
function $6445fa7f31ec0ca5$var$I(a) {
    $6445fa7f31ec0ca5$var$O = a;
    $6445fa7f31ec0ca5$var$N || ($6445fa7f31ec0ca5$var$N = !0, $6445fa7f31ec0ca5$var$S());
}
function $6445fa7f31ec0ca5$var$K(a, b) {
    $6445fa7f31ec0ca5$var$L = $6445fa7f31ec0ca5$var$D(function() {
        a($6445fa7f31ec0ca5$export$c4744153514ff05d());
    }, b);
}
$6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = 5;
$6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = 1;
$6445fa7f31ec0ca5$export$502329bbf4b505b1 = 4;
$6445fa7f31ec0ca5$export$6e3807111c4874c4 = 3;
$6445fa7f31ec0ca5$export$c27134553091fb3a = null;
$6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = 2;
$6445fa7f31ec0ca5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6445fa7f31ec0ca5$export$8352ce38b91d0c62 = function() {
    $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J));
};
$6445fa7f31ec0ca5$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6445fa7f31ec0ca5$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = function() {
    return $6445fa7f31ec0ca5$var$y;
};
$6445fa7f31ec0ca5$export$839f9183b0465a69 = function() {
    return $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
};
$6445fa7f31ec0ca5$export$72fdf0e06517287b = function(a) {
    switch($6445fa7f31ec0ca5$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6445fa7f31ec0ca5$var$y;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = b;
    try {
        return a();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$4b844e58a3e414b4 = function() {};
$6445fa7f31ec0ca5$export$816d2913ae6b83b1 = function() {};
$6445fa7f31ec0ca5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = a;
    try {
        return b();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6445fa7f31ec0ca5$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6445fa7f31ec0ca5$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$t, a), null === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && a === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t) && ($6445fa7f31ec0ca5$var$B ? ($6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1) : $6445fa7f31ec0ca5$var$B = !0, $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, c - d))) : (a.sortIndex = e, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, a), $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J)));
    return a;
};
$6445fa7f31ec0ca5$export$b5836b71941fa3ed = $6445fa7f31ec0ca5$var$M;
$6445fa7f31ec0ca5$export$cf845f2c119da08a = function(a) {
    var b = $6445fa7f31ec0ca5$var$y;
    return function() {
        var c = $6445fa7f31ec0ca5$var$y;
        $6445fa7f31ec0ca5$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6445fa7f31ec0ca5$var$y = c;
        }
    };
};

});



parcelRequire.register("10WBQ", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", function () { return $0bd3411f2ec14e23$export$9ba4e89fdfa1fc54; });
$parcel$export(module.exports, "Link", function () { return $0bd3411f2ec14e23$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "NavLink", function () { return $0bd3411f2ec14e23$export$b0d92dbee9b5b60d; });
$parcel$export(module.exports, "useNavigate", function () { return (parcelRequire("99w1R")).useNavigate; });
/**
 * React Router DOM v6.14.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $bh6RR = parcelRequire("bh6RR");

var $fSADM = parcelRequire("fSADM");
var $99w1R = parcelRequire("99w1R");

var $fSADM = parcelRequire("fSADM");
function $0bd3411f2ec14e23$var$_extends() {
    $0bd3411f2ec14e23$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0bd3411f2ec14e23$var$_extends.apply(this, arguments);
}
function $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $0bd3411f2ec14e23$var$defaultMethod = "get";
const $0bd3411f2ec14e23$var$defaultEncType = "application/x-www-form-urlencoded";
function $0bd3411f2ec14e23$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $0bd3411f2ec14e23$var$isButtonElement(object) {
    return $0bd3411f2ec14e23$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $0bd3411f2ec14e23$var$isFormElement(object) {
    return $0bd3411f2ec14e23$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $0bd3411f2ec14e23$var$isInputElement(object) {
    return $0bd3411f2ec14e23$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $0bd3411f2ec14e23$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $0bd3411f2ec14e23$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$0bd3411f2ec14e23$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $0bd3411f2ec14e23$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) {
        for (let key of defaultSearchParams.keys())if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    }
    return searchParams;
}
// One-time check for submitter support
let $0bd3411f2ec14e23$var$_formDataSupportsSubmitter = null;
function $0bd3411f2ec14e23$var$isFormDataSubmitterSupported() {
    if ($0bd3411f2ec14e23$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $0bd3411f2ec14e23$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $0bd3411f2ec14e23$var$_formDataSupportsSubmitter = true;
    }
    return $0bd3411f2ec14e23$var$_formDataSupportsSubmitter;
}
const $0bd3411f2ec14e23$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $0bd3411f2ec14e23$var$getFormEncType(encType) {
    if (encType != null && !$0bd3411f2ec14e23$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $0bd3411f2ec14e23$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($0bd3411f2ec14e23$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $fSADM.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $0bd3411f2ec14e23$var$defaultMethod;
        encType = $0bd3411f2ec14e23$var$getFormEncType(target.getAttribute("enctype")) || $0bd3411f2ec14e23$var$defaultEncType;
        formData = new FormData(target);
    } else if ($0bd3411f2ec14e23$var$isButtonElement(target) || $0bd3411f2ec14e23$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $fSADM.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $0bd3411f2ec14e23$var$defaultMethod;
        encType = $0bd3411f2ec14e23$var$getFormEncType(target.getAttribute("formenctype")) || $0bd3411f2ec14e23$var$getFormEncType(form.getAttribute("enctype")) || $0bd3411f2ec14e23$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$0bd3411f2ec14e23$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($0bd3411f2ec14e23$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $0bd3411f2ec14e23$var$defaultMethod;
        action = null;
        encType = $0bd3411f2ec14e23$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $0bd3411f2ec14e23$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $0bd3411f2ec14e23$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $0bd3411f2ec14e23$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "method",
    "action",
    "onSubmit",
    "submit",
    "relative",
    "preventScrollReset"
];
function $0bd3411f2ec14e23$export$1f3f55432a00e06d(routes, opts) {
    return (0, $fSADM.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0bd3411f2ec14e23$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $fSADM.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0bd3411f2ec14e23$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $99w1R.UNSAFE_mapRouteProperties)
    }).initialize();
}
function $0bd3411f2ec14e23$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $fSADM.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0bd3411f2ec14e23$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $fSADM.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0bd3411f2ec14e23$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $99w1R.UNSAFE_mapRouteProperties)
    }).initialize();
}
function $0bd3411f2ec14e23$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $0bd3411f2ec14e23$var$_extends({}, state, {
        errors: $0bd3411f2ec14e23$var$deserializeErrors(state.errors)
    });
    return state;
}
function $0bd3411f2ec14e23$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $fSADM.ErrorResponse)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            let error = new Error(val.message);
            // Wipe away the client-side stack trace.  Nothing to fill it in with
            // because we don't serialize SSR stack traces for security reasons
            error.stack = "";
            serialized[key] = error;
        } else serialized[key] = val;
    }
    return serialized;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $0bd3411f2ec14e23$var$START_TRANSITION = "startTransition";
const $0bd3411f2ec14e23$var$startTransitionImpl = $bh6RR[$0bd3411f2ec14e23$var$START_TRANSITION];
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $0bd3411f2ec14e23$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref;
    let historyRef = $bh6RR.useRef();
    if (historyRef.current == null) historyRef.current = (0, $fSADM.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $0bd3411f2ec14e23$var$startTransitionImpl ? $0bd3411f2ec14e23$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bh6RR.createElement((0, $99w1R.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $0bd3411f2ec14e23$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref2;
    let historyRef = $bh6RR.useRef();
    if (historyRef.current == null) historyRef.current = (0, $fSADM.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $0bd3411f2ec14e23$var$startTransitionImpl ? $0bd3411f2ec14e23$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bh6RR.createElement((0, $99w1R.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $0bd3411f2ec14e23$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, future: future, history: history } = _ref3;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $0bd3411f2ec14e23$var$startTransitionImpl ? $0bd3411f2ec14e23$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bh6RR.createElement((0, $99w1R.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $0bd3411f2ec14e23$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $0bd3411f2ec14e23$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ const $0bd3411f2ec14e23$export$a6c7ac8248d6e38a = /*#__PURE__*/ $bh6RR.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(_ref4, $0bd3411f2ec14e23$var$_excluded);
    let { basename: basename } = $bh6RR.useContext((0, $99w1R.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $0bd3411f2ec14e23$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($0bd3411f2ec14e23$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $fSADM.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $99w1R.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $0bd3411f2ec14e23$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $bh6RR.createElement("a", $0bd3411f2ec14e23$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $0bd3411f2ec14e23$export$b0d92dbee9b5b60d = /*#__PURE__*/ $bh6RR.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(_ref5, $0bd3411f2ec14e23$var$_excluded2);
    let path = (0, $99w1R.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $99w1R.useLocation)();
    let routerState = $bh6RR.useContext((0, $99w1R.UNSAFE_DataRouterStateContext));
    let { navigator: navigator } = $bh6RR.useContext((0, $99w1R.UNSAFE_NavigationContext));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$export$a6c7ac8248d6e38a, $0bd3411f2ec14e23$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $0bd3411f2ec14e23$export$a7fed597f4b8afd8 = /*#__PURE__*/ $bh6RR.forwardRef((props, ref)=>{
    let submit = $0bd3411f2ec14e23$export$47c85c6e3a081d3();
    return /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$var$FormImpl, $0bd3411f2ec14e23$var$_extends({}, props, {
        submit: submit,
        ref: ref
    }));
});
const $0bd3411f2ec14e23$var$FormImpl = /*#__PURE__*/ $bh6RR.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, method: method = $0bd3411f2ec14e23$var$defaultMethod, action: action, onSubmit: onSubmit, submit: submit, relative: relative, preventScrollReset: preventScrollReset } = _ref6, props = $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(_ref6, $0bd3411f2ec14e23$var$_excluded3);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $0bd3411f2ec14e23$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $bh6RR.createElement("form", $0bd3411f2ec14e23$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $0bd3411f2ec14e23$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $0bd3411f2ec14e23$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $0bd3411f2ec14e23$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($0bd3411f2ec14e23$var$DataRouterHook || ($0bd3411f2ec14e23$var$DataRouterHook = {}));
var $0bd3411f2ec14e23$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($0bd3411f2ec14e23$var$DataRouterStateHook || ($0bd3411f2ec14e23$var$DataRouterStateHook = {}));
function $0bd3411f2ec14e23$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $0bd3411f2ec14e23$var$useDataRouterContext(hookName) {
    let ctx = $bh6RR.useContext((0, $99w1R.UNSAFE_DataRouterContext));
    !ctx && (0, $fSADM.UNSAFE_invariant)(false);
    return ctx;
}
function $0bd3411f2ec14e23$var$useDataRouterState(hookName) {
    let state = $bh6RR.useContext((0, $99w1R.UNSAFE_DataRouterStateContext));
    !state && (0, $fSADM.UNSAFE_invariant)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $0bd3411f2ec14e23$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $99w1R.useNavigate)();
    let location = (0, $99w1R.useLocation)();
    let path = (0, $99w1R.useResolvedPath)(to, {
        relative: relative
    });
    return $bh6RR.useCallback((event)=>{
        if ($0bd3411f2ec14e23$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $fSADM.createPath)(location) === (0, $fSADM.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $0bd3411f2ec14e23$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $bh6RR.useRef($0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $bh6RR.useRef(false);
    let location = (0, $99w1R.useLocation)();
    let searchParams = $bh6RR.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $0bd3411f2ec14e23$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $99w1R.useNavigate)();
    let setSearchParams = $bh6RR.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $0bd3411f2ec14e23$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $0bd3411f2ec14e23$export$47c85c6e3a081d3() {
    let { router: router } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $bh6RR.useContext((0, $99w1R.UNSAFE_NavigationContext));
    let currentRouteId = (0, $99w1R.UNSAFE_useRouteId)();
    return $bh6RR.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $0bd3411f2ec14e23$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $0bd3411f2ec14e23$var$getFormSubmissionInfo(target, basename);
        router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            fromRouteId: currentRouteId
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
/**
 * Returns the implementation for fetcher.submit
 */ function $0bd3411f2ec14e23$var$useSubmitFetcher(fetcherKey, fetcherRouteId) {
    let { router: router } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.UseSubmitFetcher);
    let { basename: basename } = $bh6RR.useContext((0, $99w1R.UNSAFE_NavigationContext));
    return $bh6RR.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $0bd3411f2ec14e23$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $0bd3411f2ec14e23$var$getFormSubmissionInfo(target, basename);
        !(fetcherRouteId != null) && (0, $fSADM.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, fetcherRouteId, options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType
        });
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $0bd3411f2ec14e23$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $bh6RR.useContext((0, $99w1R.UNSAFE_NavigationContext));
    let routeContext = $bh6RR.useContext((0, $99w1R.UNSAFE_RouteContext));
    !routeContext && (0, $fSADM.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $0bd3411f2ec14e23$var$_extends({}, (0, $99w1R.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params and the hash of the resolved
    // URL. This is the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $99w1R.useLocation)();
    if (action == null) {
        // Safe to write to these directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        // or hash
        path.search = location.search;
        path.hash = location.hash;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $fSADM.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $fSADM.createPath)(path);
}
function $0bd3411f2ec14e23$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $bh6RR.forwardRef((props, ref)=>{
        let submit = $0bd3411f2ec14e23$var$useSubmitFetcher(fetcherKey, routeId);
        return /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$var$FormImpl, $0bd3411f2ec14e23$var$_extends({}, props, {
            ref: ref,
            submit: submit
        }));
    });
    return FetcherForm;
}
let $0bd3411f2ec14e23$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $0bd3411f2ec14e23$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.UseFetcher);
    let route = $bh6RR.useContext((0, $99w1R.UNSAFE_RouteContext));
    !route && (0, $fSADM.UNSAFE_invariant)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $fSADM.UNSAFE_invariant)(false);
    let [fetcherKey] = $bh6RR.useState(()=>String(++$0bd3411f2ec14e23$var$fetcherId));
    let [Form] = $bh6RR.useState(()=>{
        !routeId && (0, $fSADM.UNSAFE_invariant)(false);
        return $0bd3411f2ec14e23$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $bh6RR.useState(()=>(href)=>{
            !router && (0, $fSADM.UNSAFE_invariant)(false);
            !routeId && (0, $fSADM.UNSAFE_invariant)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $0bd3411f2ec14e23$var$useSubmitFetcher(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $bh6RR.useMemo(()=>$0bd3411f2ec14e23$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $bh6RR.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $0bd3411f2ec14e23$export$fa996778a3a31087() {
    let state = $0bd3411f2ec14e23$var$useDataRouterState($0bd3411f2ec14e23$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $0bd3411f2ec14e23$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $0bd3411f2ec14e23$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $0bd3411f2ec14e23$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $0bd3411f2ec14e23$var$useDataRouterState($0bd3411f2ec14e23$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $bh6RR.useContext((0, $99w1R.UNSAFE_NavigationContext));
    let location = (0, $99w1R.useLocation)();
    let matches = (0, $99w1R.useMatches)();
    let navigation = (0, $99w1R.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $bh6RR.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $0bd3411f2ec14e23$var$usePageHide($bh6RR.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $0bd3411f2ec14e23$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $0bd3411f2ec14e23$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($0bd3411f2ec14e23$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $bh6RR.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $0bd3411f2ec14e23$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $0bd3411f2ec14e23$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $bh6RR.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($0bd3411f2ec14e23$var$_extends({}, location, {
                    pathname: (0, $fSADM.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($0bd3411f2ec14e23$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $bh6RR.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(location.hash.slice(1));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0bd3411f2ec14e23$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $bh6RR.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0bd3411f2ec14e23$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $bh6RR.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $0bd3411f2ec14e23$export$39f4eb3dbd812741(_ref8) {
    let { when: when, message: message } = _ref8;
    let blocker = (0, $99w1R.unstable_useBlocker)(when);
    $bh6RR.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
    $bh6RR.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
}

});
parcelRequire.register("fSADM", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return $b8f852338811df1a$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $b8f852338811df1a$export$2b76ad033c6e6d08; });
$parcel$export(module.exports, "createPath", function () { return $b8f852338811df1a$export$fe53371bee54353d; });
$parcel$export(module.exports, "parsePath", function () { return $b8f852338811df1a$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $b8f852338811df1a$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $b8f852338811df1a$export$b71fdd3798280242; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return $b8f852338811df1a$export$3e9cee6b33872309; });
$parcel$export(module.exports, "matchRoutes", function () { return $b8f852338811df1a$export$2708184779ceb39d; });
$parcel$export(module.exports, "stripBasename", function () { return $b8f852338811df1a$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "joinPaths", function () { return $b8f852338811df1a$export$86d9a7913e44197e; });
$parcel$export(module.exports, "matchPath", function () { return $b8f852338811df1a$export$81336c211d5ff295; });
$parcel$export(module.exports, "UNSAFE_getPathContributingMatches", function () { return $b8f852338811df1a$export$90ba53ce1c7fdff2; });
$parcel$export(module.exports, "resolveTo", function () { return $b8f852338811df1a$export$cae722b0cc860f13; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return $b8f852338811df1a$export$42a99a7a4bc0e76a; });
$parcel$export(module.exports, "ErrorResponse", function () { return $b8f852338811df1a$export$acf1a680051f5031; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $b8f852338811df1a$export$972111febbeef05b; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return $b8f852338811df1a$export$386d57f03f0b2883; });
$parcel$export(module.exports, "createRouter", function () { return $b8f852338811df1a$export$baddd0131ee8c05b; });
/**
 * @remix-run/router v1.7.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $b8f852338811df1a$var$_extends() {
    $b8f852338811df1a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b8f852338811df1a$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $b8f852338811df1a$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($b8f852338811df1a$export$e19cd5f9376f8cee || ($b8f852338811df1a$export$e19cd5f9376f8cee = {}));
const $b8f852338811df1a$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $b8f852338811df1a$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $b8f852338811df1a$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $b8f852338811df1a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $b8f852338811df1a$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $b8f852338811df1a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to);
    }
    return $b8f852338811df1a$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $b8f852338811df1a$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $b8f852338811df1a$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        return $b8f852338811df1a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $b8f852338811df1a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $b8f852338811df1a$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $b8f852338811df1a$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $b8f852338811df1a$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $b8f852338811df1a$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $b8f852338811df1a$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $b8f852338811df1a$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $b8f852338811df1a$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $b8f852338811df1a$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $b8f852338811df1a$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $b8f852338811df1a$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $b8f852338811df1a$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($b8f852338811df1a$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
        let location = $b8f852338811df1a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $b8f852338811df1a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
        let location = $b8f852338811df1a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $b8f852338811df1a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to);
        $b8f852338811df1a$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($b8f852338811df1a$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($b8f852338811df1a$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $b8f852338811df1a$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($b8f852338811df1a$var$ResultType || ($b8f852338811df1a$var$ResultType = {}));
const $b8f852338811df1a$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $b8f852338811df1a$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $b8f852338811df1a$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $b8f852338811df1a$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $b8f852338811df1a$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($b8f852338811df1a$var$isIndexRoute(route)) {
            let indexRoute = $b8f852338811df1a$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $b8f852338811df1a$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $b8f852338811df1a$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $b8f852338811df1a$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $b8f852338811df1a$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $b8f852338811df1a$var$flattenRoutes(routes);
    $b8f852338811df1a$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $b8f852338811df1a$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $b8f852338811df1a$var$safelyDecodeURI(pathname));
    return matches;
}
function $b8f852338811df1a$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $b8f852338811df1a$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $b8f852338811df1a$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $b8f852338811df1a$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $b8f852338811df1a$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $b8f852338811df1a$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $b8f852338811df1a$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $b8f852338811df1a$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $b8f852338811df1a$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explodes _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $b8f852338811df1a$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $b8f852338811df1a$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $b8f852338811df1a$var$paramRe = /^:\w+$/;
const $b8f852338811df1a$var$dynamicSegmentValue = 3;
const $b8f852338811df1a$var$indexRouteValue = 2;
const $b8f852338811df1a$var$emptySegmentValue = 1;
const $b8f852338811df1a$var$staticSegmentValue = 10;
const $b8f852338811df1a$var$splatPenalty = -2;
const $b8f852338811df1a$var$isSplat = (s)=>s === "*";
function $b8f852338811df1a$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($b8f852338811df1a$var$isSplat)) initialScore += $b8f852338811df1a$var$splatPenalty;
    if (index) initialScore += $b8f852338811df1a$var$indexRouteValue;
    return segments.filter((s)=>!$b8f852338811df1a$var$isSplat(s)).reduce((score, segment)=>score + ($b8f852338811df1a$var$paramRe.test(segment) ? $b8f852338811df1a$var$dynamicSegmentValue : segment === "" ? $b8f852338811df1a$var$emptySegmentValue : $b8f852338811df1a$var$staticSegmentValue), initialScore);
}
function $b8f852338811df1a$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $b8f852338811df1a$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $b8f852338811df1a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $b8f852338811df1a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $b8f852338811df1a$export$a5c6d149b50c1d86($b8f852338811df1a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $b8f852338811df1a$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $b8f852338811df1a$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $b8f852338811df1a$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $b8f852338811df1a$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $b8f852338811df1a$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $b8f852338811df1a$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $b8f852338811df1a$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $b8f852338811df1a$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $b8f852338811df1a$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $b8f852338811df1a$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $b8f852338811df1a$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $b8f852338811df1a$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $b8f852338811df1a$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $b8f852338811df1a$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $b8f852338811df1a$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $b8f852338811df1a$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $b8f852338811df1a$var$normalizeSearch(search),
        hash: $b8f852338811df1a$var$normalizeHash(hash)
    };
}
function $b8f852338811df1a$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $b8f852338811df1a$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $b8f852338811df1a$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $b8f852338811df1a$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $b8f852338811df1a$export$8ccf933b0513f8d0(toArg);
    else {
        to = $b8f852338811df1a$var$_extends({}, toArg);
        $b8f852338811df1a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $b8f852338811df1a$var$getInvalidPathError("?", "pathname", "search", to));
        $b8f852338811df1a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $b8f852338811df1a$var$getInvalidPathError("#", "pathname", "hash", to));
        $b8f852338811df1a$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $b8f852338811df1a$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $b8f852338811df1a$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $b8f852338811df1a$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $b8f852338811df1a$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $b8f852338811df1a$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $b8f852338811df1a$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $b8f852338811df1a$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $b8f852338811df1a$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $b8f852338811df1a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $b8f852338811df1a$export$42a99a7a4bc0e76a extends Error {
}
class $b8f852338811df1a$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $b8f852338811df1a$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $b8f852338811df1a$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, null, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $b8f852338811df1a$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        if (error) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $b8f852338811df1a$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $b8f852338811df1a$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $b8f852338811df1a$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $b8f852338811df1a$var$unwrapTrackedPromise(value) {
    if (!$b8f852338811df1a$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $b8f852338811df1a$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $b8f852338811df1a$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $b8f852338811df1a$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $b8f852338811df1a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $b8f852338811df1a$export$acf1a680051f5031 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $b8f852338811df1a$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $b8f852338811df1a$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $b8f852338811df1a$var$validMutationMethods = new Set($b8f852338811df1a$var$validMutationMethodsArr);
const $b8f852338811df1a$var$validRequestMethodsArr = [
    "get",
    ...$b8f852338811df1a$var$validMutationMethodsArr
];
const $b8f852338811df1a$var$validRequestMethods = new Set($b8f852338811df1a$var$validRequestMethodsArr);
const $b8f852338811df1a$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $b8f852338811df1a$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $b8f852338811df1a$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $b8f852338811df1a$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $b8f852338811df1a$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $b8f852338811df1a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $b8f852338811df1a$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $b8f852338811df1a$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $b8f852338811df1a$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $b8f852338811df1a$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $b8f852338811df1a$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $b8f852338811df1a$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $b8f852338811df1a$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $b8f852338811df1a$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $b8f852338811df1a$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $b8f852338811df1a$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $b8f852338811df1a$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($b8f852338811df1a$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $b8f852338811df1a$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $b8f852338811df1a$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $b8f852338811df1a$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $b8f852338811df1a$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $b8f852338811df1a$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $b8f852338811df1a$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $b8f852338811df1a$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $b8f852338811df1a$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        updateState($b8f852338811df1a$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $b8f852338811df1a$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }));
        // Reset stateful navigation vars
        pendingAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $b8f852338811df1a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $b8f852338811df1a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $b8f852338811df1a$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $b8f852338811df1a$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $b8f852338811df1a$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $b8f852338811df1a$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $b8f852338811df1a$export$2708184779ceb39d(routesToUse, location, basename);
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $b8f852338811df1a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $b8f852338811df1a$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $b8f852338811df1a$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $b8f852338811df1a$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$b8f852338811df1a$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $b8f852338811df1a$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $b8f852338811df1a$var$getLoadingNavigation(location, opts.submission);
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $b8f852338811df1a$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $b8f852338811df1a$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        });
        // Call our action and get the result
        let result;
        let actionMatch = $b8f852338811df1a$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $b8f852338811df1a$var$ResultType.error,
            error: $b8f852338811df1a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $b8f852338811df1a$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($b8f852338811df1a$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($b8f852338811df1a$var$isDeferredResult(result)) throw $b8f852338811df1a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $b8f852338811df1a$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $b8f852338811df1a$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $b8f852338811df1a$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $b8f852338811df1a$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $b8f852338811df1a$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($b8f852338811df1a$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        pendingNavigationLoadId = ++incrementingLoadId;
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $b8f852338811df1a$var$findRedirect(results);
        if (redirect) {
            await startRedirectNavigation(state, redirect, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $b8f852338811df1a$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $b8f852338811df1a$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $b8f852338811df1a$export$52eace9c284d3585;
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $b8f852338811df1a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $b8f852338811df1a$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $b8f852338811df1a$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path, submission: submission, error: error } = $b8f852338811df1a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error);
            return;
        }
        let match = $b8f852338811df1a$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $b8f852338811df1a$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $b8f852338811df1a$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $b8f852338811df1a$var$getSubmittingFetcher(submission, existingFetcher);
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $b8f852338811df1a$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let actionResult = await $b8f852338811df1a$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($b8f852338811df1a$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            fetchRedirectIds.add(key);
            let loadingFetcher = $b8f852338811df1a$var$getLoadingFetcher(submission);
            state.fetchers.set(key, loadingFetcher);
            updateState({
                fetchers: new Map(state.fetchers)
            });
            return startRedirectNavigation(state, actionResult, {
                submission: submission,
                isFetchActionRedirect: true
            });
        }
        // Process any non-redirect errors thrown
        if ($b8f852338811df1a$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($b8f852338811df1a$var$isDeferredResult(actionResult)) throw $b8f852338811df1a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $b8f852338811df1a$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $b8f852338811df1a$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $b8f852338811df1a$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $b8f852338811df1a$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $b8f852338811df1a$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $b8f852338811df1a$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $b8f852338811df1a$var$findRedirect(results);
        if (redirect) return startRedirectNavigation(state, redirect);
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $b8f852338811df1a$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $b8f852338811df1a$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let didAbortFetchLoads = abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $b8f852338811df1a$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($b8f852338811df1a$var$_extends({
                errors: errors,
                loaderData: $b8f852338811df1a$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key);
        // Put this fetcher into it's loading state
        let loadingFetcher = $b8f852338811df1a$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined);
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $b8f852338811df1a$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let result = await $b8f852338811df1a$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($b8f852338811df1a$var$isDeferredResult(result)) result = await $b8f852338811df1a$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($b8f852338811df1a$var$isRedirectResult(result)) {
            fetchRedirectIds.add(key);
            await startRedirectNavigation(state, result);
            return;
        }
        // Process any non-redirect errors thrown
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key);
            // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $b8f852338811df1a$export$3e9cee6b33872309(!$b8f852338811df1a$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        let doneFetcher = $b8f852338811df1a$var$getDoneFetcher(result.data);
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        let { submission: submission, replace: replace, isFetchActionRedirect: isFetchActionRedirect } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $b8f852338811df1a$var$createLocation(state.location, redirect.location, $b8f852338811df1a$var$_extends({
            _isRedirect: true
        }, isFetchActionRedirect ? {
            _isFetchActionRedirect: true
        } : {}));
        $b8f852338811df1a$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        // Check if this an absolute external redirect that goes to a new origin
        if ($b8f852338811df1a$var$ABSOLUTE_URL_REGEX.test(redirect.location) && isBrowser) {
            let url = init.history.createURL(redirect.location);
            let isDifferentBasename = $b8f852338811df1a$export$b69e3301ce081aa3(url.pathname, basename) == null;
            if (routerWindow.location.origin !== url.origin || isDifferentBasename) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $b8f852338811df1a$export$e19cd5f9376f8cee.Replace : $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let activeSubmission = submission || $b8f852338811df1a$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        if ($b8f852338811df1a$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $b8f852338811df1a$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $b8f852338811df1a$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else if (isFetchActionRedirect) // For a fetch action redirect, we kick off a new loading navigation
        // without the fetcher submission, but we send it along for shouldRevalidate
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: $b8f852338811df1a$var$getLoadingNavigation(redirectLocation),
            fetcherSubmission: activeSubmission,
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a submission, we will preserve it through the redirect navigation
            let overrideNavigation = $b8f852338811df1a$var$getLoadingNavigation(redirectLocation, activeSubmission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$b8f852338811df1a$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $b8f852338811df1a$var$callLoaderOrAction("loader", $b8f852338811df1a$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $b8f852338811df1a$var$ResultType.error,
                        error: $b8f852338811df1a$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $b8f852338811df1a$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $b8f852338811df1a$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $b8f852338811df1a$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $b8f852338811df1a$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $b8f852338811df1a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $b8f852338811df1a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $b8f852338811df1a$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $b8f852338811df1a$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $b8f852338811df1a$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $b8f852338811df1a$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $b8f852338811df1a$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$b8f852338811df1a$var$createUseMatchesMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $b8f852338811df1a$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $b8f852338811df1a$export$4d0306f8f6a4585b = Symbol("deferred");
function $b8f852338811df1a$export$3336b097a6fbc59a(routes, opts) {
    $b8f852338811df1a$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $b8f852338811df1a$var$defaultMapRouteProperties;
    let dataRoutes = $b8f852338811df1a$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $b8f852338811df1a$var$createLocation("", $b8f852338811df1a$export$fe53371bee54353d(url), null, "default");
        let matches = $b8f852338811df1a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$b8f852338811df1a$var$isValidMethod(method) && method !== "HEAD") {
            let error = $b8f852338811df1a$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $b8f852338811df1a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($b8f852338811df1a$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $b8f852338811df1a$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $b8f852338811df1a$var$createLocation("", $b8f852338811df1a$export$fe53371bee54353d(url), null, "default");
        let matches = $b8f852338811df1a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$b8f852338811df1a$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $b8f852338811df1a$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $b8f852338811df1a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $b8f852338811df1a$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $b8f852338811df1a$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $b8f852338811df1a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($b8f852338811df1a$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$b8f852338811df1a$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $b8f852338811df1a$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($b8f852338811df1a$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $b8f852338811df1a$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $b8f852338811df1a$var$isResponse(result) ? result : $b8f852338811df1a$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($b8f852338811df1a$var$isQueryRouteResponse(e)) {
                if (e.type === $b8f852338811df1a$var$ResultType.error && !$b8f852338811df1a$var$isRedirectResponse(e.response)) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($b8f852338811df1a$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $b8f852338811df1a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $b8f852338811df1a$var$ResultType.error,
                error: error
            };
        } else {
            result = await $b8f852338811df1a$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted");
            }
        }
        if ($b8f852338811df1a$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($b8f852338811df1a$var$isDeferredResult(result)) {
            let error = $b8f852338811df1a$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $b8f852338811df1a$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($b8f852338811df1a$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $b8f852338811df1a$var$_extends({}, context, {
                statusCode: $b8f852338811df1a$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $b8f852338811df1a$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $b8f852338811df1a$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $b8f852338811df1a$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $b8f852338811df1a$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $b8f852338811df1a$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$b8f852338811df1a$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted");
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $b8f852338811df1a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $b8f852338811df1a$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $b8f852338811df1a$export$fec11da027c70692(routes, context, error) {
    let newContext = $b8f852338811df1a$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $b8f852338811df1a$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $b8f852338811df1a$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $b8f852338811df1a$export$cae722b0cc860f13(to ? to : ".", $b8f852338811df1a$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $b8f852338811df1a$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$b8f852338811df1a$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $b8f852338811df1a$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $b8f852338811df1a$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $b8f852338811df1a$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$b8f852338811df1a$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$b8f852338811df1a$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $b8f852338811df1a$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $b8f852338811df1a$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $b8f852338811df1a$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$b8f852338811df1a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$b8f852338811df1a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $b8f852338811df1a$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $b8f852338811df1a$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $b8f852338811df1a$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $b8f852338811df1a$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $b8f852338811df1a$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($b8f852338811df1a$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $b8f852338811df1a$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $b8f852338811df1a$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $b8f852338811df1a$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $b8f852338811df1a$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $b8f852338811df1a$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $b8f852338811df1a$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($b8f852338811df1a$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $b8f852338811df1a$var$shouldRevalidateLoader(match, $b8f852338811df1a$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $b8f852338811df1a$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $b8f852338811df1a$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They only set `defaultShouldRevalidate` on
        // explicit revalidation due to submission, useRevalidator, or X-Remix-Revalidate
        //
        // They automatically revalidate without even calling shouldRevalidate if:
        // - They were cancelled
        // - They're in the middle of their first load and therefore this is still
        //   an initial load and not a revalidation
        //
        // If neither of those is true, then they _always_ check shouldRevalidate
        let fetcher = state.fetchers.get(key);
        let isPerformingInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === undefined && // If a fetcher.load redirected then it'll be "loading" without any data
        // so ensure we're not processing the redirect from this fetcher
        !fetchRedirectIds.has(key);
        let fetcherMatch = $b8f852338811df1a$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = cancelledFetcherLoads.includes(key) || isPerformingInitialLoad || $b8f852338811df1a$var$shouldRevalidateLoader(fetcherMatch, $b8f852338811df1a$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $b8f852338811df1a$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $b8f852338811df1a$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $b8f852338811df1a$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $b8f852338811df1a$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $b8f852338811df1a$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $b8f852338811df1a$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$b8f852338811df1a$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $b8f852338811df1a$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $b8f852338811df1a$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let values = await Promise.all([
                    runHandler(handler),
                    $b8f852338811df1a$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $b8f852338811df1a$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $b8f852338811df1a$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $b8f852338811df1a$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $b8f852338811df1a$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $b8f852338811df1a$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $b8f852338811df1a$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($b8f852338811df1a$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($b8f852338811df1a$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $b8f852338811df1a$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$b8f852338811df1a$var$ABSOLUTE_URL_REGEX.test(location)) location = $b8f852338811df1a$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $b8f852338811df1a$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $b8f852338811df1a$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) // eslint-disable-next-line no-throw-literal
        throw {
            type: resultType || $b8f852338811df1a$var$ResultType.data,
            response: result
        };
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $b8f852338811df1a$var$ResultType.error) return {
            type: resultType,
            error: new $b8f852338811df1a$export$acf1a680051f5031(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $b8f852338811df1a$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $b8f852338811df1a$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($b8f852338811df1a$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $b8f852338811df1a$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $b8f852338811df1a$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $b8f852338811df1a$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($b8f852338811df1a$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $b8f852338811df1a$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $b8f852338811df1a$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $b8f852338811df1a$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $b8f852338811df1a$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $b8f852338811df1a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $b8f852338811df1a$export$3e9cee6b33872309(!$b8f852338811df1a$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $b8f852338811df1a$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($b8f852338811df1a$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $b8f852338811df1a$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $b8f852338811df1a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $b8f852338811df1a$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($b8f852338811df1a$var$isErrorResult(result)) {
            let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $b8f852338811df1a$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($b8f852338811df1a$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $b8f852338811df1a$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($b8f852338811df1a$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $b8f852338811df1a$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $b8f852338811df1a$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $b8f852338811df1a$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $b8f852338811df1a$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $b8f852338811df1a$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $b8f852338811df1a$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $b8f852338811df1a$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $b8f852338811df1a$export$acf1a680051f5031(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $b8f852338811df1a$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($b8f852338811df1a$var$isRedirectResult(result)) return result;
    }
}
function $b8f852338811df1a$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(path) : path;
    return $b8f852338811df1a$export$fe53371bee54353d($b8f852338811df1a$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $b8f852338811df1a$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $b8f852338811df1a$var$isDeferredResult(result) {
    return result.type === $b8f852338811df1a$var$ResultType.deferred;
}
function $b8f852338811df1a$var$isErrorResult(result) {
    return result.type === $b8f852338811df1a$var$ResultType.error;
}
function $b8f852338811df1a$var$isRedirectResult(result) {
    return (result && result.type) === $b8f852338811df1a$var$ResultType.redirect;
}
function $b8f852338811df1a$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $b8f852338811df1a$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $b8f852338811df1a$var$isRedirectResponse(result) {
    if (!$b8f852338811df1a$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $b8f852338811df1a$var$isQueryRouteResponse(obj) {
    return obj && $b8f852338811df1a$var$isResponse(obj.response) && (obj.type === $b8f852338811df1a$var$ResultType.data || $b8f852338811df1a$var$ResultType.error);
}
function $b8f852338811df1a$var$isValidMethod(method) {
    return $b8f852338811df1a$var$validRequestMethods.has(method.toLowerCase());
}
function $b8f852338811df1a$var$isMutationMethod(method) {
    return $b8f852338811df1a$var$validMutationMethods.has(method.toLowerCase());
}
async function $b8f852338811df1a$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$b8f852338811df1a$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($b8f852338811df1a$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $b8f852338811df1a$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $b8f852338811df1a$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $b8f852338811df1a$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $b8f852338811df1a$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $b8f852338811df1a$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $b8f852338811df1a$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $b8f852338811df1a$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
// Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $b8f852338811df1a$var$createUseMatchesMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $b8f852338811df1a$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $b8f852338811df1a$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $b8f852338811df1a$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $b8f852338811df1a$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $b8f852338811df1a$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $b8f852338811df1a$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $b8f852338811df1a$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data,
            " _hasFetcherDoneAnything ": true
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data,
            " _hasFetcherDoneAnything ": true
        };
        return fetcher;
    }
}
function $b8f852338811df1a$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined,
        " _hasFetcherDoneAnything ": true
    };
    return fetcher;
}
function $b8f852338811df1a$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data,
        " _hasFetcherDoneAnything ": true
    };
    return fetcher;
}

});

parcelRequire.register("99w1R", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", function () { return $6a9dcc96d11bcd0d$export$3add0d5dce533e2e; });
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", function () { return $6a9dcc96d11bcd0d$export$145dfa71566a64dc; });
$parcel$export(module.exports, "UNSAFE_NavigationContext", function () { return $6a9dcc96d11bcd0d$export$26749e8557646306; });
$parcel$export(module.exports, "UNSAFE_RouteContext", function () { return $6a9dcc96d11bcd0d$export$9072aa6dd1f93057; });
$parcel$export(module.exports, "useHref", function () { return $6a9dcc96d11bcd0d$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useResolvedPath", function () { return $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $6a9dcc96d11bcd0d$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $6a9dcc96d11bcd0d$export$9770f232ac06a008; });
$parcel$export(module.exports, "UNSAFE_useRouteId", function () { return $6a9dcc96d11bcd0d$export$5fc8298006ad9e58; });
$parcel$export(module.exports, "useNavigation", function () { return $6a9dcc96d11bcd0d$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useMatches", function () { return $6a9dcc96d11bcd0d$export$2378eb7f5ff86053; });
$parcel$export(module.exports, "unstable_useBlocker", function () { return $6a9dcc96d11bcd0d$export$2af03a1de5c0910; });
$parcel$export(module.exports, "Router", function () { return $6a9dcc96d11bcd0d$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Route", function () { return $6a9dcc96d11bcd0d$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Routes", function () { return $6a9dcc96d11bcd0d$export$3565eb3d00ca5a74; });
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", function () { return $6a9dcc96d11bcd0d$export$52b333d321859367; });
/**
 * React Router v6.14.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $bh6RR = parcelRequire("bh6RR");

var $fSADM = parcelRequire("fSADM");
function $6a9dcc96d11bcd0d$var$_extends() {
    $6a9dcc96d11bcd0d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6a9dcc96d11bcd0d$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $6a9dcc96d11bcd0d$export$3add0d5dce533e2e = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$export$145dfa71566a64dc = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$var$AwaitContext = /*#__PURE__*/ $bh6RR.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level <Router> API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $6a9dcc96d11bcd0d$export$26749e8557646306 = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$export$c7914228fb69b0f5 = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$export$9072aa6dd1f93057 = /*#__PURE__*/ $bh6RR.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $6a9dcc96d11bcd0d$var$RouteErrorContext = /*#__PURE__*/ $bh6RR.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $6a9dcc96d11bcd0d$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $fSADM.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $fSADM.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() {
    return $bh6RR.useContext($6a9dcc96d11bcd0d$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $6a9dcc96d11bcd0d$export$45d76561a5302f2b() {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $fSADM.UNSAFE_invariant)(false);
    return $bh6RR.useContext($6a9dcc96d11bcd0d$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $6a9dcc96d11bcd0d$export$1b3f31771c5d07c() {
    return $bh6RR.useContext($6a9dcc96d11bcd0d$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $6a9dcc96d11bcd0d$export$6c330e8992e8a295(pattern) {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $fSADM.UNSAFE_invariant)(false);
    let { pathname: pathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    return $bh6RR.useMemo(()=>(0, $fSADM.matchPath)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $6a9dcc96d11bcd0d$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $6a9dcc96d11bcd0d$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $bh6RR.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $6a9dcc96d11bcd0d$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $6a9dcc96d11bcd0d$var$useNavigateStable() : $6a9dcc96d11bcd0d$var$useNavigateUnstable();
}
function $6a9dcc96d11bcd0d$var$useNavigateUnstable() {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $fSADM.UNSAFE_invariant)(false);
    let dataRouterContext = $bh6RR.useContext($6a9dcc96d11bcd0d$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $fSADM.UNSAFE_getPathContributingMatches)(matches).map((match)=>match.pathnameBase));
    let activeRef = $bh6RR.useRef(false);
    $6a9dcc96d11bcd0d$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $bh6RR.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $fSADM.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $fSADM.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $6a9dcc96d11bcd0d$var$OutletContext = /*#__PURE__*/ $bh6RR.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $6a9dcc96d11bcd0d$export$4138103a3ae699cc() {
    return $bh6RR.useContext($6a9dcc96d11bcd0d$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $6a9dcc96d11bcd0d$export$a3be3530d8e40d0b(context) {
    let outlet = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $6a9dcc96d11bcd0d$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $fSADM.UNSAFE_getPathContributingMatches)(matches).map((match)=>match.pathnameBase));
    return $bh6RR.useMemo(()=>(0, $fSADM.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $6a9dcc96d11bcd0d$export$5d3fca4a98652595(routes, locationArg) {
    return $6a9dcc96d11bcd0d$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $6a9dcc96d11bcd0d$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $fSADM.UNSAFE_invariant)(false);
    let { navigator: navigator } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { matches: parentMatches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $fSADM.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $fSADM.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $fSADM.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $6a9dcc96d11bcd0d$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $fSADM.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $fSADM.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $6a9dcc96d11bcd0d$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $fSADM.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $6a9dcc96d11bcd0d$var$DefaultErrorComponent() {
    let error = $6a9dcc96d11bcd0d$export$ed527bf60f6e05f2();
    let message = (0, $fSADM.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $bh6RR.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $bh6RR.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $6a9dcc96d11bcd0d$var$defaultErrorElement = /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$DefaultErrorComponent, null);
class $6a9dcc96d11bcd0d$var$RenderErrorBoundary extends $bh6RR.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $6a9dcc96d11bcd0d$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $bh6RR.useContext($6a9dcc96d11bcd0d$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $6a9dcc96d11bcd0d$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $fSADM.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $6a9dcc96d11bcd0d$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $bh6RR.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $6a9dcc96d11bcd0d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
})($6a9dcc96d11bcd0d$var$DataRouterHook || ($6a9dcc96d11bcd0d$var$DataRouterHook = {}));
var $6a9dcc96d11bcd0d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
})($6a9dcc96d11bcd0d$var$DataRouterStateHook || ($6a9dcc96d11bcd0d$var$DataRouterStateHook = {}));
function $6a9dcc96d11bcd0d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $6a9dcc96d11bcd0d$var$useDataRouterContext(hookName) {
    let ctx = $bh6RR.useContext($6a9dcc96d11bcd0d$export$3add0d5dce533e2e);
    !ctx && (0, $fSADM.UNSAFE_invariant)(false);
    return ctx;
}
function $6a9dcc96d11bcd0d$var$useDataRouterState(hookName) {
    let state = $bh6RR.useContext($6a9dcc96d11bcd0d$export$145dfa71566a64dc);
    !state && (0, $fSADM.UNSAFE_invariant)(false);
    return state;
}
function $6a9dcc96d11bcd0d$var$useRouteContext(hookName) {
    let route = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    !route && (0, $fSADM.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $6a9dcc96d11bcd0d$var$useCurrentRouteId(hookName) {
    let route = $6a9dcc96d11bcd0d$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $fSADM.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $6a9dcc96d11bcd0d$export$5fc8298006ad9e58() {
    return $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $6a9dcc96d11bcd0d$export$d0fd4b7106de2769() {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $6a9dcc96d11bcd0d$export$600dc272ed516c15() {
    let dataRouterContext = $6a9dcc96d11bcd0d$var$useDataRouterContext($6a9dcc96d11bcd0d$var$DataRouterHook.UseRevalidator);
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRevalidator);
    return {
        revalidate: dataRouterContext.router.revalidate,
        state: state.revalidation
    };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $6a9dcc96d11bcd0d$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseMatches);
    return $bh6RR.useMemo(()=>matches.map((match)=>{
            let { pathname: pathname, params: params } = match;
            // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        }), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $6a9dcc96d11bcd0d$export$1448a5050d252c4d() {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseLoaderData);
    let routeId = $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $6a9dcc96d11bcd0d$export$fd5d37484eab868d(routeId) {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $6a9dcc96d11bcd0d$export$fdc00f3f26066d5e() {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseActionData);
    let route = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    !route && (0, $fSADM.UNSAFE_invariant)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $6a9dcc96d11bcd0d$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $bh6RR.useContext($6a9dcc96d11bcd0d$var$RouteErrorContext);
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteError);
    let routeId = $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $6a9dcc96d11bcd0d$export$78a72ddb39bdd145() {
    let value = $bh6RR.useContext($6a9dcc96d11bcd0d$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $6a9dcc96d11bcd0d$export$17f53340677d5831() {
    let value = $bh6RR.useContext($6a9dcc96d11bcd0d$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $6a9dcc96d11bcd0d$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $6a9dcc96d11bcd0d$export$2af03a1de5c0910(shouldBlock) {
    let { router: router, basename: basename } = $6a9dcc96d11bcd0d$var$useDataRouterContext($6a9dcc96d11bcd0d$var$DataRouterHook.UseBlocker);
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $bh6RR.useState("");
    let blockerFunction = $bh6RR.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $6a9dcc96d11bcd0d$var$_extends({}, currentLocation, {
                pathname: (0, $fSADM.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $6a9dcc96d11bcd0d$var$_extends({}, nextLocation, {
                pathname: (0, $fSADM.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $bh6RR.useEffect(()=>{
        let key = String(++$6a9dcc96d11bcd0d$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $bh6RR.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $fSADM.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $6a9dcc96d11bcd0d$var$useNavigateStable() {
    let { router: router } = $6a9dcc96d11bcd0d$var$useDataRouterContext($6a9dcc96d11bcd0d$var$DataRouterHook.UseNavigateStable);
    let id = $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $bh6RR.useRef(false);
    $6a9dcc96d11bcd0d$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $bh6RR.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $6a9dcc96d11bcd0d$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $6a9dcc96d11bcd0d$var$alreadyWarned = {};
function $6a9dcc96d11bcd0d$var$warningOnce(key, cond, message) {
    if (!cond && !$6a9dcc96d11bcd0d$var$alreadyWarned[key]) $6a9dcc96d11bcd0d$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $6a9dcc96d11bcd0d$var$START_TRANSITION = "startTransition";
const $6a9dcc96d11bcd0d$var$startTransitionImpl = $bh6RR[$6a9dcc96d11bcd0d$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $6a9dcc96d11bcd0d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    let [state, setStateImpl] = $bh6RR.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $6a9dcc96d11bcd0d$var$startTransitionImpl ? $6a9dcc96d11bcd0d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $bh6RR.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $bh6RR.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $6a9dcc96d11bcd0d$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $6a9dcc96d11bcd0d$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $6a9dcc96d11bcd0d$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $bh6RR.useRef();
    if (historyRef.current == null) historyRef.current = (0, $fSADM.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $6a9dcc96d11bcd0d$var$startTransitionImpl ? $6a9dcc96d11bcd0d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $6a9dcc96d11bcd0d$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $fSADM.UNSAFE_invariant)(false);
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let navigate = $6a9dcc96d11bcd0d$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $fSADM.resolveTo)(to, (0, $fSADM.UNSAFE_getPathContributingMatches)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $bh6RR.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $6a9dcc96d11bcd0d$export$910ae8079b2c2852(props) {
    return $6a9dcc96d11bcd0d$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $6a9dcc96d11bcd0d$export$e7b0ac011bb776c6(_props) {
    (0, $fSADM.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $6a9dcc96d11bcd0d$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $fSADM.Action).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $fSADM.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $bh6RR.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $fSADM.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $bh6RR.useMemo(()=>{
        let trailingPathname = (0, $fSADM.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $6a9dcc96d11bcd0d$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $6a9dcc96d11bcd0d$export$5d3fca4a98652595($6a9dcc96d11bcd0d$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $6a9dcc96d11bcd0d$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$ResolveAwait, null, children));
}
var $6a9dcc96d11bcd0d$var$AwaitRenderStatus;
(function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})($6a9dcc96d11bcd0d$var$AwaitRenderStatus || ($6a9dcc96d11bcd0d$var$AwaitRenderStatus = {}));
const $6a9dcc96d11bcd0d$var$neverSettledPromise = new Promise(()=>{});
class $6a9dcc96d11bcd0d$var$AwaitErrorBoundary extends $bh6RR.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error : promise._data !== undefined ? $6a9dcc96d11bcd0d$var$AwaitRenderStatus.success : $6a9dcc96d11bcd0d$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error && promise._error instanceof (0, $fSADM.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $6a9dcc96d11bcd0d$var$neverSettledPromise;
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $6a9dcc96d11bcd0d$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $6a9dcc96d11bcd0d$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $6a9dcc96d11bcd0d$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $bh6RR.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $bh6RR.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $bh6RR.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $6a9dcc96d11bcd0d$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $6a9dcc96d11bcd0d$export$e7b0ac011bb776c6) && (0, $fSADM.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $fSADM.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $6a9dcc96d11bcd0d$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $6a9dcc96d11bcd0d$export$daf73786167a7f72(matches) {
    return $6a9dcc96d11bcd0d$var$_renderMatches(matches);
}
function $6a9dcc96d11bcd0d$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $bh6RR.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $bh6RR.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $6a9dcc96d11bcd0d$export$f30f7e456d254e83(routes, opts) {
    return (0, $fSADM.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $6a9dcc96d11bcd0d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $fSADM.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $6a9dcc96d11bcd0d$export$52b333d321859367
    }).initialize();
}

});


parcelRequire.register("bEzwx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87befc68df50040c$export$2e2bcd8739ae039; });

var $kknQe = parcelRequire("kknQe");

var $7YxFJ = parcelRequire("7YxFJ");
function $87befc68df50040c$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $kknQe.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $7YxFJ.default)(rnds);
}
var $87befc68df50040c$export$2e2bcd8739ae039 = $87befc68df50040c$var$v4;

});
parcelRequire.register("kknQe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecc82b4b4d5334a5$export$2e2bcd8739ae039; });
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $ecc82b4b4d5334a5$var$getRandomValues;
var $ecc82b4b4d5334a5$var$rnds8 = new Uint8Array(16);
function $ecc82b4b4d5334a5$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$ecc82b4b4d5334a5$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $ecc82b4b4d5334a5$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!$ecc82b4b4d5334a5$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $ecc82b4b4d5334a5$var$getRandomValues($ecc82b4b4d5334a5$var$rnds8);
}

});

parcelRequire.register("7YxFJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ce84198744ccadf$export$2e2bcd8739ae039; });

var $jPUoq = parcelRequire("jPUoq");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $5ce84198744ccadf$var$byteToHex = [];
for(var $5ce84198744ccadf$var$i = 0; $5ce84198744ccadf$var$i < 256; ++$5ce84198744ccadf$var$i)$5ce84198744ccadf$var$byteToHex.push(($5ce84198744ccadf$var$i + 0x100).toString(16).substr(1));
function $5ce84198744ccadf$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($5ce84198744ccadf$var$byteToHex[arr[offset + 0]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 1]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 2]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 3]] + "-" + $5ce84198744ccadf$var$byteToHex[arr[offset + 4]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 5]] + "-" + $5ce84198744ccadf$var$byteToHex[arr[offset + 6]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 7]] + "-" + $5ce84198744ccadf$var$byteToHex[arr[offset + 8]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 9]] + "-" + $5ce84198744ccadf$var$byteToHex[arr[offset + 10]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 11]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 12]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 13]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 14]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $jPUoq.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $5ce84198744ccadf$export$2e2bcd8739ae039 = $5ce84198744ccadf$var$stringify;

});
parcelRequire.register("jPUoq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e70e86397c656fa2$export$2e2bcd8739ae039; });

var $bjlDU = parcelRequire("bjlDU");
function $e70e86397c656fa2$var$validate(uuid) {
    return typeof uuid === "string" && (0, $bjlDU.default).test(uuid);
}
var $e70e86397c656fa2$export$2e2bcd8739ae039 = $e70e86397c656fa2$var$validate;

});
parcelRequire.register("bjlDU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83c241de251331e8$export$2e2bcd8739ae039; });
var $83c241de251331e8$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});




parcelRequire.register("4HWKL", function(module, exports) {
/*! UIkit 3.16.22 | https://www.getuikit.com | (c) 2014 - 2023 YOOtheme | MIT License */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    const { hasOwnProperty: hasOwnProperty, toString: toString } = Object.prototype;
    function hasOwn(obj, key) {
        return hasOwnProperty.call(obj, key);
    }
    const hyphenateRe = /\B([A-Z])/g;
    const hyphenate = memoize((str)=>str.replace(hyphenateRe, "-$1").toLowerCase());
    const camelizeRe = /-(\w)/g;
    const camelize = memoize((str)=>(str.charAt(0).toLowerCase() + str.slice(1)).replace(camelizeRe, (_, c)=>c.toUpperCase()));
    const ucfirst = memoize((str)=>str.charAt(0).toUpperCase() + str.slice(1));
    function startsWith(str, search) {
        var _a;
        return (_a = str == null ? void 0 : str.startsWith) == null ? void 0 : _a.call(str, search);
    }
    function endsWith(str, search) {
        var _a;
        return (_a = str == null ? void 0 : str.endsWith) == null ? void 0 : _a.call(str, search);
    }
    function includes(obj, search) {
        var _a;
        return (_a = obj == null ? void 0 : obj.includes) == null ? void 0 : _a.call(obj, search);
    }
    function findIndex(array, predicate) {
        var _a;
        return (_a = array == null ? void 0 : array.findIndex) == null ? void 0 : _a.call(array, predicate);
    }
    const { isArray: isArray, from: toArray } = Array;
    const { assign: assign } = Object;
    function isFunction(obj) {
        return typeof obj === "function";
    }
    function isObject(obj) {
        return obj !== null && typeof obj === "object";
    }
    function isPlainObject(obj) {
        return toString.call(obj) === "[object Object]";
    }
    function isWindow(obj) {
        return isObject(obj) && obj === obj.window;
    }
    function isDocument(obj) {
        return nodeType(obj) === 9;
    }
    function isNode(obj) {
        return nodeType(obj) >= 1;
    }
    function isElement(obj) {
        return nodeType(obj) === 1;
    }
    function nodeType(obj) {
        return !isWindow(obj) && isObject(obj) && obj.nodeType;
    }
    function isBoolean(value) {
        return typeof value === "boolean";
    }
    function isString(value) {
        return typeof value === "string";
    }
    function isNumber(value) {
        return typeof value === "number";
    }
    function isNumeric(value) {
        return isNumber(value) || isString(value) && !isNaN(value - parseFloat(value));
    }
    function isEmpty(obj) {
        return !(isArray(obj) ? obj.length : isObject(obj) ? Object.keys(obj).length : false);
    }
    function isUndefined(value) {
        return value === void 0;
    }
    function toBoolean(value) {
        return isBoolean(value) ? value : value === "true" || value === "1" || value === "" ? true : value === "false" || value === "0" ? false : value;
    }
    function toNumber(value) {
        const number = Number(value);
        return isNaN(number) ? false : number;
    }
    function toFloat(value) {
        return parseFloat(value) || 0;
    }
    function toNode(element) {
        return toNodes(element)[0];
    }
    function toNodes(element) {
        return isNode(element) ? [
            element
        ] : Array.from(element || []).filter(isNode);
    }
    function toWindow(element) {
        if (isWindow(element)) return element;
        element = toNode(element);
        const document1 = isDocument(element) ? element : element == null ? void 0 : element.ownerDocument;
        return (document1 == null ? void 0 : document1.defaultView) || window;
    }
    function isEqual(value, other) {
        return value === other || isObject(value) && isObject(other) && Object.keys(value).length === Object.keys(other).length && each(value, (val, key)=>val === other[key]);
    }
    function swap(value, a, b) {
        return value.replace(new RegExp(`${a}|${b}`, "g"), (match)=>match === a ? b : a);
    }
    function last(array) {
        return array[array.length - 1];
    }
    function each(obj, cb) {
        for(const key in obj){
            if (false === cb(obj[key], key)) return false;
        }
        return true;
    }
    function sortBy$1(array, prop) {
        return array.slice().sort(({ [prop]: propA = 0 }, { [prop]: propB = 0 })=>propA > propB ? 1 : propB > propA ? -1 : 0);
    }
    function sumBy(array, iteratee) {
        return array.reduce((sum, item)=>sum + toFloat(isFunction(iteratee) ? iteratee(item) : item[iteratee]), 0);
    }
    function uniqueBy(array, prop) {
        const seen = /* @__PURE__ */ new Set();
        return array.filter(({ [prop]: check })=>seen.has(check) ? false : seen.add(check));
    }
    function pick(obj, props) {
        return props.reduce((res, prop)=>({
                ...res,
                [prop]: obj[prop]
            }), {});
    }
    function clamp(number, min = 0, max = 1) {
        return Math.min(Math.max(toNumber(number) || 0, min), max);
    }
    function noop() {}
    function intersectRect(...rects) {
        return [
            [
                "bottom",
                "top"
            ],
            [
                "right",
                "left"
            ]
        ].every(([minProp, maxProp])=>Math.min(...rects.map(({ [minProp]: min })=>min)) - Math.max(...rects.map(({ [maxProp]: max })=>max)) > 0);
    }
    function pointInRect(point, rect) {
        return point.x <= rect.right && point.x >= rect.left && point.y <= rect.bottom && point.y >= rect.top;
    }
    function ratio(dimensions, prop, value) {
        const aProp = prop === "width" ? "height" : "width";
        return {
            [aProp]: dimensions[prop] ? Math.round(value * dimensions[aProp] / dimensions[prop]) : dimensions[aProp],
            [prop]: value
        };
    }
    function contain(dimensions, maxDimensions) {
        dimensions = {
            ...dimensions
        };
        for(const prop in dimensions)dimensions = dimensions[prop] > maxDimensions[prop] ? ratio(dimensions, prop, maxDimensions[prop]) : dimensions;
        return dimensions;
    }
    function cover$1(dimensions, maxDimensions) {
        dimensions = contain(dimensions, maxDimensions);
        for(const prop in dimensions)dimensions = dimensions[prop] < maxDimensions[prop] ? ratio(dimensions, prop, maxDimensions[prop]) : dimensions;
        return dimensions;
    }
    const Dimensions = {
        ratio: ratio,
        contain: contain,
        cover: cover$1
    };
    function getIndex(i, elements, current = 0, finite = false) {
        elements = toNodes(elements);
        const { length: length } = elements;
        if (!length) return -1;
        i = isNumeric(i) ? toNumber(i) : i === "next" ? current + 1 : i === "previous" ? current - 1 : i === "last" ? length - 1 : elements.indexOf(toNode(i));
        if (finite) return clamp(i, 0, length - 1);
        i %= length;
        return i < 0 ? i + length : i;
    }
    function memoize(fn) {
        const cache = /* @__PURE__ */ Object.create(null);
        return (key)=>cache[key] || (cache[key] = fn(key));
    }
    function attr(element, name, value) {
        var _a;
        if (isObject(name)) {
            for(const key in name)attr(element, key, name[key]);
            return;
        }
        if (isUndefined(value)) return (_a = toNode(element)) == null ? void 0 : _a.getAttribute(name);
        else for (const el of toNodes(element)){
            if (isFunction(value)) value = value.call(el, attr(el, name));
            if (value === null) removeAttr(el, name);
            else el.setAttribute(name, value);
        }
    }
    function hasAttr(element, name) {
        return toNodes(element).some((element2)=>element2.hasAttribute(name));
    }
    function removeAttr(element, name) {
        toNodes(element).forEach((element2)=>element2.removeAttribute(name));
    }
    function data(element, attribute) {
        for (const name of [
            attribute,
            `data-${attribute}`
        ]){
            if (hasAttr(element, name)) return attr(element, name);
        }
    }
    const voidElements = {
        area: true,
        base: true,
        br: true,
        col: true,
        embed: true,
        hr: true,
        img: true,
        input: true,
        keygen: true,
        link: true,
        meta: true,
        param: true,
        source: true,
        track: true,
        wbr: true
    };
    function isVoidElement(element) {
        return toNodes(element).some((element2)=>voidElements[element2.tagName.toLowerCase()]);
    }
    function isVisible(element) {
        return toNodes(element).some((element2)=>element2.offsetWidth || element2.offsetHeight || element2.getClientRects().length);
    }
    const selInput = "input,select,textarea,button";
    function isInput(element) {
        return toNodes(element).some((element2)=>matches(element2, selInput));
    }
    const selFocusable = `${selInput},a[href],[tabindex]`;
    function isFocusable(element) {
        return matches(element, selFocusable);
    }
    function parent(element) {
        var _a;
        return (_a = toNode(element)) == null ? void 0 : _a.parentElement;
    }
    function filter$1(element, selector) {
        return toNodes(element).filter((element2)=>matches(element2, selector));
    }
    function matches(element, selector) {
        return toNodes(element).some((element2)=>element2.matches(selector));
    }
    function closest(element, selector) {
        return isElement(element) ? element.closest(startsWith(selector, ">") ? selector.slice(1) : selector) : toNodes(element).map((element2)=>closest(element2, selector)).filter(Boolean);
    }
    function within(element, selector) {
        return isString(selector) ? !!closest(element, selector) : toNode(selector).contains(toNode(element));
    }
    function parents(element, selector) {
        const elements = [];
        while(element = parent(element))if (!selector || matches(element, selector)) elements.push(element);
        return elements;
    }
    function children(element, selector) {
        element = toNode(element);
        const children2 = element ? toArray(element.children) : [];
        return selector ? filter$1(children2, selector) : children2;
    }
    function index(element, ref) {
        return ref ? toNodes(element).indexOf(toNode(ref)) : children(parent(element)).indexOf(element);
    }
    function isSameSiteAnchor(el) {
        el = toNode(el);
        return el && [
            "origin",
            "pathname",
            "search"
        ].every((part)=>el[part] === location[part]);
    }
    function getTargetedElement(el) {
        if (isSameSiteAnchor(el)) {
            el = toNode(el);
            const id = decodeURIComponent(el.hash).substring(1);
            return document.getElementById(id) || document.getElementsByName(id)[0];
        }
    }
    function query(selector, context) {
        return find(selector, getContext(selector, context));
    }
    function queryAll(selector, context) {
        return findAll(selector, getContext(selector, context));
    }
    function find(selector, context) {
        return toNode(_query(selector, toNode(context), "querySelector"));
    }
    function findAll(selector, context) {
        return toNodes(_query(selector, toNode(context), "querySelectorAll"));
    }
    const contextSelectorRe = /(^|[^\\],)\s*[!>+~-]/;
    const isContextSelector = memoize((selector)=>selector.match(contextSelectorRe));
    function getContext(selector, context = document) {
        return isString(selector) && isContextSelector(selector) || isDocument(context) ? context : context.ownerDocument;
    }
    const contextSanitizeRe = /([!>+~-])(?=\s+[!>+~-]|\s*$)/g;
    const sanatize = memoize((selector)=>selector.replace(contextSanitizeRe, "$1 *"));
    function _query(selector, context = document, queryFn) {
        if (!selector || !isString(selector)) return selector;
        selector = sanatize(selector);
        if (isContextSelector(selector)) {
            const split = splitSelector(selector);
            selector = "";
            for (let sel of split){
                let ctx = context;
                if (sel[0] === "!") {
                    const selectors = sel.substr(1).trim().split(" ");
                    ctx = closest(parent(context), selectors[0]);
                    sel = selectors.slice(1).join(" ").trim();
                    if (!sel.length && split.length === 1) return ctx;
                }
                if (sel[0] === "-") {
                    const selectors = sel.substr(1).trim().split(" ");
                    const prev = (ctx || context).previousElementSibling;
                    ctx = matches(prev, sel.substr(1)) ? prev : null;
                    sel = selectors.slice(1).join(" ");
                }
                if (ctx) selector += `${selector ? "," : ""}${domPath(ctx)} ${sel}`;
            }
            context = document;
        }
        try {
            return context[queryFn](selector);
        } catch (e) {
            return null;
        }
    }
    const selectorRe = /.*?[^\\](?:,|$)/g;
    const splitSelector = memoize((selector)=>selector.match(selectorRe).map((selector2)=>selector2.replace(/,$/, "").trim()));
    function domPath(element) {
        const names = [];
        while(element.parentNode){
            const id = attr(element, "id");
            if (id) {
                names.unshift(`#${escape(id)}`);
                break;
            } else {
                let { tagName: tagName } = element;
                if (tagName !== "HTML") tagName += `:nth-child(${index(element) + 1})`;
                names.unshift(tagName);
                element = element.parentNode;
            }
        }
        return names.join(" > ");
    }
    function escape(css) {
        return isString(css) ? CSS.escape(css) : "";
    }
    function on(...args) {
        let [targets, types, selector, listener, useCapture = false] = getArgs(args);
        if (listener.length > 1) listener = detail(listener);
        if (useCapture == null ? void 0 : useCapture.self) listener = selfFilter(listener);
        if (selector) listener = delegate(selector, listener);
        for (const type of types)for (const target of targets)target.addEventListener(type, listener, useCapture);
        return ()=>off(targets, types, listener, useCapture);
    }
    function off(...args) {
        let [targets, types, , listener, useCapture = false] = getArgs(args);
        for (const type of types)for (const target of targets)target.removeEventListener(type, listener, useCapture);
    }
    function once(...args) {
        const [element, types, selector, listener, useCapture = false, condition] = getArgs(args);
        const off2 = on(element, types, selector, (e)=>{
            const result = !condition || condition(e);
            if (result) {
                off2();
                listener(e, result);
            }
        }, useCapture);
        return off2;
    }
    function trigger(targets, event, detail2) {
        return toEventTargets(targets).every((target)=>target.dispatchEvent(createEvent(event, true, true, detail2)));
    }
    function createEvent(e, bubbles = true, cancelable = false, detail2) {
        if (isString(e)) e = new CustomEvent(e, {
            bubbles: bubbles,
            cancelable: cancelable,
            detail: detail2
        });
        return e;
    }
    function getArgs(args) {
        args[0] = toEventTargets(args[0]);
        if (isString(args[1])) args[1] = args[1].split(" ");
        if (isFunction(args[2])) args.splice(2, 0, false);
        return args;
    }
    function delegate(selector, listener) {
        return (e)=>{
            const current = selector[0] === ">" ? findAll(selector, e.currentTarget).reverse().filter((element)=>within(e.target, element))[0] : closest(e.target, selector);
            if (current) {
                e.current = current;
                listener.call(this, e);
                delete e.current;
            }
        };
    }
    function detail(listener) {
        return (e)=>isArray(e.detail) ? listener(e, ...e.detail) : listener(e);
    }
    function selfFilter(listener) {
        return function(e) {
            if (e.target === e.currentTarget || e.target === e.current) return listener.call(null, e);
        };
    }
    function isEventTarget(target) {
        return target && "addEventListener" in target;
    }
    function toEventTarget(target) {
        return isEventTarget(target) ? target : toNode(target);
    }
    function toEventTargets(target) {
        return isArray(target) ? target.map(toEventTarget).filter(Boolean) : isString(target) ? findAll(target) : isEventTarget(target) ? [
            target
        ] : toNodes(target);
    }
    function isTouch(e) {
        return e.pointerType === "touch" || !!e.touches;
    }
    function getEventPos(e) {
        var _a, _b;
        const { clientX: x, clientY: y } = ((_a = e.touches) == null ? void 0 : _a[0]) || ((_b = e.changedTouches) == null ? void 0 : _b[0]) || e;
        return {
            x: x,
            y: y
        };
    }
    const cssNumber = {
        "animation-iteration-count": true,
        "column-count": true,
        "fill-opacity": true,
        "flex-grow": true,
        "flex-shrink": true,
        "font-weight": true,
        "line-height": true,
        opacity: true,
        order: true,
        orphans: true,
        "stroke-dasharray": true,
        "stroke-dashoffset": true,
        widows: true,
        "z-index": true,
        zoom: true
    };
    function css(element, property, value, priority) {
        const elements = toNodes(element);
        for (const element2 of elements){
            if (isString(property)) {
                property = propName(property);
                if (isUndefined(value)) return getComputedStyle(element2).getPropertyValue(property);
                else element2.style.setProperty(property, isNumeric(value) && !cssNumber[property] ? `${value}px` : value || isNumber(value) ? value : "", priority);
            } else if (isArray(property)) {
                const props = {};
                for (const prop of property)props[prop] = css(element2, prop);
                return props;
            } else if (isObject(property)) {
                priority = value;
                each(property, (value2, property2)=>css(element2, property2, value2, priority));
            }
        }
        return elements[0];
    }
    const propName = memoize((name)=>vendorPropName(name));
    function vendorPropName(name) {
        if (startsWith(name, "--")) return name;
        name = hyphenate(name);
        const { style: style } = document.documentElement;
        if (name in style) return name;
        for (const prefix of [
            "webkit",
            "moz"
        ]){
            const prefixedName = `-${prefix}-${name}`;
            if (prefixedName in style) return prefixedName;
        }
    }
    function addClass(element, ...args) {
        apply$1(element, args, "add");
    }
    function removeClass(element, ...args) {
        apply$1(element, args, "remove");
    }
    function removeClasses(element, cls) {
        attr(element, "class", (value)=>(value || "").replace(new RegExp(`\\b${cls}\\b\\s?`, "g"), ""));
    }
    function replaceClass(element, ...args) {
        args[0] && removeClass(element, args[0]);
        args[1] && addClass(element, args[1]);
    }
    function hasClass(element, cls) {
        [cls] = getClasses(cls);
        return !!cls && toNodes(element).some((node)=>node.classList.contains(cls));
    }
    function toggleClass(element, cls, force) {
        const classes = getClasses(cls);
        if (!isUndefined(force)) force = !!force;
        for (const node of toNodes(element))for (const cls2 of classes)node.classList.toggle(cls2, force);
    }
    function apply$1(element, args, fn) {
        args = args.reduce((args2, arg)=>args2.concat(getClasses(arg)), []);
        for (const node of toNodes(element))node.classList[fn](...args);
    }
    function getClasses(str) {
        return String(str).split(/[ ,]/).filter(Boolean);
    }
    function transition$1(element, props, duration = 400, timing = "linear") {
        duration = Math.round(duration);
        return Promise.all(toNodes(element).map((element2)=>new Promise((resolve, reject)=>{
                for(const name in props){
                    const value = css(element2, name);
                    if (value === "") css(element2, name, value);
                }
                const timer = setTimeout(()=>trigger(element2, "transitionend"), duration);
                once(element2, "transitionend transitioncanceled", ({ type: type })=>{
                    clearTimeout(timer);
                    removeClass(element2, "uk-transition");
                    css(element2, {
                        transitionProperty: "",
                        transitionDuration: "",
                        transitionTimingFunction: ""
                    });
                    type === "transitioncanceled" ? reject() : resolve(element2);
                }, {
                    self: true
                });
                addClass(element2, "uk-transition");
                css(element2, {
                    transitionProperty: Object.keys(props).map(propName).join(","),
                    transitionDuration: `${duration}ms`,
                    transitionTimingFunction: timing,
                    ...props
                });
            })));
    }
    const Transition = {
        start: transition$1,
        async stop (element) {
            trigger(element, "transitionend");
            await Promise.resolve();
        },
        async cancel (element) {
            trigger(element, "transitioncanceled");
            await Promise.resolve();
        },
        inProgress (element) {
            return hasClass(element, "uk-transition");
        }
    };
    const animationPrefix = "uk-animation-";
    function animate$2(element, animation, duration = 200, origin, out) {
        return Promise.all(toNodes(element).map((element2)=>new Promise((resolve, reject)=>{
                trigger(element2, "animationcanceled");
                const timer = setTimeout(()=>trigger(element2, "animationend"), duration);
                once(element2, "animationend animationcanceled", ({ type: type })=>{
                    clearTimeout(timer);
                    type === "animationcanceled" ? reject() : resolve(element2);
                    css(element2, "animationDuration", "");
                    removeClasses(element2, `${animationPrefix}\\S*`);
                }, {
                    self: true
                });
                css(element2, "animationDuration", `${duration}ms`);
                addClass(element2, animation, animationPrefix + (out ? "leave" : "enter"));
                if (startsWith(animation, animationPrefix)) {
                    origin && addClass(element2, `uk-transform-origin-${origin}`);
                    out && addClass(element2, `${animationPrefix}reverse`);
                }
            })));
    }
    const inProgressRe = new RegExp(`${animationPrefix}(enter|leave)`);
    const Animation = {
        in: animate$2,
        out (element, animation, duration, origin) {
            return animate$2(element, animation, duration, origin, true);
        },
        inProgress (element) {
            return inProgressRe.test(attr(element, "class"));
        },
        cancel (element) {
            trigger(element, "animationcanceled");
        }
    };
    function ready(fn) {
        if (document.readyState !== "loading") {
            fn();
            return;
        }
        once(document, "DOMContentLoaded", fn);
    }
    function isTag(element, ...tagNames) {
        return tagNames.some((tagName)=>{
            var _a;
            return ((_a = element == null ? void 0 : element.tagName) == null ? void 0 : _a.toLowerCase()) === tagName.toLowerCase();
        });
    }
    function empty(element) {
        element = $(element);
        element.innerHTML = "";
        return element;
    }
    function html(parent2, html2) {
        return isUndefined(html2) ? $(parent2).innerHTML : append(empty(parent2), html2);
    }
    const prepend = applyFn("prepend");
    const append = applyFn("append");
    const before = applyFn("before");
    const after = applyFn("after");
    function applyFn(fn) {
        return function(ref, element) {
            var _a;
            const nodes = toNodes(isString(element) ? fragment(element) : element);
            (_a = $(ref)) == null || _a[fn](...nodes);
            return unwrapSingle(nodes);
        };
    }
    function remove$1(element) {
        toNodes(element).forEach((element2)=>element2.remove());
    }
    function wrapAll(element, structure) {
        structure = toNode(before(element, structure));
        while(structure.firstChild)structure = structure.firstChild;
        append(structure, element);
        return structure;
    }
    function wrapInner(element, structure) {
        return toNodes(toNodes(element).map((element2)=>element2.hasChildNodes() ? wrapAll(toArray(element2.childNodes), structure) : append(element2, structure)));
    }
    function unwrap(element) {
        toNodes(element).map(parent).filter((value, index, self)=>self.indexOf(value) === index).forEach((parent2)=>parent2.replaceWith(...parent2.childNodes));
    }
    const fragmentRe = /^\s*<(\w+|!)[^>]*>/;
    const singleTagRe = /^<(\w+)\s*\/?>(?:<\/\1>)?$/;
    function fragment(html2) {
        const matches = singleTagRe.exec(html2);
        if (matches) return document.createElement(matches[1]);
        const container = document.createElement("div");
        if (fragmentRe.test(html2)) container.insertAdjacentHTML("beforeend", html2.trim());
        else container.textContent = html2;
        return unwrapSingle(container.childNodes);
    }
    function unwrapSingle(nodes) {
        return nodes.length > 1 ? nodes : nodes[0];
    }
    function apply(node, fn) {
        if (!isElement(node)) return;
        fn(node);
        node = node.firstElementChild;
        while(node){
            const next = node.nextElementSibling;
            apply(node, fn);
            node = next;
        }
    }
    function $(selector, context) {
        return isHtml(selector) ? toNode(fragment(selector)) : find(selector, context);
    }
    function $$(selector, context) {
        return isHtml(selector) ? toNodes(fragment(selector)) : findAll(selector, context);
    }
    function isHtml(str) {
        return isString(str) && startsWith(str.trim(), "<");
    }
    const dirs$1 = {
        width: [
            "left",
            "right"
        ],
        height: [
            "top",
            "bottom"
        ]
    };
    function dimensions$1(element) {
        const rect = isElement(element) ? toNode(element).getBoundingClientRect() : {
            height: height(element),
            width: width(element),
            top: 0,
            left: 0
        };
        return {
            height: rect.height,
            width: rect.width,
            top: rect.top,
            left: rect.left,
            bottom: rect.top + rect.height,
            right: rect.left + rect.width
        };
    }
    function offset(element, coordinates) {
        const currentOffset = dimensions$1(element);
        if (element) {
            const { scrollY: scrollY, scrollX: scrollX } = toWindow(element);
            const offsetBy = {
                height: scrollY,
                width: scrollX
            };
            for(const dir in dirs$1)for (const prop of dirs$1[dir])currentOffset[prop] += offsetBy[dir];
        }
        if (!coordinates) return currentOffset;
        const pos = css(element, "position");
        each(css(element, [
            "left",
            "top"
        ]), (value, prop)=>css(element, prop, coordinates[prop] - currentOffset[prop] + toFloat(pos === "absolute" && value === "auto" ? position(element)[prop] : value)));
    }
    function position(element) {
        let { top: top, left: left } = offset(element);
        const { ownerDocument: { body: body, documentElement: documentElement }, offsetParent: offsetParent } = toNode(element);
        let parent = offsetParent || documentElement;
        while(parent && (parent === body || parent === documentElement) && css(parent, "position") === "static")parent = parent.parentNode;
        if (isElement(parent)) {
            const parentOffset = offset(parent);
            top -= parentOffset.top + toFloat(css(parent, "borderTopWidth"));
            left -= parentOffset.left + toFloat(css(parent, "borderLeftWidth"));
        }
        return {
            top: top - toFloat(css(element, "marginTop")),
            left: left - toFloat(css(element, "marginLeft"))
        };
    }
    function offsetPosition(element) {
        element = toNode(element);
        const offset2 = [
            element.offsetTop,
            element.offsetLeft
        ];
        while(element = element.offsetParent){
            offset2[0] += element.offsetTop + toFloat(css(element, `borderTopWidth`));
            offset2[1] += element.offsetLeft + toFloat(css(element, `borderLeftWidth`));
            if (css(element, "position") === "fixed") {
                const win = toWindow(element);
                offset2[0] += win.scrollY;
                offset2[1] += win.scrollX;
                return offset2;
            }
        }
        return offset2;
    }
    const height = dimension("height");
    const width = dimension("width");
    function dimension(prop) {
        const propName = ucfirst(prop);
        return (element, value)=>{
            if (isUndefined(value)) {
                if (isWindow(element)) return element[`inner${propName}`];
                if (isDocument(element)) {
                    const doc = element.documentElement;
                    return Math.max(doc[`offset${propName}`], doc[`scroll${propName}`]);
                }
                element = toNode(element);
                value = css(element, prop);
                value = value === "auto" ? element[`offset${propName}`] : toFloat(value) || 0;
                return value - boxModelAdjust(element, prop);
            } else return css(element, prop, !value && value !== 0 ? "" : +value + boxModelAdjust(element, prop) + "px");
        };
    }
    function boxModelAdjust(element, prop, sizing = "border-box") {
        return css(element, "boxSizing") === sizing ? sumBy(dirs$1[prop].map(ucfirst), (prop2)=>toFloat(css(element, `padding${prop2}`)) + toFloat(css(element, `border${prop2}Width`))) : 0;
    }
    function flipPosition(pos) {
        for(const dir in dirs$1)for(const i in dirs$1[dir]){
            if (dirs$1[dir][i] === pos) return dirs$1[dir][1 - i];
        }
        return pos;
    }
    function toPx(value, property = "width", element = window, offsetDim = false) {
        if (!isString(value)) return toFloat(value);
        return sumBy(parseCalc(value), (value2)=>{
            const unit = parseUnit(value2);
            return unit ? percent(unit === "vh" ? getViewportHeight() : unit === "vw" ? width(toWindow(element)) : offsetDim ? element[`offset${ucfirst(property)}`] : dimensions$1(element)[property], value2) : value2;
        });
    }
    const calcRe = /-?\d+(?:\.\d+)?(?:v[wh]|%|px)?/g;
    const parseCalc = memoize((calc)=>calc.toString().replace(/\s/g, "").match(calcRe) || []);
    const unitRe$1 = /(?:v[hw]|%)$/;
    const parseUnit = memoize((str)=>(str.match(unitRe$1) || [])[0]);
    function percent(base, value) {
        return base * toFloat(value) / 100;
    }
    let vh;
    let vhEl;
    function getViewportHeight() {
        if (vh) return vh;
        if (!vhEl) {
            vhEl = $("<div>");
            css(vhEl, {
                height: "100vh",
                position: "fixed"
            });
            on(window, "resize", ()=>vh = null);
        }
        append(document.body, vhEl);
        vh = vhEl.clientHeight;
        remove$1(vhEl);
        return vh;
    }
    const inBrowser = typeof window !== "undefined";
    const isRtl = inBrowser && document.dir === "rtl";
    const hasTouch = inBrowser && "ontouchstart" in window;
    const hasPointerEvents = inBrowser && window.PointerEvent;
    const pointerDown$1 = hasPointerEvents ? "pointerdown" : hasTouch ? "touchstart" : "mousedown";
    const pointerMove$1 = hasPointerEvents ? "pointermove" : hasTouch ? "touchmove" : "mousemove";
    const pointerUp$1 = hasPointerEvents ? "pointerup" : hasTouch ? "touchend" : "mouseup";
    const pointerEnter = hasPointerEvents ? "pointerenter" : hasTouch ? "" : "mouseenter";
    const pointerLeave = hasPointerEvents ? "pointerleave" : hasTouch ? "" : "mouseleave";
    const pointerCancel = hasPointerEvents ? "pointercancel" : "touchcancel";
    const fastdom = {
        reads: [],
        writes: [],
        read (task) {
            this.reads.push(task);
            scheduleFlush();
            return task;
        },
        write (task) {
            this.writes.push(task);
            scheduleFlush();
            return task;
        },
        clear (task) {
            remove(this.reads, task);
            remove(this.writes, task);
        },
        flush: flush
    };
    function flush(recursion) {
        runTasks(fastdom.reads);
        runTasks(fastdom.writes.splice(0));
        fastdom.scheduled = false;
        if (fastdom.reads.length || fastdom.writes.length) scheduleFlush(recursion + 1);
    }
    const RECURSION_LIMIT = 4;
    function scheduleFlush(recursion) {
        if (fastdom.scheduled) return;
        fastdom.scheduled = true;
        if (recursion && recursion < RECURSION_LIMIT) Promise.resolve().then(()=>flush(recursion));
        else requestAnimationFrame(()=>flush(1));
    }
    function runTasks(tasks) {
        let task;
        while(task = tasks.shift())try {
            task();
        } catch (e) {
            console.error(e);
        }
    }
    function remove(array, item) {
        const index = array.indexOf(item);
        return ~index && array.splice(index, 1);
    }
    function MouseTracker() {}
    MouseTracker.prototype = {
        positions: [],
        init () {
            this.positions = [];
            let position;
            this.unbind = on(document, "mousemove", (e)=>position = getEventPos(e));
            this.interval = setInterval(()=>{
                if (!position) return;
                this.positions.push(position);
                if (this.positions.length > 5) this.positions.shift();
            }, 50);
        },
        cancel () {
            var _a;
            (_a = this.unbind) == null || _a.call(this);
            clearInterval(this.interval);
        },
        movesTo (target) {
            if (this.positions.length < 2) return false;
            const p = target.getBoundingClientRect();
            const { left: left, right: right, top: top, bottom: bottom } = p;
            const [prevPosition] = this.positions;
            const position = last(this.positions);
            const path = [
                prevPosition,
                position
            ];
            if (pointInRect(position, p)) return false;
            const diagonals = [
                [
                    {
                        x: left,
                        y: top
                    },
                    {
                        x: right,
                        y: bottom
                    }
                ],
                [
                    {
                        x: left,
                        y: bottom
                    },
                    {
                        x: right,
                        y: top
                    }
                ]
            ];
            return diagonals.some((diagonal)=>{
                const intersection = intersect(path, diagonal);
                return intersection && pointInRect(intersection, p);
            });
        }
    };
    function intersect([{ x: x1, y: y1 }, { x: x2, y: y2 }], [{ x: x3, y: y3 }, { x: x4, y: y4 }]) {
        const denominator = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);
        if (denominator === 0) return false;
        const ua = ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) / denominator;
        if (ua < 0) return false;
        return {
            x: x1 + ua * (x2 - x1),
            y: y1 + ua * (y2 - y1)
        };
    }
    function observeIntersection(targets, cb, options = {}, { intersecting: intersecting = true } = {}) {
        const observer = new IntersectionObserver(intersecting ? (entries, observer2)=>{
            if (entries.some((entry)=>entry.isIntersecting)) cb(entries, observer2);
        } : cb, options);
        for (const el of toNodes(targets))observer.observe(el);
        return observer;
    }
    const hasResizeObserver = inBrowser && window.ResizeObserver;
    function observeResize(targets, cb, options = {
        box: "border-box"
    }) {
        if (hasResizeObserver) return observe$1(ResizeObserver, targets, cb, options);
        const off = [
            on(window, "load resize", cb),
            on(document, "loadedmetadata load", cb, true)
        ];
        return {
            disconnect: ()=>off.map((cb2)=>cb2())
        };
    }
    function observeViewportResize(cb) {
        return {
            disconnect: on([
                window,
                window.visualViewport
            ], "resize", cb)
        };
    }
    function observeMutation(targets, cb, options) {
        return observe$1(MutationObserver, targets, cb, options);
    }
    function observe$1(Observer, targets, cb, options) {
        const observer = new Observer(cb);
        for (const el of toNodes(targets))observer.observe(el, options);
        return observer;
    }
    function play(el) {
        if (isIFrame(el)) call(el, {
            func: "playVideo",
            method: "play"
        });
        if (isHTML5(el)) try {
            el.play().catch(noop);
        } catch (e) {}
    }
    function pause(el) {
        if (isIFrame(el)) call(el, {
            func: "pauseVideo",
            method: "pause"
        });
        if (isHTML5(el)) el.pause();
    }
    function mute(el) {
        if (isIFrame(el)) call(el, {
            func: "mute",
            method: "setVolume",
            value: 0
        });
        if (isHTML5(el)) el.muted = true;
    }
    function isVideo(el) {
        return isHTML5(el) || isIFrame(el);
    }
    function isHTML5(el) {
        return isTag(el, "video");
    }
    function isIFrame(el) {
        return isTag(el, "iframe") && (isYoutube(el) || isVimeo(el));
    }
    function isYoutube(el) {
        return !!el.src.match(/\/\/.*?youtube(-nocookie)?\.[a-z]+\/(watch\?v=[^&\s]+|embed)|youtu\.be\/.*/);
    }
    function isVimeo(el) {
        return !!el.src.match(/vimeo\.com\/video\/.*/);
    }
    async function call(el, cmd) {
        await enableApi(el);
        post(el, cmd);
    }
    function post(el, cmd) {
        try {
            el.contentWindow.postMessage(JSON.stringify({
                event: "command",
                ...cmd
            }), "*");
        } catch (e) {}
    }
    const stateKey = "_ukPlayer";
    let counter = 0;
    function enableApi(el) {
        if (el[stateKey]) return el[stateKey];
        const youtube = isYoutube(el);
        const vimeo = isVimeo(el);
        const id = ++counter;
        let poller;
        return el[stateKey] = new Promise((resolve)=>{
            youtube && once(el, "load", ()=>{
                const listener = ()=>post(el, {
                        event: "listening",
                        id: id
                    });
                poller = setInterval(listener, 100);
                listener();
            });
            once(window, "message", resolve, false, ({ data: data })=>{
                try {
                    data = JSON.parse(data);
                    return youtube && (data == null ? void 0 : data.id) === id && data.event === "onReady" || vimeo && Number(data == null ? void 0 : data.player_id) === id;
                } catch (e) {}
            });
            el.src = `${el.src}${includes(el.src, "?") ? "&" : "?"}${youtube ? "enablejsapi=1" : `api=1&player_id=${id}`}`;
        }).then(()=>clearInterval(poller));
    }
    function isInView(element, offsetTop = 0, offsetLeft = 0) {
        if (!isVisible(element)) return false;
        return intersectRect(...overflowParents(element).map((parent)=>{
            const { top: top, left: left, bottom: bottom, right: right } = offsetViewport(parent);
            return {
                top: top - offsetTop,
                left: left - offsetLeft,
                bottom: bottom + offsetTop,
                right: right + offsetLeft
            };
        }).concat(offset(element)));
    }
    function scrollIntoView(element, { offset: offsetBy = 0 } = {}) {
        const parents2 = isVisible(element) ? scrollParents(element, false, [
            "hidden"
        ]) : [];
        return parents2.reduce((fn, scrollElement, i)=>{
            const { scrollTop: scrollTop, scrollHeight: scrollHeight, offsetHeight: offsetHeight } = scrollElement;
            const viewport = offsetViewport(scrollElement);
            const maxScroll = scrollHeight - viewport.height;
            const { height: elHeight, top: elTop } = parents2[i - 1] ? offsetViewport(parents2[i - 1]) : offset(element);
            let top = Math.ceil(elTop - viewport.top - offsetBy + scrollTop);
            if (offsetBy > 0 && offsetHeight < elHeight + offsetBy) top += offsetBy;
            else offsetBy = 0;
            if (top > maxScroll) {
                offsetBy -= top - maxScroll;
                top = maxScroll;
            } else if (top < 0) {
                offsetBy -= top;
                top = 0;
            }
            return ()=>scrollTo(scrollElement, top - scrollTop).then(fn);
        }, ()=>Promise.resolve())();
        function scrollTo(element2, top) {
            return new Promise((resolve)=>{
                const scroll = element2.scrollTop;
                const duration = getDuration(Math.abs(top));
                const start = Date.now();
                (function step() {
                    const percent = ease(clamp((Date.now() - start) / duration));
                    element2.scrollTop = scroll + top * percent;
                    if (percent === 1) resolve();
                    else requestAnimationFrame(step);
                })();
            });
        }
        function getDuration(dist) {
            return 40 * Math.pow(dist, 0.375);
        }
        function ease(k) {
            return 0.5 * (1 - Math.cos(Math.PI * k));
        }
    }
    function scrolledOver(element, startOffset = 0, endOffset = 0) {
        if (!isVisible(element)) return 0;
        const scrollElement = scrollParent(element, true);
        const { scrollHeight: scrollHeight, scrollTop: scrollTop } = scrollElement;
        const { height: viewportHeight } = offsetViewport(scrollElement);
        const maxScroll = scrollHeight - viewportHeight;
        const elementOffsetTop = offsetPosition(element)[0] - offsetPosition(scrollElement)[0];
        const start = Math.max(0, elementOffsetTop - viewportHeight + startOffset);
        const end = Math.min(maxScroll, elementOffsetTop + element.offsetHeight - endOffset);
        return clamp((scrollTop - start) / (end - start));
    }
    function scrollParents(element, scrollable = false, props = []) {
        const scrollEl = scrollingElement(element);
        let ancestors = parents(element).reverse();
        ancestors = ancestors.slice(ancestors.indexOf(scrollEl) + 1);
        const fixedIndex = findIndex(ancestors, (el)=>css(el, "position") === "fixed");
        if (~fixedIndex) ancestors = ancestors.slice(fixedIndex);
        return [
            scrollEl
        ].concat(ancestors.filter((parent)=>css(parent, "overflow").split(" ").some((prop)=>includes([
                    "auto",
                    "scroll",
                    ...props
                ], prop)) && (!scrollable || parent.scrollHeight > offsetViewport(parent).height))).reverse();
    }
    function scrollParent(...args) {
        return scrollParents(...args)[0];
    }
    function overflowParents(element) {
        return scrollParents(element, false, [
            "hidden",
            "clip"
        ]);
    }
    function offsetViewport(scrollElement) {
        const window1 = toWindow(scrollElement);
        const { visualViewport: visualViewport, document: { documentElement: documentElement } } = window1;
        let viewportElement = scrollElement === scrollingElement(scrollElement) ? window1 : scrollElement;
        if (isWindow(viewportElement) && visualViewport) {
            let { height: height, width: width, scale: scale, pageTop: top, pageLeft: left } = visualViewport;
            height = Math.round(height * scale);
            width = Math.round(width * scale);
            return {
                height: height,
                width: width,
                top: top,
                left: left,
                bottom: top + height,
                right: left + width
            };
        }
        let rect = offset(viewportElement);
        if (css(viewportElement, "display") === "inline") return rect;
        for (let [prop, dir, start, end] of [
            [
                "width",
                "x",
                "left",
                "right"
            ],
            [
                "height",
                "y",
                "top",
                "bottom"
            ]
        ]){
            if (isWindow(viewportElement)) viewportElement = documentElement;
            else rect[start] += toFloat(css(viewportElement, `border-${start}-width`));
            const subpixel = rect[prop] % 1;
            rect[prop] = rect[dir] = viewportElement[`client${ucfirst(prop)}`] - (subpixel ? subpixel < 0.5 ? -subpixel : 1 - subpixel : 0);
            rect[end] = rect[prop] + rect[start];
        }
        return rect;
    }
    function scrollingElement(element) {
        return toWindow(element).document.scrollingElement;
    }
    const dirs = [
        [
            "width",
            "x",
            "left",
            "right"
        ],
        [
            "height",
            "y",
            "top",
            "bottom"
        ]
    ];
    function positionAt(element, target, options) {
        options = {
            attach: {
                element: [
                    "left",
                    "top"
                ],
                target: [
                    "left",
                    "top"
                ],
                ...options.attach
            },
            offset: [
                0,
                0
            ],
            placement: [],
            ...options
        };
        if (!isArray(target)) target = [
            target,
            target
        ];
        offset(element, getPosition(element, target, options));
    }
    function getPosition(element, target, options) {
        const position = attachTo(element, target, options);
        const { boundary: boundary, viewportOffset: viewportOffset = 0, placement: placement } = options;
        let offsetPosition = position;
        for (const [i, [prop, , start, end]] of Object.entries(dirs)){
            const viewport = getViewport$2(element, target[i], viewportOffset, boundary, i);
            if (isWithin(position, viewport, i)) continue;
            let offsetBy = 0;
            if (placement[i] === "flip") {
                const attach = options.attach.target[i];
                if (attach === end && position[end] <= viewport[end] || attach === start && position[start] >= viewport[start]) continue;
                offsetBy = flip(element, target, options, i)[start] - position[start];
                const scrollArea = getScrollArea(element, target[i], viewportOffset, i);
                if (!isWithin(applyOffset(position, offsetBy, i), scrollArea, i)) {
                    if (isWithin(position, scrollArea, i)) continue;
                    if (options.recursion) return false;
                    const newPos = flipAxis(element, target, options);
                    if (newPos && isWithin(newPos, scrollArea, 1 - i)) return newPos;
                    continue;
                }
            } else if (placement[i] === "shift") {
                const targetDim = offset(target[i]);
                const { offset: elOffset } = options;
                offsetBy = clamp(clamp(position[start], viewport[start], viewport[end] - position[prop]), targetDim[start] - position[prop] + elOffset[i], targetDim[end] - elOffset[i]) - position[start];
            }
            offsetPosition = applyOffset(offsetPosition, offsetBy, i);
        }
        return offsetPosition;
    }
    function attachTo(element, target, options) {
        let { attach: attach, offset: offsetBy } = {
            attach: {
                element: [
                    "left",
                    "top"
                ],
                target: [
                    "left",
                    "top"
                ],
                ...options.attach
            },
            offset: [
                0,
                0
            ],
            ...options
        };
        let elOffset = offset(element);
        for (const [i, [prop, , start, end]] of Object.entries(dirs)){
            const targetOffset = attach.target[i] === attach.element[i] ? offsetViewport(target[i]) : offset(target[i]);
            elOffset = applyOffset(elOffset, targetOffset[start] - elOffset[start] + moveBy(attach.target[i], end, targetOffset[prop]) - moveBy(attach.element[i], end, elOffset[prop]) + +offsetBy[i], i);
        }
        return elOffset;
    }
    function applyOffset(position, offset2, i) {
        const [, dir, start, end] = dirs[i];
        const newPos = {
            ...position
        };
        newPos[start] = position[dir] = position[start] + offset2;
        newPos[end] += offset2;
        return newPos;
    }
    function moveBy(attach, end, dim) {
        return attach === "center" ? dim / 2 : attach === end ? dim : 0;
    }
    function getViewport$2(element, target, viewportOffset, boundary, i) {
        let viewport = getIntersectionArea(...commonScrollParents(element, target).map(offsetViewport));
        if (viewportOffset) {
            viewport[dirs[i][2]] += viewportOffset;
            viewport[dirs[i][3]] -= viewportOffset;
        }
        if (boundary) viewport = getIntersectionArea(viewport, offset(isArray(boundary) ? boundary[i] : boundary));
        return viewport;
    }
    function getScrollArea(element, target, viewportOffset, i) {
        const [prop, axis, start, end] = dirs[i];
        const [scrollElement] = commonScrollParents(element, target);
        const viewport = offsetViewport(scrollElement);
        if ([
            "auto",
            "scroll"
        ].includes(css(scrollElement, `overflow-${axis}`))) {
            viewport[start] -= scrollElement[`scroll${ucfirst(start)}`];
            viewport[end] = viewport[start] + scrollElement[`scroll${ucfirst(prop)}`];
        }
        viewport[start] += viewportOffset;
        viewport[end] -= viewportOffset;
        return viewport;
    }
    function commonScrollParents(element, target) {
        return overflowParents(target).filter((parent)=>within(element, parent));
    }
    function getIntersectionArea(...rects) {
        let area = {};
        for (const rect of rects)for (const [, , start, end] of dirs){
            area[start] = Math.max(area[start] || 0, rect[start]);
            area[end] = Math.min(...[
                area[end],
                rect[end]
            ].filter(Boolean));
        }
        return area;
    }
    function isWithin(positionA, positionB, i) {
        const [, , start, end] = dirs[i];
        return positionA[start] >= positionB[start] && positionA[end] <= positionB[end];
    }
    function flip(element, target, { offset: offset2, attach: attach }, i) {
        return attachTo(element, target, {
            attach: {
                element: flipAttach(attach.element, i),
                target: flipAttach(attach.target, i)
            },
            offset: flipOffset(offset2, i)
        });
    }
    function flipAxis(element, target, options) {
        return getPosition(element, target, {
            ...options,
            attach: {
                element: options.attach.element.map(flipAttachAxis).reverse(),
                target: options.attach.target.map(flipAttachAxis).reverse()
            },
            offset: options.offset.reverse(),
            placement: options.placement.reverse(),
            recursion: true
        });
    }
    function flipAttach(attach, i) {
        const newAttach = [
            ...attach
        ];
        const index = dirs[i].indexOf(attach[i]);
        if (~index) newAttach[i] = dirs[i][1 - index % 2 + 2];
        return newAttach;
    }
    function flipAttachAxis(prop) {
        for(let i = 0; i < dirs.length; i++){
            const index = dirs[i].indexOf(prop);
            if (~index) return dirs[1 - i][index % 2 + 2];
        }
    }
    function flipOffset(offset2, i) {
        offset2 = [
            ...offset2
        ];
        offset2[i] *= -1;
        return offset2;
    }
    var util = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        $: $,
        $$: $$,
        Animation: Animation,
        Dimensions: Dimensions,
        MouseTracker: MouseTracker,
        Transition: Transition,
        addClass: addClass,
        after: after,
        append: append,
        apply: apply,
        assign: assign,
        attr: attr,
        before: before,
        boxModelAdjust: boxModelAdjust,
        camelize: camelize,
        children: children,
        clamp: clamp,
        closest: closest,
        createEvent: createEvent,
        css: css,
        data: data,
        dimensions: dimensions$1,
        each: each,
        empty: empty,
        endsWith: endsWith,
        escape: escape,
        fastdom: fastdom,
        filter: filter$1,
        find: find,
        findAll: findAll,
        findIndex: findIndex,
        flipPosition: flipPosition,
        fragment: fragment,
        getEventPos: getEventPos,
        getIndex: getIndex,
        getTargetedElement: getTargetedElement,
        hasAttr: hasAttr,
        hasClass: hasClass,
        hasOwn: hasOwn,
        hasTouch: hasTouch,
        height: height,
        html: html,
        hyphenate: hyphenate,
        inBrowser: inBrowser,
        includes: includes,
        index: index,
        intersectRect: intersectRect,
        isArray: isArray,
        isBoolean: isBoolean,
        isDocument: isDocument,
        isElement: isElement,
        isEmpty: isEmpty,
        isEqual: isEqual,
        isFocusable: isFocusable,
        isFunction: isFunction,
        isInView: isInView,
        isInput: isInput,
        isNode: isNode,
        isNumber: isNumber,
        isNumeric: isNumeric,
        isObject: isObject,
        isPlainObject: isPlainObject,
        isRtl: isRtl,
        isSameSiteAnchor: isSameSiteAnchor,
        isString: isString,
        isTag: isTag,
        isTouch: isTouch,
        isUndefined: isUndefined,
        isVideo: isVideo,
        isVisible: isVisible,
        isVoidElement: isVoidElement,
        isWindow: isWindow,
        last: last,
        matches: matches,
        memoize: memoize,
        mute: mute,
        noop: noop,
        observeIntersection: observeIntersection,
        observeMutation: observeMutation,
        observeResize: observeResize,
        observeViewportResize: observeViewportResize,
        off: off,
        offset: offset,
        offsetPosition: offsetPosition,
        offsetViewport: offsetViewport,
        on: on,
        once: once,
        overflowParents: overflowParents,
        parent: parent,
        parents: parents,
        pause: pause,
        pick: pick,
        play: play,
        pointInRect: pointInRect,
        pointerCancel: pointerCancel,
        pointerDown: pointerDown$1,
        pointerEnter: pointerEnter,
        pointerLeave: pointerLeave,
        pointerMove: pointerMove$1,
        pointerUp: pointerUp$1,
        position: position,
        positionAt: positionAt,
        prepend: prepend,
        propName: propName,
        query: query,
        queryAll: queryAll,
        ready: ready,
        remove: remove$1,
        removeAttr: removeAttr,
        removeClass: removeClass,
        removeClasses: removeClasses,
        replaceClass: replaceClass,
        scrollIntoView: scrollIntoView,
        scrollParent: scrollParent,
        scrollParents: scrollParents,
        scrolledOver: scrolledOver,
        selFocusable: selFocusable,
        selInput: selInput,
        sortBy: sortBy$1,
        startsWith: startsWith,
        sumBy: sumBy,
        swap: swap,
        toArray: toArray,
        toBoolean: toBoolean,
        toEventTargets: toEventTargets,
        toFloat: toFloat,
        toNode: toNode,
        toNodes: toNodes,
        toNumber: toNumber,
        toPx: toPx,
        toWindow: toWindow,
        toggleClass: toggleClass,
        trigger: trigger,
        ucfirst: ucfirst,
        uniqueBy: uniqueBy,
        unwrap: unwrap,
        width: width,
        within: within,
        wrapAll: wrapAll,
        wrapInner: wrapInner
    });
    function initWatches(instance) {
        instance._watches = [];
        for (const watches of instance.$options.watch || [])for (const [name, watch] of Object.entries(watches))registerWatch(instance, watch, name);
        instance._initial = true;
    }
    function registerWatch(instance, watch, name) {
        instance._watches.push({
            name: name,
            ...isPlainObject(watch) ? watch : {
                handler: watch
            }
        });
    }
    function runWatches(instance, values) {
        for (const { name: name, handler: handler, immediate: immediate = true } of instance._watches)if (instance._initial && immediate || hasOwn(values, name) && !isEqual(values[name], instance[name])) handler.call(instance, instance[name], values[name]);
        instance._initial = false;
    }
    function initUpdates(instance) {
        instance._data = {};
        instance._updates = [
            ...instance.$options.update || []
        ];
    }
    function prependUpdate(instance, update) {
        instance._updates.unshift(update);
    }
    function clearUpdateData(instance) {
        delete instance._data;
    }
    function callUpdate(instance, e = "update") {
        if (!instance._connected) return;
        if (!instance._updates.length) return;
        if (!instance._queued) {
            instance._queued = /* @__PURE__ */ new Set();
            fastdom.read(()=>{
                if (instance._connected) runUpdates(instance, instance._queued);
                delete instance._queued;
            });
        }
        instance._queued.add(e.type || e);
    }
    function runUpdates(instance, types) {
        for (const { read: read, write: write, events: events = [] } of instance._updates){
            if (!types.has("update") && !events.some((type)=>types.has(type))) continue;
            let result;
            if (read) {
                result = read.call(instance, instance._data, types);
                if (result && isPlainObject(result)) assign(instance._data, result);
            }
            if (write && result !== false) fastdom.write(()=>{
                if (instance._connected) write.call(instance, instance._data, types);
            });
        }
    }
    function initComputed(instance) {
        const { computed: computed } = instance.$options;
        instance._computed = {};
        if (computed) for(const key in computed)registerComputed(instance, key, computed[key]);
    }
    function registerComputed(instance, key, cb) {
        instance._hasComputed = true;
        Object.defineProperty(instance, key, {
            enumerable: true,
            get () {
                const { _computed: _computed, $props: $props, $el: $el } = instance;
                if (!hasOwn(_computed, key)) _computed[key] = (cb.get || cb).call(instance, $props, $el);
                return _computed[key];
            },
            set (value) {
                const { _computed: _computed } = instance;
                _computed[key] = cb.set ? cb.set.call(instance, value) : value;
                if (isUndefined(_computed[key])) delete _computed[key];
            }
        });
    }
    function initComputedUpdates(instance) {
        if (!instance._hasComputed) return;
        prependUpdate(instance, {
            read: ()=>runWatches(instance, resetComputed(instance)),
            events: [
                "resize",
                "computed"
            ]
        });
        registerComputedObserver();
        instances$1.add(instance);
    }
    function disconnectComputedUpdates(instance) {
        instances$1 == null || instances$1.delete(instance);
        resetComputed(instance);
    }
    function resetComputed(instance) {
        const values = {
            ...instance._computed
        };
        instance._computed = {};
        return values;
    }
    let observer;
    let instances$1;
    function registerComputedObserver() {
        if (observer) return;
        instances$1 = /* @__PURE__ */ new Set();
        observer = new MutationObserver(()=>{
            for (const instance of instances$1)callUpdate(instance, "computed");
        });
        observer.observe(document, {
            childList: true,
            subtree: true
        });
    }
    function initEvents(instance) {
        instance._events = [];
        for (const event of instance.$options.events || []){
            if (hasOwn(event, "handler")) registerEvent(instance, event);
            else for(const key in event)registerEvent(instance, event[key], key);
        }
    }
    function unbindEvents(instance) {
        instance._events.forEach((unbind)=>unbind());
        delete instance._events;
    }
    function registerEvent(instance, event, key) {
        let { name: name, el: el, handler: handler, capture: capture, passive: passive, delegate: delegate, filter: filter, self: self } = isPlainObject(event) ? event : {
            name: key,
            handler: event
        };
        el = isFunction(el) ? el.call(instance, instance) : el || instance.$el;
        if (isArray(el)) {
            el.forEach((el2)=>registerEvent(instance, {
                    ...event,
                    el: el2
                }, key));
            return;
        }
        if (!el || filter && !filter.call(instance)) return;
        instance._events.push(on(el, name, delegate ? isString(delegate) ? delegate : delegate.call(instance, instance) : null, isString(handler) ? instance[handler] : handler.bind(instance), {
            passive: passive,
            capture: capture,
            self: self
        }));
    }
    function initObservers(instance) {
        instance._observers = [];
        for (const observer of instance.$options.observe || []){
            if (hasOwn(observer, "handler")) registerObservable(instance, observer);
            else for (const observable of observer)registerObservable(instance, observable);
        }
    }
    function registerObserver(instance, ...observer) {
        instance._observers.push(...observer);
    }
    function disconnectObservers(instance) {
        for (const observer of instance._observers)observer.disconnect();
    }
    function registerObservable(instance, observable) {
        let { observe: observe, target: target = instance.$el, handler: handler, options: options, filter: filter, args: args } = observable;
        if (filter && !filter.call(instance, instance)) return;
        const key = `_observe${instance._observers.length}`;
        if (isFunction(target) && !hasOwn(instance, key)) registerComputed(instance, key, ()=>target.call(instance, instance));
        handler = isString(handler) ? instance[handler] : handler.bind(instance);
        if (isFunction(options)) options = options.call(instance, instance);
        const targets = hasOwn(instance, key) ? instance[key] : target;
        const observer = observe(targets, handler, options, args);
        if (isFunction(target) && isArray(instance[key]) && observer.unobserve) registerWatch(instance, {
            handler: updateTargets(observer),
            immediate: false
        }, key);
        registerObserver(instance, observer);
    }
    function updateTargets(observer) {
        return (targets, prev)=>{
            for (const target of prev)!includes(targets, target) && observer.unobserve(target);
            for (const target of targets)!includes(prev, target) && observer.observe(target);
        };
    }
    const strats = {};
    strats.events = strats.watch = strats.observe = strats.created = strats.beforeConnect = strats.connected = strats.beforeDisconnect = strats.disconnected = strats.destroy = concatStrat;
    strats.args = function(parentVal, childVal) {
        return childVal !== false && concatStrat(childVal || parentVal);
    };
    strats.update = function(parentVal, childVal) {
        return sortBy$1(concatStrat(parentVal, isFunction(childVal) ? {
            read: childVal
        } : childVal), "order");
    };
    strats.props = function(parentVal, childVal) {
        if (isArray(childVal)) {
            const value = {};
            for (const key of childVal)value[key] = String;
            childVal = value;
        }
        return strats.methods(parentVal, childVal);
    };
    strats.computed = strats.methods = function(parentVal, childVal) {
        return childVal ? parentVal ? {
            ...parentVal,
            ...childVal
        } : childVal : parentVal;
    };
    strats.i18n = strats.data = function(parentVal, childVal, vm) {
        if (!vm) {
            if (!childVal) return parentVal;
            if (!parentVal) return childVal;
            return function(vm2) {
                return mergeFnData(parentVal, childVal, vm2);
            };
        }
        return mergeFnData(parentVal, childVal, vm);
    };
    function mergeFnData(parentVal, childVal, vm) {
        return strats.computed(isFunction(parentVal) ? parentVal.call(vm, vm) : parentVal, isFunction(childVal) ? childVal.call(vm, vm) : childVal);
    }
    function concatStrat(parentVal, childVal) {
        parentVal = parentVal && !isArray(parentVal) ? [
            parentVal
        ] : parentVal;
        return childVal ? parentVal ? parentVal.concat(childVal) : isArray(childVal) ? childVal : [
            childVal
        ] : parentVal;
    }
    function defaultStrat(parentVal, childVal) {
        return isUndefined(childVal) ? parentVal : childVal;
    }
    function mergeOptions(parent, child, vm) {
        const options = {};
        if (isFunction(child)) child = child.options;
        if (child.extends) parent = mergeOptions(parent, child.extends, vm);
        if (child.mixins) for (const mixin of child.mixins)parent = mergeOptions(parent, mixin, vm);
        for(const key in parent)mergeKey(key);
        for(const key in child)if (!hasOwn(parent, key)) mergeKey(key);
        function mergeKey(key) {
            options[key] = (strats[key] || defaultStrat)(parent[key], child[key], vm);
        }
        return options;
    }
    function parseOptions(options, args = []) {
        try {
            return options ? startsWith(options, "{") ? JSON.parse(options) : args.length && !includes(options, ":") ? {
                [args[0]]: options
            } : options.split(";").reduce((options2, option)=>{
                const [key, value] = option.split(/:(.*)/);
                if (key && !isUndefined(value)) options2[key.trim()] = value.trim();
                return options2;
            }, {}) : {};
        } catch (e) {
            return {};
        }
    }
    function coerce$1(type, value) {
        if (type === Boolean) return toBoolean(value);
        else if (type === Number) return toNumber(value);
        else if (type === "list") return toList(value);
        else if (type === Object && isString(value)) return parseOptions(value);
        return type ? type(value) : value;
    }
    function toList(value) {
        return isArray(value) ? value : isString(value) ? value.split(/,(?![^(]*\))/).map((value2)=>isNumeric(value2) ? toNumber(value2) : toBoolean(value2.trim())) : [
            value
        ];
    }
    function initProps(instance) {
        const props = getProps$1(instance.$options);
        for(let key in props)if (!isUndefined(props[key])) instance.$props[key] = props[key];
        const exclude = [
            instance.$options.computed,
            instance.$options.methods
        ];
        for(let key in instance.$props)if (key in props && notIn(exclude, key)) instance[key] = instance.$props[key];
    }
    function getProps$1(opts) {
        const data$1 = {};
        const { args: args = [], props: props = {}, el: el, id: id } = opts;
        if (!props) return data$1;
        for(const key in props){
            const prop = hyphenate(key);
            let value = data(el, prop);
            if (isUndefined(value)) continue;
            value = props[key] === Boolean && value === "" ? true : coerce$1(props[key], value);
            if (prop === "target" && startsWith(value, "_")) continue;
            data$1[key] = value;
        }
        const options = parseOptions(data(el, id), args);
        for(const key in options){
            const prop = camelize(key);
            if (!isUndefined(props[prop])) data$1[prop] = coerce$1(props[prop], options[key]);
        }
        return data$1;
    }
    function notIn(options, key) {
        return options.every((arr)=>!arr || !hasOwn(arr, key));
    }
    function initPropsObserver(instance) {
        const { $options: $options, $props: $props } = instance;
        const { id: id, props: props, el: el } = $options;
        if (!props) return;
        const attributes = Object.keys(props);
        const filter = attributes.map((key)=>hyphenate(key)).concat(id);
        const observer = new MutationObserver((records)=>{
            const data = getProps$1($options);
            if (records.some(({ attributeName: attributeName })=>{
                const prop = attributeName.replace("data-", "");
                return (prop === id ? attributes : [
                    camelize(prop),
                    camelize(attributeName)
                ]).some((prop2)=>!isUndefined(data[prop2]) && data[prop2] !== $props[prop2]);
            })) instance.$reset();
        });
        observer.observe(el, {
            attributes: true,
            attributeFilter: filter.concat(filter.map((key)=>`data-${key}`))
        });
        registerObserver(instance, observer);
    }
    function callHook(instance, hook) {
        var _a;
        (_a = instance.$options[hook]) == null || _a.forEach((handler)=>handler.call(instance));
    }
    function callConnected(instance) {
        if (instance._connected) return;
        initProps(instance);
        callHook(instance, "beforeConnect");
        instance._connected = true;
        initEvents(instance);
        initUpdates(instance);
        initWatches(instance);
        initObservers(instance);
        initPropsObserver(instance);
        initComputedUpdates(instance);
        callHook(instance, "connected");
        callUpdate(instance);
    }
    function callDisconnected(instance) {
        if (!instance._connected) return;
        callHook(instance, "beforeDisconnect");
        unbindEvents(instance);
        clearUpdateData(instance);
        disconnectObservers(instance);
        disconnectComputedUpdates(instance);
        callHook(instance, "disconnected");
        instance._connected = false;
    }
    let uid = 0;
    function init$1(instance, options = {}) {
        options.data = normalizeData(options, instance.constructor.options);
        instance.$options = mergeOptions(instance.constructor.options, options, instance);
        instance.$props = {};
        instance._uid = uid++;
        initData(instance);
        initMethods(instance);
        initComputed(instance);
        callHook(instance, "created");
        if (options.el) instance.$mount(options.el);
    }
    function initData(instance) {
        const { data: data = {} } = instance.$options;
        for(const key in data)instance.$props[key] = instance[key] = data[key];
    }
    function initMethods(instance) {
        const { methods: methods } = instance.$options;
        if (methods) for(const key in methods)instance[key] = methods[key].bind(instance);
    }
    function normalizeData({ data: data = {} }, { args: args = [], props: props = {} }) {
        if (isArray(data)) data = data.slice(0, args.length).reduce((data2, value, index)=>{
            if (isPlainObject(value)) assign(data2, value);
            else data2[args[index]] = value;
            return data2;
        }, {});
        for(const key in data){
            if (isUndefined(data[key])) delete data[key];
            else if (props[key]) data[key] = coerce$1(props[key], data[key]);
        }
        return data;
    }
    const App = function(options) {
        init$1(this, options);
    };
    App.util = util;
    App.options = {};
    App.version = "3.16.22";
    const PREFIX = "uk-";
    const DATA = "__uikit__";
    const components$2 = {};
    function component(name, options) {
        var _a;
        const id = PREFIX + hyphenate(name);
        if (!options) {
            if (isPlainObject(components$2[id])) components$2[id] = App.extend(components$2[id]);
            return components$2[id];
        }
        name = camelize(name);
        App[name] = (element, data)=>createComponent(name, element, data);
        const opt = isPlainObject(options) ? {
            ...options
        } : options.options;
        opt.id = id;
        opt.name = name;
        (_a = opt.install) == null || _a.call(opt, App, opt, name);
        if (App._initialized && !opt.functional) requestAnimationFrame(()=>createComponent(name, `[${id}],[data-${id}]`));
        return components$2[id] = opt;
    }
    function createComponent(name, element, data, ...args) {
        const Component = component(name);
        return Component.options.functional ? new Component({
            data: isPlainObject(element) ? element : [
                element,
                data,
                ...args
            ]
        }) : element ? $$(element).map(init)[0] : init();
        function init(element2) {
            const instance = getComponent(element2, name);
            if (instance) {
                if (data) instance.$destroy();
                else return instance;
            }
            return new Component({
                el: element2,
                data: data
            });
        }
    }
    function getComponents(element) {
        return (element == null ? void 0 : element[DATA]) || {};
    }
    function getComponent(element, name) {
        return getComponents(element)[name];
    }
    function attachToElement(element, instance) {
        if (!element[DATA]) element[DATA] = {};
        element[DATA][instance.$options.name] = instance;
    }
    function detachFromElement(element, instance) {
        var _a;
        (_a = element[DATA]) == null || delete _a[instance.$options.name];
        if (!isEmpty(element[DATA])) delete element[DATA];
    }
    function globalApi(App) {
        App.component = component;
        App.getComponents = getComponents;
        App.getComponent = getComponent;
        App.update = update;
        App.use = function(plugin) {
            if (plugin.installed) return;
            plugin.call(null, this);
            plugin.installed = true;
            return this;
        };
        App.mixin = function(mixin, component2) {
            component2 = (isString(component2) ? this.component(component2) : component2) || this;
            component2.options = mergeOptions(component2.options, mixin);
        };
        App.extend = function(options) {
            options || (options = {});
            const Super = this;
            const Sub = function UIkitComponent(options2) {
                init$1(this, options2);
            };
            Sub.prototype = Object.create(Super.prototype);
            Sub.prototype.constructor = Sub;
            Sub.options = mergeOptions(Super.options, options);
            Sub.super = Super;
            Sub.extend = Super.extend;
            return Sub;
        };
        let container;
        Object.defineProperty(App, "container", {
            get () {
                return container || document.body;
            },
            set (element) {
                container = $(element);
            }
        });
    }
    function update(element, e) {
        element = element ? toNode(element) : document.body;
        for (const parentEl of parents(element).reverse())updateElement(parentEl, e);
        apply(element, (element2)=>updateElement(element2, e));
    }
    function updateElement(element, e) {
        const components = getComponents(element);
        for(const name in components)callUpdate(components[name], e);
    }
    function instanceApi(App) {
        App.prototype.$mount = function(el) {
            const instance = this;
            attachToElement(el, instance);
            instance.$options.el = el;
            if (within(el, document)) callConnected(instance);
        };
        App.prototype.$destroy = function(removeEl = false) {
            const instance = this;
            const { el: el } = instance.$options;
            if (el) callDisconnected(instance);
            callHook(instance, "destroy");
            detachFromElement(el, instance);
            if (removeEl) remove$1(instance.$el);
        };
        App.prototype.$create = createComponent;
        App.prototype.$emit = function(e) {
            callUpdate(this, e);
        };
        App.prototype.$update = function(element = this.$el, e) {
            update(element, e);
        };
        App.prototype.$reset = function() {
            callDisconnected(this);
            callConnected(this);
        };
        App.prototype.$getComponent = getComponent;
        Object.defineProperties(App.prototype, {
            $el: {
                get () {
                    return this.$options.el;
                }
            },
            $container: Object.getOwnPropertyDescriptor(App, "container")
        });
    }
    function generateId(instance, el = instance.$el, postfix = "") {
        if (el.id) return el.id;
        let id = `${instance.$options.id}-${instance._uid}${postfix}`;
        if ($(`#${id}`)) id = generateId(instance, el, `${postfix}-2`);
        return id;
    }
    globalApi(App);
    instanceApi(App);
    function boot(App) {
        if (inBrowser && window.MutationObserver) {
            if (document.body) requestAnimationFrame(()=>init(App));
            else new MutationObserver((records, observer)=>{
                if (document.body) {
                    init(App);
                    observer.disconnect();
                }
            }).observe(document.documentElement, {
                childList: true
            });
        }
    }
    function init(App) {
        trigger(document, "uikit:init", App);
        if (document.body) apply(document.body, connect);
        new MutationObserver((records)=>records.forEach(applyChildListMutation)).observe(document, {
            childList: true,
            subtree: true
        });
        new MutationObserver((records)=>records.forEach(applyAttributeMutation)).observe(document, {
            attributes: true,
            subtree: true
        });
        App._initialized = true;
    }
    function applyChildListMutation({ addedNodes: addedNodes, removedNodes: removedNodes }) {
        for (const node of addedNodes)apply(node, connect);
        for (const node of removedNodes)apply(node, disconnect);
    }
    function applyAttributeMutation({ target: target, attributeName: attributeName }) {
        var _a;
        const name = getComponentName(attributeName);
        if (name) {
            if (hasAttr(target, attributeName)) {
                createComponent(name, target);
                return;
            }
            (_a = getComponent(target, name)) == null || _a.$destroy();
        }
    }
    function connect(node) {
        const components2 = getComponents(node);
        for(const name in getComponents(node))callConnected(components2[name]);
        for (const attributeName of node.getAttributeNames()){
            const name = getComponentName(attributeName);
            name && createComponent(name, node);
        }
    }
    function disconnect(node) {
        const components2 = getComponents(node);
        for(const name in getComponents(node))callDisconnected(components2[name]);
    }
    function getComponentName(attribute) {
        if (startsWith(attribute, "data-")) attribute = attribute.slice(5);
        const cmp = components$2[attribute];
        return cmp && (isPlainObject(cmp) ? cmp : cmp.options).name;
    }
    var Class = {
        connected () {
            addClass(this.$el, this.$options.id);
        }
    };
    var Togglable = {
        props: {
            cls: Boolean,
            animation: "list",
            duration: Number,
            velocity: Number,
            origin: String,
            transition: String
        },
        data: {
            cls: false,
            animation: [
                false
            ],
            duration: 200,
            velocity: 0.2,
            origin: false,
            transition: "ease",
            clsEnter: "uk-togglabe-enter",
            clsLeave: "uk-togglabe-leave"
        },
        computed: {
            hasAnimation ({ animation: animation }) {
                return !!animation[0];
            },
            hasTransition ({ animation: animation }) {
                return [
                    "slide",
                    "reveal"
                ].some((transition)=>startsWith(animation[0], transition));
            }
        },
        methods: {
            async toggleElement (targets, toggle, animate) {
                try {
                    await Promise.all(toNodes(targets).map((el)=>{
                        const show = isBoolean(toggle) ? toggle : !this.isToggled(el);
                        if (!trigger(el, `before${show ? "show" : "hide"}`, [
                            this
                        ])) return Promise.reject();
                        const promise = (isFunction(animate) ? animate : animate === false || !this.hasAnimation ? toggleInstant : this.hasTransition ? toggleTransition : toggleAnimation)(el, show, this);
                        const cls = show ? this.clsEnter : this.clsLeave;
                        addClass(el, cls);
                        trigger(el, show ? "show" : "hide", [
                            this
                        ]);
                        const done = ()=>{
                            removeClass(el, cls);
                            trigger(el, show ? "shown" : "hidden", [
                                this
                            ]);
                        };
                        return promise ? promise.then(done, ()=>{
                            removeClass(el, cls);
                            return Promise.reject();
                        }) : done();
                    }));
                    return true;
                } catch (e) {
                    return false;
                }
            },
            isToggled (el = this.$el) {
                el = toNode(el);
                return hasClass(el, this.clsEnter) ? true : hasClass(el, this.clsLeave) ? false : this.cls ? hasClass(el, this.cls.split(" ")[0]) : isVisible(el);
            },
            _toggle (el, toggled) {
                if (!el) return;
                toggled = Boolean(toggled);
                let changed;
                if (this.cls) {
                    changed = includes(this.cls, " ") || toggled !== hasClass(el, this.cls);
                    changed && toggleClass(el, this.cls, includes(this.cls, " ") ? void 0 : toggled);
                } else {
                    changed = toggled === el.hidden;
                    changed && (el.hidden = !toggled);
                }
                $$("[autofocus]", el).some((el2)=>isVisible(el2) ? el2.focus() || true : el2.blur());
                if (changed) trigger(el, "toggled", [
                    toggled,
                    this
                ]);
            }
        }
    };
    function toggleInstant(el, show, { _toggle: _toggle }) {
        Animation.cancel(el);
        Transition.cancel(el);
        return _toggle(el, show);
    }
    async function toggleTransition(el, show, { animation: animation, duration: duration, velocity: velocity, transition: transition, _toggle: _toggle }) {
        var _a;
        const [mode = "reveal", startProp = "top"] = ((_a = animation[0]) == null ? void 0 : _a.split("-")) || [];
        const dirs = [
            [
                "left",
                "right"
            ],
            [
                "top",
                "bottom"
            ]
        ];
        const dir = dirs[includes(dirs[0], startProp) ? 0 : 1];
        const end = dir[1] === startProp;
        const props = [
            "width",
            "height"
        ];
        const dimProp = props[dirs.indexOf(dir)];
        const marginProp = `margin-${dir[0]}`;
        const marginStartProp = `margin-${startProp}`;
        let currentDim = dimensions$1(el)[dimProp];
        const inProgress = Transition.inProgress(el);
        await Transition.cancel(el);
        if (show) _toggle(el, true);
        const prevProps = Object.fromEntries([
            "padding",
            "border",
            "width",
            "height",
            "minWidth",
            "minHeight",
            "overflowY",
            "overflowX",
            marginProp,
            marginStartProp
        ].map((key)=>[
                key,
                el.style[key]
            ]));
        const dim = dimensions$1(el);
        const currentMargin = toFloat(css(el, marginProp));
        const marginStart = toFloat(css(el, marginStartProp));
        const endDim = dim[dimProp] + marginStart;
        if (!inProgress && !show) currentDim += marginStart;
        const [wrapper] = wrapInner(el, "<div>");
        css(wrapper, {
            boxSizing: "border-box",
            height: dim.height,
            width: dim.width,
            ...css(el, [
                "overflow",
                "padding",
                "borderTop",
                "borderRight",
                "borderBottom",
                "borderLeft",
                "borderImage",
                marginStartProp
            ])
        });
        css(el, {
            padding: 0,
            border: 0,
            minWidth: 0,
            minHeight: 0,
            [marginStartProp]: 0,
            width: dim.width,
            height: dim.height,
            overflow: "hidden",
            [dimProp]: currentDim
        });
        const percent = currentDim / endDim;
        duration = (velocity * endDim + duration) * (show ? 1 - percent : percent);
        const endProps = {
            [dimProp]: show ? endDim : 0
        };
        if (end) {
            css(el, marginProp, endDim - currentDim + currentMargin);
            endProps[marginProp] = show ? currentMargin : endDim + currentMargin;
        }
        if (!end ^ mode === "reveal") {
            css(wrapper, marginProp, -endDim + currentDim);
            Transition.start(wrapper, {
                [marginProp]: show ? 0 : -endDim
            }, duration, transition);
        }
        try {
            await Transition.start(el, endProps, duration, transition);
        } finally{
            css(el, prevProps);
            unwrap(wrapper.firstChild);
            if (!show) _toggle(el, false);
        }
    }
    function toggleAnimation(el, show, cmp) {
        Animation.cancel(el);
        const { animation: animation, duration: duration, _toggle: _toggle } = cmp;
        if (show) {
            _toggle(el, true);
            return Animation.in(el, animation[0], duration, cmp.origin);
        }
        return Animation.out(el, animation[1] || animation[0], duration, cmp.origin).then(()=>_toggle(el, false));
    }
    const keyMap = {
        TAB: 9,
        ESC: 27,
        SPACE: 32,
        END: 35,
        HOME: 36,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40
    };
    function resize(options) {
        return observe(observeResize, options, "resize");
    }
    function intersection(options) {
        return observe(observeIntersection, options);
    }
    function mutation(options) {
        return observe(observeMutation, options);
    }
    function lazyload(options = {}) {
        return intersection({
            handler: function(entries, observer) {
                const { targets: targets = this.$el, preload: preload = 5 } = options;
                for (const el of toNodes(isFunction(targets) ? targets(this) : targets))$$('[loading="lazy"]', el).slice(0, preload - 1).forEach((el2)=>removeAttr(el2, "loading"));
                for (const el of entries.filter(({ isIntersecting: isIntersecting })=>isIntersecting).map(({ target: target })=>target))observer.unobserve(el);
            },
            ...options
        });
    }
    function viewport() {
        return observe((target, handler)=>observeViewportResize(handler));
    }
    function scroll$1(options) {
        return observe((target, handler)=>({
                disconnect: on(target, "scroll", handler, {
                    passive: true,
                    capture: true
                })
            }), {
            target: ()=>document,
            ...options
        }, "scroll");
    }
    function swipe(options) {
        return {
            observe (target, handler) {
                return {
                    observe: noop,
                    unobserve: noop,
                    disconnect: on(target, pointerDown$1, handler, {
                        passive: true
                    })
                };
            },
            handler (e) {
                if (!isTouch(e)) return;
                const pos = getEventPos(e);
                const target = "tagName" in e.target ? e.target : parent(e.target);
                once(document, `${pointerUp$1} ${pointerCancel} scroll`, (e2)=>{
                    const { x: x, y: y } = getEventPos(e2);
                    if (e2.type !== "scroll" && target && x && Math.abs(pos.x - x) > 100 || y && Math.abs(pos.y - y) > 100) setTimeout(()=>{
                        trigger(target, "swipe");
                        trigger(target, `swipe${swipeDirection(pos.x, pos.y, x, y)}`);
                    });
                });
            },
            ...options
        };
    }
    function observe(observe2, options, emit) {
        return {
            observe: observe2,
            handler () {
                this.$emit(emit);
            },
            ...options
        };
    }
    function swipeDirection(x1, y1, x2, y2) {
        return Math.abs(x1 - x2) >= Math.abs(y1 - y2) ? x1 - x2 > 0 ? "Left" : "Right" : y1 - y2 > 0 ? "Up" : "Down";
    }
    var Accordion = {
        mixins: [
            Class,
            Togglable
        ],
        props: {
            animation: Boolean,
            targets: String,
            active: null,
            collapsible: Boolean,
            multiple: Boolean,
            toggle: String,
            content: String,
            offset: Number
        },
        data: {
            targets: "> *",
            active: false,
            animation: true,
            collapsible: true,
            multiple: false,
            clsOpen: "uk-open",
            toggle: "> .uk-accordion-title",
            content: "> .uk-accordion-content",
            offset: 0
        },
        computed: {
            items ({ targets: targets }, $el) {
                return $$(targets, $el);
            },
            toggles ({ toggle: toggle }) {
                return this.items.map((item)=>$(toggle, item));
            },
            contents ({ content: content }) {
                return this.items.map((item)=>{
                    var _a;
                    return ((_a = item._wrapper) == null ? void 0 : _a.firstElementChild) || $(content, item);
                });
            }
        },
        watch: {
            items (items, prev) {
                if (prev || hasClass(items, this.clsOpen)) return;
                const active = this.active !== false && items[Number(this.active)] || !this.collapsible && items[0];
                if (active) this.toggle(active, false);
            },
            toggles () {
                this.$emit();
            },
            contents (items) {
                for (const el of items){
                    const isOpen = hasClass(this.items.find((item)=>within(el, item)), this.clsOpen);
                    hide(el, !isOpen);
                }
                this.$emit();
            }
        },
        observe: lazyload(),
        events: [
            {
                name: "click keydown",
                delegate () {
                    return `${this.targets} ${this.$props.toggle}`;
                },
                async handler (e) {
                    var _a;
                    if (e.type === "keydown" && e.keyCode !== keyMap.SPACE) return;
                    e.preventDefault();
                    (_a = this._off) == null || _a.call(this);
                    this._off = keepScrollPosition(e.target);
                    await this.toggle(index(this.toggles, e.current));
                    this._off();
                }
            },
            {
                name: "shown hidden",
                self: true,
                delegate () {
                    return this.targets;
                },
                handler () {
                    this.$emit();
                }
            }
        ],
        update () {
            const activeItems = filter$1(this.items, `.${this.clsOpen}`);
            for(const index2 in this.items){
                const toggle = this.toggles[index2];
                const content = this.contents[index2];
                if (!toggle || !content) continue;
                toggle.id = generateId(this, toggle, `-title-${index2}`);
                content.id = generateId(this, content, `-content-${index2}`);
                const active = includes(activeItems, this.items[index2]);
                attr(toggle, {
                    role: isTag(toggle, "a") ? "button" : null,
                    "aria-controls": content.id,
                    "aria-expanded": active,
                    "aria-disabled": !this.collapsible && activeItems.length < 2 && active
                });
                attr(content, {
                    role: "region",
                    "aria-labelledby": toggle.id
                });
                if (isTag(content, "ul")) attr(children(content), "role", "presentation");
            }
        },
        methods: {
            toggle (item, animate) {
                item = this.items[getIndex(item, this.items)];
                let items = [
                    item
                ];
                const activeItems = filter$1(this.items, `.${this.clsOpen}`);
                if (!this.multiple && !includes(activeItems, items[0])) items = items.concat(activeItems);
                if (!this.collapsible && activeItems.length < 2 && includes(activeItems, item)) return;
                return Promise.all(items.map((el)=>this.toggleElement(el, !includes(activeItems, el), (el2, show)=>{
                        toggleClass(el2, this.clsOpen, show);
                        if (animate === false || !this.animation) {
                            hide($(this.content, el2), !show);
                            return;
                        }
                        return transition(el2, show, this);
                    })));
            }
        }
    };
    function hide(el, hide2) {
        el && (el.hidden = hide2);
    }
    async function transition(el, show, { content: content, duration: duration, velocity: velocity, transition: transition2 }) {
        var _a;
        content = ((_a = el._wrapper) == null ? void 0 : _a.firstElementChild) || $(content, el);
        if (!el._wrapper) el._wrapper = wrapAll(content, "<div>");
        const wrapper = el._wrapper;
        css(wrapper, "overflow", "hidden");
        const currentHeight = toFloat(css(wrapper, "height"));
        await Transition.cancel(wrapper);
        hide(content, false);
        const endHeight = sumBy([
            "marginTop",
            "marginBottom"
        ], (prop)=>css(content, prop)) + dimensions$1(content).height;
        const percent = currentHeight / endHeight;
        duration = (velocity * endHeight + duration) * (show ? 1 - percent : percent);
        css(wrapper, "height", currentHeight);
        await Transition.start(wrapper, {
            height: show ? endHeight : 0
        }, duration, transition2);
        unwrap(content);
        delete el._wrapper;
        if (!show) hide(content, true);
    }
    function keepScrollPosition(el) {
        const scrollElement = scrollParent(el, true);
        let frame;
        (function scroll() {
            frame = requestAnimationFrame(()=>{
                const { top: top } = el.getBoundingClientRect();
                if (top < 0) scrollElement.scrollTop += top;
                scroll();
            });
        })();
        return ()=>requestAnimationFrame(()=>cancelAnimationFrame(frame));
    }
    var alert = {
        mixins: [
            Class,
            Togglable
        ],
        args: "animation",
        props: {
            animation: Boolean,
            close: String
        },
        data: {
            animation: true,
            selClose: ".uk-alert-close",
            duration: 150
        },
        events: {
            name: "click",
            delegate () {
                return this.selClose;
            },
            handler (e) {
                e.preventDefault();
                this.close();
            }
        },
        methods: {
            async close () {
                await this.toggleElement(this.$el, false, animate$1);
                this.$destroy(true);
            }
        }
    };
    function animate$1(el, show, { duration: duration, transition: transition, velocity: velocity }) {
        const height = toFloat(css(el, "height"));
        css(el, "height", height);
        return Transition.start(el, {
            height: 0,
            marginTop: 0,
            marginBottom: 0,
            paddingTop: 0,
            paddingBottom: 0,
            borderTop: 0,
            borderBottom: 0,
            opacity: 0
        }, velocity * height + duration, transition);
    }
    var Video = {
        args: "autoplay",
        props: {
            automute: Boolean,
            autoplay: Boolean
        },
        data: {
            automute: false,
            autoplay: true
        },
        connected () {
            this.inView = this.autoplay === "inview";
            if (this.inView && !hasAttr(this.$el, "preload")) this.$el.preload = "none";
            if (isTag(this.$el, "iframe") && !hasAttr(this.$el, "allow")) this.$el.allow = "autoplay";
            if (this.automute) mute(this.$el);
        },
        observe: [
            intersection({
                args: {
                    intersecting: false
                }
            }),
            resize()
        ],
        update: {
            read ({ visible: visible }) {
                if (!isVideo(this.$el)) return false;
                return {
                    prev: visible,
                    visible: isVisible(this.$el),
                    inView: this.inView && isInView(this.$el)
                };
            },
            write ({ prev: prev, visible: visible, inView: inView }) {
                if (!visible || this.inView && !inView) pause(this.$el);
                else if (this.autoplay === true && !prev || inView) play(this.$el);
            },
            events: [
                "resize"
            ]
        }
    };
    var cover = {
        mixins: [
            Video
        ],
        props: {
            width: Number,
            height: Number
        },
        data: {
            automute: true
        },
        events: {
            "load loadedmetadata" () {
                this.$emit("resize");
            }
        },
        observe: resize({
            target: ({ $el: $el })=>[
                    getPositionedParent($el) || parent($el)
                ]
        }),
        update: {
            read () {
                const { ratio: ratio, cover: cover } = Dimensions;
                const { $el: $el, width: width, height: height } = this;
                let dim = {
                    width: width,
                    height: height
                };
                if (!width || !height) {
                    const intrinsic = {
                        width: $el.naturalWidth || $el.videoWidth || $el.clientWidth,
                        height: $el.naturalHeight || $el.videoHeight || $el.clientHeight
                    };
                    if (width) dim = ratio(intrinsic, "width", width);
                    else if (height) dim = ratio(intrinsic, "height", height);
                    else dim = intrinsic;
                }
                const { offsetHeight: coverHeight, offsetWidth: coverWidth } = getPositionedParent($el) || parent($el);
                const coverDim = cover(dim, {
                    width: coverWidth + (coverWidth % 2 ? 1 : 0),
                    height: coverHeight + (coverHeight % 2 ? 1 : 0)
                });
                if (!coverDim.width || !coverDim.height) return false;
                return coverDim;
            },
            write ({ height: height, width: width }) {
                css(this.$el, {
                    height: height,
                    width: width
                });
            },
            events: [
                "resize"
            ]
        }
    };
    function getPositionedParent(el) {
        while(el = parent(el)){
            if (css(el, "position") !== "static") return el;
        }
    }
    var Position = {
        props: {
            pos: String,
            offset: null,
            flip: Boolean,
            shift: Boolean,
            inset: Boolean
        },
        data: {
            pos: `bottom-${isRtl ? "right" : "left"}`,
            offset: false,
            flip: true,
            shift: true,
            inset: false
        },
        connected () {
            this.pos = this.$props.pos.split("-").concat("center").slice(0, 2);
            [this.dir, this.align] = this.pos;
            this.axis = includes([
                "top",
                "bottom"
            ], this.dir) ? "y" : "x";
        },
        methods: {
            positionAt (element, target, boundary) {
                let offset = [
                    this.getPositionOffset(element),
                    this.getShiftOffset(element)
                ];
                const placement = [
                    this.flip && "flip",
                    this.shift && "shift"
                ];
                const attach = {
                    element: [
                        this.inset ? this.dir : flipPosition(this.dir),
                        this.align
                    ],
                    target: [
                        this.dir,
                        this.align
                    ]
                };
                if (this.axis === "y") {
                    for(const prop in attach)attach[prop].reverse();
                    offset.reverse();
                    placement.reverse();
                }
                const restoreScrollPosition = storeScrollPosition(element);
                const elDim = dimensions$1(element);
                css(element, {
                    top: -elDim.height,
                    left: -elDim.width
                });
                positionAt(element, target, {
                    attach: attach,
                    offset: offset,
                    boundary: boundary,
                    placement: placement,
                    viewportOffset: this.getViewportOffset(element)
                });
                restoreScrollPosition();
            },
            getPositionOffset (element) {
                return toPx(this.offset === false ? css(element, "--uk-position-offset") : this.offset, this.axis === "x" ? "width" : "height", element) * (includes([
                    "left",
                    "top"
                ], this.dir) ? -1 : 1) * (this.inset ? -1 : 1);
            },
            getShiftOffset (element) {
                return this.align === "center" ? 0 : toPx(css(element, "--uk-position-shift-offset"), this.axis === "y" ? "width" : "height", element) * (includes([
                    "left",
                    "top"
                ], this.align) ? 1 : -1);
            },
            getViewportOffset (element) {
                return toPx(css(element, "--uk-position-viewport-offset"));
            }
        }
    };
    function storeScrollPosition(element) {
        const scrollElement = scrollParent(element);
        const { scrollTop: scrollTop } = scrollElement;
        return ()=>{
            if (scrollTop !== scrollElement.scrollTop) scrollElement.scrollTop = scrollTop;
        };
    }
    var Container = {
        props: {
            container: Boolean
        },
        data: {
            container: true
        },
        computed: {
            container ({ container: container }) {
                return container === true && this.$container || container && $(container);
            }
        }
    };
    let prevented;
    function preventBackgroundScroll(el) {
        const off = on(el, "touchmove", (e)=>{
            if (e.targetTouches.length !== 1 || matches(e.target, 'input[type="range"')) return;
            let { scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollParent(e.target);
            if (clientHeight >= scrollHeight && e.cancelable) e.preventDefault();
        }, {
            passive: false
        });
        if (prevented) return off;
        prevented = true;
        const { scrollingElement: scrollingElement } = document;
        css(scrollingElement, {
            overflowY: CSS.supports("overflow", "clip") ? "clip" : "hidden",
            touchAction: "none",
            paddingRight: width(window) - scrollingElement.clientWidth || ""
        });
        return ()=>{
            prevented = false;
            off();
            css(scrollingElement, {
                overflowY: "",
                touchAction: "",
                paddingRight: ""
            });
        };
    }
    let active$1;
    var drop = {
        mixins: [
            Container,
            Position,
            Togglable
        ],
        args: "pos",
        props: {
            mode: "list",
            toggle: Boolean,
            boundary: Boolean,
            boundaryX: Boolean,
            boundaryY: Boolean,
            target: Boolean,
            targetX: Boolean,
            targetY: Boolean,
            stretch: Boolean,
            delayShow: Number,
            delayHide: Number,
            autoUpdate: Boolean,
            clsDrop: String,
            animateOut: Boolean,
            bgScroll: Boolean
        },
        data: {
            mode: [
                "click",
                "hover"
            ],
            toggle: "- *",
            boundary: false,
            boundaryX: false,
            boundaryY: false,
            target: false,
            targetX: false,
            targetY: false,
            stretch: false,
            delayShow: 0,
            delayHide: 800,
            autoUpdate: true,
            clsDrop: false,
            animateOut: false,
            bgScroll: true,
            animation: [
                "uk-animation-fade"
            ],
            cls: "uk-open",
            container: false
        },
        computed: {
            boundary ({ boundary: boundary, boundaryX: boundaryX, boundaryY: boundaryY }, $el) {
                return [
                    query(boundaryX || boundary, $el) || window,
                    query(boundaryY || boundary, $el) || window
                ];
            },
            target ({ target: target, targetX: targetX, targetY: targetY }, $el) {
                targetX || (targetX = target || this.targetEl);
                targetY || (targetY = target || this.targetEl);
                return [
                    targetX === true ? window : query(targetX, $el),
                    targetY === true ? window : query(targetY, $el)
                ];
            }
        },
        created () {
            this.tracker = new MouseTracker();
        },
        beforeConnect () {
            this.clsDrop = this.$props.clsDrop || `uk-${this.$options.name}`;
        },
        connected () {
            addClass(this.$el, "uk-drop", this.clsDrop);
            if (this.toggle && !this.targetEl) this.targetEl = createToggleComponent(this);
            this._style = pick(this.$el.style, [
                "width",
                "height"
            ]);
        },
        disconnected () {
            if (this.isActive()) {
                this.hide(false);
                active$1 = null;
            }
            css(this.$el, this._style);
        },
        observe: lazyload({
            target: ({ toggle: toggle, $el: $el })=>query(toggle, $el),
            targets: ({ $el: $el })=>$el
        }),
        events: [
            {
                name: "click",
                delegate () {
                    return ".uk-drop-close";
                },
                handler (e) {
                    e.preventDefault();
                    this.hide(false);
                }
            },
            {
                name: "click",
                delegate () {
                    return 'a[href*="#"]';
                },
                handler ({ defaultPrevented: defaultPrevented, current: current }) {
                    const { hash: hash } = current;
                    if (!defaultPrevented && hash && isSameSiteAnchor(current) && !within(hash, this.$el)) this.hide(false);
                }
            },
            {
                name: "beforescroll",
                handler () {
                    this.hide(false);
                }
            },
            {
                name: "toggle",
                self: true,
                handler (e, toggle) {
                    e.preventDefault();
                    if (this.isToggled()) this.hide(false);
                    else this.show(toggle == null ? void 0 : toggle.$el, false);
                }
            },
            {
                name: "toggleshow",
                self: true,
                handler (e, toggle) {
                    e.preventDefault();
                    this.show(toggle == null ? void 0 : toggle.$el);
                }
            },
            {
                name: "togglehide",
                self: true,
                handler (e) {
                    e.preventDefault();
                    if (!matches(this.$el, ":focus,:hover")) this.hide();
                }
            },
            {
                name: `${pointerEnter} focusin`,
                filter () {
                    return includes(this.mode, "hover");
                },
                handler (e) {
                    if (!isTouch(e)) this.clearTimers();
                }
            },
            {
                name: `${pointerLeave} focusout`,
                filter () {
                    return includes(this.mode, "hover");
                },
                handler (e) {
                    if (!isTouch(e) && e.relatedTarget) this.hide();
                }
            },
            {
                name: "toggled",
                self: true,
                handler (e, toggled) {
                    attr(this.targetEl, "aria-expanded", toggled ? true : null);
                    if (!toggled) return;
                    this.clearTimers();
                    this.position();
                }
            },
            {
                name: "show",
                self: true,
                handler () {
                    active$1 = this;
                    this.tracker.init();
                    const handlers = [
                        listenForResize(this),
                        listenForEscClose$1(this),
                        listenForBackgroundClose$1(this),
                        this.autoUpdate && listenForScroll(this),
                        !this.bgScroll && preventBackgroundScroll(this.$el)
                    ];
                    once(this.$el, "hide", ()=>handlers.forEach((handler)=>handler && handler()), {
                        self: true
                    });
                }
            },
            {
                name: "beforehide",
                self: true,
                handler () {
                    this.clearTimers();
                }
            },
            {
                name: "hide",
                handler ({ target: target }) {
                    if (this.$el !== target) {
                        active$1 = active$1 === null && within(target, this.$el) && this.isToggled() ? this : active$1;
                        return;
                    }
                    active$1 = this.isActive() ? null : active$1;
                    this.tracker.cancel();
                }
            }
        ],
        update: {
            write () {
                if (this.isToggled() && !hasClass(this.$el, this.clsEnter)) this.position();
            }
        },
        methods: {
            show (target = this.targetEl, delay = true) {
                if (this.isToggled() && target && this.targetEl && target !== this.targetEl) this.hide(false, false);
                this.targetEl = target;
                this.clearTimers();
                if (this.isActive()) return;
                if (active$1) {
                    if (delay && active$1.isDelaying) {
                        this.showTimer = setTimeout(()=>matches(target, ":hover") && this.show(), 10);
                        return;
                    }
                    let prev;
                    while(active$1 && prev !== active$1 && !within(this.$el, active$1.$el)){
                        prev = active$1;
                        active$1.hide(false, false);
                    }
                }
                if (this.container && parent(this.$el) !== this.container) append(this.container, this.$el);
                this.showTimer = setTimeout(()=>this.toggleElement(this.$el, true), delay && this.delayShow || 0);
            },
            hide (delay = true, animate = true) {
                const hide = ()=>this.toggleElement(this.$el, false, this.animateOut && animate);
                this.clearTimers();
                this.isDelaying = getPositionedElements(this.$el).some((el)=>this.tracker.movesTo(el));
                if (delay && this.isDelaying) this.hideTimer = setTimeout(this.hide, 50);
                else if (delay && this.delayHide) this.hideTimer = setTimeout(hide, this.delayHide);
                else hide();
            },
            clearTimers () {
                clearTimeout(this.showTimer);
                clearTimeout(this.hideTimer);
                this.showTimer = null;
                this.hideTimer = null;
                this.isDelaying = false;
            },
            isActive () {
                return active$1 === this;
            },
            position () {
                removeClass(this.$el, "uk-drop-stack");
                css(this.$el, this._style);
                this.$el.hidden = true;
                const viewports = this.target.map((target)=>getViewport$1(this.$el, target));
                const viewportOffset = this.getViewportOffset(this.$el);
                const dirs = [
                    [
                        0,
                        [
                            "x",
                            "width",
                            "left",
                            "right"
                        ]
                    ],
                    [
                        1,
                        [
                            "y",
                            "height",
                            "top",
                            "bottom"
                        ]
                    ]
                ];
                for (const [i, [axis, prop]] of dirs)if (this.axis !== axis && includes([
                    axis,
                    true
                ], this.stretch)) css(this.$el, {
                    [prop]: Math.min(offset(this.boundary[i])[prop], viewports[i][prop] - 2 * viewportOffset),
                    [`overflow-${axis}`]: "auto"
                });
                const maxWidth = viewports[0].width - 2 * viewportOffset;
                this.$el.hidden = false;
                css(this.$el, "maxWidth", "");
                if (this.$el.offsetWidth > maxWidth) addClass(this.$el, "uk-drop-stack");
                css(this.$el, "maxWidth", maxWidth);
                this.positionAt(this.$el, this.target, this.boundary);
                for (const [i, [axis, prop, start, end]] of dirs)if (this.axis === axis && includes([
                    axis,
                    true
                ], this.stretch)) {
                    const positionOffset = Math.abs(this.getPositionOffset(this.$el));
                    const targetOffset = offset(this.target[i]);
                    const elOffset = offset(this.$el);
                    css(this.$el, {
                        [prop]: (targetOffset[start] > elOffset[start] ? targetOffset[this.inset ? end : start] - Math.max(offset(this.boundary[i])[start], viewports[i][start] + viewportOffset) : Math.min(offset(this.boundary[i])[end], viewports[i][end] - viewportOffset) - targetOffset[this.inset ? start : end]) - positionOffset,
                        [`overflow-${axis}`]: "auto"
                    });
                    this.positionAt(this.$el, this.target, this.boundary);
                }
            }
        }
    };
    function getPositionedElements(el) {
        const result = [];
        apply(el, (el2)=>css(el2, "position") !== "static" && result.push(el2));
        return result;
    }
    function getViewport$1(el, target) {
        return offsetViewport(overflowParents(target).find((parent2)=>within(el, parent2)));
    }
    function createToggleComponent(drop) {
        const { $el: $el } = drop.$create("toggle", query(drop.toggle, drop.$el), {
            target: drop.$el,
            mode: drop.mode
        });
        attr($el, "aria-haspopup", true);
        return $el;
    }
    function listenForResize(drop) {
        const update = ()=>drop.$emit();
        const off = [
            observeViewportResize(update),
            observeResize(overflowParents(drop.$el).concat(drop.target), update)
        ];
        return ()=>off.map((observer)=>observer.disconnect());
    }
    function listenForScroll(drop) {
        return on([
            document,
            ...overflowParents(drop.$el)
        ], "scroll", ()=>drop.$emit(), {
            passive: true
        });
    }
    function listenForEscClose$1(drop) {
        return on(document, "keydown", (e)=>{
            if (e.keyCode === keyMap.ESC) drop.hide(false);
        });
    }
    function listenForBackgroundClose$1(drop) {
        return on(document, pointerDown$1, ({ target: target })=>{
            if (!within(target, drop.$el)) once(document, `${pointerUp$1} ${pointerCancel} scroll`, ({ defaultPrevented: defaultPrevented, type: type, target: newTarget })=>{
                if (!defaultPrevented && type === pointerUp$1 && target === newTarget && !(drop.targetEl && within(target, drop.targetEl))) drop.hide(false);
            }, true);
        });
    }
    var Dropnav = {
        mixins: [
            Class,
            Container
        ],
        props: {
            align: String,
            clsDrop: String,
            boundary: Boolean,
            dropbar: Boolean,
            dropbarAnchor: Boolean,
            duration: Number,
            mode: Boolean,
            offset: Boolean,
            stretch: Boolean,
            delayShow: Boolean,
            delayHide: Boolean,
            target: Boolean,
            targetX: Boolean,
            targetY: Boolean,
            animation: Boolean,
            animateOut: Boolean
        },
        data: {
            align: isRtl ? "right" : "left",
            clsDrop: "uk-dropdown",
            clsDropbar: "uk-dropnav-dropbar",
            boundary: true,
            dropbar: false,
            dropbarAnchor: false,
            duration: 200,
            container: false,
            selNavItem: "> li > a, > ul > li > a"
        },
        computed: {
            dropbarAnchor ({ dropbarAnchor: dropbarAnchor }, $el) {
                return query(dropbarAnchor, $el) || $el;
            },
            dropbar ({ dropbar: dropbar }) {
                if (!dropbar) return null;
                dropbar = this._dropbar || query(dropbar, this.$el) || $(`+ .${this.clsDropbar}`, this.$el);
                return dropbar ? dropbar : this._dropbar = $("<div></div>");
            },
            dropContainer (_, $el) {
                return this.container || $el;
            },
            dropdowns ({ clsDrop: clsDrop }, $el) {
                var _a;
                const dropdowns = $$(`.${clsDrop}`, $el);
                if (this.dropContainer !== $el) for (const el of $$(`.${clsDrop}`, this.dropContainer)){
                    const target = (_a = this.getDropdown(el)) == null ? void 0 : _a.targetEl;
                    if (!includes(dropdowns, el) && target && within(target, this.$el)) dropdowns.push(el);
                }
                return dropdowns;
            },
            items ({ selNavItem: selNavItem }, $el) {
                return $$(selNavItem, $el);
            }
        },
        watch: {
            dropbar (dropbar) {
                addClass(dropbar, "uk-dropbar", "uk-dropbar-top", this.clsDropbar, `uk-${this.$options.name}-dropbar`);
            },
            dropdowns (dropdowns) {
                this.$create("drop", dropdowns.filter((el)=>!this.getDropdown(el)), {
                    ...this.$props,
                    flip: false,
                    shift: true,
                    pos: `bottom-${this.align}`,
                    boundary: this.boundary === true ? this.$el : this.boundary
                });
            }
        },
        disconnected () {
            remove$1(this._dropbar);
            delete this._dropbar;
        },
        events: [
            {
                name: "mouseover focusin",
                delegate () {
                    return this.selNavItem;
                },
                handler ({ current: current }) {
                    const active2 = this.getActive();
                    if (active2 && includes(active2.mode, "hover") && active2.targetEl && !within(active2.targetEl, current) && !active2.isDelaying) active2.hide(false);
                }
            },
            {
                name: "keydown",
                self: true,
                delegate () {
                    return this.selNavItem;
                },
                handler (e) {
                    var _a;
                    const { current: current, keyCode: keyCode } = e;
                    const active2 = this.getActive();
                    if (keyCode === keyMap.DOWN && (active2 == null ? void 0 : active2.targetEl) === current) {
                        e.preventDefault();
                        (_a = $(selFocusable, active2.$el)) == null || _a.focus();
                    }
                    handleNavItemNavigation(e, this.items, active2);
                }
            },
            {
                name: "keydown",
                el () {
                    return this.dropContainer;
                },
                delegate () {
                    return `.${this.clsDrop}`;
                },
                handler (e) {
                    var _a;
                    const { current: current, keyCode: keyCode } = e;
                    if (!includes(this.dropdowns, current)) return;
                    const active2 = this.getActive();
                    let next = -1;
                    if (keyCode === keyMap.HOME) next = 0;
                    else if (keyCode === keyMap.END) next = "last";
                    else if (keyCode === keyMap.UP) next = "previous";
                    else if (keyCode === keyMap.DOWN) next = "next";
                    else if (keyCode === keyMap.ESC) (_a = active2.targetEl) == null || _a.focus();
                    if (~next) {
                        e.preventDefault();
                        const elements = $$(selFocusable, current);
                        elements[getIndex(next, elements, findIndex(elements, (el)=>matches(el, ":focus")))].focus();
                    }
                    handleNavItemNavigation(e, this.items, active2);
                }
            },
            {
                name: "mouseleave",
                el () {
                    return this.dropbar;
                },
                filter () {
                    return this.dropbar;
                },
                handler () {
                    const active2 = this.getActive();
                    if (active2 && includes(active2.mode, "hover") && !this.dropdowns.some((el)=>matches(el, ":hover"))) active2.hide();
                }
            },
            {
                name: "beforeshow",
                el () {
                    return this.dropContainer;
                },
                filter () {
                    return this.dropbar;
                },
                handler ({ target: target }) {
                    if (!this.isDropbarDrop(target)) return;
                    if (this.dropbar.previousElementSibling !== this.dropbarAnchor) after(this.dropbarAnchor, this.dropbar);
                    addClass(target, `${this.clsDrop}-dropbar`);
                }
            },
            {
                name: "show",
                el () {
                    return this.dropContainer;
                },
                filter () {
                    return this.dropbar;
                },
                handler ({ target: target }) {
                    if (!this.isDropbarDrop(target)) return;
                    const drop = this.getDropdown(target);
                    const adjustHeight = ()=>{
                        const targetOffsets = parents(target, `.${this.clsDrop}`).concat(target).map((el)=>offset(el));
                        const minTop = Math.min(...targetOffsets.map(({ top: top })=>top));
                        const maxBottom = Math.max(...targetOffsets.map(({ bottom: bottom })=>bottom));
                        const dropbarOffset = offset(this.dropbar);
                        css(this.dropbar, "top", this.dropbar.offsetTop - (dropbarOffset.top - minTop));
                        this.transitionTo(maxBottom - minTop + toFloat(css(target, "marginBottom")), target);
                    };
                    this._observer = observeResize([
                        drop.$el,
                        ...drop.target
                    ], adjustHeight);
                    adjustHeight();
                }
            },
            {
                name: "beforehide",
                el () {
                    return this.dropContainer;
                },
                filter () {
                    return this.dropbar;
                },
                handler (e) {
                    const active2 = this.getActive();
                    if (matches(this.dropbar, ":hover") && active2.$el === e.target && !this.items.some((el)=>active2.targetEl !== el && matches(el, ":focus"))) e.preventDefault();
                }
            },
            {
                name: "hide",
                el () {
                    return this.dropContainer;
                },
                filter () {
                    return this.dropbar;
                },
                handler ({ target: target }) {
                    var _a;
                    if (!this.isDropbarDrop(target)) return;
                    (_a = this._observer) == null || _a.disconnect();
                    const active2 = this.getActive();
                    if (!active2 || active2.$el === target) this.transitionTo(0);
                }
            }
        ],
        methods: {
            getActive () {
                var _a;
                return includes(this.dropdowns, (_a = active$1) == null ? void 0 : _a.$el) && active$1;
            },
            async transitionTo (newHeight, el) {
                const { dropbar: dropbar } = this;
                const oldHeight = height(dropbar);
                el = oldHeight < newHeight && el;
                await Transition.cancel([
                    el,
                    dropbar
                ]);
                css(el, "clipPath", `polygon(0 0,100% 0,100% ${oldHeight}px,0 ${oldHeight}px)`);
                height(dropbar, oldHeight);
                await Promise.all([
                    Transition.start(dropbar, {
                        height: newHeight
                    }, this.duration),
                    Transition.start(el, {
                        clipPath: `polygon(0 0,100% 0,100% ${newHeight}px,0 ${newHeight}px)`
                    }, this.duration).finally(()=>css(el, {
                            clipPath: ""
                        }))
                ]).catch(noop);
            },
            getDropdown (el) {
                return this.$getComponent(el, "drop") || this.$getComponent(el, "dropdown");
            },
            isDropbarDrop (el) {
                return this.getDropdown(el) && hasClass(el, this.clsDrop);
            }
        }
    };
    function handleNavItemNavigation(e, toggles, active2) {
        var _a, _b, _c;
        const { current: current, keyCode: keyCode } = e;
        let next = -1;
        if (keyCode === keyMap.HOME) next = 0;
        else if (keyCode === keyMap.END) next = "last";
        else if (keyCode === keyMap.LEFT) next = "previous";
        else if (keyCode === keyMap.RIGHT) next = "next";
        else if (keyCode === keyMap.TAB) {
            (_a = active2.targetEl) == null || _a.focus();
            (_b = active2.hide) == null || _b.call(active2, false);
        }
        if (~next) {
            e.preventDefault();
            (_c = active2.hide) == null || _c.call(active2, false);
            toggles[getIndex(next, toggles, toggles.indexOf(active2.targetEl || current))].focus();
        }
    }
    var formCustom = {
        mixins: [
            Class
        ],
        args: "target",
        props: {
            target: Boolean
        },
        data: {
            target: false
        },
        computed: {
            input (_, $el) {
                return $(selInput, $el);
            },
            state () {
                return this.input.nextElementSibling;
            },
            target ({ target: target }, $el) {
                return target && (target === true && parent(this.input) === $el && this.input.nextElementSibling || $(target, $el));
            }
        },
        update () {
            var _a;
            const { target: target, input: input } = this;
            if (!target) return;
            let option;
            const prop = isInput(target) ? "value" : "textContent";
            const prev = target[prop];
            const value = ((_a = input.files) == null ? void 0 : _a[0]) ? input.files[0].name : matches(input, "select") && (option = $$("option", input).filter((el)=>el.selected)[0]) ? option.textContent : input.value;
            if (prev !== value) target[prop] = value;
        },
        events: [
            {
                name: "change",
                handler () {
                    this.$emit();
                }
            },
            {
                name: "reset",
                el () {
                    return closest(this.$el, "form");
                },
                handler () {
                    this.$emit();
                }
            }
        ]
    };
    var Margin = {
        props: {
            margin: String,
            firstColumn: Boolean
        },
        data: {
            margin: "uk-margin-small-top",
            firstColumn: "uk-first-column"
        },
        observe: [
            mutation({
                options: {
                    childList: true,
                    attributes: true,
                    attributeFilter: [
                        "style"
                    ]
                }
            }),
            resize({
                target: ({ $el: $el })=>[
                        $el,
                        ...children($el)
                    ]
            })
        ],
        update: {
            read () {
                const rows = getRows(this.$el.children);
                return {
                    rows: rows,
                    columns: getColumns(rows)
                };
            },
            write ({ columns: columns, rows: rows }) {
                for (const row of rows)for (const column of row){
                    toggleClass(column, this.margin, rows[0] !== row);
                    toggleClass(column, this.firstColumn, columns[0].includes(column));
                }
            },
            events: [
                "resize"
            ]
        }
    };
    function getRows(items) {
        return sortBy(items, "top", "bottom");
    }
    function getColumns(rows) {
        const columns = [];
        for (const row of rows){
            const sorted = sortBy(row, "left", "right");
            for(let j = 0; j < sorted.length; j++)columns[j] = columns[j] ? columns[j].concat(sorted[j]) : sorted[j];
        }
        return isRtl ? columns.reverse() : columns;
    }
    function sortBy(items, startProp, endProp) {
        const sorted = [
            []
        ];
        for (const el of items){
            if (!isVisible(el)) continue;
            let dim = getOffset(el);
            for(let i = sorted.length - 1; i >= 0; i--){
                const current = sorted[i];
                if (!current[0]) {
                    current.push(el);
                    break;
                }
                let startDim;
                if (current[0].offsetParent === el.offsetParent) startDim = getOffset(current[0]);
                else {
                    dim = getOffset(el, true);
                    startDim = getOffset(current[0], true);
                }
                if (dim[startProp] >= startDim[endProp] - 1 && dim[startProp] !== startDim[startProp]) {
                    sorted.push([
                        el
                    ]);
                    break;
                }
                if (dim[endProp] - 1 > startDim[startProp] || dim[startProp] === startDim[startProp]) {
                    current.push(el);
                    break;
                }
                if (i === 0) {
                    sorted.unshift([
                        el
                    ]);
                    break;
                }
            }
        }
        return sorted;
    }
    function getOffset(element, offset = false) {
        let { offsetTop: offsetTop, offsetLeft: offsetLeft, offsetHeight: offsetHeight, offsetWidth: offsetWidth } = element;
        if (offset) [offsetTop, offsetLeft] = offsetPosition(element);
        return {
            top: offsetTop,
            left: offsetLeft,
            bottom: offsetTop + offsetHeight,
            right: offsetLeft + offsetWidth
        };
    }
    var grid = {
        extends: Margin,
        mixins: [
            Class
        ],
        name: "grid",
        props: {
            masonry: Boolean,
            parallax: Number
        },
        data: {
            margin: "uk-grid-margin",
            clsStack: "uk-grid-stack",
            masonry: false,
            parallax: 0
        },
        connected () {
            this.masonry && addClass(this.$el, "uk-flex-top uk-flex-wrap-top");
        },
        observe: scroll$1({
            filter: ({ parallax: parallax })=>parallax
        }),
        update: [
            {
                write ({ columns: columns }) {
                    toggleClass(this.$el, this.clsStack, columns.length < 2);
                },
                events: [
                    "resize"
                ]
            },
            {
                read (data) {
                    let { columns: columns, rows: rows } = data;
                    if (!columns.length || !this.masonry && !this.parallax || positionedAbsolute(this.$el)) {
                        data.translates = false;
                        return false;
                    }
                    let translates = false;
                    const nodes = children(this.$el);
                    const columnHeights = columns.map((column)=>sumBy(column, "offsetHeight"));
                    const margin = getMarginTop(nodes, this.margin) * (rows.length - 1);
                    const elHeight = Math.max(...columnHeights) + margin;
                    if (this.masonry) {
                        columns = columns.map((column)=>sortBy$1(column, "offsetTop"));
                        translates = getTranslates(rows, columns);
                    }
                    let padding = Math.abs(this.parallax);
                    if (padding) padding = columnHeights.reduce((newPadding, hgt, i)=>Math.max(newPadding, hgt + margin + (i % 2 ? padding : padding / 8) - elHeight), 0);
                    return {
                        padding: padding,
                        columns: columns,
                        translates: translates,
                        height: translates ? elHeight : ""
                    };
                },
                write ({ height: height, padding: padding }) {
                    css(this.$el, "paddingBottom", padding || "");
                    height !== false && css(this.$el, "height", height);
                },
                events: [
                    "resize"
                ]
            },
            {
                read () {
                    if (this.parallax && positionedAbsolute(this.$el)) return false;
                    return {
                        scrolled: this.parallax ? scrolledOver(this.$el) * Math.abs(this.parallax) : false
                    };
                },
                write ({ columns: columns, scrolled: scrolled, translates: translates }) {
                    if (scrolled === false && !translates) return;
                    columns.forEach((column, i)=>column.forEach((el, j)=>css(el, "transform", !scrolled && !translates ? "" : `translateY(${(translates && -translates[i][j]) + (scrolled ? i % 2 ? scrolled : scrolled / 8 : 0)}px)`)));
                },
                events: [
                    "scroll",
                    "resize"
                ]
            }
        ]
    };
    function positionedAbsolute(el) {
        return children(el).some((el2)=>css(el2, "position") === "absolute");
    }
    function getTranslates(rows, columns) {
        const rowHeights = rows.map((row)=>Math.max(...row.map((el)=>el.offsetHeight)));
        return columns.map((elements)=>{
            let prev = 0;
            return elements.map((element, row)=>prev += row ? rowHeights[row - 1] - elements[row - 1].offsetHeight : 0);
        });
    }
    function getMarginTop(nodes, cls) {
        const [node] = nodes.filter((el)=>hasClass(el, cls));
        return toFloat(node ? css(node, "marginTop") : css(nodes[0], "paddingLeft"));
    }
    var heightMatch = {
        args: "target",
        props: {
            target: String,
            row: Boolean
        },
        data: {
            target: "> *",
            row: true
        },
        computed: {
            elements ({ target: target }, $el) {
                return $$(target, $el);
            }
        },
        observe: resize({
            target: ({ $el: $el, elements: elements })=>[
                    $el,
                    ...elements
                ]
        }),
        update: {
            read () {
                return {
                    rows: (this.row ? getRows(this.elements) : [
                        this.elements
                    ]).map(match$1)
                };
            },
            write ({ rows: rows }) {
                for (const { heights: heights, elements: elements } of rows)elements.forEach((el, i)=>css(el, "minHeight", heights[i]));
            },
            events: [
                "resize"
            ]
        }
    };
    function match$1(elements) {
        if (elements.length < 2) return {
            heights: [
                ""
            ],
            elements: elements
        };
        let heights = elements.map(getHeight);
        const max = Math.max(...heights);
        return {
            heights: elements.map((el, i)=>heights[i].toFixed(2) === max.toFixed(2) ? "" : max),
            elements: elements
        };
    }
    function getHeight(element) {
        const style = pick(element.style, [
            "display",
            "minHeight"
        ]);
        if (!isVisible(element)) css(element, "display", "block", "important");
        css(element, "minHeight", "");
        const height = dimensions$1(element).height - boxModelAdjust(element, "height", "content-box");
        css(element, style);
        return height;
    }
    var heightViewport = {
        props: {
            expand: Boolean,
            offsetTop: Boolean,
            offsetBottom: Boolean,
            minHeight: Number
        },
        data: {
            expand: false,
            offsetTop: false,
            offsetBottom: false,
            minHeight: 0
        },
        // check for offsetTop change
        observe: resize({
            target: ({ $el: $el })=>[
                    $el,
                    ...scrollParents($el)
                ]
        }),
        update: {
            read () {
                if (!isVisible(this.$el)) return false;
                let minHeight = "";
                const box = boxModelAdjust(this.$el, "height", "content-box");
                const { body: body, scrollingElement: scrollingElement } = document;
                const scrollElement = scrollParent(this.$el);
                const { height: viewportHeight } = offsetViewport(scrollElement === body ? scrollingElement : scrollElement);
                if (this.expand) minHeight = `${viewportHeight - (dimensions$1(scrollElement).height - dimensions$1(this.$el).height) - box}px`;
                else {
                    const isScrollingElement = scrollingElement === scrollElement || body === scrollElement;
                    minHeight = `calc(${isScrollingElement ? "100vh" : `${viewportHeight}px`}`;
                    if (this.offsetTop) {
                        if (isScrollingElement) {
                            const top = offsetPosition(this.$el)[0] - offsetPosition(scrollElement)[0];
                            minHeight += top > 0 && top < viewportHeight / 2 ? ` - ${top}px` : "";
                        } else minHeight += ` - ${css(scrollElement, "paddingTop")}`;
                    }
                    if (this.offsetBottom === true) minHeight += ` - ${dimensions$1(this.$el.nextElementSibling).height}px`;
                    else if (isNumeric(this.offsetBottom)) minHeight += ` - ${this.offsetBottom}vh`;
                    else if (this.offsetBottom && endsWith(this.offsetBottom, "px")) minHeight += ` - ${toFloat(this.offsetBottom)}px`;
                    else if (isString(this.offsetBottom)) minHeight += ` - ${dimensions$1(query(this.offsetBottom, this.$el)).height}px`;
                    minHeight += `${box ? ` - ${box}px` : ""})`;
                }
                return {
                    minHeight: minHeight
                };
            },
            write ({ minHeight: minHeight }) {
                css(this.$el, "minHeight", `max(${this.minHeight || 0}px, ${minHeight})`);
            },
            events: [
                "resize"
            ]
        }
    };
    var Svg = {
        args: "src",
        props: {
            width: Number,
            height: Number,
            ratio: Number
        },
        data: {
            ratio: 1
        },
        connected () {
            this.svg = this.getSvg().then((el)=>{
                if (!this._connected) return;
                const svg = insertSVG(el, this.$el);
                if (this.svgEl && svg !== this.svgEl) remove$1(this.svgEl);
                applyWidthAndHeight.call(this, svg, el);
                return this.svgEl = svg;
            }, noop);
        },
        disconnected () {
            this.svg.then((svg)=>{
                if (this._connected) return;
                if (isVoidElement(this.$el)) this.$el.hidden = false;
                remove$1(svg);
                this.svgEl = null;
            });
            this.svg = null;
        },
        methods: {
            async getSvg () {}
        }
    };
    function insertSVG(el, root) {
        if (isVoidElement(root) || isTag(root, "canvas")) {
            root.hidden = true;
            const next = root.nextElementSibling;
            return equals(el, next) ? next : after(root, el);
        }
        const last = root.lastElementChild;
        return equals(el, last) ? last : append(root, el);
    }
    function equals(el, other) {
        return isTag(el, "svg") && isTag(other, "svg") && el.innerHTML === other.innerHTML;
    }
    function applyWidthAndHeight(el, ref) {
        const props = [
            "width",
            "height"
        ];
        let dimensions = props.map((prop)=>this[prop]);
        if (!dimensions.some((val)=>val)) dimensions = props.map((prop)=>attr(ref, prop));
        const viewBox = attr(ref, "viewBox");
        if (viewBox && !dimensions.some((val)=>val)) dimensions = viewBox.split(" ").slice(2);
        dimensions.forEach((val, i)=>attr(el, props[i], toFloat(val) * this.ratio || null));
    }
    var I18n = {
        props: {
            i18n: Object
        },
        data: {
            i18n: null
        },
        methods: {
            t (key, ...params) {
                var _a, _b, _c;
                let i = 0;
                return ((_c = ((_a = this.i18n) == null ? void 0 : _a[key]) || ((_b = this.$options.i18n) == null ? void 0 : _b[key])) == null ? void 0 : _c.replace(/%s/g, ()=>params[i++] || "")) || "";
            }
        }
    };
    var closeIcon = '<svg width="14" height="14" viewBox="0 0 14 14"><line fill="none" stroke="#000" stroke-width="1.1" x1="1" y1="1" x2="13" y2="13"/><line fill="none" stroke="#000" stroke-width="1.1" x1="13" y1="1" x2="1" y2="13"/></svg>';
    var closeLarge = '<svg width="20" height="20" viewBox="0 0 20 20"><line fill="none" stroke="#000" stroke-width="1.4" x1="1" y1="1" x2="19" y2="19"/><line fill="none" stroke="#000" stroke-width="1.4" x1="19" y1="1" x2="1" y2="19"/></svg>';
    var dropParentIcon = '<svg width="12" height="12" viewBox="0 0 12 12"><polyline fill="none" stroke="#000" stroke-width="1.1" points="1 3.5 6 8.5 11 3.5"/></svg>';
    var marker = '<svg width="20" height="20" viewBox="0 0 20 20"><rect x="9" y="4" width="1" height="11"/><rect x="4" y="9" width="11" height="1"/></svg>';
    var navParentIcon = '<svg width="12" height="12" viewBox="0 0 12 12"><polyline fill="none" stroke="#000" stroke-width="1.1" points="1 3.5 6 8.5 11 3.5"/></svg>';
    var navParentIconLarge = '<svg width="14" height="14" viewBox="0 0 14 14"><polyline fill="none" stroke="#000" stroke-width="1.1" points="1 4 7 10 13 4"/></svg>';
    var navbarParentIcon = '<svg width="12" height="12" viewBox="0 0 12 12"><polyline fill="none" stroke="#000" stroke-width="1.1" points="1 3.5 6 8.5 11 3.5"/></svg>';
    var navbarToggleIcon = '<svg width="20" height="20" viewBox="0 0 20 20"><style>.uk-navbar-toggle-animate svg&gt;[class*=&quot;line-&quot;]{transition:0.2s ease-in-out;transition-property:transform, opacity;transform-origin:center;opacity:1}.uk-navbar-toggle svg&gt;.line-3{opacity:0}.uk-navbar-toggle-animate[aria-expanded=&quot;true&quot;] svg&gt;.line-3{opacity:1}.uk-navbar-toggle-animate[aria-expanded=&quot;true&quot;] svg&gt;.line-2{transform:rotate(45deg)}.uk-navbar-toggle-animate[aria-expanded=&quot;true&quot;] svg&gt;.line-3{transform:rotate(-45deg)}.uk-navbar-toggle-animate[aria-expanded=&quot;true&quot;] svg&gt;.line-1,.uk-navbar-toggle-animate[aria-expanded=&quot;true&quot;] svg&gt;.line-4{opacity:0}.uk-navbar-toggle-animate[aria-expanded=&quot;true&quot;] svg&gt;.line-1{transform:translateY(6px) scaleX(0)}.uk-navbar-toggle-animate[aria-expanded=&quot;true&quot;] svg&gt;.line-4{transform:translateY(-6px) scaleX(0)}</style><rect class="line-1" y="3" width="20" height="2"/><rect class="line-2" y="9" width="20" height="2"/><rect class="line-3" y="9" width="20" height="2"/><rect class="line-4" y="15" width="20" height="2"/></svg>';
    var overlayIcon = '<svg width="40" height="40" viewBox="0 0 40 40"><rect x="19" y="0" width="1" height="40"/><rect x="0" y="19" width="40" height="1"/></svg>';
    var paginationNext = '<svg width="7" height="12" viewBox="0 0 7 12"><polyline fill="none" stroke="#000" stroke-width="1.2" points="1 1 6 6 1 11"/></svg>';
    var paginationPrevious = '<svg width="7" height="12" viewBox="0 0 7 12"><polyline fill="none" stroke="#000" stroke-width="1.2" points="6 1 1 6 6 11"/></svg>';
    var searchIcon = '<svg width="20" height="20" viewBox="0 0 20 20"><circle fill="none" stroke="#000" stroke-width="1.1" cx="9" cy="9" r="7"/><path fill="none" stroke="#000" stroke-width="1.1" d="M14,14 L18,18 L14,14 Z"/></svg>';
    var searchLarge = '<svg width="40" height="40" viewBox="0 0 40 40"><circle fill="none" stroke="#000" stroke-width="1.8" cx="17.5" cy="17.5" r="16.5"/><line fill="none" stroke="#000" stroke-width="1.8" x1="38" y1="39" x2="29" y2="30"/></svg>';
    var searchNavbar = '<svg width="24" height="24" viewBox="0 0 24 24"><circle fill="none" stroke="#000" stroke-width="1.1" cx="10.5" cy="10.5" r="9.5"/><line fill="none" stroke="#000" stroke-width="1.1" x1="23" y1="23" x2="17" y2="17"/></svg>';
    var slidenavNext = '<svg width="14" height="24" viewBox="0 0 14 24"><polyline fill="none" stroke="#000" stroke-width="1.4" points="1.225,23 12.775,12 1.225,1"/></svg>';
    var slidenavNextLarge = '<svg width="25" height="40" viewBox="0 0 25 40"><polyline fill="none" stroke="#000" stroke-width="2" points="4.002,38.547 22.527,20.024 4,1.5"/></svg>';
    var slidenavPrevious = '<svg width="14" height="24" viewBox="0 0 14 24"><polyline fill="none" stroke="#000" stroke-width="1.4" points="12.775,1 1.225,12 12.775,23"/></svg>';
    var slidenavPreviousLarge = '<svg width="25" height="40" viewBox="0 0 25 40"><polyline fill="none" stroke="#000" stroke-width="2" points="20.527,1.5 2,20.024 20.525,38.547"/></svg>';
    var spinner = '<svg width="30" height="30" viewBox="0 0 30 30"><circle fill="none" stroke="#000" cx="15" cy="15" r="14"/></svg>';
    var totop = '<svg width="18" height="10" viewBox="0 0 18 10"><polyline fill="none" stroke="#000" stroke-width="1.2" points="1 9 9 1 17 9"/></svg>';
    const icons = {
        spinner: spinner,
        totop: totop,
        marker: marker,
        "close-icon": closeIcon,
        "close-large": closeLarge,
        "drop-parent-icon": dropParentIcon,
        "nav-parent-icon": navParentIcon,
        "nav-parent-icon-large": navParentIconLarge,
        "navbar-parent-icon": navbarParentIcon,
        "navbar-toggle-icon": navbarToggleIcon,
        "overlay-icon": overlayIcon,
        "pagination-next": paginationNext,
        "pagination-previous": paginationPrevious,
        "search-icon": searchIcon,
        "search-large": searchLarge,
        "search-navbar": searchNavbar,
        "slidenav-next": slidenavNext,
        "slidenav-next-large": slidenavNextLarge,
        "slidenav-previous": slidenavPrevious,
        "slidenav-previous-large": slidenavPreviousLarge
    };
    const Icon = {
        install: install$3,
        mixins: [
            Svg
        ],
        args: "icon",
        props: {
            icon: String
        },
        isIcon: true,
        beforeConnect () {
            addClass(this.$el, "uk-icon");
        },
        methods: {
            async getSvg () {
                const icon = getIcon(this.icon);
                if (!icon) throw "Icon not found.";
                return icon;
            }
        }
    };
    const IconComponent = {
        args: false,
        extends: Icon,
        data: (vm)=>({
                icon: hyphenate(vm.constructor.options.name)
            }),
        beforeConnect () {
            addClass(this.$el, this.$options.id);
        }
    };
    const NavParentIcon = {
        extends: IconComponent,
        beforeConnect () {
            const icon = this.$props.icon;
            this.icon = closest(this.$el, ".uk-nav-primary") ? `${icon}-large` : icon;
        }
    };
    const Search = {
        extends: IconComponent,
        mixins: [
            I18n
        ],
        i18n: {
            toggle: "Open Search",
            submit: "Submit Search"
        },
        beforeConnect () {
            this.icon = hasClass(this.$el, "uk-search-icon") && parents(this.$el, ".uk-search-large").length ? "search-large" : parents(this.$el, ".uk-search-navbar").length ? "search-navbar" : this.$props.icon;
            if (hasAttr(this.$el, "aria-label")) return;
            if (hasClass(this.$el, "uk-search-toggle") || hasClass(this.$el, "uk-navbar-toggle")) {
                const label = this.t("toggle");
                attr(this.$el, "aria-label", label);
            } else {
                const button = closest(this.$el, "a,button");
                if (button) {
                    const label = this.t("submit");
                    attr(button, "aria-label", label);
                }
            }
        }
    };
    const Spinner = {
        extends: IconComponent,
        beforeConnect () {
            attr(this.$el, "role", "status");
        },
        methods: {
            async getSvg () {
                const icon = await Icon.methods.getSvg.call(this);
                if (this.ratio !== 1) css($("circle", icon), "strokeWidth", 1 / this.ratio);
                return icon;
            }
        }
    };
    const ButtonComponent = {
        extends: IconComponent,
        mixins: [
            I18n
        ],
        beforeConnect () {
            const button = closest(this.$el, "a,button");
            attr(button, "role", this.role !== null && isTag(button, "a") ? "button" : this.role);
            const label = this.t("label");
            if (label && !hasAttr(button, "aria-label")) attr(button, "aria-label", label);
        }
    };
    const Slidenav = {
        extends: ButtonComponent,
        beforeConnect () {
            addClass(this.$el, "uk-slidenav");
            const icon = this.$props.icon;
            this.icon = hasClass(this.$el, "uk-slidenav-large") ? `${icon}-large` : icon;
        }
    };
    const NavbarToggleIcon = {
        extends: ButtonComponent,
        i18n: {
            label: "Open menu"
        }
    };
    const Close = {
        extends: ButtonComponent,
        i18n: {
            label: "Close"
        },
        beforeConnect () {
            this.icon = `close-${hasClass(this.$el, "uk-close-large") ? "large" : "icon"}`;
        }
    };
    const Marker = {
        extends: ButtonComponent,
        i18n: {
            label: "Open"
        }
    };
    const Totop = {
        extends: ButtonComponent,
        i18n: {
            label: "Back to top"
        }
    };
    const PaginationNext = {
        extends: ButtonComponent,
        i18n: {
            label: "Next page"
        },
        data: {
            role: null
        }
    };
    const PaginationPrevious = {
        extends: ButtonComponent,
        i18n: {
            label: "Previous page"
        },
        data: {
            role: null
        }
    };
    const parsed = {};
    function install$3(UIkit) {
        UIkit.icon.add = (name, svg)=>{
            const added = isString(name) ? {
                [name]: svg
            } : name;
            each(added, (svg2, name2)=>{
                icons[name2] = svg2;
                delete parsed[name2];
            });
            if (UIkit._initialized) apply(document.body, (el)=>each(UIkit.getComponents(el), (cmp)=>{
                    cmp.$options.isIcon && cmp.icon in added && cmp.$reset();
                }));
        };
    }
    function getIcon(icon) {
        if (!icons[icon]) return null;
        if (!parsed[icon]) parsed[icon] = $((icons[applyRtl(icon)] || icons[icon]).trim());
        return parsed[icon].cloneNode(true);
    }
    function applyRtl(icon) {
        return isRtl ? swap(swap(icon, "left", "right"), "previous", "next") : icon;
    }
    const nativeLazyLoad = inBrowser && "loading" in HTMLImageElement.prototype;
    var img = {
        args: "dataSrc",
        props: {
            dataSrc: String,
            sources: String,
            margin: String,
            target: String,
            loading: String
        },
        data: {
            dataSrc: "",
            sources: false,
            margin: "50%",
            target: false,
            loading: "lazy"
        },
        connected () {
            if (this.loading !== "lazy") {
                this.load();
                return;
            }
            if (nativeLazyLoad && isImg(this.$el)) {
                this.$el.loading = "lazy";
                setSrcAttrs(this.$el);
            }
            ensureSrcAttribute(this.$el);
        },
        disconnected () {
            if (this.img) this.img.onload = "";
            delete this.img;
        },
        observe: intersection({
            target: ({ $el: $el, $props: $props })=>[
                    $el,
                    ...queryAll($props.target, $el)
                ],
            handler (entries, observer) {
                this.load();
                observer.disconnect();
            },
            options: ({ margin: margin })=>({
                    rootMargin: margin
                }),
            filter: ({ loading: loading })=>loading === "lazy"
        }),
        methods: {
            load () {
                if (this.img) return this.img;
                const image = isImg(this.$el) ? this.$el : getImageFromElement(this.$el, this.dataSrc, this.sources);
                removeAttr(image, "loading");
                setSrcAttrs(this.$el, image.currentSrc);
                return this.img = image;
            }
        }
    };
    function setSrcAttrs(el, src) {
        if (isImg(el)) {
            const parentNode = parent(el);
            const elements = isTag(parentNode, "picture") ? children(parentNode) : [
                el
            ];
            elements.forEach((el2)=>setSourceProps(el2, el2));
        } else if (src) {
            const change = !includes(el.style.backgroundImage, src);
            if (change) {
                css(el, "backgroundImage", `url(${escape(src)})`);
                trigger(el, createEvent("load", false));
            }
        }
    }
    const srcProps = [
        "data-src",
        "data-srcset",
        "sizes"
    ];
    function setSourceProps(sourceEl, targetEl) {
        for (const prop of srcProps){
            const value = data(sourceEl, prop);
            if (value) attr(targetEl, prop.replace(/^(data-)+/, ""), value);
        }
    }
    function getImageFromElement(el, src, sources) {
        const img = new Image();
        wrapInPicture(img, sources);
        setSourceProps(el, img);
        img.onload = ()=>{
            setSrcAttrs(el, img.currentSrc);
        };
        attr(img, "src", src);
        return img;
    }
    function wrapInPicture(img, sources) {
        sources = parseSources(sources);
        if (sources.length) {
            const picture = fragment("<picture>");
            for (const attrs of sources){
                const source = fragment("<source>");
                attr(source, attrs);
                append(picture, source);
            }
            append(picture, img);
        }
    }
    function parseSources(sources) {
        if (!sources) return [];
        if (startsWith(sources, "[")) try {
            sources = JSON.parse(sources);
        } catch (e) {
            sources = [];
        }
        else sources = parseOptions(sources);
        if (!isArray(sources)) sources = [
            sources
        ];
        return sources.filter((source)=>!isEmpty(source));
    }
    function ensureSrcAttribute(el) {
        if (isImg(el) && !hasAttr(el, "src")) attr(el, "src", 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg"></svg>');
    }
    function isImg(el) {
        return isTag(el, "img");
    }
    var Media = {
        props: {
            media: Boolean
        },
        data: {
            media: false
        },
        connected () {
            const media = toMedia(this.media, this.$el);
            this.matchMedia = true;
            if (media) {
                this.mediaObj = window.matchMedia(media);
                const handler = ()=>{
                    this.matchMedia = this.mediaObj.matches;
                    trigger(this.$el, createEvent("mediachange", false, true, [
                        this.mediaObj
                    ]));
                };
                this.offMediaObj = on(this.mediaObj, "change", ()=>{
                    handler();
                    this.$emit("resize");
                });
                handler();
            }
        },
        disconnected () {
            var _a;
            (_a = this.offMediaObj) == null || _a.call(this);
        }
    };
    function toMedia(value, element) {
        if (isString(value)) {
            if (startsWith(value, "@")) value = toFloat(css(element, `--uk-breakpoint-${value.substr(1)}`));
            else if (isNaN(value)) return value;
        }
        return value && isNumeric(value) ? `(min-width: ${value}px)` : "";
    }
    var leader = {
        mixins: [
            Class,
            Media
        ],
        props: {
            fill: String
        },
        data: {
            fill: "",
            clsWrapper: "uk-leader-fill",
            clsHide: "uk-leader-hide",
            attrFill: "data-fill"
        },
        computed: {
            fill ({ fill: fill }) {
                return fill || css(this.$el, "--uk-leader-fill-content");
            }
        },
        connected () {
            [this.wrapper] = wrapInner(this.$el, `<span class="${this.clsWrapper}">`);
        },
        disconnected () {
            unwrap(this.wrapper.childNodes);
        },
        observe: resize(),
        update: {
            read () {
                const width = Math.trunc(this.$el.offsetWidth / 2);
                return {
                    width: width,
                    fill: this.fill,
                    hide: !this.matchMedia
                };
            },
            write ({ width: width, fill: fill, hide: hide }) {
                toggleClass(this.wrapper, this.clsHide, hide);
                attr(this.wrapper, this.attrFill, new Array(width).join(fill));
            },
            events: [
                "resize"
            ]
        }
    };
    const active = [];
    var Modal = {
        mixins: [
            Class,
            Container,
            Togglable
        ],
        props: {
            selPanel: String,
            selClose: String,
            escClose: Boolean,
            bgClose: Boolean,
            stack: Boolean,
            role: String
        },
        data: {
            cls: "uk-open",
            escClose: true,
            bgClose: true,
            overlay: true,
            stack: false,
            role: "dialog"
        },
        computed: {
            panel ({ selPanel: selPanel }, $el) {
                return $(selPanel, $el);
            },
            transitionElement () {
                return this.panel;
            },
            bgClose ({ bgClose: bgClose }) {
                return bgClose && this.panel;
            }
        },
        connected () {
            attr(this.panel || this.$el, "role", this.role);
            if (this.overlay) attr(this.panel || this.$el, "aria-modal", true);
        },
        beforeDisconnect () {
            if (includes(active, this)) this.toggleElement(this.$el, false, false);
        },
        events: [
            {
                name: "click",
                delegate () {
                    return `${this.selClose},a[href*="#"]`;
                },
                handler (e) {
                    const { current: current, defaultPrevented: defaultPrevented } = e;
                    const { hash: hash } = current;
                    if (!defaultPrevented && hash && isSameSiteAnchor(current) && !within(hash, this.$el) && $(hash, document.body)) this.hide();
                    else if (matches(current, this.selClose)) {
                        e.preventDefault();
                        this.hide();
                    }
                }
            },
            {
                name: "toggle",
                self: true,
                handler (e) {
                    if (e.defaultPrevented) return;
                    e.preventDefault();
                    if (this.isToggled() === includes(active, this)) this.toggle();
                }
            },
            {
                name: "beforeshow",
                self: true,
                handler (e) {
                    if (includes(active, this)) return false;
                    if (!this.stack && active.length) {
                        Promise.all(active.map((modal)=>modal.hide())).then(this.show);
                        e.preventDefault();
                    } else active.push(this);
                }
            },
            {
                name: "show",
                self: true,
                handler () {
                    if (this.stack) css(this.$el, "zIndex", toFloat(css(this.$el, "zIndex")) + active.length);
                    const handlers = [
                        this.overlay && preventBackgroundFocus(this),
                        this.overlay && preventBackgroundScroll(this.$el),
                        this.bgClose && listenForBackgroundClose(this),
                        this.escClose && listenForEscClose(this)
                    ];
                    once(this.$el, "hidden", ()=>handlers.forEach((handler)=>handler && handler()), {
                        self: true
                    });
                    addClass(document.documentElement, this.clsPage);
                }
            },
            {
                name: "shown",
                self: true,
                handler () {
                    if (!isFocusable(this.$el)) attr(this.$el, "tabindex", "-1");
                    if (!matches(this.$el, ":focus-within")) this.$el.focus();
                }
            },
            {
                name: "hidden",
                self: true,
                handler () {
                    if (includes(active, this)) active.splice(active.indexOf(this), 1);
                    css(this.$el, "zIndex", "");
                    if (!active.some((modal)=>modal.clsPage === this.clsPage)) removeClass(document.documentElement, this.clsPage);
                }
            }
        ],
        methods: {
            toggle () {
                return this.isToggled() ? this.hide() : this.show();
            },
            show () {
                if (this.container && parent(this.$el) !== this.container) {
                    append(this.container, this.$el);
                    return new Promise((resolve)=>requestAnimationFrame(()=>this.show().then(resolve)));
                }
                return this.toggleElement(this.$el, true, animate);
            },
            hide () {
                return this.toggleElement(this.$el, false, animate);
            }
        }
    };
    function animate(el, show, { transitionElement: transitionElement, _toggle: _toggle }) {
        return new Promise((resolve, reject)=>once(el, "show hide", ()=>{
                var _a;
                (_a = el._reject) == null || _a.call(el);
                el._reject = reject;
                _toggle(el, show);
                const off = once(transitionElement, "transitionstart", ()=>{
                    once(transitionElement, "transitionend transitioncancel", resolve, {
                        self: true
                    });
                    clearTimeout(timer);
                }, {
                    self: true
                });
                const timer = setTimeout(()=>{
                    off();
                    resolve();
                }, toMs(css(transitionElement, "transitionDuration")));
            })).then(()=>delete el._reject);
    }
    function toMs(time) {
        return time ? endsWith(time, "ms") ? toFloat(time) : toFloat(time) * 1e3 : 0;
    }
    function preventBackgroundFocus(modal) {
        return on(document, "focusin", (e)=>{
            if (last(active) === modal && !within(e.target, modal.$el)) modal.$el.focus();
        });
    }
    function listenForBackgroundClose(modal) {
        return on(document, pointerDown$1, ({ target: target })=>{
            if (last(active) !== modal || modal.overlay && !within(target, modal.$el) || within(target, modal.panel)) return;
            once(document, `${pointerUp$1} ${pointerCancel} scroll`, ({ defaultPrevented: defaultPrevented, type: type, target: newTarget })=>{
                if (!defaultPrevented && type === pointerUp$1 && target === newTarget) modal.hide();
            }, true);
        });
    }
    function listenForEscClose(modal) {
        return on(document, "keydown", (e)=>{
            if (e.keyCode === 27 && last(active) === modal) modal.hide();
        });
    }
    var modal = {
        install: install$2,
        mixins: [
            Modal
        ],
        data: {
            clsPage: "uk-modal-page",
            selPanel: ".uk-modal-dialog",
            selClose: ".uk-modal-close, .uk-modal-close-default, .uk-modal-close-outside, .uk-modal-close-full"
        },
        events: [
            {
                name: "show",
                self: true,
                handler () {
                    if (hasClass(this.panel, "uk-margin-auto-vertical")) addClass(this.$el, "uk-flex");
                    else css(this.$el, "display", "block");
                    height(this.$el);
                }
            },
            {
                name: "hidden",
                self: true,
                handler () {
                    css(this.$el, "display", "");
                    removeClass(this.$el, "uk-flex");
                }
            }
        ]
    };
    function install$2({ modal: modal }) {
        modal.dialog = function(content, options) {
            const dialog = modal(`<div class="uk-modal"> <div class="uk-modal-dialog">${content}</div> </div>`, {
                stack: true,
                role: "alertdialog",
                ...options
            });
            dialog.show();
            on(dialog.$el, "hidden", async ()=>{
                await Promise.resolve();
                dialog.$destroy(true);
            }, {
                self: true
            });
            return dialog;
        };
        modal.alert = function(message, options) {
            return openDialog(({ i18n: i18n })=>`<div class="uk-modal-body">${isString(message) ? message : html(message)}</div> <div class="uk-modal-footer uk-text-right"> <button class="uk-button uk-button-primary uk-modal-close" autofocus>${i18n.ok}</button> </div>`, options);
        };
        modal.confirm = function(message, options) {
            return openDialog(({ i18n: i18n })=>`<form> <div class="uk-modal-body">${isString(message) ? message : html(message)}</div> <div class="uk-modal-footer uk-text-right"> <button class="uk-button uk-button-default uk-modal-close" type="button">${i18n.cancel}</button> <button class="uk-button uk-button-primary" autofocus>${i18n.ok}</button> </div> </form>`, options, ()=>Promise.reject());
        };
        modal.prompt = function(message, value, options) {
            const promise = openDialog(({ i18n: i18n })=>`<form class="uk-form-stacked"> <div class="uk-modal-body"> <label>${isString(message) ? message : html(message)}</label> <input class="uk-input" value="${value || ""}" autofocus> </div> <div class="uk-modal-footer uk-text-right"> <button class="uk-button uk-button-default uk-modal-close" type="button">${i18n.cancel}</button> <button class="uk-button uk-button-primary">${i18n.ok}</button> </div> </form>`, options, ()=>null, ()=>input.value);
            const { $el: $el } = promise.dialog;
            const input = $("input", $el);
            on($el, "show", ()=>input.select());
            return promise;
        };
        modal.i18n = {
            ok: "Ok",
            cancel: "Cancel"
        };
        function openDialog(tmpl, options, hideFn = noop, submitFn = noop) {
            options = {
                bgClose: false,
                escClose: true,
                ...options,
                i18n: {
                    ...modal.i18n,
                    ...options == null ? void 0 : options.i18n
                }
            };
            const dialog = modal.dialog(tmpl(options), options);
            return assign(new Promise((resolve)=>{
                const off = on(dialog.$el, "hide", ()=>resolve(hideFn()));
                on(dialog.$el, "submit", "form", (e)=>{
                    e.preventDefault();
                    resolve(submitFn(dialog));
                    off();
                    dialog.hide();
                });
            }), {
                dialog: dialog
            });
        }
    }
    var nav = {
        extends: Accordion,
        data: {
            targets: "> .uk-parent",
            toggle: "> a",
            content: "> ul"
        }
    };
    var navbar = {
        extends: Dropnav,
        data: {
            clsDrop: "uk-navbar-dropdown",
            selNavItem: ".uk-navbar-nav > li > a,a.uk-navbar-item,button.uk-navbar-item,.uk-navbar-item a,.uk-navbar-item button,.uk-navbar-toggle"
        },
        watch: {
            items () {
                const justify = hasClass(this.$el, "uk-navbar-justify");
                for (const container of $$(".uk-navbar-nav, .uk-navbar-left, .uk-navbar-right", this.$el))css(container, "flexGrow", justify ? $$(".uk-navbar-nav > li > a, .uk-navbar-item, .uk-navbar-toggle", container).length : "");
            }
        }
    };
    var offcanvas = {
        mixins: [
            Modal
        ],
        args: "mode",
        props: {
            mode: String,
            flip: Boolean,
            overlay: Boolean,
            swiping: Boolean
        },
        data: {
            mode: "slide",
            flip: false,
            overlay: false,
            clsPage: "uk-offcanvas-page",
            clsContainer: "uk-offcanvas-container",
            selPanel: ".uk-offcanvas-bar",
            clsFlip: "uk-offcanvas-flip",
            clsContainerAnimation: "uk-offcanvas-container-animation",
            clsSidebarAnimation: "uk-offcanvas-bar-animation",
            clsMode: "uk-offcanvas",
            clsOverlay: "uk-offcanvas-overlay",
            selClose: ".uk-offcanvas-close",
            container: false,
            swiping: true
        },
        computed: {
            clsFlip ({ flip: flip, clsFlip: clsFlip }) {
                return flip ? clsFlip : "";
            },
            clsOverlay ({ overlay: overlay, clsOverlay: clsOverlay }) {
                return overlay ? clsOverlay : "";
            },
            clsMode ({ mode: mode, clsMode: clsMode }) {
                return `${clsMode}-${mode}`;
            },
            clsSidebarAnimation ({ mode: mode, clsSidebarAnimation: clsSidebarAnimation }) {
                return mode === "none" || mode === "reveal" ? "" : clsSidebarAnimation;
            },
            clsContainerAnimation ({ mode: mode, clsContainerAnimation: clsContainerAnimation }) {
                return mode !== "push" && mode !== "reveal" ? "" : clsContainerAnimation;
            },
            transitionElement ({ mode: mode }) {
                return mode === "reveal" ? parent(this.panel) : this.panel;
            }
        },
        observe: swipe({
            filter: ({ swiping: swiping })=>swiping
        }),
        update: {
            read () {
                if (this.isToggled() && !isVisible(this.$el)) this.hide();
            },
            events: [
                "resize"
            ]
        },
        events: [
            {
                name: "touchmove",
                self: true,
                passive: false,
                filter () {
                    return this.overlay;
                },
                handler (e) {
                    e.cancelable && e.preventDefault();
                }
            },
            {
                name: "show",
                self: true,
                handler () {
                    if (this.mode === "reveal" && !hasClass(parent(this.panel), this.clsMode)) {
                        wrapAll(this.panel, "<div>");
                        addClass(parent(this.panel), this.clsMode);
                    }
                    const { body: body, scrollingElement: scrollingElement } = document;
                    addClass(body, this.clsContainer, this.clsFlip);
                    css(body, "touch-action", "pan-y pinch-zoom");
                    css(this.$el, "display", "block");
                    css(this.panel, "maxWidth", scrollingElement.clientWidth);
                    addClass(this.$el, this.clsOverlay);
                    addClass(this.panel, this.clsSidebarAnimation, this.mode === "reveal" ? "" : this.clsMode);
                    height(body);
                    addClass(body, this.clsContainerAnimation);
                    this.clsContainerAnimation && suppressUserScale();
                }
            },
            {
                name: "hide",
                self: true,
                handler () {
                    removeClass(document.body, this.clsContainerAnimation);
                    css(document.body, "touch-action", "");
                }
            },
            {
                name: "hidden",
                self: true,
                handler () {
                    this.clsContainerAnimation && resumeUserScale();
                    if (this.mode === "reveal") unwrap(this.panel);
                    removeClass(this.panel, this.clsSidebarAnimation, this.clsMode);
                    removeClass(this.$el, this.clsOverlay);
                    css(this.$el, "display", "");
                    css(this.panel, "maxWidth", "");
                    removeClass(document.body, this.clsContainer, this.clsFlip);
                }
            },
            {
                name: "swipeLeft swipeRight",
                handler (e) {
                    if (this.isToggled() && endsWith(e.type, "Left") ^ this.flip) this.hide();
                }
            }
        ]
    };
    function suppressUserScale() {
        getViewport().content += ",user-scalable=0";
    }
    function resumeUserScale() {
        const viewport = getViewport();
        viewport.content = viewport.content.replace(/,user-scalable=0$/, "");
    }
    function getViewport() {
        return $('meta[name="viewport"]', document.head) || append(document.head, '<meta name="viewport">');
    }
    var overflowAuto = {
        mixins: [
            Class
        ],
        props: {
            selContainer: String,
            selContent: String,
            minHeight: Number
        },
        data: {
            selContainer: ".uk-modal",
            selContent: ".uk-modal-dialog",
            minHeight: 150
        },
        computed: {
            container ({ selContainer: selContainer }, $el) {
                return closest($el, selContainer);
            },
            content ({ selContent: selContent }, $el) {
                return closest($el, selContent);
            }
        },
        observe: resize({
            target: ({ container: container, content: content })=>[
                    container,
                    content
                ]
        }),
        update: {
            read () {
                if (!this.content || !this.container || !isVisible(this.$el)) return false;
                return {
                    max: Math.max(this.minHeight, height(this.container) - (dimensions$1(this.content).height - height(this.$el)))
                };
            },
            write ({ max: max }) {
                css(this.$el, {
                    minHeight: this.minHeight,
                    maxHeight: max
                });
            },
            events: [
                "resize"
            ]
        }
    };
    var responsive = {
        props: [
            "width",
            "height"
        ],
        connected () {
            addClass(this.$el, "uk-responsive-width");
        },
        observe: resize({
            target: ({ $el: $el })=>[
                    $el,
                    parent($el)
                ]
        }),
        update: {
            read () {
                return isVisible(this.$el) && this.width && this.height ? {
                    width: width(parent(this.$el)),
                    height: this.height
                } : false;
            },
            write (dim) {
                height(this.$el, Dimensions.contain({
                    height: this.height,
                    width: this.width
                }, dim).height);
            },
            events: [
                "resize"
            ]
        }
    };
    var scroll = {
        props: {
            offset: Number
        },
        data: {
            offset: 0
        },
        connected () {
            registerClick(this);
        },
        disconnected () {
            unregisterClick(this);
        },
        methods: {
            async scrollTo (el) {
                el = el && $(el) || document.body;
                if (trigger(this.$el, "beforescroll", [
                    this,
                    el
                ])) {
                    await scrollIntoView(el, {
                        offset: this.offset
                    });
                    trigger(this.$el, "scrolled", [
                        this,
                        el
                    ]);
                }
            }
        }
    };
    const instances = /* @__PURE__ */ new Set();
    function registerClick(cmp) {
        if (!instances.size) on(document, "click", clickHandler);
        instances.add(cmp);
    }
    function unregisterClick(cmp) {
        instances.delete(cmp);
        if (!instances.size) off(document, "click", clickHandler);
    }
    function clickHandler(e) {
        if (e.defaultPrevented) return;
        for (const instance of instances)if (within(e.target, instance.$el) && isSameSiteAnchor(instance.$el)) {
            e.preventDefault();
            if (window.location.href !== instance.$el.href) window.history.pushState({}, "", instance.$el.href);
            instance.scrollTo(getTargetedElement(instance.$el));
        }
    }
    var scrollspy = {
        args: "cls",
        props: {
            cls: String,
            target: String,
            hidden: Boolean,
            margin: String,
            repeat: Boolean,
            delay: Number
        },
        data: ()=>({
                cls: "",
                target: false,
                hidden: true,
                margin: "-1px",
                repeat: false,
                delay: 0,
                inViewClass: "uk-scrollspy-inview"
            }),
        computed: {
            elements ({ target: target }, $el) {
                return target ? $$(target, $el) : [
                    $el
                ];
            }
        },
        watch: {
            elements (elements) {
                if (this.hidden) css(filter$1(elements, `:not(.${this.inViewClass})`), "opacity", 0);
            }
        },
        connected () {
            this.elementData = /* @__PURE__ */ new Map();
        },
        disconnected () {
            for (const [el, state] of this.elementData.entries())removeClass(el, this.inViewClass, (state == null ? void 0 : state.cls) || "");
            delete this.elementData;
        },
        observe: intersection({
            target: ({ elements: elements })=>elements,
            handler (records) {
                const elements = this.elementData;
                for (const { target: el, isIntersecting: isIntersecting } of records){
                    if (!elements.has(el)) elements.set(el, {
                        cls: data(el, "uk-scrollspy-class") || this.cls
                    });
                    const state = elements.get(el);
                    if (!this.repeat && state.show) continue;
                    state.show = isIntersecting;
                }
                this.$emit();
            },
            options: (instance)=>({
                    rootMargin: instance.margin
                }),
            args: {
                intersecting: false
            }
        }),
        update: [
            {
                write (data) {
                    for (const [el, state] of this.elementData.entries()){
                        if (state.show && !state.inview && !state.queued) {
                            state.queued = true;
                            data.promise = (data.promise || Promise.resolve()).then(()=>new Promise((resolve)=>setTimeout(resolve, this.delay))).then(()=>{
                                this.toggle(el, true);
                                setTimeout(()=>{
                                    state.queued = false;
                                    this.$emit();
                                }, 300);
                            });
                        } else if (!state.show && state.inview && !state.queued && this.repeat) this.toggle(el, false);
                    }
                }
            }
        ],
        methods: {
            toggle (el, inview) {
                var _a;
                const state = this.elementData.get(el);
                if (!state) return;
                (_a = state.off) == null || _a.call(state);
                css(el, "opacity", !inview && this.hidden ? 0 : "");
                toggleClass(el, this.inViewClass, inview);
                toggleClass(el, state.cls);
                if (/\buk-animation-/.test(state.cls)) {
                    const removeAnimationClasses = ()=>removeClasses(el, "uk-animation-[\\w-]+");
                    if (inview) state.off = once(el, "animationcancel animationend", removeAnimationClasses);
                    else removeAnimationClasses();
                }
                trigger(el, inview ? "inview" : "outview");
                state.inview = inview;
                this.$update(el);
            }
        }
    };
    var scrollspyNav = {
        props: {
            cls: String,
            closest: String,
            scroll: Boolean,
            overflow: Boolean,
            offset: Number
        },
        data: {
            cls: "uk-active",
            closest: false,
            scroll: false,
            overflow: true,
            offset: 0
        },
        computed: {
            links (_, $el) {
                return $$('a[href*="#"]', $el).filter((el)=>el.hash && isSameSiteAnchor(el));
            },
            elements ({ closest: selector }) {
                return closest(this.links, selector || "*");
            }
        },
        watch: {
            links (links) {
                if (this.scroll) this.$create("scroll", links, {
                    offset: this.offset || 0
                });
            }
        },
        observe: [
            intersection(),
            scroll$1()
        ],
        update: [
            {
                read () {
                    const targets = this.links.map(getTargetedElement).filter(Boolean);
                    const { length: length } = targets;
                    if (!length || !isVisible(this.$el)) return false;
                    const scrollElement = scrollParent(targets, true);
                    const { scrollTop: scrollTop, scrollHeight: scrollHeight } = scrollElement;
                    const viewport = offsetViewport(scrollElement);
                    const max = scrollHeight - viewport.height;
                    let active = false;
                    if (scrollTop === max) active = length - 1;
                    else {
                        for(let i = 0; i < targets.length; i++){
                            if (offset(targets[i]).top - viewport.top - this.offset > 0) break;
                            active = +i;
                        }
                        if (active === false && this.overflow) active = 0;
                    }
                    return {
                        active: active
                    };
                },
                write ({ active: active }) {
                    const changed = active !== false && !hasClass(this.elements[active], this.cls);
                    this.links.forEach((el)=>el.blur());
                    for(let i = 0; i < this.elements.length; i++)toggleClass(this.elements[i], this.cls, +i === active);
                    if (changed) trigger(this.$el, "active", [
                        active,
                        this.elements[active]
                    ]);
                },
                events: [
                    "scroll",
                    "resize"
                ]
            }
        ]
    };
    var sticky = {
        mixins: [
            Class,
            Media
        ],
        props: {
            position: String,
            top: null,
            bottom: null,
            start: null,
            end: null,
            offset: String,
            overflowFlip: Boolean,
            animation: String,
            clsActive: String,
            clsInactive: String,
            clsFixed: String,
            clsBelow: String,
            selTarget: String,
            showOnUp: Boolean,
            targetOffset: Number
        },
        data: {
            position: "top",
            top: false,
            bottom: false,
            start: false,
            end: false,
            offset: 0,
            overflowFlip: false,
            animation: "",
            clsActive: "uk-active",
            clsInactive: "",
            clsFixed: "uk-sticky-fixed",
            clsBelow: "uk-sticky-below",
            selTarget: "",
            showOnUp: false,
            targetOffset: false
        },
        computed: {
            selTarget ({ selTarget: selTarget }, $el) {
                return selTarget && $(selTarget, $el) || $el;
            }
        },
        connected () {
            this.start = coerce(this.start || this.top);
            this.end = coerce(this.end || this.bottom);
            this.placeholder = $("+ .uk-sticky-placeholder", this.$el) || $('<div class="uk-sticky-placeholder"></div>');
            this.isFixed = false;
            this.setActive(false);
        },
        disconnected () {
            if (this.isFixed) {
                this.hide();
                removeClass(this.selTarget, this.clsInactive);
            }
            reset(this.$el);
            remove$1(this.placeholder);
            this.placeholder = null;
        },
        observe: [
            resize({
                target: ({ $el: $el })=>[
                        $el,
                        document.scrollingElement
                    ]
            }),
            viewport(),
            scroll$1()
        ],
        events: [
            {
                name: "load hashchange popstate",
                el () {
                    return window;
                },
                filter () {
                    return this.targetOffset !== false;
                },
                handler () {
                    const { scrollingElement: scrollingElement } = document;
                    if (!location.hash || scrollingElement.scrollTop === 0) return;
                    setTimeout(()=>{
                        const targetOffset = offset($(location.hash));
                        const elOffset = offset(this.$el);
                        if (this.isFixed && intersectRect(targetOffset, elOffset)) scrollingElement.scrollTop = targetOffset.top - elOffset.height - toPx(this.targetOffset, "height", this.placeholder) - toPx(this.offset, "height", this.placeholder);
                    });
                }
            },
            {
                name: "transitionstart",
                capture: true,
                handler () {
                    this.transitionInProgress = once(this.$el, "transitionend transitioncancel", ()=>this.transitionInProgress = null);
                }
            }
        ],
        update: [
            {
                read ({ height: height$1, width: width, margin: margin, sticky: sticky }) {
                    this.inactive = !this.matchMedia || !isVisible(this.$el);
                    if (this.inactive) return;
                    const hide = this.isFixed && !this.transitionInProgress;
                    if (hide) {
                        preventTransition(this.selTarget);
                        this.hide();
                    }
                    if (!this.active) {
                        ({ height: height$1, width: width } = offset(this.$el));
                        margin = css(this.$el, "margin");
                    }
                    if (hide) this.show();
                    const viewport2 = toPx("100vh", "height");
                    const dynamicViewport = height(window);
                    const maxScrollHeight = document.scrollingElement.scrollHeight - viewport2;
                    let position = this.position;
                    if (this.overflowFlip && height$1 > viewport2) position = position === "top" ? "bottom" : "top";
                    const referenceElement = this.isFixed ? this.placeholder : this.$el;
                    let offset$1 = toPx(this.offset, "height", sticky ? this.$el : referenceElement);
                    if (position === "bottom" && (height$1 < dynamicViewport || this.overflowFlip)) offset$1 += dynamicViewport - height$1;
                    const overflow = this.overflowFlip ? 0 : Math.max(0, height$1 + offset$1 - viewport2);
                    const topOffset = offset(referenceElement).top;
                    const elHeight = offset(this.$el).height;
                    const start = (this.start === false ? topOffset : parseProp(this.start, this.$el, topOffset)) - offset$1;
                    const end = this.end === false ? maxScrollHeight : Math.min(maxScrollHeight, parseProp(this.end, this.$el, topOffset + height$1, true) - elHeight - offset$1 + overflow);
                    sticky = maxScrollHeight && !this.showOnUp && start + offset$1 === topOffset && end === Math.min(maxScrollHeight, parseProp("!*", this.$el, 0, true) - elHeight - offset$1 + overflow) && css(parent(this.$el), "overflowY") === "visible";
                    return {
                        start: start,
                        end: end,
                        offset: offset$1,
                        overflow: overflow,
                        topOffset: topOffset,
                        height: height$1,
                        elHeight: elHeight,
                        width: width,
                        margin: margin,
                        top: offsetPosition(referenceElement)[0],
                        sticky: sticky
                    };
                },
                write ({ height: height, width: width, margin: margin, offset: offset, sticky: sticky }) {
                    if (this.inactive || sticky || !this.isFixed) reset(this.$el);
                    if (this.inactive) return;
                    if (sticky) {
                        height = width = margin = 0;
                        css(this.$el, {
                            position: "sticky",
                            top: offset
                        });
                    }
                    const { placeholder: placeholder } = this;
                    css(placeholder, {
                        height: height,
                        width: width,
                        margin: margin
                    });
                    if (!within(placeholder, document)) placeholder.hidden = true;
                    (sticky ? before : after)(this.$el, placeholder);
                },
                events: [
                    "resize"
                ]
            },
            {
                read ({ scroll: prevScroll = 0, dir: prevDir = "down", overflow: overflow, overflowScroll: overflowScroll = 0, start: start, end: end }) {
                    const scroll2 = document.scrollingElement.scrollTop;
                    const dir = prevScroll <= scroll2 ? "down" : "up";
                    return {
                        dir: dir,
                        prevDir: prevDir,
                        scroll: scroll2,
                        prevScroll: prevScroll,
                        offsetParentTop: offset((this.isFixed ? this.placeholder : this.$el).offsetParent).top,
                        overflowScroll: clamp(overflowScroll + clamp(scroll2, start, end) - clamp(prevScroll, start, end), 0, overflow)
                    };
                },
                write (data, types) {
                    const isScrollUpdate = types.has("scroll");
                    const { initTimestamp: initTimestamp = 0, dir: dir, prevDir: prevDir, scroll: scroll2, prevScroll: prevScroll = 0, top: top, start: start, topOffset: topOffset, height: height } = data;
                    if (scroll2 < 0 || scroll2 === prevScroll && isScrollUpdate || this.showOnUp && !isScrollUpdate && !this.isFixed) return;
                    const now = Date.now();
                    if (now - initTimestamp > 300 || dir !== prevDir) {
                        data.initScroll = scroll2;
                        data.initTimestamp = now;
                    }
                    if (this.showOnUp && !this.isFixed && Math.abs(data.initScroll - scroll2) <= 30 && Math.abs(prevScroll - scroll2) <= 10) return;
                    if (this.inactive || scroll2 < start || this.showOnUp && (scroll2 <= start || dir === "down" && isScrollUpdate || dir === "up" && !this.isFixed && scroll2 <= topOffset + height)) {
                        if (!this.isFixed) {
                            if (Animation.inProgress(this.$el) && top > scroll2) {
                                Animation.cancel(this.$el);
                                this.hide();
                            }
                            return;
                        }
                        if (this.animation && scroll2 > topOffset) {
                            Animation.cancel(this.$el);
                            Animation.out(this.$el, this.animation).then(()=>this.hide(), noop);
                        } else this.hide();
                    } else if (this.isFixed) this.update();
                    else if (this.animation && scroll2 > topOffset) {
                        Animation.cancel(this.$el);
                        this.show();
                        Animation.in(this.$el, this.animation).catch(noop);
                    } else {
                        preventTransition(this.selTarget);
                        this.show();
                    }
                },
                events: [
                    "resize",
                    "resizeViewport",
                    "scroll"
                ]
            }
        ],
        methods: {
            show () {
                this.isFixed = true;
                this.update();
                this.placeholder.hidden = false;
            },
            hide () {
                const { offset: offset, sticky: sticky } = this._data;
                this.setActive(false);
                removeClass(this.$el, this.clsFixed, this.clsBelow);
                if (sticky) css(this.$el, "top", offset);
                else css(this.$el, {
                    position: "",
                    top: "",
                    width: "",
                    marginTop: ""
                });
                this.placeholder.hidden = true;
                this.isFixed = false;
            },
            update () {
                let { width: width, scroll: scroll2 = 0, overflow: overflow, overflowScroll: overflowScroll = 0, start: start, end: end, offset: offset, topOffset: topOffset, height: height, elHeight: elHeight, offsetParentTop: offsetParentTop, sticky: sticky } = this._data;
                const active = start !== 0 || scroll2 > start;
                if (!sticky) {
                    let position = "fixed";
                    if (scroll2 > end) {
                        offset += end - offsetParentTop;
                        position = "absolute";
                    }
                    css(this.$el, {
                        position: position,
                        width: width,
                        marginTop: 0
                    }, "important");
                }
                if (overflow) offset -= overflowScroll;
                css(this.$el, "top", offset);
                this.setActive(active);
                toggleClass(this.$el, this.clsBelow, scroll2 > topOffset + (sticky ? Math.min(height, elHeight) : height));
                addClass(this.$el, this.clsFixed);
            },
            setActive (active) {
                const prev = this.active;
                this.active = active;
                if (active) {
                    replaceClass(this.selTarget, this.clsInactive, this.clsActive);
                    prev !== active && trigger(this.$el, "active");
                } else {
                    replaceClass(this.selTarget, this.clsActive, this.clsInactive);
                    prev !== active && trigger(this.$el, "inactive");
                }
            }
        }
    };
    function parseProp(value, el, propOffset, padding) {
        if (!value) return 0;
        if (isNumeric(value) || isString(value) && value.match(/^-?\d/)) return propOffset + toPx(value, "height", el, true);
        else {
            const refElement = value === true ? parent(el) : query(value, el);
            return offset(refElement).bottom - (padding && refElement && within(el, refElement) ? toFloat(css(refElement, "paddingBottom")) : 0);
        }
    }
    function coerce(value) {
        if (value === "true") return true;
        else if (value === "false") return false;
        return value;
    }
    function reset(el) {
        css(el, {
            position: "",
            top: "",
            marginTop: "",
            width: ""
        });
    }
    function preventTransition(el) {
        css(el, "transition", "0s");
        requestAnimationFrame(()=>css(el, "transition", ""));
    }
    function getMaxPathLength(el) {
        return Math.ceil(Math.max(0, ...$$("[stroke]", el).map((stroke)=>{
            try {
                return stroke.getTotalLength();
            } catch (e) {
                return 0;
            }
        })));
    }
    var svg = {
        mixins: [
            Svg
        ],
        args: "src",
        props: {
            src: String,
            icon: String,
            attributes: "list",
            strokeAnimation: Boolean
        },
        data: {
            strokeAnimation: false
        },
        observe: [
            mutation({
                async handler () {
                    const svg = await this.svg;
                    if (svg) applyAttributes.call(this, svg);
                },
                options: {
                    attributes: true,
                    attributeFilter: [
                        "id",
                        "class",
                        "style"
                    ]
                }
            })
        ],
        async connected () {
            if (includes(this.src, "#")) [this.src, this.icon] = this.src.split("#");
            const svg = await this.svg;
            if (svg) {
                applyAttributes.call(this, svg);
                if (this.strokeAnimation) applyAnimation(svg);
            }
        },
        methods: {
            async getSvg () {
                if (isTag(this.$el, "img") && !this.$el.complete && this.$el.loading === "lazy") return new Promise((resolve)=>once(this.$el, "load", ()=>resolve(this.getSvg())));
                return parseSVG(await loadSVG(this.src), this.icon) || Promise.reject("SVG not found.");
            }
        }
    };
    function applyAttributes(el) {
        const { $el: $el } = this;
        addClass(el, attr($el, "class"), "uk-svg");
        for(let i = 0; i < $el.style.length; i++){
            const prop = $el.style[i];
            css(el, prop, css($el, prop));
        }
        for(const attribute in this.attributes){
            const [prop, value] = this.attributes[attribute].split(":", 2);
            attr(el, prop, value);
        }
        if (!this.$el.id) removeAttr(el, "id");
    }
    const loadSVG = memoize(async (src)=>{
        if (src) {
            if (startsWith(src, "data:")) return decodeURIComponent(src.split(",")[1]);
            else return (await fetch(src)).text();
        } else return Promise.reject();
    });
    function parseSVG(svg, icon) {
        if (icon && includes(svg, "<symbol")) svg = parseSymbols(svg)[icon] || svg;
        svg = $(svg.substr(svg.indexOf("<svg")));
        return (svg == null ? void 0 : svg.hasChildNodes()) && svg;
    }
    const symbolRe = /<symbol([^]*?id=(['"])(.+?)\2[^]*?<\/)symbol>/g;
    const parseSymbols = memoize(function(svg) {
        const symbols = {};
        symbolRe.lastIndex = 0;
        let match;
        while(match = symbolRe.exec(svg))symbols[match[3]] = `<svg ${match[1]}svg>`;
        return symbols;
    });
    function applyAnimation(el) {
        const length = getMaxPathLength(el);
        if (length) css(el, "--uk-animation-stroke", length);
    }
    const selDisabled = ".uk-disabled *, .uk-disabled, [disabled]";
    var Switcher = {
        mixins: [
            Togglable
        ],
        args: "connect",
        props: {
            connect: String,
            toggle: String,
            itemNav: String,
            active: Number,
            followFocus: Boolean,
            swiping: Boolean
        },
        data: {
            connect: "~.uk-switcher",
            toggle: "> * > :first-child",
            itemNav: false,
            active: 0,
            cls: "uk-active",
            attrItem: "uk-switcher-item",
            selVertical: ".uk-nav",
            followFocus: false,
            swiping: true
        },
        computed: {
            connects ({ connect: connect }, $el) {
                return queryAll(connect, $el);
            },
            connectChildren () {
                return this.connects.map((el)=>children(el)).flat();
            },
            toggles ({ toggle: toggle }, $el) {
                return $$(toggle, $el);
            },
            children () {
                return children(this.$el).filter((child)=>this.toggles.some((toggle)=>within(toggle, child)));
            }
        },
        watch: {
            connects (connects) {
                if (this.swiping) css(connects, "touchAction", "pan-y pinch-zoom");
                this.$emit();
            },
            connectChildren () {
                let index = Math.max(0, this.index());
                for (const el of this.connects)children(el).forEach((child, i)=>toggleClass(child, this.cls, i === index));
                this.$emit();
            },
            toggles (toggles) {
                this.$emit();
                const active = this.index();
                this.show(~active ? active : toggles[this.active] || toggles[0]);
            }
        },
        connected () {
            attr(this.$el, "role", "tablist");
        },
        observe: [
            lazyload({
                targets: ({ connectChildren: connectChildren })=>connectChildren
            }),
            swipe({
                target: ({ connects: connects })=>connects,
                filter: ({ swiping: swiping })=>swiping
            })
        ],
        events: [
            {
                name: "click keydown",
                delegate () {
                    return this.toggle;
                },
                handler (e) {
                    if (!matches(e.current, selDisabled) && (e.type === "click" || e.keyCode === keyMap.SPACE)) {
                        e.preventDefault();
                        this.show(e.current);
                    }
                }
            },
            {
                name: "keydown",
                delegate () {
                    return this.toggle;
                },
                handler (e) {
                    const { current: current, keyCode: keyCode } = e;
                    const isVertical = matches(this.$el, this.selVertical);
                    let i = keyCode === keyMap.HOME ? 0 : keyCode === keyMap.END ? "last" : keyCode === keyMap.LEFT && !isVertical || keyCode === keyMap.UP && isVertical ? "previous" : keyCode === keyMap.RIGHT && !isVertical || keyCode === keyMap.DOWN && isVertical ? "next" : -1;
                    if (~i) {
                        e.preventDefault();
                        const toggles = this.toggles.filter((el)=>!matches(el, selDisabled));
                        const next = toggles[getIndex(i, toggles, toggles.indexOf(current))];
                        next.focus();
                        if (this.followFocus) this.show(next);
                    }
                }
            },
            {
                name: "click",
                el () {
                    return this.connects.concat(this.itemNav ? queryAll(this.itemNav, this.$el) : []);
                },
                delegate () {
                    return `[${this.attrItem}],[data-${this.attrItem}]`;
                },
                handler (e) {
                    if (closest(e.target, "a,button")) {
                        e.preventDefault();
                        this.show(data(e.current, this.attrItem));
                    }
                }
            },
            {
                name: "swipeRight swipeLeft",
                filter () {
                    return this.swiping;
                },
                el () {
                    return this.connects;
                },
                handler ({ type: type }) {
                    this.show(endsWith(type, "Left") ? "next" : "previous");
                }
            }
        ],
        update () {
            var _a;
            attr(this.connects, "role", "presentation");
            attr(children(this.$el), "role", "presentation");
            for(const index in this.toggles){
                const toggle = this.toggles[index];
                const item = (_a = this.connects[0]) == null ? void 0 : _a.children[index];
                attr(toggle, "role", "tab");
                if (!item) continue;
                toggle.id = generateId(this, toggle, `-tab-${index}`);
                item.id = generateId(this, item, `-tabpanel-${index}`);
                attr(toggle, "aria-controls", item.id);
                attr(item, {
                    role: "tabpanel",
                    "aria-labelledby": toggle.id
                });
            }
            attr(this.$el, "aria-orientation", matches(this.$el, this.selVertical) ? "vertical" : null);
        },
        methods: {
            index () {
                return findIndex(this.children, (el)=>hasClass(el, this.cls));
            },
            show (item) {
                const toggles = this.toggles.filter((el)=>!matches(el, selDisabled));
                const prev = this.index();
                const next = getIndex(!isNode(item) || includes(toggles, item) ? item : 0, toggles, getIndex(this.toggles[prev], toggles));
                const active = getIndex(toggles[next], this.toggles);
                this.children.forEach((child, i)=>{
                    toggleClass(child, this.cls, active === i);
                    attr(this.toggles[i], {
                        "aria-selected": active === i,
                        tabindex: active === i ? null : -1
                    });
                });
                const animate = prev >= 0 && prev !== next;
                this.connects.forEach(async ({ children: children2 })=>{
                    const actives = toArray(children2).filter((child, i)=>i !== active && hasClass(child, this.cls));
                    await this.toggleElement(actives, false, animate);
                    await this.toggleElement(children2[active], true, animate);
                });
            }
        }
    };
    var tab = {
        mixins: [
            Class
        ],
        extends: Switcher,
        props: {
            media: Boolean
        },
        data: {
            media: 960,
            attrItem: "uk-tab-item",
            selVertical: ".uk-tab-left,.uk-tab-right"
        },
        connected () {
            const cls = hasClass(this.$el, "uk-tab-left") ? "uk-tab-left" : hasClass(this.$el, "uk-tab-right") ? "uk-tab-right" : false;
            if (cls) this.$create("toggle", this.$el, {
                cls: cls,
                mode: "media",
                media: this.media
            });
        }
    };
    const KEY_SPACE = 32;
    var toggle = {
        mixins: [
            Media,
            Togglable
        ],
        args: "target",
        props: {
            href: String,
            target: null,
            mode: "list",
            queued: Boolean
        },
        data: {
            href: false,
            target: false,
            mode: "click",
            queued: true
        },
        computed: {
            target ({ target: target }, $el) {
                target = queryAll(target || $el.hash, $el);
                return target.length && target || [
                    $el
                ];
            }
        },
        connected () {
            if (!includes(this.mode, "media")) {
                if (!isFocusable(this.$el)) attr(this.$el, "tabindex", "0");
                if (!this.cls && isTag(this.$el, "a")) attr(this.$el, "role", "button");
            }
        },
        observe: lazyload({
            target: ({ target: target })=>target
        }),
        events: [
            {
                name: pointerDown$1,
                filter () {
                    return includes(this.mode, "hover");
                },
                handler (e) {
                    this._preventClick = null;
                    if (!isTouch(e) || isBoolean(this._showState) || this.$el.disabled) return;
                    trigger(this.$el, "focus");
                    once(document, pointerDown$1, ()=>trigger(this.$el, "blur"), true, (e2)=>!within(e2.target, this.$el));
                    if (includes(this.mode, "click")) this._preventClick = true;
                }
            },
            {
                name: `${pointerEnter} ${pointerLeave} focus blur`,
                filter () {
                    return includes(this.mode, "hover");
                },
                handler (e) {
                    if (isTouch(e) || this.$el.disabled) return;
                    const show = includes([
                        pointerEnter,
                        "focus"
                    ], e.type);
                    const expanded = this.isToggled(this.target);
                    if (!show && (!isBoolean(this._showState) || expanded === this._showState || e.type === pointerLeave && matches(this.$el, ":focus") || e.type === "blur" && matches(this.$el, ":hover"))) {
                        if (expanded === this._showState) this._showState = null;
                        return;
                    }
                    if (show && isBoolean(this._showState) && expanded !== this._showState) return;
                    this._showState = show ? expanded : null;
                    this.toggle(`toggle${show ? "show" : "hide"}`);
                }
            },
            {
                name: "keydown",
                filter () {
                    return includes(this.mode, "click") && !isTag(this.$el, "input");
                },
                handler (e) {
                    if (e.keyCode === KEY_SPACE) {
                        e.preventDefault();
                        this.$el.click();
                    }
                }
            },
            {
                name: "click",
                filter () {
                    return [
                        "click",
                        "hover"
                    ].some((mode)=>includes(this.mode, mode));
                },
                handler (e) {
                    let link;
                    if (this._preventClick || closest(e.target, 'a[href="#"], a[href=""]') || (link = closest(e.target, "a[href]")) && (!this.isToggled(this.target) || link.hash && matches(this.target, link.hash))) e.preventDefault();
                    if (!this._preventClick && includes(this.mode, "click")) this.toggle();
                }
            },
            {
                name: "mediachange",
                filter () {
                    return includes(this.mode, "media");
                },
                el () {
                    return this.target;
                },
                handler (e, mediaObj) {
                    if (mediaObj.matches ^ this.isToggled(this.target)) this.toggle();
                }
            }
        ],
        methods: {
            async toggle (type) {
                if (!trigger(this.target, type || "toggle", [
                    this
                ])) return;
                if (hasAttr(this.$el, "aria-expanded")) attr(this.$el, "aria-expanded", !this.isToggled(this.target));
                if (!this.queued) return this.toggleElement(this.target);
                const leaving = this.target.filter((el)=>hasClass(el, this.clsLeave));
                if (leaving.length) {
                    for (const el of this.target){
                        const isLeaving = includes(leaving, el);
                        this.toggleElement(el, isLeaving, isLeaving);
                    }
                    return;
                }
                const toggled = this.target.filter(this.isToggled);
                if (await this.toggleElement(toggled, false)) await this.toggleElement(this.target.filter((el)=>!includes(toggled, el)), true);
            }
        }
    };
    var components$1 = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        Accordion: Accordion,
        Alert: alert,
        Close: Close,
        Cover: cover,
        Drop: drop,
        DropParentIcon: IconComponent,
        Dropdown: drop,
        Dropnav: Dropnav,
        FormCustom: formCustom,
        Grid: grid,
        HeightMatch: heightMatch,
        HeightViewport: heightViewport,
        Icon: Icon,
        Img: img,
        Leader: leader,
        Margin: Margin,
        Marker: Marker,
        Modal: modal,
        Nav: nav,
        NavParentIcon: NavParentIcon,
        Navbar: navbar,
        NavbarParentIcon: IconComponent,
        NavbarToggleIcon: NavbarToggleIcon,
        Offcanvas: offcanvas,
        OverflowAuto: overflowAuto,
        OverlayIcon: IconComponent,
        PaginationNext: PaginationNext,
        PaginationPrevious: PaginationPrevious,
        Responsive: responsive,
        Scroll: scroll,
        Scrollspy: scrollspy,
        ScrollspyNav: scrollspyNav,
        SearchIcon: Search,
        SlidenavNext: Slidenav,
        SlidenavPrevious: Slidenav,
        Spinner: Spinner,
        Sticky: sticky,
        Svg: svg,
        Switcher: Switcher,
        Tab: tab,
        Toggle: toggle,
        Totop: Totop,
        Video: Video
    });
    each(components$1, (component, name)=>App.component(name, component));
    boot(App);
    const units = [
        "days",
        "hours",
        "minutes",
        "seconds"
    ];
    var countdown = {
        mixins: [
            Class
        ],
        props: {
            date: String,
            clsWrapper: String,
            role: String
        },
        data: {
            date: "",
            clsWrapper: ".uk-countdown-%unit%",
            role: "timer"
        },
        connected () {
            attr(this.$el, "role", this.role);
            this.date = toFloat(Date.parse(this.$props.date));
            this.end = false;
            this.start();
        },
        disconnected () {
            this.stop();
        },
        events: {
            name: "visibilitychange",
            el () {
                return document;
            },
            handler () {
                if (document.hidden) this.stop();
                else this.start();
            }
        },
        methods: {
            start () {
                this.stop();
                this.update();
                if (!this.timer) {
                    trigger(this.$el, "countdownstart");
                    this.timer = setInterval(this.update, 1e3);
                }
            },
            stop () {
                if (this.timer) {
                    clearInterval(this.timer);
                    trigger(this.$el, "countdownstop");
                    this.timer = null;
                }
            },
            update () {
                const timespan = getTimeSpan(this.date);
                if (!timespan.total) {
                    this.stop();
                    if (!this.end) {
                        trigger(this.$el, "countdownend");
                        this.end = true;
                    }
                }
                for (const unit of units){
                    const el = $(this.clsWrapper.replace("%unit%", unit), this.$el);
                    if (!el) continue;
                    let digits = String(Math.trunc(timespan[unit]));
                    digits = digits.length < 2 ? `0${digits}` : digits;
                    if (el.textContent !== digits) {
                        digits = digits.split("");
                        if (digits.length !== el.children.length) html(el, digits.map(()=>"<span></span>").join(""));
                        digits.forEach((digit, i)=>el.children[i].textContent = digit);
                    }
                }
            }
        }
    };
    function getTimeSpan(date) {
        const total = Math.max(0, date - Date.now()) / 1e3;
        return {
            total: total,
            seconds: total % 60,
            minutes: total / 60 % 60,
            hours: total / 60 / 60 % 24,
            days: total / 60 / 60 / 24
        };
    }
    const clsLeave = "uk-transition-leave";
    const clsEnter = "uk-transition-enter";
    function fade(action, target, duration, stagger = 0) {
        const index = transitionIndex(target, true);
        const propsIn = {
            opacity: 1
        };
        const propsOut = {
            opacity: 0
        };
        const wrapIndexFn = (fn)=>()=>index === transitionIndex(target) ? fn() : Promise.reject();
        const leaveFn = wrapIndexFn(async ()=>{
            addClass(target, clsLeave);
            await Promise.all(getTransitionNodes(target).map((child, i)=>new Promise((resolve)=>setTimeout(()=>Transition.start(child, propsOut, duration / 2, "ease").then(resolve), i * stagger))));
            removeClass(target, clsLeave);
        });
        const enterFn = wrapIndexFn(async ()=>{
            const oldHeight = height(target);
            addClass(target, clsEnter);
            action();
            css(children(target), {
                opacity: 0
            });
            await awaitFrame$1();
            const nodes = children(target);
            const newHeight = height(target);
            css(target, "alignContent", "flex-start");
            height(target, oldHeight);
            const transitionNodes = getTransitionNodes(target);
            css(nodes, propsOut);
            const transitions = transitionNodes.map(async (child, i)=>{
                await awaitTimeout(i * stagger);
                await Transition.start(child, propsIn, duration / 2, "ease");
            });
            if (oldHeight !== newHeight) transitions.push(Transition.start(target, {
                height: newHeight
            }, duration / 2 + transitionNodes.length * stagger, "ease"));
            await Promise.all(transitions).then(()=>{
                removeClass(target, clsEnter);
                if (index === transitionIndex(target)) {
                    css(target, {
                        height: "",
                        alignContent: ""
                    });
                    css(nodes, {
                        opacity: ""
                    });
                    delete target.dataset.transition;
                }
            });
        });
        return hasClass(target, clsLeave) ? waitTransitionend(target).then(enterFn) : hasClass(target, clsEnter) ? waitTransitionend(target).then(leaveFn).then(enterFn) : leaveFn().then(enterFn);
    }
    function transitionIndex(target, next) {
        if (next) target.dataset.transition = 1 + transitionIndex(target);
        return toNumber(target.dataset.transition) || 0;
    }
    function waitTransitionend(target) {
        return Promise.all(children(target).filter(Transition.inProgress).map((el)=>new Promise((resolve)=>once(el, "transitionend transitioncanceled", resolve))));
    }
    function getTransitionNodes(target) {
        return getRows(children(target)).reduce((nodes, row)=>nodes.concat(sortBy$1(row.filter((el)=>isInView(el)), "offsetLeft")), []);
    }
    function awaitFrame$1() {
        return new Promise((resolve)=>requestAnimationFrame(resolve));
    }
    function awaitTimeout(timeout) {
        return new Promise((resolve)=>setTimeout(resolve, timeout));
    }
    async function slide(action, target, duration) {
        await awaitFrame();
        let nodes = children(target);
        const currentProps = nodes.map((el)=>getProps(el, true));
        const targetProps = {
            ...css(target, [
                "height",
                "padding"
            ]),
            display: "block"
        };
        await Promise.all(nodes.concat(target).map(Transition.cancel));
        action();
        nodes = nodes.concat(children(target).filter((el)=>!includes(nodes, el)));
        await Promise.resolve();
        fastdom.flush();
        const targetStyle = attr(target, "style");
        const targetPropsTo = css(target, [
            "height",
            "padding"
        ]);
        const [propsTo, propsFrom] = getTransitionProps(target, nodes, currentProps);
        const attrsTo = nodes.map((el)=>({
                style: attr(el, "style")
            }));
        nodes.forEach((el, i)=>propsFrom[i] && css(el, propsFrom[i]));
        css(target, targetProps);
        trigger(target, "scroll");
        fastdom.flush();
        await awaitFrame();
        const transitions = nodes.map((el, i)=>parent(el) === target && Transition.start(el, propsTo[i], duration, "ease")).concat(Transition.start(target, targetPropsTo, duration, "ease"));
        try {
            await Promise.all(transitions);
            nodes.forEach((el, i)=>{
                attr(el, attrsTo[i]);
                if (parent(el) === target) css(el, "display", propsTo[i].opacity === 0 ? "none" : "");
            });
            attr(target, "style", targetStyle);
        } catch (e) {
            attr(nodes, "style", "");
            resetProps(target, targetProps);
        }
    }
    function getProps(el, opacity) {
        const zIndex = css(el, "zIndex");
        return isVisible(el) ? {
            display: "",
            opacity: opacity ? css(el, "opacity") : "0",
            pointerEvents: "none",
            position: "absolute",
            zIndex: zIndex === "auto" ? index(el) : zIndex,
            ...getPositionWithMargin(el)
        } : false;
    }
    function getTransitionProps(target, nodes, currentProps) {
        const propsTo = nodes.map((el, i)=>parent(el) && i in currentProps ? currentProps[i] ? isVisible(el) ? getPositionWithMargin(el) : {
                opacity: 0
            } : {
                opacity: isVisible(el) ? 1 : 0
            } : false);
        const propsFrom = propsTo.map((props, i)=>{
            const from = parent(nodes[i]) === target && (currentProps[i] || getProps(nodes[i]));
            if (!from) return false;
            if (!props) delete from.opacity;
            else if (!("opacity" in props)) {
                const { opacity: opacity } = from;
                if (opacity % 1) props.opacity = 1;
                else delete from.opacity;
            }
            return from;
        });
        return [
            propsTo,
            propsFrom
        ];
    }
    function resetProps(el, props) {
        for(const prop in props)css(el, prop, "");
    }
    function getPositionWithMargin(el) {
        const { height: height, width: width } = offset(el);
        return {
            height: height,
            width: width,
            transform: "",
            ...position(el),
            ...css(el, [
                "marginTop",
                "marginLeft"
            ])
        };
    }
    function awaitFrame() {
        return new Promise((resolve)=>requestAnimationFrame(resolve));
    }
    var Animate = {
        props: {
            duration: Number,
            animation: Boolean
        },
        data: {
            duration: 150,
            animation: "slide"
        },
        methods: {
            animate (action, target = this.$el) {
                const name = this.animation;
                const animationFn = name === "fade" ? fade : name === "delayed-fade" ? (...args)=>fade(...args, 40) : name ? slide : ()=>{
                    action();
                    return Promise.resolve();
                };
                return animationFn(action, target, this.duration).catch(noop);
            }
        }
    };
    var filter = {
        mixins: [
            Animate
        ],
        args: "target",
        props: {
            target: String,
            selActive: Boolean
        },
        data: {
            target: "",
            selActive: false,
            attrItem: "uk-filter-control",
            cls: "uk-active",
            duration: 250
        },
        computed: {
            toggles ({ attrItem: attrItem }, $el) {
                return $$(`[${attrItem}],[data-${attrItem}]`, $el);
            },
            children ({ target: target }, $el) {
                return $$(`${target} > *`, $el);
            }
        },
        watch: {
            toggles (toggles) {
                this.updateState();
                const actives = $$(this.selActive, this.$el);
                for (const toggle of toggles){
                    if (this.selActive !== false) toggleClass(toggle, this.cls, includes(actives, toggle));
                    const button = findButton(toggle);
                    if (isTag(button, "a")) attr(button, "role", "button");
                }
            },
            children (list, prev) {
                if (prev) this.updateState();
            }
        },
        events: {
            name: "click keydown",
            delegate () {
                return `[${this.attrItem}],[data-${this.attrItem}]`;
            },
            handler (e) {
                if (e.type === "keydown" && e.keyCode !== keyMap.SPACE) return;
                if (closest(e.target, "a,button")) {
                    e.preventDefault();
                    this.apply(e.current);
                }
            }
        },
        methods: {
            apply (el) {
                const prevState = this.getState();
                const newState = mergeState(el, this.attrItem, this.getState());
                if (!isEqualState(prevState, newState)) this.setState(newState);
            },
            getState () {
                return this.toggles.filter((item)=>hasClass(item, this.cls)).reduce((state, el)=>mergeState(el, this.attrItem, state), {
                    filter: {
                        "": ""
                    },
                    sort: []
                });
            },
            async setState (state, animate = true) {
                state = {
                    filter: {
                        "": ""
                    },
                    sort: [],
                    ...state
                };
                trigger(this.$el, "beforeFilter", [
                    this,
                    state
                ]);
                for (const toggle of this.toggles)toggleClass(toggle, this.cls, matchFilter(toggle, this.attrItem, state));
                await Promise.all($$(this.target, this.$el).map((target)=>{
                    const filterFn = ()=>{
                        applyState(state, target, children(target));
                        this.$update(this.$el);
                    };
                    return animate ? this.animate(filterFn, target) : filterFn();
                }));
                trigger(this.$el, "afterFilter", [
                    this
                ]);
            },
            updateState () {
                fastdom.write(()=>this.setState(this.getState(), false));
            }
        }
    };
    function getFilter(el, attr2) {
        return parseOptions(data(el, attr2), [
            "filter"
        ]);
    }
    function isEqualState(stateA, stateB) {
        return [
            "filter",
            "sort"
        ].every((prop)=>isEqual(stateA[prop], stateB[prop]));
    }
    function applyState(state, target, children) {
        const selector = getSelector(state);
        children.forEach((el)=>css(el, "display", selector && !matches(el, selector) ? "none" : ""));
        const [sort, order] = state.sort;
        if (sort) {
            const sorted = sortItems(children, sort, order);
            if (!isEqual(sorted, children)) append(target, sorted);
        }
    }
    function mergeState(el, attr2, state) {
        const { filter: filter, group: group, sort: sort, order: order = "asc" } = getFilter(el, attr2);
        if (filter || isUndefined(sort)) {
            if (group) {
                if (filter) {
                    delete state.filter[""];
                    state.filter[group] = filter;
                } else {
                    delete state.filter[group];
                    if (isEmpty(state.filter) || "" in state.filter) state.filter = {
                        "": filter || ""
                    };
                }
            } else state.filter = {
                "": filter || ""
            };
        }
        if (!isUndefined(sort)) state.sort = [
            sort,
            order
        ];
        return state;
    }
    function matchFilter(el, attr2, { filter: stateFilter = {
        "": ""
    }, sort: [stateSort, stateOrder] }) {
        const { filter: filter = "", group: group = "", sort: sort, order: order = "asc" } = getFilter(el, attr2);
        return isUndefined(sort) ? group in stateFilter && filter === stateFilter[group] || !filter && group && !(group in stateFilter) && !stateFilter[""] : stateSort === sort && stateOrder === order;
    }
    function getSelector({ filter: filter }) {
        let selector = "";
        each(filter, (value)=>selector += value || "");
        return selector;
    }
    function sortItems(nodes, sort, order) {
        return [
            ...nodes
        ].sort((a, b)=>data(a, sort).localeCompare(data(b, sort), void 0, {
                numeric: true
            }) * (order === "asc" || -1));
    }
    function findButton(el) {
        return $("a,button", el) || el;
    }
    var Animations$2 = {
        slide: {
            show (dir) {
                return [
                    {
                        transform: translate(dir * -100)
                    },
                    {
                        transform: translate()
                    }
                ];
            },
            percent (current) {
                return translated(current);
            },
            translate (percent, dir) {
                return [
                    {
                        transform: translate(dir * -100 * percent)
                    },
                    {
                        transform: translate(dir * 100 * (1 - percent))
                    }
                ];
            }
        }
    };
    function translated(el) {
        return Math.abs(css(el, "transform").split(",")[4] / el.offsetWidth) || 0;
    }
    function translate(value = 0, unit = "%") {
        value += value ? unit : "";
        return `translate3d(${value}, 0, 0)`;
    }
    function scale3d(value) {
        return `scale3d(${value}, ${value}, 1)`;
    }
    var Animations$1 = {
        ...Animations$2,
        fade: {
            show () {
                return [
                    {
                        opacity: 0
                    },
                    {
                        opacity: 1
                    }
                ];
            },
            percent (current) {
                return 1 - css(current, "opacity");
            },
            translate (percent) {
                return [
                    {
                        opacity: 1 - percent
                    },
                    {
                        opacity: percent
                    }
                ];
            }
        },
        scale: {
            show () {
                return [
                    {
                        opacity: 0,
                        transform: scale3d(0.8)
                    },
                    {
                        opacity: 1,
                        transform: scale3d(1)
                    }
                ];
            },
            percent (current) {
                return 1 - css(current, "opacity");
            },
            translate (percent) {
                return [
                    {
                        opacity: 1 - percent,
                        transform: scale3d(1 - 0.2 * percent)
                    },
                    {
                        opacity: percent,
                        transform: scale3d(0.8 + 0.2 * percent)
                    }
                ];
            }
        }
    };
    function Transitioner$1(prev, next, dir, { animation: animation, easing: easing }) {
        const { percent: percent, translate: translate, show: show = noop } = animation;
        const props = show(dir);
        let resolve;
        return {
            dir: dir,
            show (duration, percent2 = 0, linear) {
                const timing = linear ? "linear" : easing;
                duration -= Math.round(duration * clamp(percent2, -1, 1));
                this.translate(percent2);
                triggerUpdate$1(next, "itemin", {
                    percent: percent2,
                    duration: duration,
                    timing: timing,
                    dir: dir
                });
                triggerUpdate$1(prev, "itemout", {
                    percent: 1 - percent2,
                    duration: duration,
                    timing: timing,
                    dir: dir
                });
                return new Promise((res)=>{
                    resolve || (resolve = res);
                    Promise.all([
                        Transition.start(next, props[1], duration, timing),
                        Transition.start(prev, props[0], duration, timing)
                    ]).then(()=>{
                        this.reset();
                        resolve();
                    }, noop);
                });
            },
            cancel () {
                return Transition.cancel([
                    next,
                    prev
                ]);
            },
            reset () {
                for(const prop in props[0])css([
                    next,
                    prev
                ], prop, "");
            },
            async forward (duration, percent2 = this.percent()) {
                await this.cancel();
                return this.show(duration, percent2, true);
            },
            translate (percent2) {
                this.reset();
                const props2 = translate(percent2, dir);
                css(next, props2[1]);
                css(prev, props2[0]);
                triggerUpdate$1(next, "itemtranslatein", {
                    percent: percent2,
                    dir: dir
                });
                triggerUpdate$1(prev, "itemtranslateout", {
                    percent: 1 - percent2,
                    dir: dir
                });
            },
            percent () {
                return percent(prev || next, next, dir);
            },
            getDistance () {
                return prev == null ? void 0 : prev.offsetWidth;
            }
        };
    }
    function triggerUpdate$1(el, type, data) {
        trigger(el, createEvent(type, false, false, data));
    }
    var SliderNav = {
        i18n: {
            next: "Next slide",
            previous: "Previous slide",
            slideX: "Slide %s",
            slideLabel: "%s of %s",
            role: "String"
        },
        data: {
            selNav: false,
            role: "region"
        },
        computed: {
            nav ({ selNav: selNav }, $el) {
                return $(selNav, $el);
            },
            navChildren () {
                return children(this.nav);
            },
            selNavItem ({ attrItem: attrItem }) {
                return `[${attrItem}],[data-${attrItem}]`;
            },
            navItems (_, $el) {
                return $$(this.selNavItem, $el);
            }
        },
        watch: {
            nav (nav, prev) {
                attr(nav, "role", "tablist");
                if (prev) this.$emit();
            },
            list (list) {
                attr(list, "role", "presentation");
            },
            navChildren (children2) {
                attr(children2, "role", "presentation");
            },
            navItems (items) {
                for (const el of items){
                    const cmd = data(el, this.attrItem);
                    const button = $("a,button", el) || el;
                    let ariaLabel;
                    let ariaControls = null;
                    if (isNumeric(cmd)) {
                        const item = toNumber(cmd);
                        const slide = this.slides[item];
                        if (slide) {
                            if (!slide.id) slide.id = generateId(this, slide, `-item-${cmd}`);
                            ariaControls = slide.id;
                        }
                        ariaLabel = this.t("slideX", toFloat(cmd) + 1);
                        attr(button, "role", "tab");
                    } else {
                        if (this.list) {
                            if (!this.list.id) this.list.id = generateId(this, this.list, "-items");
                            ariaControls = this.list.id;
                        }
                        ariaLabel = this.t(cmd);
                    }
                    attr(button, {
                        "aria-controls": ariaControls,
                        "aria-label": attr(button, "aria-label") || ariaLabel
                    });
                }
            },
            slides (slides) {
                slides.forEach((slide, i)=>attr(slide, {
                        role: this.nav ? "tabpanel" : "group",
                        "aria-label": this.t("slideLabel", i + 1, this.length),
                        "aria-roledescription": this.nav ? null : "slide"
                    }));
            },
            length (length) {
                const navLength = this.navChildren.length;
                if (this.nav && length !== navLength) {
                    empty(this.nav);
                    for(let i = 0; i < length; i++)append(this.nav, `<li ${this.attrItem}="${i}"><a href></a></li>`);
                }
            }
        },
        connected () {
            attr(this.$el, {
                role: this.role,
                "aria-roledescription": "carousel"
            });
        },
        update: [
            {
                write () {
                    this.navItems.concat(this.nav).forEach((el)=>el && (el.hidden = !this.maxIndex));
                    this.updateNav();
                },
                events: [
                    "resize"
                ]
            }
        ],
        events: [
            {
                name: "click keydown",
                delegate () {
                    return this.selNavItem;
                },
                handler (e) {
                    if (closest(e.target, "a,button") && (e.type === "click" || e.keyCode === keyMap.SPACE)) {
                        e.preventDefault();
                        this.show(data(e.current, this.attrItem));
                    }
                }
            },
            {
                name: "itemshow",
                handler: "updateNav"
            },
            {
                name: "keydown",
                delegate () {
                    return this.selNavItem;
                },
                handler (e) {
                    const { current: current, keyCode: keyCode } = e;
                    const cmd = data(current, this.attrItem);
                    if (!isNumeric(cmd)) return;
                    let i = keyCode === keyMap.HOME ? 0 : keyCode === keyMap.END ? "last" : keyCode === keyMap.LEFT ? "previous" : keyCode === keyMap.RIGHT ? "next" : -1;
                    if (~i) {
                        e.preventDefault();
                        this.show(i);
                    }
                }
            }
        ],
        methods: {
            updateNav () {
                const index = this.getValidIndex();
                let focus;
                let focusEl;
                for (const el of this.navItems){
                    const cmd = data(el, this.attrItem);
                    const button = $("a,button", el) || el;
                    if (isNumeric(cmd)) {
                        const item = toNumber(cmd);
                        const active = item === index;
                        toggleClass(el, this.clsActive, active);
                        attr(button, {
                            "aria-selected": active,
                            tabindex: active ? null : -1
                        });
                        if (active) focusEl = button;
                        focus || (focus = matches(button, ":focus"));
                    } else toggleClass(el, "uk-invisible", this.finite && (cmd === "previous" && index === 0 || cmd === "next" && index >= this.maxIndex));
                    if (focus && focusEl) focusEl.focus();
                }
            }
        }
    };
    const pointerOptions = {
        passive: false,
        capture: true
    };
    const pointerUpOptions = {
        passive: true,
        capture: true
    };
    const pointerDown = "touchstart mousedown";
    const pointerMove = "touchmove mousemove";
    const pointerUp = "touchend touchcancel mouseup click input scroll";
    var SliderDrag = {
        props: {
            draggable: Boolean
        },
        data: {
            draggable: true,
            threshold: 10
        },
        created () {
            for (const key of [
                "start",
                "move",
                "end"
            ]){
                const fn = this[key];
                this[key] = (e)=>{
                    const pos = getEventPos(e).x * (isRtl ? -1 : 1);
                    this.prevPos = pos === this.pos ? this.prevPos : this.pos;
                    this.pos = pos;
                    fn(e);
                };
            }
        },
        events: [
            {
                name: pointerDown,
                passive: true,
                delegate () {
                    return `${this.selList} > *`;
                },
                handler (e) {
                    if (!this.draggable || !isTouch(e) && hasSelectableText(e.target) || closest(e.target, selInput) || e.button > 0 || this.length < 2) return;
                    this.start(e);
                }
            },
            {
                name: "dragstart",
                handler (e) {
                    e.preventDefault();
                }
            },
            {
                // iOS workaround for slider stopping if swiping fast
                name: pointerMove,
                el () {
                    return this.list;
                },
                handler: noop,
                ...pointerOptions
            }
        ],
        methods: {
            start () {
                this.drag = this.pos;
                if (this._transitioner) {
                    this.percent = this._transitioner.percent();
                    this.drag += this._transitioner.getDistance() * this.percent * this.dir;
                    this._transitioner.cancel();
                    this._transitioner.translate(this.percent);
                    this.dragging = true;
                    this.stack = [];
                } else this.prevIndex = this.index;
                on(document, pointerMove, this.move, pointerOptions);
                on(document, pointerUp, this.end, pointerUpOptions);
                css(this.list, "userSelect", "none");
            },
            move (e) {
                const distance = this.pos - this.drag;
                if (distance === 0 || this.prevPos === this.pos || !this.dragging && Math.abs(distance) < this.threshold) return;
                css(this.list, "pointerEvents", "none");
                e.cancelable && e.preventDefault();
                this.dragging = true;
                this.dir = distance < 0 ? 1 : -1;
                let { slides: slides, prevIndex: prevIndex } = this;
                let dis = Math.abs(distance);
                let nextIndex = this.getIndex(prevIndex + this.dir);
                let width = this._getDistance(prevIndex, nextIndex);
                while(nextIndex !== prevIndex && dis > width){
                    this.drag -= width * this.dir;
                    prevIndex = nextIndex;
                    dis -= width;
                    nextIndex = this.getIndex(prevIndex + this.dir);
                    width = this._getDistance(prevIndex, nextIndex);
                }
                this.percent = dis / width;
                const prev = slides[prevIndex];
                const next = slides[nextIndex];
                const changed = this.index !== nextIndex;
                const edge = prevIndex === nextIndex;
                let itemShown;
                for (const i of [
                    this.index,
                    this.prevIndex
                ])if (!includes([
                    nextIndex,
                    prevIndex
                ], i)) {
                    trigger(slides[i], "itemhidden", [
                        this
                    ]);
                    if (edge) {
                        itemShown = true;
                        this.prevIndex = prevIndex;
                    }
                }
                if (this.index === prevIndex && this.prevIndex !== prevIndex || itemShown) trigger(slides[this.index], "itemshown", [
                    this
                ]);
                if (changed) {
                    this.prevIndex = prevIndex;
                    this.index = nextIndex;
                    !edge && trigger(prev, "beforeitemhide", [
                        this
                    ]);
                    trigger(next, "beforeitemshow", [
                        this
                    ]);
                }
                this._transitioner = this._translate(Math.abs(this.percent), prev, !edge && next);
                if (changed) {
                    !edge && trigger(prev, "itemhide", [
                        this
                    ]);
                    trigger(next, "itemshow", [
                        this
                    ]);
                }
            },
            end () {
                off(document, pointerMove, this.move, pointerOptions);
                off(document, pointerUp, this.end, pointerUpOptions);
                if (this.dragging) {
                    this.dragging = null;
                    if (this.index === this.prevIndex) {
                        this.percent = 1 - this.percent;
                        this.dir *= -1;
                        this._show(false, this.index, true);
                        this._transitioner = null;
                    } else {
                        const dirChange = (isRtl ? this.dir * (isRtl ? 1 : -1) : this.dir) < 0 === this.prevPos > this.pos;
                        this.index = dirChange ? this.index : this.prevIndex;
                        if (dirChange) this.percent = 1 - this.percent;
                        this.show(this.dir > 0 && !dirChange || this.dir < 0 && dirChange ? "next" : "previous", true);
                    }
                }
                css(this.list, {
                    userSelect: "",
                    pointerEvents: ""
                });
                this.drag = this.percent = null;
            },
            _getDistance (prev, next) {
                return this._getTransitioner(prev, prev !== next && next).getDistance() || this.slides[prev].offsetWidth;
            }
        }
    };
    function hasSelectableText(el) {
        return css(el, "userSelect") !== "none" && toArray(el.childNodes).some((el2)=>el2.nodeType === 3 && el2.textContent.trim());
    }
    var SliderAutoplay = {
        props: {
            autoplay: Boolean,
            autoplayInterval: Number,
            pauseOnHover: Boolean
        },
        data: {
            autoplay: false,
            autoplayInterval: 7e3,
            pauseOnHover: true
        },
        connected () {
            attr(this.list, "aria-live", this.autoplay ? "off" : "polite");
            this.autoplay && this.startAutoplay();
        },
        disconnected () {
            this.stopAutoplay();
        },
        update () {
            attr(this.slides, "tabindex", "-1");
        },
        events: [
            {
                name: "visibilitychange",
                el () {
                    return document;
                },
                filter () {
                    return this.autoplay;
                },
                handler () {
                    if (document.hidden) this.stopAutoplay();
                    else this.startAutoplay();
                }
            }
        ],
        methods: {
            startAutoplay () {
                this.stopAutoplay();
                this.interval = setInterval(()=>{
                    if (!(this.stack.length || this.draggable && matches(this.$el, ":focus-within") || this.pauseOnHover && matches(this.$el, ":hover"))) this.show("next");
                }, this.autoplayInterval);
            },
            stopAutoplay () {
                clearInterval(this.interval);
            }
        }
    };
    var Slider = {
        mixins: [
            SliderAutoplay,
            SliderDrag,
            SliderNav,
            I18n
        ],
        props: {
            clsActivated: Boolean,
            easing: String,
            index: Number,
            finite: Boolean,
            velocity: Number
        },
        data: ()=>({
                easing: "ease",
                finite: false,
                velocity: 1,
                index: 0,
                prevIndex: -1,
                stack: [],
                percent: 0,
                clsActive: "uk-active",
                clsActivated: false,
                Transitioner: false,
                transitionOptions: {}
            }),
        connected () {
            this.prevIndex = -1;
            this.index = this.getValidIndex(this.$props.index);
            this.stack = [];
        },
        disconnected () {
            removeClass(this.slides, this.clsActive);
        },
        computed: {
            duration ({ velocity: velocity }, $el) {
                return speedUp($el.offsetWidth / velocity);
            },
            list ({ selList: selList }, $el) {
                return $(selList, $el);
            },
            maxIndex () {
                return this.length - 1;
            },
            slides () {
                return children(this.list);
            },
            length () {
                return this.slides.length;
            }
        },
        watch: {
            slides (slides, prev) {
                if (prev) this.$emit();
            }
        },
        observe: resize(),
        methods: {
            show (index, force = false) {
                var _a;
                if (this.dragging || !this.length) return;
                const { stack: stack } = this;
                const queueIndex = force ? 0 : stack.length;
                const reset = ()=>{
                    stack.splice(queueIndex, 1);
                    if (stack.length) this.show(stack.shift(), true);
                };
                stack[force ? "unshift" : "push"](index);
                if (!force && stack.length > 1) {
                    if (stack.length === 2) (_a = this._transitioner) == null || _a.forward(Math.min(this.duration, 200));
                    return;
                }
                const prevIndex = this.getIndex(this.index);
                const prev = hasClass(this.slides, this.clsActive) && this.slides[prevIndex];
                const nextIndex = this.getIndex(index, this.index);
                const next = this.slides[nextIndex];
                if (prev === next) {
                    reset();
                    return;
                }
                this.dir = getDirection(index, prevIndex);
                this.prevIndex = prevIndex;
                this.index = nextIndex;
                if (prev && !trigger(prev, "beforeitemhide", [
                    this
                ]) || !trigger(next, "beforeitemshow", [
                    this,
                    prev
                ])) {
                    this.index = this.prevIndex;
                    reset();
                    return;
                }
                const promise = this._show(prev, next, force).then(()=>{
                    prev && trigger(prev, "itemhidden", [
                        this
                    ]);
                    trigger(next, "itemshown", [
                        this
                    ]);
                    stack.shift();
                    this._transitioner = null;
                    requestAnimationFrame(()=>stack.length && this.show(stack.shift(), true));
                });
                prev && trigger(prev, "itemhide", [
                    this
                ]);
                trigger(next, "itemshow", [
                    this
                ]);
                return promise;
            },
            getIndex (index = this.index, prev = this.index) {
                return clamp(getIndex(index, this.slides, prev, this.finite), 0, Math.max(0, this.maxIndex));
            },
            getValidIndex (index = this.index, prevIndex = this.prevIndex) {
                return this.getIndex(index, prevIndex);
            },
            _show (prev, next, force) {
                this._transitioner = this._getTransitioner(prev, next, this.dir, {
                    easing: force ? next.offsetWidth < 600 ? "cubic-bezier(0.25, 0.46, 0.45, 0.94)" : "cubic-bezier(0.165, 0.84, 0.44, 1)" : this.easing,
                    ...this.transitionOptions
                });
                if (!force && !prev) {
                    this._translate(1);
                    return Promise.resolve();
                }
                const { length: length } = this.stack;
                return this._transitioner[length > 1 ? "forward" : "show"](length > 1 ? Math.min(this.duration, 75 + 75 / (length - 1)) : this.duration, this.percent);
            },
            _translate (percent, prev = this.prevIndex, next = this.index) {
                const transitioner = this._getTransitioner(prev === next ? false : prev, next);
                transitioner.translate(percent);
                return transitioner;
            },
            _getTransitioner (prev = this.prevIndex, next = this.index, dir = this.dir || 1, options = this.transitionOptions) {
                return new this.Transitioner(this.slides[prev] || prev, this.slides[next] || next, dir * (isRtl ? -1 : 1), options);
            }
        }
    };
    function getDirection(index, prevIndex) {
        return index === "next" ? 1 : index === "previous" ? -1 : index < prevIndex ? -1 : 1;
    }
    function speedUp(x) {
        return 0.5 * x + 300;
    }
    var Slideshow = {
        mixins: [
            Slider
        ],
        props: {
            animation: String
        },
        data: {
            animation: "slide",
            clsActivated: "uk-transition-active",
            Animations: Animations$2,
            Transitioner: Transitioner$1
        },
        computed: {
            animation ({ animation: animation, Animations: Animations2 }) {
                return {
                    ...Animations2[animation] || Animations2.slide,
                    name: animation
                };
            },
            transitionOptions () {
                return {
                    animation: this.animation
                };
            }
        },
        events: {
            beforeitemshow ({ target: target }) {
                addClass(target, this.clsActive);
            },
            itemshown ({ target: target }) {
                addClass(target, this.clsActivated);
            },
            itemhidden ({ target: target }) {
                removeClass(target, this.clsActive, this.clsActivated);
            }
        }
    };
    var LightboxPanel = {
        mixins: [
            Modal,
            Slideshow
        ],
        functional: true,
        props: {
            delayControls: Number,
            preload: Number,
            videoAutoplay: Boolean,
            template: String
        },
        data: ()=>({
                preload: 1,
                videoAutoplay: false,
                delayControls: 3e3,
                items: [],
                cls: "uk-open",
                clsPage: "uk-lightbox-page",
                selList: ".uk-lightbox-items",
                attrItem: "uk-lightbox-item",
                selClose: ".uk-close-large",
                selCaption: ".uk-lightbox-caption",
                pauseOnHover: false,
                velocity: 2,
                Animations: Animations$1,
                template: `<div class="uk-lightbox uk-overflow-hidden"> <ul class="uk-lightbox-items"></ul> <div class="uk-lightbox-toolbar uk-position-top uk-text-right uk-transition-slide-top uk-transition-opaque"> <button class="uk-lightbox-toolbar-icon uk-close-large" type="button" uk-close></button> </div> <a class="uk-lightbox-button uk-position-center-left uk-position-medium uk-transition-fade" href uk-slidenav-previous uk-lightbox-item="previous"></a> <a class="uk-lightbox-button uk-position-center-right uk-position-medium uk-transition-fade" href uk-slidenav-next uk-lightbox-item="next"></a> <div class="uk-lightbox-toolbar uk-lightbox-caption uk-position-bottom uk-text-center uk-transition-slide-bottom uk-transition-opaque"></div> </div>`
            }),
        created () {
            const $el = $(this.template);
            const list = $(this.selList, $el);
            this.items.forEach(()=>append(list, "<li>"));
            const close = $("[uk-close]", $el);
            const closeLabel = this.t("close");
            if (close && closeLabel) close.dataset.i18n = JSON.stringify({
                label: closeLabel
            });
            this.$mount(append(this.container, $el));
        },
        computed: {
            caption ({ selCaption: selCaption }, $el) {
                return $(selCaption, $el);
            }
        },
        events: [
            {
                name: `${pointerMove$1} ${pointerDown$1} keydown`,
                handler: "showControls"
            },
            {
                name: "click",
                self: true,
                delegate () {
                    return `${this.selList} > *`;
                },
                handler (e) {
                    if (!e.defaultPrevented) this.hide();
                }
            },
            {
                name: "shown",
                self: true,
                handler () {
                    this.showControls();
                }
            },
            {
                name: "hide",
                self: true,
                handler () {
                    this.hideControls();
                    removeClass(this.slides, this.clsActive);
                    Transition.stop(this.slides);
                }
            },
            {
                name: "hidden",
                self: true,
                handler () {
                    this.$destroy(true);
                }
            },
            {
                name: "keyup",
                el () {
                    return document;
                },
                handler ({ keyCode: keyCode }) {
                    if (!this.isToggled(this.$el) || !this.draggable) return;
                    let i = -1;
                    if (keyCode === keyMap.LEFT) i = "previous";
                    else if (keyCode === keyMap.RIGHT) i = "next";
                    else if (keyCode === keyMap.HOME) i = 0;
                    else if (keyCode === keyMap.END) i = "last";
                    if (~i) this.show(i);
                }
            },
            {
                name: "beforeitemshow",
                handler (e) {
                    if (this.isToggled()) return;
                    this.draggable = false;
                    e.preventDefault();
                    this.toggleElement(this.$el, true, false);
                    this.animation = Animations$1["scale"];
                    removeClass(e.target, this.clsActive);
                    this.stack.splice(1, 0, this.index);
                }
            },
            {
                name: "itemshow",
                handler () {
                    html(this.caption, this.getItem().caption || "");
                    for(let j = -this.preload; j <= this.preload; j++)this.loadItem(this.index + j);
                }
            },
            {
                name: "itemshown",
                handler () {
                    this.draggable = this.$props.draggable;
                }
            },
            {
                name: "itemload",
                async handler (_, item) {
                    const { source: src, type: type, alt: alt = "", poster: poster, attrs: attrs = {} } = item;
                    this.setItem(item, "<span uk-spinner></span>");
                    if (!src) return;
                    let matches;
                    const iframeAttrs = {
                        allowfullscreen: "",
                        style: "max-width: 100%; box-sizing: border-box;",
                        "uk-responsive": "",
                        "uk-video": `${this.videoAutoplay}`
                    };
                    if (type === "image" || src.match(/\.(avif|jpe?g|jfif|a?png|gif|svg|webp)($|\?)/i)) {
                        const img = createEl("img", {
                            src: src,
                            alt: alt,
                            ...attrs
                        });
                        on(img, "load", ()=>this.setItem(item, img));
                        on(img, "error", ()=>this.setError(item));
                    } else if (type === "video" || src.match(/\.(mp4|webm|ogv)($|\?)/i)) {
                        const video = createEl("video", {
                            src: src,
                            poster: poster,
                            controls: "",
                            playsinline: "",
                            "uk-video": `${this.videoAutoplay}`,
                            ...attrs
                        });
                        on(video, "loadedmetadata", ()=>this.setItem(item, video));
                        on(video, "error", ()=>this.setError(item));
                    } else if (type === "iframe" || src.match(/\.(html|php)($|\?)/i)) this.setItem(item, createEl("iframe", {
                        src: src,
                        allowfullscreen: "",
                        class: "uk-lightbox-iframe",
                        ...attrs
                    }));
                    else if (matches = src.match(/\/\/(?:.*?youtube(-nocookie)?\..*?(?:[?&]v=|\/shorts\/)|youtu\.be\/)([\w-]{11})[&?]?(.*)?/)) this.setItem(item, createEl("iframe", {
                        src: `https://www.youtube${matches[1] || ""}.com/embed/${matches[2]}${matches[3] ? `?${matches[3]}` : ""}`,
                        width: 1920,
                        height: 1080,
                        ...iframeAttrs,
                        ...attrs
                    }));
                    else if (matches = src.match(/\/\/.*?vimeo\.[a-z]+\/(\d+)[&?]?(.*)?/)) try {
                        const { height: height, width: width } = await (await fetch(`https://vimeo.com/api/oembed.json?maxwidth=1920&url=${encodeURI(src)}`, {
                            credentials: "omit"
                        })).json();
                        this.setItem(item, createEl("iframe", {
                            src: `https://player.vimeo.com/video/${matches[1]}${matches[2] ? `?${matches[2]}` : ""}`,
                            width: width,
                            height: height,
                            ...iframeAttrs,
                            ...attrs
                        }));
                    } catch (e) {
                        this.setError(item);
                    }
                }
            }
        ],
        methods: {
            loadItem (index = this.index) {
                const item = this.getItem(index);
                if (!this.getSlide(item).childElementCount) trigger(this.$el, "itemload", [
                    item
                ]);
            },
            getItem (index = this.index) {
                return this.items[getIndex(index, this.slides)];
            },
            setItem (item, content) {
                trigger(this.$el, "itemloaded", [
                    this,
                    html(this.getSlide(item), content)
                ]);
            },
            getSlide (item) {
                return this.slides[this.items.indexOf(item)];
            },
            setError (item) {
                this.setItem(item, '<span uk-icon="icon: bolt; ratio: 2"></span>');
            },
            showControls () {
                clearTimeout(this.controlsTimer);
                this.controlsTimer = setTimeout(this.hideControls, this.delayControls);
                addClass(this.$el, "uk-active", "uk-transition-active");
            },
            hideControls () {
                removeClass(this.$el, "uk-active", "uk-transition-active");
            }
        }
    };
    function createEl(tag, attrs) {
        const el = fragment(`<${tag}>`);
        attr(el, attrs);
        return el;
    }
    var lightbox = {
        install: install$1,
        props: {
            toggle: String
        },
        data: {
            toggle: "a"
        },
        computed: {
            toggles ({ toggle: toggle }, $el) {
                return $$(toggle, $el);
            }
        },
        watch: {
            toggles (toggles) {
                this.hide();
                for (const toggle of toggles)if (isTag(toggle, "a")) attr(toggle, "role", "button");
            }
        },
        disconnected () {
            this.hide();
        },
        events: {
            name: "click",
            delegate () {
                return `${this.toggle}:not(.uk-disabled)`;
            },
            handler (e) {
                e.preventDefault();
                this.show(e.current);
            }
        },
        methods: {
            show (index) {
                const items = uniqueBy(this.toggles.map(toItem), "source");
                if (isElement(index)) {
                    const { source: source } = toItem(index);
                    index = findIndex(items, ({ source: src })=>source === src);
                }
                this.panel = this.panel || this.$create("lightboxPanel", {
                    ...this.$props,
                    items: items
                });
                on(this.panel.$el, "hidden", ()=>this.panel = null);
                return this.panel.show(index);
            },
            hide () {
                var _a;
                return (_a = this.panel) == null ? void 0 : _a.hide();
            }
        }
    };
    function install$1(UIkit, Lightbox) {
        if (!UIkit.lightboxPanel) UIkit.component("lightboxPanel", LightboxPanel);
        assign(Lightbox.props, UIkit.component("lightboxPanel").options.props);
    }
    function toItem(el) {
        const item = {};
        for (const attr2 of [
            "href",
            "caption",
            "type",
            "poster",
            "alt",
            "attrs"
        ])item[attr2 === "href" ? "source" : attr2] = data(el, attr2);
        item.attrs = parseOptions(item.attrs);
        return item;
    }
    var notification = {
        mixins: [
            Container
        ],
        functional: true,
        args: [
            "message",
            "status"
        ],
        data: {
            message: "",
            status: "",
            timeout: 5e3,
            group: null,
            pos: "top-center",
            clsContainer: "uk-notification",
            clsClose: "uk-notification-close",
            clsMsg: "uk-notification-message"
        },
        install: install,
        computed: {
            marginProp ({ pos: pos }) {
                return `margin${startsWith(pos, "top") ? "Top" : "Bottom"}`;
            },
            startProps () {
                return {
                    opacity: 0,
                    [this.marginProp]: -this.$el.offsetHeight
                };
            }
        },
        created () {
            const posClass = `${this.clsContainer}-${this.pos}`;
            let container = $(`.${posClass}`, this.container);
            if (!container || !isVisible(container)) container = append(this.container, `<div class="${this.clsContainer} ${posClass}"></div>`);
            this.$mount(append(container, `<div class="${this.clsMsg}${this.status ? ` ${this.clsMsg}-${this.status}` : ""}" role="alert"> <a href class="${this.clsClose}" data-uk-close></a> <div>${this.message}</div> </div>`));
        },
        async connected () {
            const margin = toFloat(css(this.$el, this.marginProp));
            await Transition.start(css(this.$el, this.startProps), {
                opacity: 1,
                [this.marginProp]: margin
            });
            if (this.timeout) this.timer = setTimeout(this.close, this.timeout);
        },
        events: {
            click (e) {
                if (closest(e.target, 'a[href="#"],a[href=""]')) e.preventDefault();
                this.close();
            },
            [pointerEnter] () {
                if (this.timer) clearTimeout(this.timer);
            },
            [pointerLeave] () {
                if (this.timeout) this.timer = setTimeout(this.close, this.timeout);
            }
        },
        methods: {
            async close (immediate) {
                const removeFn = (el)=>{
                    const container = parent(el);
                    trigger(el, "close", [
                        this
                    ]);
                    remove$1(el);
                    if (!(container == null ? void 0 : container.hasChildNodes())) remove$1(container);
                };
                if (this.timer) clearTimeout(this.timer);
                if (!immediate) await Transition.start(this.$el, this.startProps);
                removeFn(this.$el);
            }
        }
    };
    function install(UIkit) {
        UIkit.notification.closeAll = function(group, immediate) {
            apply(document.body, (el)=>{
                const notification = UIkit.getComponent(el, "notification");
                if (notification && (!group || group === notification.group)) notification.close(immediate);
            });
        };
    }
    const props = {
        x: transformFn,
        y: transformFn,
        rotate: transformFn,
        scale: transformFn,
        color: colorFn,
        backgroundColor: colorFn,
        borderColor: colorFn,
        blur: filterFn,
        hue: filterFn,
        fopacity: filterFn,
        grayscale: filterFn,
        invert: filterFn,
        saturate: filterFn,
        sepia: filterFn,
        opacity: cssPropFn,
        stroke: strokeFn,
        bgx: backgroundFn,
        bgy: backgroundFn
    };
    const { keys: keys } = Object;
    var Parallax = {
        mixins: [
            Media
        ],
        props: fillObject(keys(props), "list"),
        data: fillObject(keys(props), void 0),
        computed: {
            props (properties, $el) {
                const stops = {};
                for(const prop in properties)if (prop in props && !isUndefined(properties[prop])) stops[prop] = properties[prop].slice();
                const result = {};
                for(const prop in stops)result[prop] = props[prop](prop, $el, stops[prop], stops);
                return result;
            }
        },
        events: {
            load () {
                this.$emit();
            }
        },
        methods: {
            reset () {
                for(const prop in this.getCss(0))css(this.$el, prop, "");
            },
            getCss (percent) {
                const css2 = {
                    transform: "",
                    filter: ""
                };
                for(const prop in this.props)this.props[prop](css2, clamp(percent));
                css2.willChange = Object.keys(css2).filter((key)=>css2[key] !== "").map(propName).join(",");
                return css2;
            }
        }
    };
    function transformFn(prop, el, stops) {
        let unit = getUnit(stops) || ({
            x: "px",
            y: "px",
            rotate: "deg"
        })[prop] || "";
        let transformFn2;
        if (prop === "x" || prop === "y") {
            prop = `translate${ucfirst(prop)}`;
            transformFn2 = (stop)=>toFloat(toFloat(stop).toFixed(unit === "px" ? 0 : 6));
        } else if (prop === "scale") {
            unit = "";
            transformFn2 = (stop)=>getUnit([
                    stop
                ]) ? toPx(stop, "width", el, true) / el.offsetWidth : stop;
        }
        if (stops.length === 1) stops.unshift(prop === "scale" ? 1 : 0);
        stops = parseStops(stops, transformFn2);
        return (css2, percent)=>{
            css2.transform += ` ${prop}(${getValue(stops, percent)}${unit})`;
        };
    }
    function colorFn(prop, el, stops) {
        if (stops.length === 1) stops.unshift(getCssValue(el, prop, ""));
        stops = parseStops(stops, (stop)=>parseColor(el, stop));
        return (css2, percent)=>{
            const [start, end, p] = getStop(stops, percent);
            const value = start.map((value2, i)=>{
                value2 += p * (end[i] - value2);
                return i === 3 ? toFloat(value2) : parseInt(value2, 10);
            }).join(",");
            css2[prop] = `rgba(${value})`;
        };
    }
    function parseColor(el, color) {
        return getCssValue(el, "color", color).split(/[(),]/g).slice(1, -1).concat(1).slice(0, 4).map(toFloat);
    }
    function filterFn(prop, el, stops) {
        if (stops.length === 1) stops.unshift(0);
        const unit = getUnit(stops) || ({
            blur: "px",
            hue: "deg"
        })[prop] || "%";
        prop = ({
            fopacity: "opacity",
            hue: "hue-rotate"
        })[prop] || prop;
        stops = parseStops(stops);
        return (css2, percent)=>{
            const value = getValue(stops, percent);
            css2.filter += ` ${prop}(${value + unit})`;
        };
    }
    function cssPropFn(prop, el, stops) {
        if (stops.length === 1) stops.unshift(getCssValue(el, prop, ""));
        stops = parseStops(stops);
        return (css2, percent)=>{
            css2[prop] = getValue(stops, percent);
        };
    }
    function strokeFn(prop, el, stops) {
        if (stops.length === 1) stops.unshift(0);
        const unit = getUnit(stops);
        const length = getMaxPathLength(el);
        stops = parseStops(stops.reverse(), (stop)=>{
            stop = toFloat(stop);
            return unit === "%" ? stop * length / 100 : stop;
        });
        if (!stops.some(([value])=>value)) return noop;
        css(el, "strokeDasharray", length);
        return (css2, percent)=>{
            css2.strokeDashoffset = getValue(stops, percent);
        };
    }
    function backgroundFn(prop, el, stops, props2) {
        if (stops.length === 1) stops.unshift(0);
        const attr = prop === "bgy" ? "height" : "width";
        props2[prop] = parseStops(stops, (stop)=>toPx(stop, attr, el));
        const bgProps = [
            "bgx",
            "bgy"
        ].filter((prop2)=>prop2 in props2);
        if (bgProps.length === 2 && prop === "bgx") return noop;
        if (getCssValue(el, "backgroundSize", "") === "cover") return backgroundCoverFn(prop, el, stops, props2);
        const positions = {};
        for (const prop2 of bgProps)positions[prop2] = getBackgroundPos(el, prop2);
        return setBackgroundPosFn(bgProps, positions, props2);
    }
    function backgroundCoverFn(prop, el, stops, props2) {
        const dimImage = getBackgroundImageDimensions(el);
        if (!dimImage.width) return noop;
        const dimEl = {
            width: el.offsetWidth,
            height: el.offsetHeight
        };
        const bgProps = [
            "bgx",
            "bgy"
        ].filter((prop2)=>prop2 in props2);
        const positions = {};
        for (const prop2 of bgProps){
            const values = props2[prop2].map(([value])=>value);
            const min = Math.min(...values);
            const max = Math.max(...values);
            const down = values.indexOf(min) < values.indexOf(max);
            const diff = max - min;
            positions[prop2] = `${(down ? -diff : 0) - (down ? min : max)}px`;
            dimEl[prop2 === "bgy" ? "height" : "width"] += diff;
        }
        const dim = Dimensions.cover(dimImage, dimEl);
        for (const prop2 of bgProps){
            const attr = prop2 === "bgy" ? "height" : "width";
            const overflow = dim[attr] - dimEl[attr];
            positions[prop2] = `max(${getBackgroundPos(el, prop2)},-${overflow}px) + ${positions[prop2]}`;
        }
        const fn = setBackgroundPosFn(bgProps, positions, props2);
        return (css2, percent)=>{
            fn(css2, percent);
            css2.backgroundSize = `${dim.width}px ${dim.height}px`;
            css2.backgroundRepeat = "no-repeat";
        };
    }
    function getBackgroundPos(el, prop) {
        return getCssValue(el, `background-position-${prop.substr(-1)}`, "");
    }
    function setBackgroundPosFn(bgProps, positions, props2) {
        return function(css2, percent) {
            for (const prop of bgProps){
                const value = getValue(props2[prop], percent);
                css2[`background-position-${prop.substr(-1)}`] = `calc(${positions[prop]} + ${value}px)`;
            }
        };
    }
    const dimensions = {};
    function getBackgroundImageDimensions(el) {
        const src = css(el, "backgroundImage").replace(/^none|url\(["']?(.+?)["']?\)$/, "$1");
        if (dimensions[src]) return dimensions[src];
        const image = new Image();
        if (src) {
            image.src = src;
            if (!image.naturalWidth) {
                image.onload = ()=>{
                    dimensions[src] = toDimensions(image);
                    trigger(el, createEvent("load", false));
                };
                return toDimensions(image);
            }
        }
        return dimensions[src] = toDimensions(image);
    }
    function toDimensions(image) {
        return {
            width: image.naturalWidth,
            height: image.naturalHeight
        };
    }
    function parseStops(stops, fn = toFloat) {
        const result = [];
        const { length: length } = stops;
        let nullIndex = 0;
        for(let i = 0; i < length; i++){
            let [value, percent] = isString(stops[i]) ? stops[i].trim().split(/ (?![^(]*\))/) : [
                stops[i]
            ];
            value = fn(value);
            percent = percent ? toFloat(percent) / 100 : null;
            if (i === 0) {
                if (percent === null) percent = 0;
                else if (percent) result.push([
                    value,
                    0
                ]);
            } else if (i === length - 1) {
                if (percent === null) percent = 1;
                else if (percent !== 1) {
                    result.push([
                        value,
                        percent
                    ]);
                    percent = 1;
                }
            }
            result.push([
                value,
                percent
            ]);
            if (percent === null) nullIndex++;
            else if (nullIndex) {
                const leftPercent = result[i - nullIndex - 1][1];
                const p = (percent - leftPercent) / (nullIndex + 1);
                for(let j = nullIndex; j > 0; j--)result[i - j][1] = leftPercent + p * (nullIndex - j + 1);
                nullIndex = 0;
            }
        }
        return result;
    }
    function getStop(stops, percent) {
        const index = findIndex(stops.slice(1), ([, targetPercent])=>percent <= targetPercent) + 1;
        return [
            stops[index - 1][0],
            stops[index][0],
            (percent - stops[index - 1][1]) / (stops[index][1] - stops[index - 1][1])
        ];
    }
    function getValue(stops, percent) {
        const [start, end, p] = getStop(stops, percent);
        return isNumber(start) ? start + Math.abs(start - end) * p * (start < end ? 1 : -1) : +end;
    }
    const unitRe = /^-?\d+(\S+)?/;
    function getUnit(stops, defaultUnit) {
        var _a;
        for (const stop of stops){
            const match = (_a = stop.match) == null ? void 0 : _a.call(stop, unitRe);
            if (match) return match[1];
        }
        return defaultUnit;
    }
    function getCssValue(el, prop, value) {
        const prev = el.style[prop];
        const val = css(css(el, prop, value), prop);
        el.style[prop] = prev;
        return val;
    }
    function fillObject(keys2, value) {
        return keys2.reduce((data, prop)=>{
            data[prop] = value;
            return data;
        }, {});
    }
    var parallax = {
        mixins: [
            Parallax
        ],
        props: {
            target: String,
            viewport: Number,
            // Deprecated
            easing: Number,
            start: String,
            end: String
        },
        data: {
            target: false,
            viewport: 1,
            easing: 1,
            start: 0,
            end: 0
        },
        computed: {
            target ({ target: target }, $el) {
                return getOffsetElement(target && query(target, $el) || $el);
            },
            start ({ start: start }) {
                return toPx(start, "height", this.target, true);
            },
            end ({ end: end, viewport: viewport2 }) {
                return toPx(end || (viewport2 = (1 - viewport2) * 100) && `${viewport2}vh+${viewport2}%`, "height", this.target, true);
            }
        },
        observe: [
            resize({
                target: ({ $el: $el, target: target })=>[
                        $el,
                        target,
                        scrollParent(target, true)
                    ]
            }),
            scroll$1(),
            viewport()
        ],
        update: {
            read ({ percent: percent }, types) {
                if (!types.has("scroll")) percent = false;
                if (!isVisible(this.$el)) return false;
                if (!this.matchMedia) return;
                const prev = percent;
                percent = ease(scrolledOver(this.target, this.start, this.end), this.easing);
                return {
                    percent: percent,
                    style: prev === percent ? false : this.getCss(percent)
                };
            },
            write ({ style: style }) {
                if (!this.matchMedia) {
                    this.reset();
                    return;
                }
                style && css(this.$el, style);
            },
            events: [
                "scroll",
                "resize"
            ]
        }
    };
    function ease(percent, easing) {
        return easing >= 0 ? Math.pow(percent, easing + 1) : 1 - Math.pow(1 - percent, 1 - easing);
    }
    function getOffsetElement(el) {
        return el ? "offsetTop" in el ? el : getOffsetElement(parent(el)) : document.documentElement;
    }
    var SliderReactive = {
        update: {
            write () {
                if (this.stack.length || this.dragging) return;
                const index = this.getValidIndex(this.index);
                if (!~this.prevIndex || this.index !== index) this.show(index);
                else this._translate(1, this.prevIndex, this.index);
            },
            events: [
                "resize"
            ]
        }
    };
    var SliderPreload = {
        observe: lazyload({
            target: ({ slides: slides })=>slides,
            targets: (instance)=>instance.getAdjacentSlides()
        })
    };
    function Transitioner(prev, next, dir, { center: center, easing: easing, list: list }) {
        const from = prev ? getLeft(prev, list, center) : getLeft(next, list, center) + dimensions$1(next).width * dir;
        const to = next ? getLeft(next, list, center) : from + dimensions$1(prev).width * dir * (isRtl ? -1 : 1);
        let resolve;
        return {
            dir: dir,
            show (duration, percent = 0, linear) {
                const timing = linear ? "linear" : easing;
                duration -= Math.round(duration * clamp(percent, -1, 1));
                this.translate(percent);
                percent = prev ? percent : clamp(percent, 0, 1);
                triggerUpdate(this.getItemIn(), "itemin", {
                    percent: percent,
                    duration: duration,
                    timing: timing,
                    dir: dir
                });
                prev && triggerUpdate(this.getItemIn(true), "itemout", {
                    percent: 1 - percent,
                    duration: duration,
                    timing: timing,
                    dir: dir
                });
                return new Promise((res)=>{
                    resolve || (resolve = res);
                    Transition.start(list, {
                        transform: translate(-to * (isRtl ? -1 : 1), "px")
                    }, duration, timing).then(resolve, noop);
                });
            },
            cancel () {
                return Transition.cancel(list);
            },
            reset () {
                css(list, "transform", "");
            },
            async forward (duration, percent = this.percent()) {
                await this.cancel();
                return this.show(duration, percent, true);
            },
            translate (percent) {
                const distance = this.getDistance() * dir * (isRtl ? -1 : 1);
                css(list, "transform", translate(clamp(-to + (distance - distance * percent), -getWidth(list), dimensions$1(list).width) * (isRtl ? -1 : 1), "px"));
                const actives = this.getActives();
                const itemIn = this.getItemIn();
                const itemOut = this.getItemIn(true);
                percent = prev ? clamp(percent, -1, 1) : 0;
                for (const slide of children(list)){
                    const isActive = includes(actives, slide);
                    const isIn = slide === itemIn;
                    const isOut = slide === itemOut;
                    const translateIn = isIn || !isOut && (isActive || dir * (isRtl ? -1 : 1) === -1 ^ getElLeft(slide, list) > getElLeft(prev || next));
                    triggerUpdate(slide, `itemtranslate${translateIn ? "in" : "out"}`, {
                        dir: dir,
                        percent: isOut ? 1 - percent : isIn ? percent : isActive ? 1 : 0
                    });
                }
            },
            percent () {
                return Math.abs((css(list, "transform").split(",")[4] * (isRtl ? -1 : 1) + from) / (to - from));
            },
            getDistance () {
                return Math.abs(to - from);
            },
            getItemIn (out = false) {
                let actives = this.getActives();
                let nextActives = inView(list, getLeft(next || prev, list, center));
                if (out) {
                    const temp = actives;
                    actives = nextActives;
                    nextActives = temp;
                }
                return nextActives[findIndex(nextActives, (el)=>!includes(actives, el))];
            },
            getActives () {
                return inView(list, getLeft(prev || next, list, center));
            }
        };
    }
    function getLeft(el, list, center) {
        const left = getElLeft(el, list);
        return center ? left - centerEl(el, list) : Math.min(left, getMax(list));
    }
    function getMax(list) {
        return Math.max(0, getWidth(list) - dimensions$1(list).width);
    }
    function getWidth(list) {
        return sumBy(children(list), (el)=>dimensions$1(el).width);
    }
    function centerEl(el, list) {
        return dimensions$1(list).width / 2 - dimensions$1(el).width / 2;
    }
    function getElLeft(el, list) {
        return el && (position(el).left + (isRtl ? dimensions$1(el).width - dimensions$1(list).width : 0)) * (isRtl ? -1 : 1) || 0;
    }
    function inView(list, listLeft) {
        listLeft -= 1;
        const listWidth = dimensions$1(list).width;
        const listRight = listLeft + listWidth + 2;
        return children(list).filter((slide)=>{
            const slideLeft = getElLeft(slide, list);
            const slideRight = slideLeft + Math.min(dimensions$1(slide).width, listWidth);
            return slideLeft >= listLeft && slideRight <= listRight;
        });
    }
    function triggerUpdate(el, type, data) {
        trigger(el, createEvent(type, false, false, data));
    }
    var slider = {
        mixins: [
            Class,
            Slider,
            SliderReactive,
            SliderPreload
        ],
        props: {
            center: Boolean,
            sets: Boolean
        },
        data: {
            center: false,
            sets: false,
            attrItem: "uk-slider-item",
            selList: ".uk-slider-items",
            selNav: ".uk-slider-nav",
            clsContainer: "uk-slider-container",
            Transitioner: Transitioner
        },
        computed: {
            avgWidth () {
                return getWidth(this.list) / this.length;
            },
            finite ({ finite: finite }) {
                return finite || isFinite(this.list, this.center);
            },
            maxIndex () {
                if (!this.finite || this.center && !this.sets) return this.length - 1;
                if (this.center) return last(this.sets);
                let lft = 0;
                const max = getMax(this.list);
                const index = findIndex(this.slides, (el)=>{
                    if (lft >= max) return true;
                    lft += dimensions$1(el).width;
                });
                return ~index ? index : this.length - 1;
            },
            sets ({ sets: enabled }) {
                if (!enabled) return;
                let left = 0;
                const sets = [];
                const width = dimensions$1(this.list).width;
                for(let i = 0; i < this.length; i++){
                    const slideWidth = dimensions$1(this.slides[i]).width;
                    if (left + slideWidth > width) left = 0;
                    if (this.center) {
                        if (left < width / 2 && left + slideWidth + dimensions$1(getIndex(+i + 1, this.slides)).width / 2 > width / 2) {
                            sets.push(+i);
                            left = width / 2 - slideWidth / 2;
                        }
                    } else if (left === 0) sets.push(Math.min(+i, this.maxIndex));
                    left += slideWidth;
                }
                if (sets.length) return sets;
            },
            transitionOptions () {
                return {
                    center: this.center,
                    list: this.list
                };
            },
            slides () {
                return children(this.list).filter(isVisible);
            }
        },
        connected () {
            toggleClass(this.$el, this.clsContainer, !$(`.${this.clsContainer}`, this.$el));
        },
        observe: resize({
            target: ({ slides: slides })=>slides
        }),
        update: {
            write () {
                for (const el of this.navItems){
                    const index = toNumber(data(el, this.attrItem));
                    if (index !== false) el.hidden = !this.maxIndex || index > this.maxIndex || this.sets && !includes(this.sets, index);
                }
                if (this.length && !this.dragging && !this.stack.length) {
                    this.reorder();
                    this._translate(1);
                }
                this.updateActiveClasses();
            },
            events: [
                "resize"
            ]
        },
        events: {
            beforeitemshow (e) {
                if (!this.dragging && this.sets && this.stack.length < 2 && !includes(this.sets, this.index)) this.index = this.getValidIndex();
                const diff = Math.abs(this.index - this.prevIndex + (this.dir > 0 && this.index < this.prevIndex || this.dir < 0 && this.index > this.prevIndex ? (this.maxIndex + 1) * this.dir : 0));
                if (!this.dragging && diff > 1) {
                    for(let i = 0; i < diff; i++)this.stack.splice(1, 0, this.dir > 0 ? "next" : "previous");
                    e.preventDefault();
                    return;
                }
                const index = this.dir < 0 || !this.slides[this.prevIndex] ? this.index : this.prevIndex;
                this.duration = speedUp(this.avgWidth / this.velocity) * (dimensions$1(this.slides[index]).width / this.avgWidth);
                this.reorder();
            },
            itemshow () {
                if (~this.prevIndex) addClass(this._getTransitioner().getItemIn(), this.clsActive);
            },
            itemshown () {
                this.updateActiveClasses();
            }
        },
        methods: {
            reorder () {
                if (this.finite) {
                    css(this.slides, "order", "");
                    return;
                }
                const index = this.dir > 0 && this.slides[this.prevIndex] ? this.prevIndex : this.index;
                this.slides.forEach((slide, i)=>css(slide, "order", this.dir > 0 && i < index ? 1 : this.dir < 0 && i >= this.index ? -1 : ""));
                if (!this.center) return;
                const next = this.slides[index];
                let width = dimensions$1(this.list).width / 2 - dimensions$1(next).width / 2;
                let j = 0;
                while(width > 0){
                    const slideIndex = this.getIndex(--j + index, index);
                    const slide = this.slides[slideIndex];
                    css(slide, "order", slideIndex > index ? -2 : -1);
                    width -= dimensions$1(slide).width;
                }
            },
            updateActiveClasses () {
                const actives = this._getTransitioner(this.index).getActives();
                const activeClasses = [
                    this.clsActive,
                    (!this.sets || includes(this.sets, toFloat(this.index))) && this.clsActivated || ""
                ];
                for (const slide of this.slides){
                    const active = includes(actives, slide);
                    toggleClass(slide, activeClasses, active);
                    attr(slide, "aria-hidden", !active);
                    for (const focusable of $$(selFocusable, slide)){
                        if (!hasOwn(focusable, "_tabindex")) focusable._tabindex = attr(focusable, "tabindex");
                        attr(focusable, "tabindex", active ? focusable._tabindex : -1);
                    }
                }
            },
            getValidIndex (index = this.index, prevIndex = this.prevIndex) {
                index = this.getIndex(index, prevIndex);
                if (!this.sets) return index;
                let prev;
                do {
                    if (includes(this.sets, index)) return index;
                    prev = index;
                    index = this.getIndex(index + this.dir, prevIndex);
                }while (index !== prev);
                return index;
            },
            getAdjacentSlides () {
                const { width: width } = dimensions$1(this.list);
                const left = -width;
                const right = width * 2;
                const slideWidth = dimensions$1(this.slides[this.index]).width;
                const slideLeft = this.center ? width / 2 - slideWidth / 2 : 0;
                const slides = /* @__PURE__ */ new Set();
                for (const i of [
                    -1,
                    1
                ]){
                    let currentLeft = slideLeft + (i > 0 ? slideWidth : 0);
                    let j = 0;
                    do {
                        const slide = this.slides[this.getIndex(this.index + i + j++ * i)];
                        currentLeft += dimensions$1(slide).width * i;
                        slides.add(slide);
                    }while (this.length > j && currentLeft > left && currentLeft < right);
                }
                return Array.from(slides);
            }
        }
    };
    function isFinite(list, center) {
        if (!list || list.length < 2) return true;
        const { width: listWidth } = dimensions$1(list);
        if (!center) return Math.ceil(getWidth(list)) < Math.trunc(listWidth + getMaxElWidth(list));
        const slides = children(list);
        const listHalf = Math.trunc(listWidth / 2);
        for(const index in slides){
            const slide = slides[index];
            const slideWidth = dimensions$1(slide).width;
            const slidesInView = /* @__PURE__ */ new Set([
                slide
            ]);
            let diff = 0;
            for (const i of [
                -1,
                1
            ]){
                let left = slideWidth / 2;
                let j = 0;
                while(left < listHalf){
                    const nextSlide = slides[getIndex(+index + i + j++ * i, slides)];
                    if (slidesInView.has(nextSlide)) return true;
                    left += dimensions$1(nextSlide).width;
                    slidesInView.add(nextSlide);
                }
                diff = Math.max(diff, slideWidth / 2 + dimensions$1(slides[getIndex(+index + i, slides)]).width / 2 - (left - listHalf));
            }
            if (diff > sumBy(slides.filter((slide2)=>!slidesInView.has(slide2)), (slide2)=>dimensions$1(slide2).width)) return true;
        }
        return false;
    }
    function getMaxElWidth(list) {
        return Math.max(0, ...children(list).map((el)=>dimensions$1(el).width));
    }
    var sliderParallax = {
        mixins: [
            Parallax
        ],
        data: {
            selItem: "!li"
        },
        beforeConnect () {
            this.item = query(this.selItem, this.$el);
        },
        disconnected () {
            this.item = null;
        },
        events: [
            {
                name: "itemin itemout",
                self: true,
                el () {
                    return this.item;
                },
                handler ({ type: type, detail: { percent: percent, duration: duration, timing: timing, dir: dir } }) {
                    fastdom.read(()=>{
                        if (!this.matchMedia) return;
                        const propsFrom = this.getCss(getCurrentPercent(type, dir, percent));
                        const propsTo = this.getCss(isIn(type) ? 0.5 : dir > 0 ? 1 : 0);
                        fastdom.write(()=>{
                            css(this.$el, propsFrom);
                            Transition.start(this.$el, propsTo, duration, timing).catch(noop);
                        });
                    });
                }
            },
            {
                name: "transitioncanceled transitionend",
                self: true,
                el () {
                    return this.item;
                },
                handler () {
                    Transition.cancel(this.$el);
                }
            },
            {
                name: "itemtranslatein itemtranslateout",
                self: true,
                el () {
                    return this.item;
                },
                handler ({ type: type, detail: { percent: percent, dir: dir } }) {
                    fastdom.read(()=>{
                        if (!this.matchMedia) {
                            this.reset();
                            return;
                        }
                        const props = this.getCss(getCurrentPercent(type, dir, percent));
                        fastdom.write(()=>css(this.$el, props));
                    });
                }
            }
        ]
    };
    function isIn(type) {
        return endsWith(type, "in");
    }
    function getCurrentPercent(type, dir, percent) {
        percent /= 2;
        return isIn(type) ^ dir < 0 ? percent : 1 - percent;
    }
    var Animations = {
        ...Animations$2,
        fade: {
            show () {
                return [
                    {
                        opacity: 0,
                        zIndex: 0
                    },
                    {
                        zIndex: -1
                    }
                ];
            },
            percent (current) {
                return 1 - css(current, "opacity");
            },
            translate (percent) {
                return [
                    {
                        opacity: 1 - percent,
                        zIndex: 0
                    },
                    {
                        zIndex: -1
                    }
                ];
            }
        },
        scale: {
            show () {
                return [
                    {
                        opacity: 0,
                        transform: scale3d(1.5),
                        zIndex: 0
                    },
                    {
                        zIndex: -1
                    }
                ];
            },
            percent (current) {
                return 1 - css(current, "opacity");
            },
            translate (percent) {
                return [
                    {
                        opacity: 1 - percent,
                        transform: scale3d(1 + 0.5 * percent),
                        zIndex: 0
                    },
                    {
                        zIndex: -1
                    }
                ];
            }
        },
        pull: {
            show (dir) {
                return dir < 0 ? [
                    {
                        transform: translate(30),
                        zIndex: -1
                    },
                    {
                        transform: translate(),
                        zIndex: 0
                    }
                ] : [
                    {
                        transform: translate(-100),
                        zIndex: 0
                    },
                    {
                        transform: translate(),
                        zIndex: -1
                    }
                ];
            },
            percent (current, next, dir) {
                return dir < 0 ? 1 - translated(next) : translated(current);
            },
            translate (percent, dir) {
                return dir < 0 ? [
                    {
                        transform: translate(30 * percent),
                        zIndex: -1
                    },
                    {
                        transform: translate(-100 * (1 - percent)),
                        zIndex: 0
                    }
                ] : [
                    {
                        transform: translate(-percent * 100),
                        zIndex: 0
                    },
                    {
                        transform: translate(30 * (1 - percent)),
                        zIndex: -1
                    }
                ];
            }
        },
        push: {
            show (dir) {
                return dir < 0 ? [
                    {
                        transform: translate(100),
                        zIndex: 0
                    },
                    {
                        transform: translate(),
                        zIndex: -1
                    }
                ] : [
                    {
                        transform: translate(-30),
                        zIndex: -1
                    },
                    {
                        transform: translate(),
                        zIndex: 0
                    }
                ];
            },
            percent (current, next, dir) {
                return dir > 0 ? 1 - translated(next) : translated(current);
            },
            translate (percent, dir) {
                return dir < 0 ? [
                    {
                        transform: translate(percent * 100),
                        zIndex: 0
                    },
                    {
                        transform: translate(-30 * (1 - percent)),
                        zIndex: -1
                    }
                ] : [
                    {
                        transform: translate(-30 * percent),
                        zIndex: -1
                    },
                    {
                        transform: translate(100 * (1 - percent)),
                        zIndex: 0
                    }
                ];
            }
        }
    };
    var slideshow = {
        mixins: [
            Class,
            Slideshow,
            SliderReactive,
            SliderPreload
        ],
        props: {
            ratio: String,
            minHeight: Number,
            maxHeight: Number
        },
        data: {
            ratio: "16:9",
            minHeight: false,
            maxHeight: false,
            selList: ".uk-slideshow-items",
            attrItem: "uk-slideshow-item",
            selNav: ".uk-slideshow-nav",
            Animations: Animations
        },
        update: {
            read () {
                if (!this.list) return false;
                let [width, height] = this.ratio.split(":").map(Number);
                height = height * this.list.offsetWidth / width || 0;
                if (this.minHeight) height = Math.max(this.minHeight, height);
                if (this.maxHeight) height = Math.min(this.maxHeight, height);
                return {
                    height: height - boxModelAdjust(this.list, "height", "content-box")
                };
            },
            write ({ height: height }) {
                height > 0 && css(this.list, "minHeight", height);
            },
            events: [
                "resize"
            ]
        },
        methods: {
            getAdjacentSlides () {
                return [
                    1,
                    -1
                ].map((i)=>this.slides[this.getIndex(this.index + i)]);
            }
        }
    };
    var sortable = {
        mixins: [
            Class,
            Animate
        ],
        props: {
            group: String,
            threshold: Number,
            clsItem: String,
            clsPlaceholder: String,
            clsDrag: String,
            clsDragState: String,
            clsBase: String,
            clsNoDrag: String,
            clsEmpty: String,
            clsCustom: String,
            handle: String
        },
        data: {
            group: false,
            threshold: 5,
            clsItem: "uk-sortable-item",
            clsPlaceholder: "uk-sortable-placeholder",
            clsDrag: "uk-sortable-drag",
            clsDragState: "uk-drag",
            clsBase: "uk-sortable",
            clsNoDrag: "uk-sortable-nodrag",
            clsEmpty: "uk-sortable-empty",
            clsCustom: "",
            handle: false,
            pos: {}
        },
        created () {
            for (const key of [
                "init",
                "start",
                "move",
                "end"
            ]){
                const fn = this[key];
                this[key] = (e)=>{
                    assign(this.pos, getEventPos(e));
                    fn(e);
                };
            }
        },
        events: {
            name: pointerDown$1,
            passive: false,
            handler: "init"
        },
        computed: {
            target () {
                return (this.$el.tBodies || [
                    this.$el
                ])[0];
            },
            items () {
                return children(this.target);
            },
            isEmpty () {
                return isEmpty(this.items);
            },
            handles ({ handle: handle }, el) {
                return handle ? $$(handle, el) : this.items;
            }
        },
        watch: {
            isEmpty (empty) {
                toggleClass(this.target, this.clsEmpty, empty);
            },
            handles (handles, prev) {
                css(prev, {
                    touchAction: "",
                    userSelect: ""
                });
                css(handles, {
                    touchAction: hasTouch ? "none" : "",
                    userSelect: "none"
                });
            }
        },
        update: {
            write (data) {
                if (!this.drag || !parent(this.placeholder)) return;
                const { pos: { x: x, y: y }, origin: { offsetTop: offsetTop, offsetLeft: offsetLeft }, placeholder: placeholder } = this;
                css(this.drag, {
                    top: y - offsetTop,
                    left: x - offsetLeft
                });
                const sortable = this.getSortable(document.elementFromPoint(x, y));
                if (!sortable) return;
                const { items: items } = sortable;
                if (items.some(Transition.inProgress)) return;
                const target = findTarget(items, {
                    x: x,
                    y: y
                });
                if (items.length && (!target || target === placeholder)) return;
                const previous = this.getSortable(placeholder);
                const insertTarget = findInsertTarget(sortable.target, target, placeholder, x, y, sortable === previous && data.moved !== target);
                if (insertTarget === false) return;
                if (insertTarget && placeholder === insertTarget) return;
                if (sortable !== previous) {
                    previous.remove(placeholder);
                    data.moved = target;
                } else delete data.moved;
                sortable.insert(placeholder, insertTarget);
                this.touched.add(sortable);
            },
            events: [
                "move"
            ]
        },
        methods: {
            init (e) {
                const { target: target, button: button, defaultPrevented: defaultPrevented } = e;
                const [placeholder] = this.items.filter((el)=>within(target, el));
                if (!placeholder || defaultPrevented || button > 0 || isInput(target) || within(target, `.${this.clsNoDrag}`) || this.handle && !within(target, this.handle)) return;
                e.preventDefault();
                this.touched = /* @__PURE__ */ new Set([
                    this
                ]);
                this.placeholder = placeholder;
                this.origin = {
                    target: target,
                    index: index(placeholder),
                    ...this.pos
                };
                on(document, pointerMove$1, this.move);
                on(document, pointerUp$1, this.end);
                if (!this.threshold) this.start(e);
            },
            start (e) {
                this.drag = appendDrag(this.$container, this.placeholder);
                const { left: left, top: top } = this.placeholder.getBoundingClientRect();
                assign(this.origin, {
                    offsetLeft: this.pos.x - left,
                    offsetTop: this.pos.y - top
                });
                addClass(this.drag, this.clsDrag, this.clsCustom);
                addClass(this.placeholder, this.clsPlaceholder);
                addClass(this.items, this.clsItem);
                addClass(document.documentElement, this.clsDragState);
                trigger(this.$el, "start", [
                    this,
                    this.placeholder
                ]);
                trackScroll(this.pos);
                this.move(e);
            },
            move (e) {
                if (this.drag) this.$emit("move");
                else if (Math.abs(this.pos.x - this.origin.x) > this.threshold || Math.abs(this.pos.y - this.origin.y) > this.threshold) this.start(e);
            },
            end () {
                off(document, pointerMove$1, this.move);
                off(document, pointerUp$1, this.end);
                if (!this.drag) return;
                untrackScroll();
                const sortable = this.getSortable(this.placeholder);
                if (this === sortable) {
                    if (this.origin.index !== index(this.placeholder)) trigger(this.$el, "moved", [
                        this,
                        this.placeholder
                    ]);
                } else {
                    trigger(sortable.$el, "added", [
                        sortable,
                        this.placeholder
                    ]);
                    trigger(this.$el, "removed", [
                        this,
                        this.placeholder
                    ]);
                }
                trigger(this.$el, "stop", [
                    this,
                    this.placeholder
                ]);
                remove$1(this.drag);
                this.drag = null;
                for (const { clsPlaceholder: clsPlaceholder, clsItem: clsItem } of this.touched)for (const sortable2 of this.touched)removeClass(sortable2.items, clsPlaceholder, clsItem);
                this.touched = null;
                removeClass(document.documentElement, this.clsDragState);
            },
            insert (element, target) {
                addClass(this.items, this.clsItem);
                const insert = ()=>target ? before(target, element) : append(this.target, element);
                this.animate(insert);
            },
            remove (element) {
                if (!within(element, this.target)) return;
                this.animate(()=>remove$1(element));
            },
            getSortable (element) {
                do {
                    const sortable = this.$getComponent(element, "sortable");
                    if (sortable && (sortable === this || this.group !== false && sortable.group === this.group)) return sortable;
                }while (element = parent(element));
            }
        }
    };
    let trackTimer;
    function trackScroll(pos) {
        let last = Date.now();
        trackTimer = setInterval(()=>{
            let { x: x, y: y } = pos;
            y += document.scrollingElement.scrollTop;
            const dist = (Date.now() - last) * 0.3;
            last = Date.now();
            scrollParents(document.elementFromPoint(x, pos.y)).reverse().some((scrollEl)=>{
                let { scrollTop: scroll, scrollHeight: scrollHeight } = scrollEl;
                const { top: top, bottom: bottom, height: height2 } = offsetViewport(scrollEl);
                if (top < y && top + 35 > y) scroll -= dist;
                else if (bottom > y && bottom - 35 < y) scroll += dist;
                else return;
                if (scroll > 0 && scroll < scrollHeight - height2) {
                    scrollEl.scrollTop = scroll;
                    return true;
                }
            });
        }, 15);
    }
    function untrackScroll() {
        clearInterval(trackTimer);
    }
    function appendDrag(container, element) {
        let clone;
        if (isTag(element, "li", "tr")) {
            clone = $("<div>");
            append(clone, element.cloneNode(true).children);
            for (const attribute of element.getAttributeNames())attr(clone, attribute, element.getAttribute(attribute));
        } else clone = element.cloneNode(true);
        append(container, clone);
        css(clone, "margin", "0", "important");
        css(clone, {
            boxSizing: "border-box",
            width: element.offsetWidth,
            height: element.offsetHeight,
            padding: css(element, "padding")
        });
        height(clone.firstElementChild, height(element.firstElementChild));
        return clone;
    }
    function findTarget(items, point) {
        return items[findIndex(items, (item)=>pointInRect(point, item.getBoundingClientRect()))];
    }
    function findInsertTarget(list, target, placeholder, x, y, sameList) {
        if (!children(list).length) return;
        const rect = target.getBoundingClientRect();
        if (!sameList) {
            if (!isHorizontal(list, placeholder)) return y < rect.top + rect.height / 2 ? target : target.nextElementSibling;
            return target;
        }
        const placeholderRect = placeholder.getBoundingClientRect();
        const sameRow = linesIntersect([
            rect.top,
            rect.bottom
        ], [
            placeholderRect.top,
            placeholderRect.bottom
        ]);
        const [pointerPos, lengthProp, startProp, endProp] = sameRow ? [
            x,
            "width",
            "left",
            "right"
        ] : [
            y,
            "height",
            "top",
            "bottom"
        ];
        const diff = placeholderRect[lengthProp] < rect[lengthProp] ? rect[lengthProp] - placeholderRect[lengthProp] : 0;
        if (placeholderRect[startProp] < rect[startProp]) {
            if (diff && pointerPos < rect[startProp] + diff) return false;
            return target.nextElementSibling;
        }
        if (diff && pointerPos > rect[endProp] - diff) return false;
        return target;
    }
    function isHorizontal(list, placeholder) {
        const single = children(list).length === 1;
        if (single) append(list, placeholder);
        const items = children(list);
        const isHorizontal2 = items.some((el, i)=>{
            const rectA = el.getBoundingClientRect();
            return items.slice(i + 1).some((el2)=>{
                const rectB = el2.getBoundingClientRect();
                return !linesIntersect([
                    rectA.left,
                    rectA.right
                ], [
                    rectB.left,
                    rectB.right
                ]);
            });
        });
        if (single) remove$1(placeholder);
        return isHorizontal2;
    }
    function linesIntersect(lineA, lineB) {
        return lineA[1] > lineB[0] && lineB[1] > lineA[0];
    }
    var tooltip = {
        mixins: [
            Container,
            Togglable,
            Position
        ],
        args: "title",
        props: {
            delay: Number,
            title: String
        },
        data: {
            pos: "top",
            title: "",
            delay: 0,
            animation: [
                "uk-animation-scale-up"
            ],
            duration: 100,
            cls: "uk-active"
        },
        beforeConnect () {
            this.id = generateId(this, {});
            this._hasTitle = hasAttr(this.$el, "title");
            attr(this.$el, {
                title: "",
                "aria-describedby": this.id
            });
            makeFocusable(this.$el);
        },
        disconnected () {
            this.hide();
            if (!attr(this.$el, "title")) attr(this.$el, "title", this._hasTitle ? this.title : null);
        },
        methods: {
            show () {
                if (this.isToggled(this.tooltip || null) || !this.title) return;
                clearTimeout(this.showTimer);
                this.showTimer = setTimeout(this._show, this.delay);
            },
            async hide () {
                if (matches(this.$el, "input:focus")) return;
                clearTimeout(this.showTimer);
                if (this.isToggled(this.tooltip || null)) await this.toggleElement(this.tooltip, false, false);
                remove$1(this.tooltip);
                this.tooltip = null;
            },
            async _show () {
                this.tooltip = append(this.container, `<div id="${this.id}" class="uk-${this.$options.name}" role="tooltip"> <div class="uk-${this.$options.name}-inner">${this.title}</div> </div>`);
                on(this.tooltip, "toggled", (e, toggled)=>{
                    if (!toggled) return;
                    const update = ()=>this.positionAt(this.tooltip, this.$el);
                    update();
                    const [dir, align] = getAlignment(this.tooltip, this.$el, this.pos);
                    this.origin = this.axis === "y" ? `${flipPosition(dir)}-${align}` : `${align}-${flipPosition(dir)}`;
                    const handlers = [
                        once(document, `keydown ${pointerDown$1}`, this.hide, false, (e2)=>e2.type === pointerDown$1 && !within(e2.target, this.$el) || e2.type === "keydown" && e2.keyCode === keyMap.ESC),
                        on([
                            document,
                            ...overflowParents(this.$el)
                        ], "scroll", update, {
                            passive: true
                        })
                    ];
                    once(this.tooltip, "hide", ()=>handlers.forEach((handler)=>handler()), {
                        self: true
                    });
                });
                if (!await this.toggleElement(this.tooltip, true)) this.hide();
            }
        },
        events: {
            focus: "show",
            blur: "hide",
            [`${pointerEnter} ${pointerLeave}`] (e) {
                if (!isTouch(e)) this[e.type === pointerEnter ? "show" : "hide"]();
            },
            // Clicking a button does not give it focus on all browsers and platforms
            // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#clicking_and_focus
            [pointerDown$1] (e) {
                if (isTouch(e)) this.show();
            }
        }
    };
    function makeFocusable(el) {
        if (!isFocusable(el)) attr(el, "tabindex", "0");
    }
    function getAlignment(el, target, [dir, align]) {
        const elOffset = offset(el);
        const targetOffset = offset(target);
        const properties = [
            [
                "left",
                "right"
            ],
            [
                "top",
                "bottom"
            ]
        ];
        for (const props2 of properties){
            if (elOffset[props2[0]] >= targetOffset[props2[1]]) {
                dir = props2[1];
                break;
            }
            if (elOffset[props2[1]] <= targetOffset[props2[0]]) {
                dir = props2[0];
                break;
            }
        }
        const props = includes(properties[0], dir) ? properties[1] : properties[0];
        if (elOffset[props[0]] === targetOffset[props[0]]) align = props[0];
        else if (elOffset[props[1]] === targetOffset[props[1]]) align = props[1];
        else align = "center";
        return [
            dir,
            align
        ];
    }
    var upload = {
        mixins: [
            I18n
        ],
        i18n: {
            invalidMime: "Invalid File Type: %s",
            invalidName: "Invalid File Name: %s",
            invalidSize: "Invalid File Size: %s Kilobytes Max"
        },
        props: {
            allow: String,
            clsDragover: String,
            concurrent: Number,
            maxSize: Number,
            method: String,
            mime: String,
            multiple: Boolean,
            name: String,
            params: Object,
            type: String,
            url: String
        },
        data: {
            allow: false,
            clsDragover: "uk-dragover",
            concurrent: 1,
            maxSize: 0,
            method: "POST",
            mime: false,
            multiple: false,
            name: "files[]",
            params: {},
            type: "",
            url: "",
            abort: noop,
            beforeAll: noop,
            beforeSend: noop,
            complete: noop,
            completeAll: noop,
            error: noop,
            fail: noop,
            load: noop,
            loadEnd: noop,
            loadStart: noop,
            progress: noop
        },
        events: {
            change (e) {
                if (!matches(e.target, 'input[type="file"]')) return;
                e.preventDefault();
                if (e.target.files) this.upload(e.target.files);
                e.target.value = "";
            },
            drop (e) {
                stop(e);
                const transfer = e.dataTransfer;
                if (!(transfer == null ? void 0 : transfer.files)) return;
                removeClass(this.$el, this.clsDragover);
                this.upload(transfer.files);
            },
            dragenter (e) {
                stop(e);
            },
            dragover (e) {
                stop(e);
                addClass(this.$el, this.clsDragover);
            },
            dragleave (e) {
                stop(e);
                removeClass(this.$el, this.clsDragover);
            }
        },
        methods: {
            async upload (files) {
                files = toArray(files);
                if (!files.length) return;
                trigger(this.$el, "upload", [
                    files
                ]);
                for (const file of files){
                    if (this.maxSize && this.maxSize * 1e3 < file.size) {
                        this.fail(this.t("invalidSize", this.maxSize));
                        return;
                    }
                    if (this.allow && !match(this.allow, file.name)) {
                        this.fail(this.t("invalidName", this.allow));
                        return;
                    }
                    if (this.mime && !match(this.mime, file.type)) {
                        this.fail(this.t("invalidMime", this.mime));
                        return;
                    }
                }
                if (!this.multiple) files = files.slice(0, 1);
                this.beforeAll(this, files);
                const chunks = chunk(files, this.concurrent);
                const upload = async (files2)=>{
                    const data = new FormData();
                    files2.forEach((file)=>data.append(this.name, file));
                    for(const key in this.params)data.append(key, this.params[key]);
                    try {
                        const xhr = await ajax(this.url, {
                            data: data,
                            method: this.method,
                            responseType: this.type,
                            beforeSend: (env)=>{
                                const { xhr: xhr2 } = env;
                                on(xhr2.upload, "progress", this.progress);
                                for (const type of [
                                    "loadStart",
                                    "load",
                                    "loadEnd",
                                    "abort"
                                ])on(xhr2, type.toLowerCase(), this[type]);
                                return this.beforeSend(env);
                            }
                        });
                        this.complete(xhr);
                        if (chunks.length) await upload(chunks.shift());
                        else this.completeAll(xhr);
                    } catch (e) {
                        this.error(e);
                    }
                };
                await upload(chunks.shift());
            }
        }
    };
    function match(pattern, path) {
        return path.match(new RegExp(`^${pattern.replace(/\//g, "\\/").replace(/\*\*/g, "(\\/[^\\/]+)*").replace(/\*/g, "[^\\/]+").replace(/((?!\\))\?/g, "$1.")}$`, "i"));
    }
    function chunk(files, size) {
        const chunks = [];
        for(let i = 0; i < files.length; i += size)chunks.push(files.slice(i, i + size));
        return chunks;
    }
    function stop(e) {
        e.preventDefault();
        e.stopPropagation();
    }
    function ajax(url, options) {
        const env = {
            data: null,
            method: "GET",
            headers: {},
            xhr: new XMLHttpRequest(),
            beforeSend: noop,
            responseType: "",
            ...options
        };
        return Promise.resolve().then(()=>env.beforeSend(env)).then(()=>send(url, env));
    }
    function send(url, env) {
        return new Promise((resolve, reject)=>{
            const { xhr: xhr } = env;
            for(const prop in env){
                if (prop in xhr) try {
                    xhr[prop] = env[prop];
                } catch (e) {}
            }
            xhr.open(env.method.toUpperCase(), url);
            for(const header in env.headers)xhr.setRequestHeader(header, env.headers[header]);
            on(xhr, "load", ()=>{
                if (xhr.status === 0 || xhr.status >= 200 && xhr.status < 300 || xhr.status === 304) resolve(xhr);
                else reject(assign(Error(xhr.statusText), {
                    xhr: xhr,
                    status: xhr.status
                }));
            });
            on(xhr, "error", ()=>reject(assign(Error("Network Error"), {
                    xhr: xhr
                })));
            on(xhr, "timeout", ()=>reject(assign(Error("Network Timeout"), {
                    xhr: xhr
                })));
            xhr.send(env.data);
        });
    }
    var components = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        Countdown: countdown,
        Filter: filter,
        Lightbox: lightbox,
        LightboxPanel: LightboxPanel,
        Notification: notification,
        Parallax: parallax,
        Slider: slider,
        SliderParallax: sliderParallax,
        Slideshow: slideshow,
        SlideshowParallax: sliderParallax,
        Sortable: sortable,
        Tooltip: tooltip,
        Upload: upload
    });
    each(components, (component, name)=>App.component(name, component));
    return App;
});

});

parcelRequire.register("6MvbO", function(module, exports) {

module.exports = import("./" + (parcelRequire("kyEFX")).resolve("kII0x")).then(()=>parcelRequire("lrsy7"));

});

parcelRequire.register("7MY7w", function(module, exports) {

module.exports = import("./" + (parcelRequire("kyEFX")).resolve("lPdvU")).then(()=>parcelRequire("5jeKq"));

});

parcelRequire.register("hh03X", function(module, exports) {

module.exports = import("./" + (parcelRequire("kyEFX")).resolve("52G6n")).then(()=>parcelRequire("6Cd5l"));

});

parcelRequire.register("IS0yk", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kyEFX")).resolve("a0NCf")),
    import("./" + (parcelRequire("kyEFX")).resolve("jept6"))
]).then(()=>parcelRequire("5A6yQ"));

});

parcelRequire.register("k7827", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kyEFX")).resolve("a0NCf")),
    import("./" + (parcelRequire("kyEFX")).resolve("adr9F"))
]).then(()=>parcelRequire("im99a"));

});

parcelRequire.register("4eRKn", function(module, exports) {

module.exports = import("./" + (parcelRequire("kyEFX")).resolve("4rwME")).then(()=>parcelRequire("iVv49"));

});


var $ih19M = parcelRequire("ih19M");
var $6fc264ec92100d3a$export$882461b6382ed46c;
var $6fc264ec92100d3a$export$757ceba2d55c277e;
"use strict";
var $47cfd4084854a574$exports = {};
"use strict";
function $47cfd4084854a574$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($47cfd4084854a574$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$47cfd4084854a574$var$checkDCE();

$47cfd4084854a574$exports = (parcelRequire("foRq4"));


var $6fc264ec92100d3a$var$i;
$6fc264ec92100d3a$export$882461b6382ed46c = $47cfd4084854a574$exports.createRoot;
$6fc264ec92100d3a$export$757ceba2d55c277e = $47cfd4084854a574$exports.hydrateRoot;



var $10WBQ = parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $bh6RR = parcelRequire("bh6RR");

var $bEzwx = parcelRequire("bEzwx");

var $4HWKL = parcelRequire("4HWKL");
var $93da2243eb9df8d8$exports = {};
/*! UIkit 3.16.22 | https://www.getuikit.com | (c) 2014 - 2023 YOOtheme | MIT License */ (function(global, factory) {
    $93da2243eb9df8d8$exports = factory();
})($93da2243eb9df8d8$exports, function() {
    "use strict";
    function plugin(UIkit) {
        if (plugin.installed) return;
        UIkit.icon.add({
            "youtube": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M15,4.1c1,0.1,2.3,0,3,0.8c0.8,0.8,0.9,2.1,0.9,3.1C19,9.2,19,10.9,19,12c-0.1,1.1,0,2.4-0.5,3.4c-0.5,1.1-1.4,1.5-2.5,1.6 c-1.2,0.1-8.6,0.1-11,0c-1.1-0.1-2.4-0.1-3.2-1c-0.7-0.8-0.7-2-0.8-3C1,11.8,1,10.1,1,8.9c0-1.1,0-2.4,0.5-3.4C2,4.5,3,4.3,4.1,4.2 C5.3,4.1,12.6,4,15,4.1z M8,7.5v6l5.5-3L8,7.5z"/></svg>',
            "yootheme": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="m16.15,5.48c-1.37,0-2.45.61-3.11,1.54-.66-.93-1.74-1.54-3.11-1.54-1.75,0-3.03,1-3.57,2.41v-2.22h-2.01v4.45c0,.85-.31,1.35-1.18,1.35s-1.18-.5-1.18-1.35v-4.45H0v4.86c0,.7.17,1.33.53,1.82.34.49.88.85,1.6,1v3.16h2.1v-3.16c1.28-.28,1.96-1.17,2.1-2.35.52,1.44,1.81,2.48,3.59,2.48,1.37,0,2.45-.61,3.11-1.54.66.93,1.74,1.54,3.11,1.54,2.37,0,3.85-1.82,3.85-4s-1.49-4-3.85-4Zm-6.22,5.99c-1.11,0-1.85-.72-1.85-1.99s.74-1.99,1.85-1.99,1.85.72,1.85,1.99-.74,1.99-1.85,1.99Zm6.22,0c-1.11,0-1.85-.72-1.85-1.99s.74-1.99,1.85-1.99,1.85.72,1.85,1.99-.74,1.99-1.85,1.99Z"/></svg>',
            "yelp": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M17.175,14.971c-0.112,0.77-1.686,2.767-2.406,3.054c-0.246,0.1-0.487,0.076-0.675-0.069	c-0.122-0.096-2.446-3.859-2.446-3.859c-0.194-0.293-0.157-0.682,0.083-0.978c0.234-0.284,0.581-0.393,0.881-0.276	c0.016,0.01,4.21,1.394,4.332,1.482c0.178,0.148,0.263,0.379,0.225,0.646L17.175,14.971L17.175,14.971z M11.464,10.789	c-0.203-0.307-0.199-0.666,0.009-0.916c0,0,2.625-3.574,2.745-3.657c0.203-0.135,0.452-0.141,0.69-0.025	c0.691,0.335,2.085,2.405,2.167,3.199v0.027c0.024,0.271-0.082,0.491-0.273,0.623c-0.132,0.083-4.43,1.155-4.43,1.155	c-0.322,0.096-0.68-0.06-0.882-0.381L11.464,10.789z M9.475,9.563C9.32,9.609,8.848,9.757,8.269,8.817c0,0-3.916-6.16-4.007-6.351	c-0.057-0.212,0.011-0.455,0.202-0.65C5.047,1.211,8.21,0.327,9.037,0.529c0.27,0.069,0.457,0.238,0.522,0.479	c0.047,0.266,0.433,5.982,0.488,7.264C10.098,9.368,9.629,9.517,9.475,9.563z M9.927,19.066c-0.083,0.225-0.273,0.373-0.54,0.421	c-0.762,0.13-3.15-0.751-3.647-1.342c-0.096-0.131-0.155-0.262-0.167-0.394c-0.011-0.095,0-0.189,0.036-0.272	c0.061-0.155,2.917-3.538,2.917-3.538c0.214-0.272,0.595-0.355,0.952-0.213c0.345,0.13,0.56,0.428,0.536,0.749	C10.014,14.479,9.977,18.923,9.927,19.066z M3.495,13.912c-0.235-0.009-0.444-0.148-0.568-0.382c-0.089-0.17-0.151-0.453-0.19-0.794	C2.63,11.701,2.761,10.144,3.07,9.648c0.145-0.226,0.357-0.345,0.592-0.336c0.154,0,4.255,1.667,4.255,1.667	c0.321,0.118,0.521,0.453,0.5,0.833c-0.023,0.37-0.236,0.655-0.551,0.738L3.495,13.912z"/></svg>',
            "xing": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M4.4,4.56 C4.24,4.56 4.11,4.61 4.05,4.72 C3.98,4.83 3.99,4.97 4.07,5.12 L5.82,8.16 L5.82,8.17 L3.06,13.04 C2.99,13.18 2.99,13.33 3.06,13.44 C3.12,13.55 3.24,13.62 3.4,13.62 L6,13.62 C6.39,13.62 6.57,13.36 6.71,13.12 C6.71,13.12 9.41,8.35 9.51,8.16 C9.49,8.14 7.72,5.04 7.72,5.04 C7.58,4.81 7.39,4.56 6.99,4.56 L4.4,4.56 L4.4,4.56 Z"/><path d="M15.3,1 C14.91,1 14.74,1.25 14.6,1.5 C14.6,1.5 9.01,11.42 8.82,11.74 C8.83,11.76 12.51,18.51 12.51,18.51 C12.64,18.74 12.84,19 13.23,19 L15.82,19 C15.98,19 16.1,18.94 16.16,18.83 C16.23,18.72 16.23,18.57 16.16,18.43 L12.5,11.74 L12.5,11.72 L18.25,1.56 C18.32,1.42 18.32,1.27 18.25,1.16 C18.21,1.06 18.08,1 17.93,1 L15.3,1 L15.3,1 Z"/></svg>',
            "world": '<svg width="20" height="20" viewBox="0 0 20 20"><path fill="none" stroke="#000" d="M1,10.5 L19,10.5"/><path fill="none" stroke="#000" d="M2.35,15.5 L17.65,15.5"/><path fill="none" stroke="#000" d="M2.35,5.5 L17.523,5.5"/><path fill="none" stroke="#000" d="M10,19.46 L9.98,19.46 C7.31,17.33 5.61,14.141 5.61,10.58 C5.61,7.02 7.33,3.83 10,1.7 C10.01,1.7 9.99,1.7 10,1.7 L10,1.7 C12.67,3.83 14.4,7.02 14.4,10.58 C14.4,14.141 12.67,17.33 10,19.46 L10,19.46 L10,19.46 L10,19.46 Z"/><circle fill="none" stroke="#000" cx="10" cy="10.5" r="9"/></svg>',
            "wordpress": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M10,0.5c-5.2,0-9.5,4.3-9.5,9.5s4.3,9.5,9.5,9.5c5.2,0,9.5-4.3,9.5-9.5S15.2,0.5,10,0.5L10,0.5L10,0.5z M15.6,3.9h-0.1 c-0.8,0-1.4,0.7-1.4,1.5c0,0.7,0.4,1.3,0.8,1.9c0.3,0.6,0.7,1.3,0.7,2.3c0,0.7-0.3,1.5-0.6,2.7L14.1,15l-3-8.9 c0.5,0,0.9-0.1,0.9-0.1C12.5,6,12.5,5.3,12,5.4c0,0-1.3,0.1-2.2,0.1C9,5.5,7.7,5.4,7.7,5.4C7.2,5.3,7.2,6,7.6,6c0,0,0.4,0.1,0.9,0.1 l1.3,3.5L8,15L5,6.1C5.5,6.1,5.9,6,5.9,6C6.4,6,6.3,5.3,5.9,5.4c0,0-1.3,0.1-2.2,0.1c-0.2,0-0.3,0-0.5,0c1.5-2.2,4-3.7,6.9-3.7 C12.2,1.7,14.1,2.6,15.6,3.9L15.6,3.9L15.6,3.9z M2.5,6.6l3.9,10.8c-2.7-1.3-4.6-4.2-4.6-7.4C1.8,8.8,2,7.6,2.5,6.6L2.5,6.6L2.5,6.6 z M10.2,10.7l2.5,6.9c0,0,0,0.1,0.1,0.1C11.9,18,11,18.2,10,18.2c-0.8,0-1.6-0.1-2.3-0.3L10.2,10.7L10.2,10.7L10.2,10.7z M14.2,17.1 l2.5-7.3c0.5-1.2,0.6-2.1,0.6-2.9c0-0.3,0-0.6-0.1-0.8c0.6,1.2,1,2.5,1,4C18.3,13,16.6,15.7,14.2,17.1L14.2,17.1L14.2,17.1z"/></svg>',
            "whatsapp": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M16.7,3.3c-1.8-1.8-4.1-2.8-6.7-2.8c-5.2,0-9.4,4.2-9.4,9.4c0,1.7,0.4,3.3,1.3,4.7l-1.3,4.9l5-1.3c1.4,0.8,2.9,1.2,4.5,1.2 l0,0l0,0c5.2,0,9.4-4.2,9.4-9.4C19.5,7.4,18.5,5,16.7,3.3 M10.1,17.7L10.1,17.7c-1.4,0-2.8-0.4-4-1.1l-0.3-0.2l-3,0.8l0.8-2.9 l-0.2-0.3c-0.8-1.2-1.2-2.7-1.2-4.2c0-4.3,3.5-7.8,7.8-7.8c2.1,0,4.1,0.8,5.5,2.3c1.5,1.5,2.3,3.4,2.3,5.5 C17.9,14.2,14.4,17.7,10.1,17.7 M14.4,11.9c-0.2-0.1-1.4-0.7-1.6-0.8c-0.2-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.6,0.8-0.8,0.9 c-0.1,0.2-0.3,0.2-0.5,0.1c-0.2-0.1-1-0.4-1.9-1.2c-0.7-0.6-1.2-1.4-1.3-1.6c-0.1-0.2,0-0.4,0.1-0.5C8,8.8,8.1,8.7,8.2,8.5 c0.1-0.1,0.2-0.2,0.2-0.4c0.1-0.2,0-0.3,0-0.4C8.4,7.6,7.9,6.5,7.7,6C7.5,5.5,7.3,5.6,7.2,5.6c-0.1,0-0.3,0-0.4,0 c-0.2,0-0.4,0.1-0.6,0.3c-0.2,0.2-0.8,0.8-0.8,2c0,1.2,0.8,2.3,1,2.4c0.1,0.2,1.7,2.5,4,3.5c0.6,0.2,1,0.4,1.3,0.5 c0.6,0.2,1.1,0.2,1.5,0.1c0.5-0.1,1.4-0.6,1.6-1.1c0.2-0.5,0.2-1,0.1-1.1C14.8,12.1,14.6,12,14.4,11.9"/></svg>',
            "warning": '<svg width="20" height="20" viewBox="0 0 20 20"><circle cx="10" cy="14" r="1"/><circle fill="none" stroke="#000" stroke-width="1.1" cx="10" cy="10" r="9"/><path d="M10.97,7.72 C10.85,9.54 10.56,11.29 10.56,11.29 C10.51,11.87 10.27,12 9.99,12 C9.69,12 9.49,11.87 9.43,11.29 C9.43,11.29 9.16,9.54 9.03,7.72 C8.96,6.54 9.03,6 9.03,6 C9.03,5.45 9.46,5.02 9.99,5 C10.53,5.01 10.97,5.44 10.97,6 C10.97,6 11.04,6.54 10.97,7.72 L10.97,7.72 Z"/></svg>',
            "vimeo": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M2.065,7.59C1.84,7.367,1.654,7.082,1.468,6.838c-0.332-0.42-0.137-0.411,0.274-0.772c1.026-0.91,2.004-1.896,3.127-2.688 c1.017-0.713,2.365-1.173,3.286-0.039c0.849,1.045,0.869,2.629,1.084,3.891c0.215,1.309,0.421,2.648,0.88,3.901 c0.127,0.352,0.37,1.018,0.81,1.074c0.567,0.078,1.145-0.917,1.408-1.289c0.684-0.987,1.611-2.317,1.494-3.587 c-0.115-1.349-1.572-1.095-2.482-0.773c0.146-1.514,1.555-3.216,2.912-3.792c1.439-0.597,3.579-0.587,4.302,1.036 c0.772,1.759,0.078,3.802-0.763,5.396c-0.918,1.731-2.1,3.333-3.363,4.829c-1.114,1.329-2.432,2.787-4.093,3.422 c-1.897,0.723-3.021-0.686-3.667-2.318c-0.705-1.777-1.056-3.771-1.565-5.621C4.898,8.726,4.644,7.836,4.136,7.191 C3.473,6.358,2.72,7.141,2.065,7.59C1.977,7.502,2.115,7.551,2.065,7.59L2.065,7.59z"/></svg>',
            "video-camera": '<svg width="20" height="20" viewBox="0 0 20 20"><polygon fill="none" stroke="#000" points="19.5 5.9 19.5 14.1 14.5 10.4 14.5 15.5 .5 15.5 .5 4.5 14.5 4.5 14.5 9.6 19.5 5.9"/></svg>',
            "users": '<svg width="20" height="20" viewBox="0 0 20 20"><circle fill="none" stroke="#000" stroke-width="1.1" cx="7.7" cy="8.6" r="3.5"/><path fill="none" stroke="#000" stroke-width="1.1" d="M1,18.1 C1.7,14.6 4.4,12.1 7.6,12.1 C10.9,12.1 13.7,14.8 14.3,18.3"/><path fill="none" stroke="#000" stroke-width="1.1" d="M11.4,4 C12.8,2.4 15.4,2.8 16.3,4.7 C17.2,6.6 15.7,8.9 13.6,8.9 C16.5,8.9 18.8,11.3 19.2,14.1"/></svg>',
            "user": '<svg width="20" height="20" viewBox="0 0 20 20"><circle fill="none" stroke="#000" stroke-width="1.1" cx="9.9" cy="6.4" r="4.4"/><path fill="none" stroke="#000" stroke-width="1.1" d="M1.5,19 C2.3,14.5 5.8,11.2 10,11.2 C14.2,11.2 17.7,14.6 18.5,19.2"/></svg>',
            "upload": '<svg width="20" height="20" viewBox="0 0 20 20"><polyline fill="none" stroke="#000" points="5 8 9.5 3.5 14 8"/><rect x="3" y="17" width="13" height="1"/><line fill="none" stroke="#000" x1="9.5" y1="15" x2="9.5" y2="4"/></svg>',
            "unlock": '<svg width="20" height="20" viewBox="0 0 20 20"><rect fill="none" stroke="#000" x="3.5" y="8.5" width="13" height="10"/><path fill="none" stroke="#000" d="M6.5,8.5 L6.5,4.9 C6.5,3 8.1,1.5 10,1.5 C11.9,1.5 13.5,3 13.5,4.9"/></svg>',
            "uikit": '<svg width="20" height="20" viewBox="0 0 20 20"><polygon points="14.4,3.1 11.3,5.1 15,7.3 15,12.9 10,15.7 5,12.9 5,8.5 2,6.8 2,14.8 9.9,19.5 18,14.8 18,5.3"/><polygon points="9.8,4.2 6.7,2.4 9.8,0.4 12.9,2.3"/></svg>',
            "twitter": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M19,4.74 C18.339,5.029 17.626,5.229 16.881,5.32 C17.644,4.86 18.227,4.139 18.503,3.28 C17.79,3.7 17.001,4.009 16.159,4.17 C15.485,3.45 14.526,3 13.464,3 C11.423,3 9.771,4.66 9.771,6.7 C9.771,6.99 9.804,7.269 9.868,7.539 C6.795,7.38 4.076,5.919 2.254,3.679 C1.936,4.219 1.754,4.86 1.754,5.539 C1.754,6.82 2.405,7.95 3.397,8.61 C2.79,8.589 2.22,8.429 1.723,8.149 L1.723,8.189 C1.723,9.978 2.997,11.478 4.686,11.82 C4.376,11.899 4.049,11.939 3.713,11.939 C3.475,11.939 3.245,11.919 3.018,11.88 C3.49,13.349 4.852,14.419 6.469,14.449 C5.205,15.429 3.612,16.019 1.882,16.019 C1.583,16.019 1.29,16.009 1,15.969 C2.635,17.019 4.576,17.629 6.662,17.629 C13.454,17.629 17.17,12 17.17,7.129 C17.17,6.969 17.166,6.809 17.157,6.649 C17.879,6.129 18.504,5.478 19,4.74"/></svg>',
            "twitch": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M5.23,1,2,4.23V15.85H5.88v3.23L9.1,15.85h2.59L17.5,10V1Zm11,8.4L13.62,12H11L8.78,14.24V12H5.88V2.29H16.21Z"/><rect x="12.98" y="4.55" width="1.29" height="3.88"/><rect x="9.43" y="4.55" width="1.29" height="3.88"/></svg>',
            "tv": '<svg width="20" height="20" viewBox="0 0 20 20"><rect x="7" y="16" width="6" height="1"/><rect fill="none" stroke="#000" x=".5" y="3.5" width="19" height="11"/></svg>',
            "tumblr": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M6.885,8.598c0,0,0,3.393,0,4.996c0,0.282,0,0.66,0.094,0.942c0.377,1.509,1.131,2.545,2.545,3.11 c1.319,0.472,2.356,0.472,3.676,0c0.565-0.188,1.132-0.659,1.132-0.659l-0.849-2.263c0,0-1.036,0.378-1.603,0.283 c-0.565-0.094-1.226-0.66-1.226-1.508c0-1.603,0-4.902,0-4.902h2.828V5.771h-2.828V2H8.205c0,0-0.094,0.66-0.188,0.942 C7.828,3.791,7.262,4.733,6.603,5.394C5.848,6.147,5,6.43,5,6.43v2.168H6.885z"/></svg>',
            "tripadvisor": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M19.021,7.866C19.256,6.862,20,5.854,20,5.854h-3.346C14.781,4.641,12.504,4,9.98,4C7.363,4,4.999,4.651,3.135,5.876H0	c0,0,0.738,0.987,0.976,1.988c-0.611,0.837-0.973,1.852-0.973,2.964c0,2.763,2.249,5.009,5.011,5.009	c1.576,0,2.976-0.737,3.901-1.879l1.063,1.599l1.075-1.615c0.475,0.611,1.1,1.111,1.838,1.451c1.213,0.547,2.574,0.612,3.825,0.15	c2.589-0.963,3.913-3.852,2.964-6.439c-0.175-0.463-0.4-0.876-0.675-1.238H19.021z M16.38,14.594	c-1.002,0.371-2.088,0.328-3.06-0.119c-0.688-0.317-1.252-0.817-1.657-1.438c-0.164-0.25-0.313-0.52-0.417-0.811	c-0.124-0.328-0.186-0.668-0.217-1.014c-0.063-0.689,0.037-1.396,0.339-2.043c0.448-0.971,1.251-1.71,2.25-2.079	c2.075-0.765,4.375,0.3,5.14,2.366c0.762,2.066-0.301,4.37-2.363,5.134L16.38,14.594L16.38,14.594z M8.322,13.066	c-0.72,1.059-1.935,1.76-3.309,1.76c-2.207,0-4.001-1.797-4.001-3.996c0-2.203,1.795-4.002,4.001-4.002	c2.204,0,3.999,1.8,3.999,4.002c0,0.137-0.024,0.261-0.04,0.396c-0.067,0.678-0.284,1.313-0.648,1.853v-0.013H8.322z M2.472,10.775	c0,1.367,1.112,2.479,2.476,2.479c1.363,0,2.472-1.11,2.472-2.479c0-1.359-1.11-2.468-2.472-2.468	C3.584,8.306,2.473,9.416,2.472,10.775L2.472,10.775z M12.514,10.775c0,1.367,1.104,2.479,2.471,2.479	c1.363,0,2.474-1.108,2.474-2.479c0-1.359-1.11-2.468-2.474-2.468c-1.364,0-2.477,1.109-2.477,2.468H12.514z M3.324,10.775	c0-0.893,0.726-1.618,1.614-1.618c0.889,0,1.625,0.727,1.625,1.618c0,0.898-0.725,1.627-1.625,1.627	c-0.901,0-1.625-0.729-1.625-1.627H3.324z M13.354,10.775c0-0.893,0.726-1.618,1.627-1.618c0.886,0,1.61,0.727,1.61,1.618	c0,0.898-0.726,1.627-1.626,1.627s-1.625-0.729-1.625-1.627H13.354z M9.977,4.875c1.798,0,3.425,0.324,4.849,0.968	c-0.535,0.015-1.061,0.108-1.586,0.3c-1.264,0.463-2.264,1.388-2.815,2.604c-0.262,0.551-0.398,1.133-0.448,1.72	C9.79,7.905,7.677,5.873,5.076,5.82C6.501,5.208,8.153,4.875,9.94,4.875H9.977z"/></svg>',
            "triangle-up": '<svg width="20" height="20" viewBox="0 0 20 20"><polygon points="5 13 10 8 15 13"/></svg>',
            "triangle-right": '<svg width="20" height="20" viewBox="0 0 20 20"><polygon points="8 5 13 10 8 15"/></svg>',
            "triangle-left": '<svg width="20" height="20" viewBox="0 0 20 20"><polygon points="12 5 7 10 12 15"/></svg>',
            "triangle-down": '<svg width="20" height="20" viewBox="0 0 20 20"><polygon points="5 7 15 7 10 12"/></svg>',
            "trash": '<svg width="20" height="20" viewBox="0 0 20 20"><polyline fill="none" stroke="#000" points="6.5 3 6.5 1.5 13.5 1.5 13.5 3"/><polyline fill="none" stroke="#000" points="4.5 4 4.5 18.5 15.5 18.5 15.5 4"/><rect x="8" y="7" width="1" height="9"/><rect x="11" y="7" width="1" height="9"/><rect x="2" y="3" width="16" height="1"/></svg>',
            "tiktok": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M17.24,6V8.82a6.79,6.79,0,0,1-4-1.28v5.81A5.26,5.26,0,1,1,8,8.1a4.36,4.36,0,0,1,.72.05v2.9A2.57,2.57,0,0,0,7.64,11a2.4,2.4,0,1,0,2.77,2.38V2h2.86a4,4,0,0,0,1.84,3.38A4,4,0,0,0,17.24,6Z"/></svg>',
            "thumbnails": '<svg width="20" height="20" viewBox="0 0 20 20"><rect fill="none" stroke="#000" x="3.5" y="3.5" width="5" height="5"/><rect fill="none" stroke="#000" x="11.5" y="3.5" width="5" height="5"/><rect fill="none" stroke="#000" x="11.5" y="11.5" width="5" height="5"/><rect fill="none" stroke="#000" x="3.5" y="11.5" width="5" height="5"/></svg>',
            "tag": '<svg width="20" height="20" viewBox="0 0 20 20"><path fill="none" stroke="#000" stroke-width="1.1" d="M17.5,3.71 L17.5,7.72 C17.5,7.96 17.4,8.2 17.21,8.39 L8.39,17.2 C7.99,17.6 7.33,17.6 6.93,17.2 L2.8,13.07 C2.4,12.67 2.4,12.01 2.8,11.61 L11.61,2.8 C11.81,2.6 12.08,2.5 12.34,2.5 L16.19,2.5 C16.52,2.5 16.86,2.63 17.11,2.88 C17.35,3.11 17.48,3.4 17.5,3.71 L17.5,3.71 Z"/><circle cx="14" cy="6" r="1"/></svg>',
            "tablet": '<svg width="20" height="20" viewBox="0 0 20 20"><path fill="none" stroke="#000" d="M5,18.5 C4.2,18.5 3.5,17.8 3.5,17 L3.5,3 C3.5,2.2 4.2,1.5 5,1.5 L16,1.5 C16.8,1.5 17.5,2.2 17.5,3 L17.5,17 C17.5,17.8 16.8,18.5 16,18.5 L5,18.5 L5,18.5 L5,18.5 Z"/><circle cx="10.5" cy="16.3" r=".8"/></svg>',
            "tablet-landscape": '<svg width="20" height="20" viewBox="0 0 20 20"><path fill="none" stroke="#000" d="M1.5,5 C1.5,4.2 2.2,3.5 3,3.5 L17,3.5 C17.8,3.5 18.5,4.2 18.5,5 L18.5,16 C18.5,16.8 17.8,17.5 17,17.5 L3,17.5 C2.2,17.5 1.5,16.8 1.5,16 L1.5,5 L1.5,5 L1.5,5 Z"/><circle cx="3.7" cy="10.5" r=".8"/></svg>',
            "table": '<svg width="20" height="20" viewBox="0 0 20 20"><rect x="1" y="3" width="18" height="1"/><rect x="1" y="7" width="18" height="1"/><rect x="1" y="11" width="18" height="1"/><rect x="1" y="15" width="18" height="1"/></svg>',
            "strikethrough": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M6,13.02 L6.65,13.02 C7.64,15.16 8.86,16.12 10.41,16.12 C12.22,16.12 12.92,14.93 12.92,13.89 C12.92,12.55 11.99,12.03 9.74,11.23 C8.05,10.64 6.23,10.11 6.23,7.83 C6.23,5.5 8.09,4.09 10.4,4.09 C11.44,4.09 12.13,4.31 12.72,4.54 L13.33,4 L13.81,4 L13.81,7.59 L13.16,7.59 C12.55,5.88 11.52,4.89 10.07,4.89 C8.84,4.89 7.89,5.69 7.89,7.03 C7.89,8.29 8.89,8.78 10.88,9.45 C12.57,10.03 14.38,10.6 14.38,12.91 C14.38,14.75 13.27,16.93 10.18,16.93 C9.18,16.93 8.17,16.69 7.46,16.39 L6.52,17 L6,17 L6,13.02 L6,13.02 Z"/><rect x="3" y="10" width="15" height="1"/></svg>',
            "star": '<svg width="20" height="20" viewBox="0 0 20 20"><polygon fill="none" stroke="#000" stroke-width="1.01" points="10 2 12.63 7.27 18.5 8.12 14.25 12.22 15.25 18 10 15.27 4.75 18 5.75 12.22 1.5 8.12 7.37 7.27"/></svg>',
            "soundcloud": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M17.2,9.4c-0.4,0-0.8,0.1-1.101,0.2c-0.199-2.5-2.399-4.5-5-4.5c-0.6,0-1.2,0.1-1.7,0.3C9.2,5.5,9.1,5.6,9.1,5.6V15h8 c1.601,0,2.801-1.2,2.801-2.8C20,10.7,18.7,9.4,17.2,9.4L17.2,9.4z"/><rect x="6" y="6.5" width="1.5" height="8.5"/><rect x="3" y="8" width="1.5" height="7"/><rect y="10" width="1.5" height="5"/></svg>',
            "social": '<svg width="20" height="20" viewBox="0 0 20 20"><line fill="none" stroke="#000" stroke-width="1.1" x1="13.4" y1="14" x2="6.3" y2="10.7"/><line fill="none" stroke="#000" stroke-width="1.1" x1="13.5" y1="5.5" x2="6.5" y2="8.8"/><circle fill="none" stroke="#000" stroke-width="1.1" cx="15.5" cy="4.6" r="2.3"/><circle fill="none" stroke="#000" stroke-width="1.1" cx="15.5" cy="14.8" r="2.3"/><circle fill="none" stroke="#000" stroke-width="1.1" cx="4.5" cy="9.8" r="2.3"/></svg>',
            "sign-out": '<svg width="20" height="20" viewBox="0 0 20 20"><polygon points="13.1 13.4 12.5 12.8 15.28 10 8 10 8 9 15.28 9 12.5 6.2 13.1 5.62 17 9.5"/><polygon points="13 2 3 2 3 17 13 17 13 16 4 16 4 3 13 3"/></svg>',
            "sign-in": '<svg width="20" height="20" viewBox="0 0 20 20"><polygon points="7 2 17 2 17 17 7 17 7 16 16 16 16 3 7 3"/><polygon points="9.1 13.4 8.5 12.8 11.28 10 4 10 4 9 11.28 9 8.5 6.2 9.1 5.62 13 9.5"/></svg>',
            "shrink": '<svg width="20" height="20" viewBox="0 0 20 20"><polygon points="11 4 12 4 12 8 16 8 16 9 11 9"/><polygon points="4 11 9 11 9 16 8 16 8 12 4 12"/><path fill="none" stroke="#000" stroke-width="1.1" d="M12,8 L18,2"/><path fill="none" stroke="#000" stroke-width="1.1" d="M2,18 L8,12"/></svg>',
            "settings": '<svg width="20" height="20" viewBox="0 0 20 20"><ellipse fill="none" stroke="#000" cx="6.11" cy="3.55" rx="2.11" ry="2.15"/><ellipse fill="none" stroke="#000" cx="6.11" cy="15.55" rx="2.11" ry="2.15"/><circle fill="none" stroke="#000" cx="13.15" cy="9.55" r="2.15"/><rect x="1" y="3" width="3" height="1"/><rect x="10" y="3" width="8" height="1"/><rect x="1" y="9" width="8" height="1"/><rect x="15" y="9" width="3" height="1"/><rect x="1" y="15" width="3" height="1"/><rect x="10" y="15" width="8" height="1"/></svg>',
            "server": '<svg width="20" height="20" viewBox="0 0 20 20"><rect x="3" y="3" width="1" height="2"/><rect x="5" y="3" width="1" height="2"/><rect x="7" y="3" width="1" height="2"/><rect x="16" y="3" width="1" height="1"/><rect x="16" y="10" width="1" height="1"/><circle fill="none" stroke="#000" cx="9.9" cy="17.4" r="1.4"/><rect x="3" y="10" width="1" height="2"/><rect x="5" y="10" width="1" height="2"/><rect x="9.5" y="14" width="1" height="2"/><rect x="3" y="17" width="6" height="1"/><rect x="11" y="17" width="6" height="1"/><rect fill="none" stroke="#000" x="1.5" y="1.5" width="17" height="5"/><rect fill="none" stroke="#000" x="1.5" y="8.5" width="17" height="5"/></svg>',
            "search": '<svg width="20" height="20" viewBox="0 0 20 20"><circle fill="none" stroke="#000" stroke-width="1.1" cx="9" cy="9" r="7"/><path fill="none" stroke="#000" stroke-width="1.1" d="M14,14 L18,18 L14,14 Z"/></svg>',
            "rss": '<svg width="20" height="20" viewBox="0 0 20 20"><circle cx="3.12" cy="16.8" r="1.85"/><path fill="none" stroke="#000" stroke-width="1.1" d="M1.5,8.2 C1.78,8.18 2.06,8.16 2.35,8.16 C7.57,8.16 11.81,12.37 11.81,17.57 C11.81,17.89 11.79,18.19 11.76,18.5"/><path fill="none" stroke="#000" stroke-width="1.1" d="M1.5,2.52 C1.78,2.51 2.06,2.5 2.35,2.5 C10.72,2.5 17.5,9.24 17.5,17.57 C17.5,17.89 17.49,18.19 17.47,18.5"/></svg>',
            "reply": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M17.7,13.11 C16.12,10.02 13.84,7.85 11.02,6.61 C10.57,6.41 9.75,6.13 9,5.91 L9,2 L1,9 L9,16 L9,12.13 C10.78,12.47 12.5,13.19 14.09,14.25 C17.13,16.28 18.56,18.54 18.56,18.54 C18.56,18.54 18.81,15.28 17.7,13.11 L17.7,13.11 Z M14.82,13.53 C13.17,12.4 11.01,11.4 8,10.92 L8,13.63 L2.55,9 L8,4.25 L8,6.8 C8.3,6.86 9.16,7.02 10.37,7.49 C13.3,8.65 15.54,10.96 16.65,13.08 C16.97,13.7 17.48,14.86 17.68,16 C16.87,15.05 15.73,14.15 14.82,13.53 L14.82,13.53 Z"/></svg>',
            "refresh": '<svg width="20" height="20" viewBox="0 0 20 20"><path fill="none" stroke="#000" stroke-width="1.1" d="M17.08,11.15 C17.09,11.31 17.1,11.47 17.1,11.64 C17.1,15.53 13.94,18.69 10.05,18.69 C6.16,18.68 3,15.53 3,11.63 C3,7.74 6.16,4.58 10.05,4.58 C10.9,4.58 11.71,4.73 12.46,5"/><polyline fill="none" stroke="#000" points="9.9 2 12.79 4.89 9.79 7.9"/></svg>',
            "reddit": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M19 9.05a2.56 2.56 0 0 0-2.56-2.56 2.59 2.59 0 0 0-1.88.82 10.63 10.63 0 0 0-4.14-1v-.08c.58-1.62 1.58-3.89 2.7-4.1.38-.08.77.12 1.19.57a1.15 1.15 0 0 0-.06.37 1.48 1.48 0 1 0 1.51-1.45 1.43 1.43 0 0 0-.76.19A2.29 2.29 0 0 0 12.91 1c-2.11.43-3.39 4.38-3.63 5.19 0 0 0 .11-.06.11a10.65 10.65 0 0 0-3.75 1A2.56 2.56 0 0 0 1 9.05a2.42 2.42 0 0 0 .72 1.76A5.18 5.18 0 0 0 1.24 13c0 3.66 3.92 6.64 8.73 6.64s8.74-3 8.74-6.64a5.23 5.23 0 0 0-.46-2.13A2.58 2.58 0 0 0 19 9.05zm-16.88 0a1.44 1.44 0 0 1 2.27-1.19 7.68 7.68 0 0 0-2.07 1.91 1.33 1.33 0 0 1-.2-.72zM10 18.4c-4.17 0-7.55-2.4-7.55-5.4S5.83 7.53 10 7.53 17.5 10 17.5 13s-3.38 5.4-7.5 5.4zm7.69-8.61a7.62 7.62 0 0 0-2.09-1.91 1.41 1.41 0 0 1 .84-.28 1.47 1.47 0 0 1 1.44 1.45 1.34 1.34 0 0 1-.21.72z"/><path d="M6.69 12.58a1.39 1.39 0 1 1 1.39-1.39 1.38 1.38 0 0 1-1.38 1.39z"/><path d="M14.26 11.2a1.39 1.39 0 1 1-1.39-1.39 1.39 1.39 0 0 1 1.39 1.39z"/><path d="M13.09 14.88a.54.54 0 0 1-.09.77 5.3 5.3 0 0 1-3.26 1.19 5.61 5.61 0 0 1-3.4-1.22.55.55 0 1 1 .73-.83 4.09 4.09 0 0 0 5.25 0 .56.56 0 0 1 .77.09z"/></svg>',
            "receiver": '<svg width="20" height="20" viewBox="0 0 20 20"><path fill="none" stroke="#000" stroke-width="1.01" d="M6.189,13.611C8.134,15.525 11.097,18.239 13.867,18.257C16.47,18.275 18.2,16.241 18.2,16.241L14.509,12.551L11.539,13.639L6.189,8.29L7.313,5.355L3.76,1.8C3.76,1.8 1.732,3.537 1.7,6.092C1.667,8.809 4.347,11.738 6.189,13.611"/></svg>',
            "quote-right": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M17.27,7.79 C17.27,9.45 16.97,10.43 15.99,12.02 C14.98,13.64 13,15.23 11.56,15.97 L11.1,15.08 C12.34,14.2 13.14,13.51 14.02,11.82 C14.27,11.34 14.41,10.92 14.49,10.54 C14.3,10.58 14.09,10.6 13.88,10.6 C12.06,10.6 10.59,9.12 10.59,7.3 C10.59,5.48 12.06,4 13.88,4 C15.39,4 16.67,5.02 17.05,6.42 C17.19,6.82 17.27,7.27 17.27,7.79 L17.27,7.79 Z"/><path d="M8.68,7.79 C8.68,9.45 8.38,10.43 7.4,12.02 C6.39,13.64 4.41,15.23 2.97,15.97 L2.51,15.08 C3.75,14.2 4.55,13.51 5.43,11.82 C5.68,11.34 5.82,10.92 5.9,10.54 C5.71,10.58 5.5,10.6 5.29,10.6 C3.47,10.6 2,9.12 2,7.3 C2,5.48 3.47,4 5.29,4 C6.8,4 8.08,5.02 8.46,6.42 C8.6,6.82 8.68,7.27 8.68,7.79 L8.68,7.79 Z"/></svg>',
            "question": '<svg width="20" height="20" viewBox="0 0 20 20"><circle fill="none" stroke="#000" stroke-width="1.1" cx="10" cy="10" r="9"/><circle cx="10.44" cy="14.42" r="1.05"/><path fill="none" stroke="#000" stroke-width="1.2" d="M8.17,7.79 C8.17,4.75 12.72,4.73 12.72,7.72 C12.72,8.67 11.81,9.15 11.23,9.75 C10.75,10.24 10.51,10.73 10.45,11.4 C10.44,11.53 10.43,11.64 10.43,11.75"/></svg>',
            "push": '<svg width="20" height="20" viewBox="0 0 20 20"><polygon points="12.15,4 9.5,1.4 6.85,4 6.15,3.3 9.5,0 12.85,3.3"/><line fill="none" stroke="#000" x1="9.5" y1="10" x2="9.5" y2="1"/><polyline fill="none" stroke="#000" points="6 5.5 3.5 5.5 3.5 18.5 15.5 18.5 15.5 5.5 13 5.5"/></svg>',
            "pull": '<svg width="20" height="20" viewBox="0 0 20 20"><polygon points="6.85,8 9.5,10.6 12.15,8 12.85,8.7 9.5,12 6.15,8.7"/><line fill="none" stroke="#000" x1="9.5" y1="11" x2="9.5" y2="2"/><polyline fill="none" stroke="#000" points="6,5.5 3.5,5.5 3.5,18.5 15.5,18.5 15.5,5.5 13,5.5"/></svg>',
            "print": '<svg width="20" height="20" viewBox="0 0 20 20"><polyline fill="none" stroke="#000" points="4.5 13.5 1.5 13.5 1.5 6.5 18.5 6.5 18.5 13.5 15.5 13.5"/><polyline fill="none" stroke="#000" points="15.5 6.5 15.5 2.5 4.5 2.5 4.5 6.5"/><rect fill="none" stroke="#000" width="11" height="6" x="4.5" y="11.5"/><rect width="8" height="1" x="6" y="13"/><rect width="8" height="1" x="6" y="15"/></svg>',
            "plus": '<svg width="20" height="20" viewBox="0 0 20 20"><rect x="9" y="1" width="1" height="17"/><rect x="1" y="9" width="17" height="1"/></svg>',
            "plus-circle": '<svg width="20" height="20" viewBox="0 0 20 20"><circle fill="none" stroke="#000" stroke-width="1.1" cx="9.5" cy="9.5" r="9"/><line fill="none" stroke="#000" x1="9.5" y1="5" x2="9.5" y2="14"/><line fill="none" stroke="#000" x1="5" y1="9.5" x2="14" y2="9.5"/></svg>',
            "play": '<svg width="20" height="20" viewBox="0 0 20 20"><polygon fill="none" stroke="#000" points="6.5,5 14.5,10 6.5,15"/></svg>',
            "play-circle": '<svg width="20" height="20" viewBox="0 0 20 20"><polygon fill="none" stroke="#000" stroke-width="1.1" points="8.5 7 13.5 10 8.5 13"/><circle fill="none" stroke="#000" stroke-width="1.1" cx="10" cy="10" r="9"/></svg>',
            "pinterest": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M10.21,1 C5.5,1 3,4.16 3,7.61 C3,9.21 3.85,11.2 5.22,11.84 C5.43,11.94 5.54,11.89 5.58,11.69 C5.62,11.54 5.8,10.8 5.88,10.45 C5.91,10.34 5.89,10.24 5.8,10.14 C5.36,9.59 5,8.58 5,7.65 C5,5.24 6.82,2.91 9.93,2.91 C12.61,2.91 14.49,4.74 14.49,7.35 C14.49,10.3 13,12.35 11.06,12.35 C9.99,12.35 9.19,11.47 9.44,10.38 C9.75,9.08 10.35,7.68 10.35,6.75 C10.35,5.91 9.9,5.21 8.97,5.21 C7.87,5.21 6.99,6.34 6.99,7.86 C6.99,8.83 7.32,9.48 7.32,9.48 C7.32,9.48 6.24,14.06 6.04,14.91 C5.7,16.35 6.08,18.7 6.12,18.9 C6.14,19.01 6.26,19.05 6.33,18.95 C6.44,18.81 7.74,16.85 8.11,15.44 C8.24,14.93 8.79,12.84 8.79,12.84 C9.15,13.52 10.19,14.09 11.29,14.09 C14.58,14.09 16.96,11.06 16.96,7.3 C16.94,3.7 14,1 10.21,1"/></svg>',
            "phone": '<svg width="20" height="20" viewBox="0 0 20 20"><path fill="none" stroke="#000" d="M15.5,17 C15.5,17.8 14.8,18.5 14,18.5 L7,18.5 C6.2,18.5 5.5,17.8 5.5,17 L5.5,3 C5.5,2.2 6.2,1.5 7,1.5 L14,1.5 C14.8,1.5 15.5,2.2 15.5,3 L15.5,17 L15.5,17 L15.5,17 Z"/><circle cx="10.5" cy="16.5" r=".8"/></svg>',
            "phone-landscape": '<svg width="20" height="20" viewBox="0 0 20 20"><path fill="none" stroke="#000" d="M17,5.5 C17.8,5.5 18.5,6.2 18.5,7 L18.5,14 C18.5,14.8 17.8,15.5 17,15.5 L3,15.5 C2.2,15.5 1.5,14.8 1.5,14 L1.5,7 C1.5,6.2 2.2,5.5 3,5.5 L17,5.5 L17,5.5 L17,5.5 Z"/><circle cx="3.8" cy="10.5" r=".8"/></svg>',
            "pencil": '<svg width="20" height="20" viewBox="0 0 20 20"><path fill="none" stroke="#000" d="M17.25,6.01 L7.12,16.1 L3.82,17.2 L5.02,13.9 L15.12,3.88 C15.71,3.29 16.66,3.29 17.25,3.88 C17.83,4.47 17.83,5.42 17.25,6.01 L17.25,6.01 Z"/><path fill="none" stroke="#000" d="M15.98,7.268 L13.851,5.148"/></svg>',
            "paint-bucket": '<svg width="20" height="20" viewBox="0 0 20 20"><path fill="none" stroke="#000" stroke-width="1.1" d="m6.42,2.16l5.28,5.28"/><path d="m18.49,11.83s1.51,2.06,1.51,3.36c0,.92-.76,1.64-1.51,1.64h0c-.75,0-1.49-.72-1.49-1.64,0-1.3,1.49-3.36,1.49-3.36h0Z"/><line fill="none" stroke="#000" x1="1.26" y1="10.5" x2="16" y2="10.5"/><polygon fill="none" stroke="#000" stroke-width="1.1" points="10.2 1.55 17.6 8.93 8.08 18.45 .7 11.07 10.2 1.55"/></svg>',
            "pagekit": '<svg width="20" height="20" viewBox="0 0 20 20"><polygon points="3,1 17,1 17,16 10,16 10,13 14,13 14,4 6,4 6,16 10,16 10,19 3,19"/></svg>',
            "nut": '<svg width="20" height="20" viewBox="0 0 20 20"><polygon fill="none" stroke="#000" points="2.5,5.7 10,1.3 17.5,5.7 17.5,14.3 10,18.7 2.5,14.3"/><circle fill="none" stroke="#000" cx="10" cy="10" r="3.5"/></svg>',
            "move": '<svg width="20" height="20" viewBox="0 0 20 20"><polygon points="4,5 1,5 1,9 2,9 2,6 4,6"/><polygon points="1,16 2,16 2,18 4,18 4,19 1,19"/><polygon points="14,16 14,19 11,19 11,18 13,18 13,16"/><rect fill="none" stroke="#000" x="5.5" y="1.5" width="13" height="13"/><rect x="1" y="11" width="1" height="3"/><rect x="6" y="18" width="3" height="1"/></svg>',
            "more": '<svg width="20" height="20" viewBox="0 0 20 20"><circle cx="3" cy="10" r="2"/><circle cx="10" cy="10" r="2"/><circle cx="17" cy="10" r="2"/></svg>',
            "more-vertical": '<svg width="20" height="20" viewBox="0 0 20 20"><circle cx="10" cy="3" r="2"/><circle cx="10" cy="10" r="2"/><circle cx="10" cy="17" r="2"/></svg>',
            "minus": '<svg width="20" height="20" viewBox="0 0 20 20"><rect height="1" width="18" y="9" x="1"/></svg>',
            "minus-circle": '<svg width="20" height="20" viewBox="0 0 20 20"><circle fill="none" stroke="#000" stroke-width="1.1" cx="9.5" cy="9.5" r="9"/><line fill="none" stroke="#000" x1="5" y1="9.5" x2="14" y2="9.5"/></svg>',
            "microsoft": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="m2,2h7.58v7.58H2V2Zm8.42,0h7.58v7.58h-7.58V2ZM2,10.42h7.58v7.58H2v-7.58Zm8.42,0h7.58v7.58h-7.58"/></svg>',
            "microphone": '<svg width="20" height="20" viewBox="0 0 20 20"><line fill="none" stroke="#000" x1="10" x2="10" y1="16.44" y2="18.5"/><line fill="none" stroke="#000" x1="7" x2="13" y1="18.5" y2="18.5"/><path fill="none" stroke="#000" stroke-width="1.1" d="M13.5 4.89v5.87a3.5 3.5 0 0 1-7 0V4.89a3.5 3.5 0 0 1 7 0z"/><path fill="none" stroke="#000" stroke-width="1.1" d="M15.5 10.36V11a5.5 5.5 0 0 1-11 0v-.6"/></svg>',
            "menu": '<svg width="20" height="20" viewBox="0 0 20 20"><rect x="2" y="4" width="16" height="1"/><rect x="2" y="9" width="16" height="1"/><rect x="2" y="14" width="16" height="1"/></svg>',
            "mastodon": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="m18.5,6.87c0-3.95-2.59-5.11-2.59-5.11-1.31-.6-3.55-.85-5.88-.87h-.06c-2.33.02-4.57.27-5.88.87,0,0-2.59,1.16-2.59,5.11,0,.91-.02,1.99.01,3.14.09,3.87.71,7.68,4.28,8.62,1.65.44,3.06.53,4.2.47,2.07-.11,3.23-.74,3.23-.74l-.07-1.5s-1.48.47-3.14.41c-1.64-.06-3.38-.18-3.64-2.2-.02-.18-.04-.37-.04-.57,0,0,1.61.39,3.66.49,1.25.06,2.42-.07,3.61-.22,2.28-.27,4.27-1.68,4.52-2.97.39-2.02.36-4.94.36-4.94Zm-3.05,5.09h-1.9v-4.65c0-.98-.41-1.48-1.24-1.48-.91,0-1.37.59-1.37,1.76v2.54h-1.89v-2.54c0-1.17-.46-1.76-1.37-1.76-.82,0-1.24.5-1.24,1.48v4.65h-1.9v-4.79c0-.98.25-1.76.75-2.33.52-.58,1.19-.87,2.03-.87.97,0,1.71.37,2.19,1.12l.47.79.47-.79c.49-.75,1.22-1.12,2.19-1.12.84,0,1.51.29,2.03.87.5.58.75,1.35.75,2.33v4.79Z"/></svg>',
            "mail": '<svg width="20" height="20" viewBox="0 0 20 20"><polyline fill="none" stroke="#000" points="1.4,6.5 10,11 18.6,6.5"/><path d="M 1,4 1,16 19,16 19,4 1,4 Z M 18,15 2,15 2,5 18,5 18,15 Z"/></svg>',
            "lock": '<svg width="20" height="20" viewBox="0 0 20 20"><rect fill="none" stroke="#000" height="10" width="13" y="8.5" x="3.5"/><path fill="none" stroke="#000" d="M6.5,8 L6.5,4.88 C6.5,3.01 8.07,1.5 10,1.5 C11.93,1.5 13.5,3.01 13.5,4.88 L13.5,8"/></svg>',
            "location": '<svg width="20" height="20" viewBox="0 0 20 20"><path fill="none" stroke="#000" stroke-width="1.01" d="M10,0.5 C6.41,0.5 3.5,3.39 3.5,6.98 C3.5,11.83 10,19 10,19 C10,19 16.5,11.83 16.5,6.98 C16.5,3.39 13.59,0.5 10,0.5 L10,0.5 Z"/><circle fill="none" stroke="#000" cx="10" cy="6.8" r="2.3"/></svg>',
            "list": '<svg width="20" height="20" viewBox="0 0 20 20"><rect x="6" y="4" width="12" height="1"/><rect x="6" y="9" width="12" height="1"/><rect x="6" y="14" width="12" height="1"/><rect x="2" y="4" width="2" height="1"/><rect x="2" y="9" width="2" height="1"/><rect x="2" y="14" width="2" height="1"/></svg>',
            "linkedin": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M5.77,17.89 L5.77,7.17 L2.21,7.17 L2.21,17.89 L5.77,17.89 L5.77,17.89 Z M3.99,5.71 C5.23,5.71 6.01,4.89 6.01,3.86 C5.99,2.8 5.24,2 4.02,2 C2.8,2 2,2.8 2,3.85 C2,4.88 2.77,5.7 3.97,5.7 L3.99,5.7 L3.99,5.71 L3.99,5.71 Z"/><path d="M7.75,17.89 L11.31,17.89 L11.31,11.9 C11.31,11.58 11.33,11.26 11.43,11.03 C11.69,10.39 12.27,9.73 13.26,9.73 C14.55,9.73 15.06,10.71 15.06,12.15 L15.06,17.89 L18.62,17.89 L18.62,11.74 C18.62,8.45 16.86,6.92 14.52,6.92 C12.6,6.92 11.75,7.99 11.28,8.73 L11.3,8.73 L11.3,7.17 L7.75,7.17 C7.79,8.17 7.75,17.89 7.75,17.89 L7.75,17.89 L7.75,17.89 Z"/></svg>',
            "link": '<svg width="20" height="20" viewBox="0 0 20 20"><path fill="none" stroke="#000" stroke-width="1.1" d="M10.625,12.375 L7.525,15.475 C6.825,16.175 5.925,16.175 5.225,15.475 L4.525,14.775 C3.825,14.074 3.825,13.175 4.525,12.475 L7.625,9.375"/><path fill="none" stroke="#000" stroke-width="1.1" d="M9.325,7.375 L12.425,4.275 C13.125,3.575 14.025,3.575 14.724,4.275 L15.425,4.975 C16.125,5.675 16.125,6.575 15.425,7.275 L12.325,10.375"/><path fill="none" stroke="#000" stroke-width="1.1" d="M7.925,11.875 L11.925,7.975"/></svg>',
            "lifesaver": '<svg width="20" height="20" viewBox="0 0 20 20"><circle fill="none" stroke="#000" cx="10" cy="10" r="9"/><circle fill="none" stroke="#000" cx="10" cy="10" r="5"/><line fill="none" stroke="#000" stroke-width="1.1" x1="5.17" y1="2.39" x2="8.11" y2="5.33"/><line fill="none" stroke="#000" stroke-width="1.1" x1="5.33" y1="8.11" x2="2.39" y2="5.17"/><line fill="none" stroke="#000" stroke-width="1.1" x1="14.83" y1="17.61" x2="11.89" y2="14.67"/><line fill="none" stroke="#000" stroke-width="1.1" x1="14.67" y1="11.89" x2="17.61" y2="14.83"/><line fill="none" stroke="#000" stroke-width="1.1" x1="17.61" y1="5.17" x2="14.67" y2="8.11"/><line fill="none" stroke="#000" stroke-width="1.1" x1="11.89" y1="5.33" x2="14.83" y2="2.39"/><line fill="none" stroke="#000" stroke-width="1.1" x1="8.11" y1="14.67" x2="5.17" y2="17.61"/><line fill="none" stroke="#000" stroke-width="1.1" x1="2.39" y1="14.83" x2="5.33" y2="11.89"/></svg>',
            "laptop": '<svg width="20" height="20" viewBox="0 0 20 20"><rect y="16" width="20" height="1"/><rect fill="none" stroke="#000" x="2.5" y="4.5" width="15" height="10"/></svg>',
            "joomla": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M7.8,13.4l1.7-1.7L5.9,8c-0.6-0.5-0.6-1.5,0-2c0.6-0.6,1.4-0.6,2,0l1.7-1.7c-1-1-2.3-1.3-3.6-1C5.8,2.2,4.8,1.4,3.7,1.4 c-1.3,0-2.3,1-2.3,2.3c0,1.1,0.8,2,1.8,2.3c-0.4,1.3-0.1,2.8,1,3.8L7.8,13.4L7.8,13.4z"/><path d="M10.2,4.3c1-1,2.5-1.4,3.8-1c0.2-1.1,1.1-2,2.3-2c1.3,0,2.3,1,2.3,2.3c0,1.2-0.9,2.2-2,2.3c0.4,1.3,0,2.8-1,3.8L13.9,8 c0.6-0.5,0.6-1.5,0-2c-0.5-0.6-1.5-0.6-2,0L8.2,9.7L6.5,8"/><path d="M14.1,16.8c-1.3,0.4-2.8,0.1-3.8-1l1.7-1.7c0.6,0.6,1.5,0.6,2,0c0.5-0.6,0.6-1.5,0-2l-3.7-3.7L12,6.7l3.7,3.7 c1,1,1.3,2.4,1,3.6c1.1,0.2,2,1.1,2,2.3c0,1.3-1,2.3-2.3,2.3C15.2,18.6,14.3,17.8,14.1,16.8"/><path d="M13.2,12.2l-3.7,3.7c-1,1-2.4,1.3-3.6,1c-0.2,1-1.2,1.8-2.2,1.8c-1.3,0-2.3-1-2.3-2.3c0-1.1,0.8-2,1.8-2.3 c-0.3-1.3,0-2.7,1-3.7l1.7,1.7c-0.6,0.6-0.6,1.5,0,2c0.6,0.6,1.4,0.6,2,0l3.7-3.7"/></svg>',
            "italic": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M12.63,5.48 L10.15,14.52 C10,15.08 10.37,15.25 11.92,15.3 L11.72,16 L6,16 L6.2,15.31 C7.78,15.26 8.19,15.09 8.34,14.53 L10.82,5.49 C10.97,4.92 10.63,4.76 9.09,4.71 L9.28,4 L15,4 L14.81,4.69 C13.23,4.75 12.78,4.91 12.63,5.48 L12.63,5.48 Z"/></svg>',
            "instagram": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M13.55,1H6.46C3.45,1,1,3.44,1,6.44v7.12c0,3,2.45,5.44,5.46,5.44h7.08c3.02,0,5.46-2.44,5.46-5.44V6.44 C19.01,3.44,16.56,1,13.55,1z M17.5,14c0,1.93-1.57,3.5-3.5,3.5H6c-1.93,0-3.5-1.57-3.5-3.5V6c0-1.93,1.57-3.5,3.5-3.5h8 c1.93,0,3.5,1.57,3.5,3.5V14z"/><circle cx="14.87" cy="5.26" r="1.09"/><path d="M10.03,5.45c-2.55,0-4.63,2.06-4.63,4.6c0,2.55,2.07,4.61,4.63,4.61c2.56,0,4.63-2.061,4.63-4.61 C14.65,7.51,12.58,5.45,10.03,5.45L10.03,5.45L10.03,5.45z M10.08,13c-1.66,0-3-1.34-3-2.99c0-1.65,1.34-2.99,3-2.99s3,1.34,3,2.99 C13.08,11.66,11.74,13,10.08,13L10.08,13L10.08,13z"/></svg>',
            "info": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M12.13,11.59 C11.97,12.84 10.35,14.12 9.1,14.16 C6.17,14.2 9.89,9.46 8.74,8.37 C9.3,8.16 10.62,7.83 10.62,8.81 C10.62,9.63 10.12,10.55 9.88,11.32 C8.66,15.16 12.13,11.15 12.14,11.18 C12.16,11.21 12.16,11.35 12.13,11.59 C12.08,11.95 12.16,11.35 12.13,11.59 L12.13,11.59 Z M11.56,5.67 C11.56,6.67 9.36,7.15 9.36,6.03 C9.36,5 11.56,4.54 11.56,5.67 L11.56,5.67 Z"/><circle fill="none" stroke="#000" stroke-width="1.1" cx="10" cy="10" r="9"/></svg>',
            "image": '<svg width="20" height="20" viewBox="0 0 20 20"><circle cx="16.1" cy="6.1" r="1.1"/><rect fill="none" stroke="#000" x=".5" y="2.5" width="19" height="15"/><polyline fill="none" stroke="#000" stroke-width="1.01" points="4,13 8,9 13,14"/><polyline fill="none" stroke="#000" stroke-width="1.01" points="11,12 12.5,10.5 16,14"/></svg>',
            "home": '<svg width="20" height="20" viewBox="0 0 20 20"><polygon points="18.65 11.35 10 2.71 1.35 11.35 0.65 10.65 10 1.29 19.35 10.65"/><polygon points="15 4 18 4 18 7 17 7 17 5 15 5"/><polygon points="3 11 4 11 4 18 7 18 7 12 12 12 12 18 16 18 16 11 17 11 17 19 11 19 11 13 8 13 8 19 3 19"/></svg>',
            "history": '<svg width="20" height="20" viewBox="0 0 20 20"><polyline fill="#000" points="1 2 2 2 2 6 6 6 6 7 1 7 1 2"/><path fill="none" stroke="#000" stroke-width="1.1" d="M2.1,6.548 C3.391,3.29 6.746,1 10.5,1 C15.5,1 19.5,5 19.5,10 C19.5,15 15.5,19 10.5,19 C5.5,19 1.5,15 1.5,10"/><rect x="9" y="4" width="1" height="7"/><path fill="none" stroke="#000" stroke-width="1.1" d="M13.018,14.197 L9.445,10.625"/></svg>',
            "heart": '<svg width="20" height="20" viewBox="0 0 20 20"><path fill="none" stroke="#000" stroke-width="1.03" d="M10,4 C10,4 8.1,2 5.74,2 C3.38,2 1,3.55 1,6.73 C1,8.84 2.67,10.44 2.67,10.44 L10,18 L17.33,10.44 C17.33,10.44 19,8.84 19,6.73 C19,3.55 16.62,2 14.26,2 C11.9,2 10,4 10,4 L10,4 Z"/></svg>',
            "hashtag": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M15.431,8 L15.661,7 L12.911,7 L13.831,3 L12.901,3 L11.98,7 L9.29,7 L10.21,3 L9.281,3 L8.361,7 L5.23,7 L5,8 L8.13,8 L7.21,12 L4.23,12 L4,13 L6.98,13 L6.061,17 L6.991,17 L7.911,13 L10.601,13 L9.681,17 L10.611,17 L11.531,13 L14.431,13 L14.661,12 L11.76,12 L12.681,8 L15.431,8 Z M10.831,12 L8.141,12 L9.061,8 L11.75,8 L10.831,12 Z"/></svg>',
            "happy": '<svg width="20" height="20" viewBox="0 0 20 20"><circle cx="13" cy="7" r="1"/><circle cx="7" cy="7" r="1"/><circle fill="none" stroke="#000" cx="10" cy="10" r="8.5"/><path fill="none" stroke="#000" d="M14.6,11.4 C13.9,13.3 12.1,14.5 10,14.5 C7.9,14.5 6.1,13.3 5.4,11.4"/></svg>',
            "grid": '<svg width="20" height="20" viewBox="0 0 20 20"><rect x="2" y="2" width="3" height="3"/><rect x="8" y="2" width="3" height="3"/><rect x="14" y="2" width="3" height="3"/><rect x="2" y="8" width="3" height="3"/><rect x="8" y="8" width="3" height="3"/><rect x="14" y="8" width="3" height="3"/><rect x="2" y="14" width="3" height="3"/><rect x="8" y="14" width="3" height="3"/><rect x="14" y="14" width="3" height="3"/></svg>',
            "google": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M17.86,9.09 C18.46,12.12 17.14,16.05 13.81,17.56 C9.45,19.53 4.13,17.68 2.47,12.87 C0.68,7.68 4.22,2.42 9.5,2.03 C11.57,1.88 13.42,2.37 15.05,3.65 C15.22,3.78 15.37,3.93 15.61,4.14 C14.9,4.81 14.23,5.45 13.5,6.14 C12.27,5.08 10.84,4.72 9.28,4.98 C8.12,5.17 7.16,5.76 6.37,6.63 C4.88,8.27 4.62,10.86 5.76,12.82 C6.95,14.87 9.17,15.8 11.57,15.25 C13.27,14.87 14.76,13.33 14.89,11.75 L10.51,11.75 L10.51,9.09 L17.86,9.09 L17.86,9.09 Z"/></svg>',
            "gitter": '<svg width="20" height="20" viewBox="0 0 20 20"><rect x="3.5" y="1" width="1.531" height="11.471"/><rect x="7.324" y="4.059" width="1.529" height="15.294"/><rect x="11.148" y="4.059" width="1.527" height="15.294"/><rect x="14.971" y="4.059" width="1.529" height="8.412"/></svg>',
            "github": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M10,1 C5.03,1 1,5.03 1,10 C1,13.98 3.58,17.35 7.16,18.54 C7.61,18.62 7.77,18.34 7.77,18.11 C7.77,17.9 7.76,17.33 7.76,16.58 C5.26,17.12 4.73,15.37 4.73,15.37 C4.32,14.33 3.73,14.05 3.73,14.05 C2.91,13.5 3.79,13.5 3.79,13.5 C4.69,13.56 5.17,14.43 5.17,14.43 C5.97,15.8 7.28,15.41 7.79,15.18 C7.87,14.6 8.1,14.2 8.36,13.98 C6.36,13.75 4.26,12.98 4.26,9.53 C4.26,8.55 4.61,7.74 5.19,7.11 C5.1,6.88 4.79,5.97 5.28,4.73 C5.28,4.73 6.04,4.49 7.75,5.65 C8.47,5.45 9.24,5.35 10,5.35 C10.76,5.35 11.53,5.45 12.25,5.65 C13.97,4.48 14.72,4.73 14.72,4.73 C15.21,5.97 14.9,6.88 14.81,7.11 C15.39,7.74 15.73,8.54 15.73,9.53 C15.73,12.99 13.63,13.75 11.62,13.97 C11.94,14.25 12.23,14.8 12.23,15.64 C12.23,16.84 12.22,17.81 12.22,18.11 C12.22,18.35 12.38,18.63 12.84,18.54 C16.42,17.35 19,13.98 19,10 C19,5.03 14.97,1 10,1 L10,1 Z"/></svg>',
            "github-alt": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M10,0.5 C4.75,0.5 0.5,4.76 0.5,10.01 C0.5,15.26 4.75,19.51 10,19.51 C15.24,19.51 19.5,15.26 19.5,10.01 C19.5,4.76 15.25,0.5 10,0.5 L10,0.5 Z M12.81,17.69 C12.81,17.69 12.81,17.7 12.79,17.69 C12.47,17.75 12.35,17.59 12.35,17.36 L12.35,16.17 C12.35,15.45 12.09,14.92 11.58,14.56 C12.2,14.51 12.77,14.39 13.26,14.21 C13.87,13.98 14.36,13.69 14.74,13.29 C15.42,12.59 15.76,11.55 15.76,10.17 C15.76,9.25 15.45,8.46 14.83,7.8 C15.1,7.08 15.07,6.29 14.75,5.44 L14.51,5.42 C14.34,5.4 14.06,5.46 13.67,5.61 C13.25,5.78 12.79,6.03 12.31,6.35 C11.55,6.16 10.81,6.05 10.09,6.05 C9.36,6.05 8.61,6.15 7.88,6.35 C7.28,5.96 6.75,5.68 6.26,5.54 C6.07,5.47 5.9,5.44 5.78,5.44 L5.42,5.44 C5.06,6.29 5.04,7.08 5.32,7.8 C4.7,8.46 4.4,9.25 4.4,10.17 C4.4,11.94 4.96,13.16 6.08,13.84 C6.53,14.13 7.05,14.32 7.69,14.43 C8.03,14.5 8.32,14.54 8.55,14.55 C8.07,14.89 7.82,15.42 7.82,16.16 L7.82,17.51 C7.8,17.69 7.7,17.8 7.51,17.8 C4.21,16.74 1.82,13.65 1.82,10.01 C1.82,5.5 5.49,1.83 10,1.83 C14.5,1.83 18.17,5.5 18.17,10.01 C18.18,13.53 15.94,16.54 12.81,17.69 L12.81,17.69 Z"/></svg>',
            "git-fork": '<svg width="20" height="20" viewBox="0 0 20 20"><circle fill="none" stroke="#000" stroke-width="1.2" cx="5.79" cy="2.79" r="1.79"/><circle fill="none" stroke="#000" stroke-width="1.2" cx="14.19" cy="2.79" r="1.79"/><circle fill="none" stroke="#000" stroke-width="1.2" cx="10.03" cy="16.79" r="1.79"/><path fill="none" stroke="#000" stroke-width="2" d="M5.79,4.57 L5.79,6.56 C5.79,9.19 10.03,10.22 10.03,13.31 C10.03,14.86 10.04,14.55 10.04,14.55 C10.04,14.37 10.04,14.86 10.04,13.31 C10.04,10.22 14.2,9.19 14.2,6.56 L14.2,4.57"/></svg>',
            "git-branch": '<svg width="20" height="20" viewBox="0 0 20 20"><circle fill="none" stroke="#000" stroke-width="1.2" cx="7" cy="3" r="2"/><circle fill="none" stroke="#000" stroke-width="1.2" cx="14" cy="6" r="2"/><circle fill="none" stroke="#000" stroke-width="1.2" cx="7" cy="17" r="2"/><path fill="none" stroke="#000" stroke-width="2" d="M14,8 C14,10.41 12.43,10.87 10.56,11.25 C9.09,11.54 7,12.06 7,15 L7,5"/></svg>',
            "future": '<svg width="20" height="20" viewBox="0 0 20 20"><polyline points="19 2 18 2 18 6 14 6 14 7 19 7 19 2"/><path fill="none" stroke="#000" stroke-width="1.1" d="M18,6.548 C16.709,3.29 13.354,1 9.6,1 C4.6,1 0.6,5 0.6,10 C0.6,15 4.6,19 9.6,19 C14.6,19 18.6,15 18.6,10"/><rect x="9" y="4" width="1" height="7"/><path d="M13.018,14.197 L9.445,10.625" fill="none" stroke="#000" stroke-width="1.1"/></svg>',
            "foursquare": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M15.23,2 C15.96,2 16.4,2.41 16.5,2.86 C16.57,3.15 16.56,3.44 16.51,3.73 C16.46,4.04 14.86,11.72 14.75,12.03 C14.56,12.56 14.16,12.82 13.61,12.83 C13.03,12.84 11.09,12.51 10.69,13 C10.38,13.38 7.79,16.39 6.81,17.53 C6.61,17.76 6.4,17.96 6.08,17.99 C5.68,18.04 5.29,17.87 5.17,17.45 C5.12,17.28 5.1,17.09 5.1,16.91 C5.1,12.4 4.86,7.81 5.11,3.31 C5.17,2.5 5.81,2.12 6.53,2 L15.23,2 L15.23,2 Z M9.76,11.42 C9.94,11.19 10.17,11.1 10.45,11.1 L12.86,11.1 C13.12,11.1 13.31,10.94 13.36,10.69 C13.37,10.64 13.62,9.41 13.74,8.83 C13.81,8.52 13.53,8.28 13.27,8.28 C12.35,8.29 11.42,8.28 10.5,8.28 C9.84,8.28 9.83,7.69 9.82,7.21 C9.8,6.85 10.13,6.55 10.5,6.55 C11.59,6.56 12.67,6.55 13.76,6.55 C14.03,6.55 14.23,6.4 14.28,6.14 C14.34,5.87 14.67,4.29 14.67,4.29 C14.67,4.29 14.82,3.74 14.19,3.74 L7.34,3.74 C7,3.75 6.84,4.02 6.84,4.33 C6.84,7.58 6.85,14.95 6.85,14.99 C6.87,15 8.89,12.51 9.76,11.42 L9.76,11.42 Z"/></svg>',
            "forward": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M2.47,13.11 C4.02,10.02 6.27,7.85 9.04,6.61 C9.48,6.41 10.27,6.13 11,5.91 L11,2 L18.89,9 L11,16 L11,12.13 C9.25,12.47 7.58,13.19 6.02,14.25 C3.03,16.28 1.63,18.54 1.63,18.54 C1.63,18.54 1.38,15.28 2.47,13.11 L2.47,13.11 Z M5.3,13.53 C6.92,12.4 9.04,11.4 12,10.92 L12,13.63 L17.36,9 L12,4.25 L12,6.8 C11.71,6.86 10.86,7.02 9.67,7.49 C6.79,8.65 4.58,10.96 3.49,13.08 C3.18,13.7 2.68,14.87 2.49,16 C3.28,15.05 4.4,14.15 5.3,13.53 L5.3,13.53 Z"/></svg>',
            "folder": '<svg width="20" height="20" viewBox="0 0 20 20"><polygon fill="none" stroke="#000" points="9.5 5.5 8.5 3.5 1.5 3.5 1.5 16.5 18.5 16.5 18.5 5.5"/></svg>',
            "flickr": '<svg width="20" height="20" viewBox="0 0 20 20"><circle cx="5.5" cy="9.5" r="3.5"/><circle cx="14.5" cy="9.5" r="3.5"/></svg>',
            "file": '<svg width="20" height="20" viewBox="0 0 20 20"><rect fill="none" stroke="#000" x="3.5" y="1.5" width="13" height="17"/></svg>',
            "file-text": '<svg width="20" height="20" viewBox="0 0 20 20"><rect fill="none" stroke="#000" width="13" height="17" x="3.5" y="1.5"/><line fill="none" stroke="#000" x1="6" x2="12" y1="12.5" y2="12.5"/><line fill="none" stroke="#000" x1="6" x2="14" y1="8.5" y2="8.5"/><line fill="none" stroke="#000" x1="6" x2="14" y1="6.5" y2="6.5"/><line fill="none" stroke="#000" x1="6" x2="14" y1="10.5" y2="10.5"/></svg>',
            "file-pdf": '<svg width="20" height="20" viewBox="0 0 20 20"><rect fill="none" stroke="#000" width="13" height="17" x="3.5" y="1.5"/><path d="M14.65 11.67c-.48.3-1.37-.19-1.79-.37a4.65 4.65 0 0 1 1.49.06c.35.1.36.28.3.31zm-6.3.06l.43-.79a14.7 14.7 0 0 0 .75-1.64 5.48 5.48 0 0 0 1.25 1.55l.2.15a16.36 16.36 0 0 0-2.63.73zM9.5 5.32c.2 0 .32.5.32.97a1.99 1.99 0 0 1-.23 1.04 5.05 5.05 0 0 1-.17-1.3s0-.71.08-.71zm-3.9 9a4.35 4.35 0 0 1 1.21-1.46l.24-.22a4.35 4.35 0 0 1-1.46 1.68zm9.23-3.3a2.05 2.05 0 0 0-1.32-.3 11.07 11.07 0 0 0-1.58.11 4.09 4.09 0 0 1-.74-.5 5.39 5.39 0 0 1-1.32-2.06 10.37 10.37 0 0 0 .28-2.62 1.83 1.83 0 0 0-.07-.25.57.57 0 0 0-.52-.4H9.4a.59.59 0 0 0-.6.38 6.95 6.95 0 0 0 .37 3.14c-.26.63-1 2.12-1 2.12-.3.58-.57 1.08-.82 1.5l-.8.44A3.11 3.11 0 0 0 5 14.16a.39.39 0 0 0 .15.42l.24.13c1.15.56 2.28-1.74 2.66-2.42a23.1 23.1 0 0 1 3.59-.85 4.56 4.56 0 0 0 2.91.8.5.5 0 0 0 .3-.21 1.1 1.1 0 0 0 .12-.75.84.84 0 0 0-.14-.25z"/></svg>',
            "file-edit": '<svg width="20" height="20" viewBox="0 0 20 20"><path fill="none" stroke="#000" d="M18.65,1.68 C18.41,1.45 18.109,1.33 17.81,1.33 C17.499,1.33 17.209,1.45 16.98,1.68 L8.92,9.76 L8,12.33 L10.55,11.41 L18.651,3.34 C19.12,2.87 19.12,2.15 18.65,1.68 L18.65,1.68 L18.65,1.68 Z"/><polyline fill="none" stroke="#000" points="16.5 8.482 16.5 18.5 3.5 18.5 3.5 1.5 14.211 1.5"/></svg>',
            "facebook": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M11,10h2.6l0.4-3H11V5.3c0-0.9,0.2-1.5,1.5-1.5H14V1.1c-0.3,0-1-0.1-2.1-0.1C9.6,1,8,2.4,8,5v2H5.5v3H8v8h3V10z"/></svg>',
            "eye": '<svg width="20" height="20" viewBox="0 0 20 20"><circle fill="none" stroke="#000" cx="10" cy="10" r="3.45"/><path fill="none" stroke="#000" d="m19.5,10c-2.4,3.66-5.26,7-9.5,7h0,0,0c-4.24,0-7.1-3.34-9.49-7C2.89,6.34,5.75,3,9.99,3h0,0,0c4.25,0,7.11,3.34,9.5,7Z"/></svg>',
            "eye-slash": '<svg width="20" height="20" viewBox="0 0 20 20"><path fill="none" stroke="#000" d="m7.56,7.56c.62-.62,1.49-1.01,2.44-1.01,1.91,0,3.45,1.54,3.45,3.45,0,.95-.39,1.82-1.01,2.44"/><path fill="none" stroke="#000" d="m19.5,10c-2.4,3.66-5.26,7-9.5,7h0,0,0c-4.24,0-7.1-3.34-9.49-7C2.89,6.34,5.75,3,9.99,3h0,0,0c4.25,0,7.11,3.34,9.5,7Z"/><line fill="none" stroke="#000" x1="2.5" y1="2.5" x2="17.5" y2="17.5"/></svg>',
            "expand": '<svg width="20" height="20" viewBox="0 0 20 20"><polygon points="13 2 18 2 18 7 17 7 17 3 13 3"/><polygon points="2 13 3 13 3 17 7 17 7 18 2 18"/><path fill="none" stroke="#000" stroke-width="1.1" d="M11,9 L17,3"/><path fill="none" stroke="#000" stroke-width="1.1" d="M3,17 L9,11"/></svg>',
            "etsy": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M8,4.26C8,4.07,8,4,8.31,4h4.46c.79,0,1.22.67,1.53,1.91l.25,1h.76c.14-2.82.26-4,.26-4S13.65,3,12.52,3H6.81L3.75,2.92v.84l1,.2c.73.11.9.27,1,1,0,0,.06,2,.06,5.17s-.06,5.14-.06,5.14c0,.59-.23.81-1,.94l-1,.2v.84l3.06-.1h5.11c1.15,0,3.82.1,3.82.1,0-.7.45-3.88.51-4.22h-.73l-.76,1.69a2.25,2.25,0,0,1-2.45,1.47H9.4c-1,0-1.44-.4-1.44-1.24V10.44s2.16,0,2.86.06c.55,0,.85.19,1.06,1l.23,1H13L12.9,9.94,13,7.41h-.85l-.28,1.13c-.16.74-.28.84-1,1-1,.1-2.89.09-2.89.09Z"/></svg>',
            "dribbble": '<svg width="20" height="20" viewBox="0 0 20 20"><path fill="none" stroke="#000" stroke-width="1.4" d="M1.3,8.9c0,0,5,0.1,8.6-1c1.4-0.4,2.6-0.9,4-1.9 c1.4-1.1,2.5-2.5,2.5-2.5"/><path fill="none" stroke="#000" stroke-width="1.4" d="M3.9,16.6c0,0,1.7-2.8,3.5-4.2 c1.8-1.3,4-2,5.7-2.2C16,10,19,10.6,19,10.6"/><path fill="none" stroke="#000" stroke-width="1.4" d="M6.9,1.6c0,0,3.3,4.6,4.2,6.8 c0.4,0.9,1.3,3.1,1.9,5.2c0.6,2,0.9,4.4,0.9,4.4"/><circle fill="none" stroke="#000" stroke-width="1.4" cx="10" cy="10" r="9"/></svg>',
            "download": '<svg width="20" height="20" viewBox="0 0 20 20"><polyline fill="none" stroke="#000" points="14,10 9.5,14.5 5,10"/><rect x="3" y="17" width="13" height="1"/><line fill="none" stroke="#000" x1="9.5" y1="13.91" x2="9.5" y2="3"/></svg>',
            "discord": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M16.074,4.361a14.243,14.243,0,0,0-3.61-1.134,10.61,10.61,0,0,0-.463.96,13.219,13.219,0,0,0-4,0,10.138,10.138,0,0,0-.468-.96A14.206,14.206,0,0,0,3.919,4.364,15.146,15.146,0,0,0,1.324,14.5a14.435,14.435,0,0,0,4.428,2.269A10.982,10.982,0,0,0,6.7,15.21a9.294,9.294,0,0,1-1.494-.727c.125-.093.248-.19.366-.289a10.212,10.212,0,0,0,8.854,0c.119.1.242.2.366.289a9.274,9.274,0,0,1-1.5.728,10.8,10.8,0,0,0,.948,1.562,14.419,14.419,0,0,0,4.431-2.27A15.128,15.128,0,0,0,16.074,4.361Zm-8.981,8.1a1.7,1.7,0,0,1-1.573-1.79A1.689,1.689,0,0,1,7.093,8.881a1.679,1.679,0,0,1,1.573,1.791A1.687,1.687,0,0,1,7.093,12.462Zm5.814,0a1.7,1.7,0,0,1-1.573-1.79,1.689,1.689,0,0,1,1.573-1.791,1.679,1.679,0,0,1,1.573,1.791A1.688,1.688,0,0,1,12.907,12.462Z"/></svg>',
            "desktop": '<svg width="20" height="20" viewBox="0 0 20 20"><rect x="8" y="15" width="1" height="2"/><rect x="11" y="15" width="1" height="2"/><rect x="5" y="16" width="10" height="1"/><rect fill="none" stroke="#000" x="1.5" y="3.5" width="17" height="11"/></svg>',
            "database": '<svg width="20" height="20" viewBox="0 0 20 20"><ellipse fill="none" stroke="#000" cx="10" cy="4.64" rx="7.5" ry="3.14"/><path fill="none" stroke="#000" d="M17.5,8.11 C17.5,9.85 14.14,11.25 10,11.25 C5.86,11.25 2.5,9.84 2.5,8.11"/><path fill="none" stroke="#000" d="M17.5,11.25 C17.5,12.99 14.14,14.39 10,14.39 C5.86,14.39 2.5,12.98 2.5,11.25"/><path fill="none" stroke="#000" d="M17.49,4.64 L17.5,14.36 C17.5,16.1 14.14,17.5 10,17.5 C5.86,17.5 2.5,16.09 2.5,14.36 L2.5,4.64"/></svg>',
            "crosshairs": '<svg width="20" height="20" viewBox="0 0 20 20"><circle fill="none" stroke="#000" cx="10" cy="10" r="7.5"/><line fill="none" stroke="#000" x1="10" x2="10" y2="8"/><line fill="none" stroke="#000" x1="10" y1="12" x2="10" y2="20"/><line fill="none" stroke="#000" y1="10" x2="8" y2="10"/><line fill="none" stroke="#000" x1="12" y1="10" x2="20" y2="10"/></svg>',
            "credit-card": '<svg width="20" height="20" viewBox="0 0 20 20"><rect fill="none" stroke="#000" x="1.5" y="4.5" width="17" height="12"/><rect x="1" y="7" width="18" height="3"/></svg>',
            "copy": '<svg width="20" height="20" viewBox="0 0 20 20"><rect fill="none" stroke="#000" x="3.5" y="2.5" width="12" height="16"/><polyline fill="none" stroke="#000" points="5 0.5 17.5 0.5 17.5 17"/></svg>',
            "comments": '<svg width="20" height="20" viewBox="0 0 20 20"><polyline fill="none" stroke="#000" points="2 0.5 19.5 0.5 19.5 13"/><path d="M5,19.71 L5,15 L0,15 L0,2 L18,2 L18,15 L9.71,15 L5,19.71 L5,19.71 L5,19.71 Z M1,14 L6,14 L6,17.29 L9.29,14 L17,14 L17,3 L1,3 L1,14 L1,14 L1,14 Z"/></svg>',
            "commenting": '<svg width="20" height="20" viewBox="0 0 20 20"><polygon fill="none" stroke="#000" points="1.5,1.5 18.5,1.5 18.5,13.5 10.5,13.5 6.5,17.5 6.5,13.5 1.5,13.5"/><circle cx="10" cy="8" r="1"/><circle cx="6" cy="8" r="1"/><circle cx="14" cy="8" r="1"/></svg>',
            "comment": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M6,18.71 L6,14 L1,14 L1,1 L19,1 L19,14 L10.71,14 L6,18.71 L6,18.71 Z M2,13 L7,13 L7,16.29 L10.29,13 L18,13 L18,2 L2,2 L2,13 L2,13 Z"/></svg>',
            "cog": '<svg width="20" height="20" viewBox="0 0 20 20"><circle fill="none" stroke="#000" cx="9.997" cy="10" r="3.31"/><path fill="none" stroke="#000" d="M18.488,12.285 L16.205,16.237 C15.322,15.496 14.185,15.281 13.303,15.791 C12.428,16.289 12.047,17.373 12.246,18.5 L7.735,18.5 C7.938,17.374 7.553,16.299 6.684,15.791 C5.801,15.27 4.655,15.492 3.773,16.237 L1.5,12.285 C2.573,11.871 3.317,10.999 3.317,9.991 C3.305,8.98 2.573,8.121 1.5,7.716 L3.765,3.784 C4.645,4.516 5.794,4.738 6.687,4.232 C7.555,3.722 7.939,2.637 7.735,1.5 L12.263,1.5 C12.072,2.637 12.441,3.71 13.314,4.22 C14.206,4.73 15.343,4.516 16.225,3.794 L18.487,7.714 C17.404,8.117 16.661,8.988 16.67,10.009 C16.672,11.018 17.415,11.88 18.488,12.285 L18.488,12.285 Z"/></svg>',
            "code": '<svg width="20" height="20" viewBox="0 0 20 20"><polyline fill="none" stroke="#000" stroke-width="1.01" points="13,4 19,10 13,16"/><polyline fill="none" stroke="#000" stroke-width="1.01" points="7,4 1,10 7,16"/></svg>',
            "cloud-upload": '<svg width="20" height="20" viewBox="0 0 20 20"><path fill="none" stroke="#000" stroke-width="1.1" d="M6.5,14.61 L3.75,14.61 C1.96,14.61 0.5,13.17 0.5,11.39 C0.5,9.76 1.72,8.41 3.31,8.2 C3.38,5.31 5.75,3 8.68,3 C11.19,3 13.31,4.71 13.89,7.02 C14.39,6.8 14.93,6.68 15.5,6.68 C17.71,6.68 19.5,8.45 19.5,10.64 C19.5,12.83 17.71,14.6 15.5,14.6 L12.5,14.6"/><polyline fill="none" stroke="#000" points="7.25 11.75 9.5 9.5 11.75 11.75"/><path fill="none" stroke="#000" d="M9.5,18 L9.5,9.5"/></svg>',
            "cloud-download": '<svg width="20" height="20" viewBox="0 0 20 20"><path fill="none" stroke="#000" stroke-width="1.1" d="M6.5,14.61 L3.75,14.61 C1.96,14.61 0.5,13.17 0.5,11.39 C0.5,9.76 1.72,8.41 3.3,8.2 C3.38,5.31 5.75,3 8.68,3 C11.19,3 13.31,4.71 13.89,7.02 C14.39,6.8 14.93,6.68 15.5,6.68 C17.71,6.68 19.5,8.45 19.5,10.64 C19.5,12.83 17.71,14.6 15.5,14.6 L12.5,14.6"/><polyline fill="none" stroke="#000" points="11.75 16 9.5 18.25 7.25 16"/><path fill="none" stroke="#000" d="M9.5,18 L9.5,9.5"/></svg>',
            "close": '<svg width="20" height="20" viewBox="0 0 20 20"><path fill="none" stroke="#000" stroke-width="1.06" d="M16,16 L4,4"/><path fill="none" stroke="#000" stroke-width="1.06" d="M16,4 L4,16"/></svg>',
            "clock": '<svg width="20" height="20" viewBox="0 0 20 20"><circle fill="none" stroke="#000" stroke-width="1.1" cx="10" cy="10" r="9"/><rect x="9" y="4" width="1" height="7"/><path fill="none" stroke="#000" stroke-width="1.1" d="M13.018,14.197 L9.445,10.625"/></svg>',
            "chevron-up": '<svg width="20" height="20" viewBox="0 0 20 20"><polyline fill="none" stroke="#000" stroke-width="1.03" points="4 13 10 7 16 13"/></svg>',
            "chevron-right": '<svg width="20" height="20" viewBox="0 0 20 20"><polyline fill="none" stroke="#000" stroke-width="1.03" points="7 4 13 10 7 16"/></svg>',
            "chevron-left": '<svg width="20" height="20" viewBox="0 0 20 20"><polyline fill="none" stroke="#000" stroke-width="1.03" points="13 16 7 10 13 4"/></svg>',
            "chevron-down": '<svg width="20" height="20" viewBox="0 0 20 20"><polyline fill="none" stroke="#000" stroke-width="1.03" points="16 7 10 13 4 7"/></svg>',
            "chevron-double-right": '<svg width="20" height="20" viewBox="0 0 20 20"><polyline fill="none" stroke="#000" stroke-width="1.03" points="10 6 14 10 10 14"/><polyline fill="none" stroke="#000" stroke-width="1.03" points="6 6 10 10 6 14"/></svg>',
            "chevron-double-left": '<svg width="20" height="20" viewBox="0 0 20 20"><polyline fill="none" stroke="#000" stroke-width="1.03" points="10 14 6 10 10 6"/><polyline fill="none" stroke="#000" stroke-width="1.03" points="14 14 10 10 14 6"/></svg>',
            "check": '<svg width="20" height="20" viewBox="0 0 20 20"><polyline fill="none" stroke="#000" stroke-width="1.1" points="4,10 8,15 17,4"/></svg>',
            "cart": '<svg width="20" height="20" viewBox="0 0 20 20"><circle cx="7.3" cy="17.3" r="1.4"/><circle cx="13.3" cy="17.3" r="1.4"/><polyline fill="none" stroke="#000" points="0 2 3.2 4 5.3 12.5 16 12.5 18 6.5 8 6.5"/></svg>',
            "camera": '<svg width="20" height="20" viewBox="0 0 20 20"><circle fill="none" stroke="#000" stroke-width="1.1" cx="10" cy="10.8" r="3.8"/><path fill="none" stroke="#000" d="M1,4.5 C0.7,4.5 0.5,4.7 0.5,5 L0.5,17 C0.5,17.3 0.7,17.5 1,17.5 L19,17.5 C19.3,17.5 19.5,17.3 19.5,17 L19.5,5 C19.5,4.7 19.3,4.5 19,4.5 L13.5,4.5 L13.5,2.9 C13.5,2.6 13.3,2.5 13,2.5 L7,2.5 C6.7,2.5 6.5,2.6 6.5,2.9 L6.5,4.5 L1,4.5 L1,4.5 Z"/></svg>',
            "calendar": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M 2,3 2,17 18,17 18,3 2,3 Z M 17,16 3,16 3,8 17,8 17,16 Z M 17,7 3,7 3,4 17,4 17,7 Z"/><rect width="1" height="3" x="6" y="2"/><rect width="1" height="3" x="13" y="2"/></svg>',
            "bookmark": '<svg width="20" height="20" viewBox="0 0 20 20"><polygon fill="none" stroke="#000" points="5.5 1.5 15.5 1.5 15.5 17.5 10.5 12.5 5.5 17.5"/></svg>',
            "bolt": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M4.74,20 L7.73,12 L3,12 L15.43,1 L12.32,9 L17.02,9 L4.74,20 L4.74,20 L4.74,20 Z M9.18,11 L7.1,16.39 L14.47,10 L10.86,10 L12.99,4.67 L5.61,11 L9.18,11 L9.18,11 L9.18,11 Z"/></svg>',
            "bold": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M5,15.3 C5.66,15.3 5.9,15 5.9,14.53 L5.9,5.5 C5.9,4.92 5.56,4.7 5,4.7 L5,4 L8.95,4 C12.6,4 13.7,5.37 13.7,6.9 C13.7,7.87 13.14,9.17 10.86,9.59 L10.86,9.7 C13.25,9.86 14.29,11.28 14.3,12.54 C14.3,14.47 12.94,16 9,16 L5,16 L5,15.3 Z M9,9.3 C11.19,9.3 11.8,8.5 11.85,7 C11.85,5.65 11.3,4.8 9,4.8 L7.67,4.8 L7.67,9.3 L9,9.3 Z M9.185,15.22 C11.97,15 12.39,14 12.4,12.58 C12.4,11.15 11.39,10 9,10 L7.67,10 L7.67,15 L9.18,15 Z"/></svg>',
            "bell": '<svg width="20" height="20" viewBox="0 0 20 20"><path fill="none" stroke="#000" stroke-width="1.1" d="M17,15.5 L3,15.5 C2.99,14.61 3.79,13.34 4.1,12.51 C4.58,11.3 4.72,10.35 5.19,7.01 C5.54,4.53 5.89,3.2 7.28,2.16 C8.13,1.56 9.37,1.5 9.81,1.5 L9.96,1.5 C9.96,1.5 11.62,1.41 12.67,2.17 C14.08,3.2 14.42,4.54 14.77,7.02 C15.26,10.35 15.4,11.31 15.87,12.52 C16.2,13.34 17.01,14.61 17,15.5 L17,15.5 Z"/><path fill="none" stroke="#000" d="M12.39,16 C12.39,17.37 11.35,18.43 9.91,18.43 C8.48,18.43 7.42,17.37 7.42,16"/></svg>',
            "behance": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M9.5,10.6c-0.4-0.5-0.9-0.9-1.6-1.1c1.7-1,2.2-3.2,0.7-4.7C7.8,4,6.3,4,5.2,4C3.5,4,1.7,4,0,4v12c1.7,0,3.4,0,5.2,0 c1,0,2.1,0,3.1-0.5C10.2,14.6,10.5,12.3,9.5,10.6L9.5,10.6z M5.6,6.1c1.8,0,1.8,2.7-0.1,2.7c-1,0-2,0-2.9,0V6.1H5.6z M2.6,13.8v-3.1 c1.1,0,2.1,0,3.2,0c2.1,0,2.1,3.2,0.1,3.2L2.6,13.8z"/><path d="M19.9,10.9C19.7,9.2,18.7,7.6,17,7c-4.2-1.3-7.3,3.4-5.3,7.1c0.9,1.7,2.8,2.3,4.7,2.1c1.7-0.2,2.9-1.3,3.4-2.9h-2.2 c-0.4,1.3-2.4,1.5-3.5,0.6c-0.4-0.4-0.6-1.1-0.6-1.7H20C20,11.7,19.9,10.9,19.9,10.9z M13.5,10.6c0-1.6,2.3-2.7,3.5-1.4 c0.4,0.4,0.5,0.9,0.6,1.4H13.5L13.5,10.6z"/><rect x="13" y="4" width="5" height="1.4"/></svg>',
            "ban": '<svg width="20" height="20" viewBox="0 0 20 20"><circle fill="none" stroke="#000" stroke-width="1.1" cx="10" cy="10" r="9"/><line fill="none" stroke="#000" stroke-width="1.1" x1="4" y1="3.5" x2="16" y2="16.5"/></svg>',
            "bag": '<svg width="20" height="20" viewBox="0 0 20 20"><path fill="none" stroke="#000" d="M7.5,7.5V4A2.48,2.48,0,0,1,10,1.5,2.54,2.54,0,0,1,12.5,4V7.5"/><polygon fill="none" stroke="#000" points="16.5 7.5 3.5 7.5 2.5 18.5 17.5 18.5 16.5 7.5"/></svg>',
            "arrow-up": '<svg width="20" height="20" viewBox="0 0 20 20"><polygon points="10.5,4 15.37,9.4 14.63,10.08 10.5,5.49 6.37,10.08 5.63,9.4"/><line fill="none" stroke="#000" x1="10.5" y1="16" x2="10.5" y2="5"/></svg>',
            "arrow-right": '<svg width="20" height="20" viewBox="0 0 20 20"><polyline fill="none" stroke="#000" points="10 5 15 9.5 10 14"/><line fill="none" stroke="#000" x1="4" y1="9.5" x2="15" y2="9.5"/></svg>',
            "arrow-left": '<svg width="20" height="20" viewBox="0 0 20 20"><polyline fill="none" stroke="#000" points="10 14 5 9.5 10 5"/><line fill="none" stroke="#000" x1="16" y1="9.5" x2="5" y2="9.52"/></svg>',
            "arrow-down": '<svg width="20" height="20" viewBox="0 0 20 20"><polygon points="10.5,16.08 5.63,10.66 6.37,10 10.5,14.58 14.63,10 15.37,10.66"/><line fill="none" stroke="#000" x1="10.5" y1="4" x2="10.5" y2="15"/></svg>',
            "apple": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="m17.23,6.93c-.1.08-1.95,1.12-1.95,3.43,0,2.67,2.35,3.62,2.42,3.64-.01.06-.37,1.29-1.24,2.55-.77,1.11-1.58,2.22-2.8,2.22s-1.54-.71-2.95-.71-1.87.73-2.99.73-1.9-1.03-2.8-2.29c-1.04-1.48-1.88-3.78-1.88-5.96,0-3.5,2.28-5.36,4.51-5.36,1.19,0,2.18.78,2.93.78s1.82-.83,3.17-.83c.51,0,2.36.05,3.57,1.79h0Zm-4.21-3.27c.56-.66.96-1.59.96-2.51,0-.13-.01-.26-.03-.36-.91.03-1.99.61-2.65,1.36-.51.58-.99,1.5-.99,2.44,0,.14.02.28.03.33.06.01.15.02.24.02.82,0,1.85-.55,2.44-1.28h0Z"/></svg>',
            "android": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="m14.88,6.77l1.66-2.87c.09-.16.04-.37-.12-.46-.16-.09-.37-.04-.46.12l-1.68,2.91c-1.28-.59-2.73-.91-4.28-.91s-3,.33-4.28.91l-1.68-2.91c-.09-.16-.3-.22-.46-.12-.16.09-.22.3-.12.46l1.66,2.87C2.26,8.32.32,11.22,0,14.61h20c-.32-3.39-2.26-6.29-5.12-7.84h0Zm-9.47,5.03c-.46,0-.84-.38-.84-.84s.38-.84.84-.84.84.38.84.84c0,.46-.37.84-.84.84Zm9.18,0c-.46,0-.84-.38-.84-.84s.38-.84.84-.84.84.38.84.84c0,.46-.37.84-.84.84Z"/></svg>',
            "android-robot": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="m17.61,7.96v4.64c-.06,1.48-2.17,1.48-2.23,0v-4.64c.06-1.48,2.17-1.48,2.23,0Z"/><path d="m4.62,7.96v4.64c-.06,1.48-2.17,1.48-2.23,0v-4.64c.06-1.48,2.17-1.48,2.23,0Z"/><path d="m12.78,2.85c-.11-.07-.23-.13-.34-.19.13-.23.65-1.17.79-1.42.07-.12-.05-.27-.18-.23-.04.01-.07.04-.09.08l-.79,1.43c-1.32-.6-2.98-.6-4.3,0-.13-.23-.65-1.18-.79-1.43-.04-.07-.14-.1-.21-.06-.08.04-.1.14-.06.21,0,0,.79,1.42.79,1.42-1.49.77-2.53,2.28-2.53,3.99-.02,0,9.93,0,9.93,0,.01-1.55-.87-2.98-2.19-3.8Zm-5.07,1.98c-.23,0-.41-.19-.41-.41.01-.27.21-.41.41-.41s.4.14.42.41c0,.22-.18.42-.41.41Zm4.58,0c-.23,0-.42-.19-.41-.41.01-.28.21-.41.41-.41s.4.14.41.41c0,.23-.19.41-.41.41Z"/><path d="m14.97,7.03v7.2c0,.66-.54,1.2-1.2,1.2h-.8v2.46c-.06,1.48-2.16,1.48-2.23,0,0,0,0-2.46,0-2.46h-1.48v2.46c0,.61-.5,1.11-1.11,1.11s-1.11-.5-1.11-1.11v-2.46h-.8c-.66,0-1.2-.54-1.2-1.2,0,0,0-7.2,0-7.2h9.93Z"/></svg>',
            "album": '<svg width="20" height="20" viewBox="0 0 20 20"><rect x="5" y="2" width="10" height="1"/><rect x="3" y="4" width="14" height="1"/><rect fill="none" stroke="#000" x="1.5" y="6.5" width="17" height="11"/></svg>',
            "500px": '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M9.624,11.866c-0.141,0.132,0.479,0.658,0.662,0.418c0.051-0.046,0.607-0.61,0.662-0.664c0,0,0.738,0.719,0.814,0.719 c0.1,0,0.207-0.055,0.322-0.17c0.27-0.269,0.135-0.416,0.066-0.495l-0.631-0.616l0.658-0.668c0.146-0.156,0.021-0.314-0.1-0.449 c-0.182-0.18-0.359-0.226-0.471-0.125l-0.656,0.654l-0.654-0.654c-0.033-0.034-0.08-0.045-0.124-0.045 c-0.079,0-0.191,0.068-0.307,0.181c-0.202,0.202-0.247,0.351-0.133,0.462l0.665,0.665L9.624,11.866z"/><path d="M11.066,2.884c-1.061,0-2.185,0.248-3.011,0.604c-0.087,0.034-0.141,0.106-0.15,0.205C7.893,3.784,7.919,3.909,7.982,4.066 c0.05,0.136,0.187,0.474,0.452,0.372c0.844-0.326,1.779-0.507,2.633-0.507c0.963,0,1.9,0.191,2.781,0.564 c0.695,0.292,1.357,0.719,2.078,1.34c0.051,0.044,0.105,0.068,0.164,0.068c0.143,0,0.273-0.137,0.389-0.271 c0.191-0.214,0.324-0.395,0.135-0.575c-0.686-0.654-1.436-1.138-2.363-1.533C13.24,3.097,12.168,2.884,11.066,2.884z"/><path d="M16.43,15.747c-0.092-0.028-0.242,0.05-0.309,0.119l0,0c-0.652,0.652-1.42,1.169-2.268,1.521 c-0.877,0.371-1.814,0.551-2.779,0.551c-0.961,0-1.896-0.189-2.775-0.564c-0.848-0.36-1.612-0.879-2.268-1.53 c-0.682-0.688-1.196-1.455-1.529-2.268c-0.325-0.799-0.471-1.643-0.471-1.643c-0.045-0.24-0.258-0.249-0.567-0.203 c-0.128,0.021-0.519,0.079-0.483,0.36v0.01c0.105,0.644,0.289,1.284,0.545,1.895c0.417,0.969,1.002,1.849,1.756,2.604 c0.757,0.754,1.636,1.34,2.604,1.757C8.901,18.785,9.97,19,11.088,19c1.104,0,2.186-0.215,3.188-0.645 c1.838-0.896,2.604-1.757,2.604-1.757c0.182-0.204,0.227-0.317-0.1-0.643C16.779,15.956,16.525,15.774,16.43,15.747z"/><path d="M5.633,13.287c0.293,0.71,0.723,1.341,1.262,1.882c0.54,0.54,1.172,0.971,1.882,1.264c0.731,0.303,1.509,0.461,2.298,0.461 c0.801,0,1.578-0.158,2.297-0.461c0.711-0.293,1.344-0.724,1.883-1.264c0.543-0.541,0.971-1.172,1.264-1.882 c0.314-0.721,0.463-1.5,0.463-2.298c0-0.79-0.148-1.569-0.463-2.289c-0.293-0.699-0.721-1.329-1.264-1.881 c-0.539-0.541-1.172-0.959-1.867-1.263c-0.721-0.303-1.5-0.461-2.299-0.461c-0.802,0-1.613,0.159-2.322,0.461 c-0.577,0.25-1.544,0.867-2.119,1.454v0.012V2.108h8.16C15.1,2.104,15.1,1.69,15.1,1.552C15.1,1.417,15.1,1,14.809,1H5.915 C5.676,1,5.527,1.192,5.527,1.384v6.84c0,0.214,0.273,0.372,0.529,0.428c0.5,0.105,0.614-0.056,0.737-0.224l0,0 c0.18-0.273,0.776-0.884,0.787-0.894c0.901-0.905,2.117-1.408,3.416-1.408c1.285,0,2.5,0.501,3.412,1.408 c0.914,0.914,1.408,2.122,1.408,3.405c0,1.288-0.508,2.496-1.408,3.405c-0.9,0.896-2.152,1.406-3.438,1.406 c-0.877,0-1.711-0.229-2.433-0.671v-4.158c0-0.553,0.237-1.151,0.643-1.614c0.462-0.519,1.094-0.799,1.782-0.799 c0.664,0,1.293,0.253,1.758,0.715c0.459,0.459,0.709,1.071,0.709,1.723c0,1.385-1.094,2.468-2.488,2.468 c-0.273,0-0.769-0.121-0.781-0.125c-0.281-0.087-0.405,0.306-0.438,0.436c-0.159,0.496,0.079,0.585,0.123,0.607 c0.452,0.137,0.743,0.157,1.129,0.157c1.973,0,3.572-1.6,3.572-3.57c0-1.964-1.6-3.552-3.572-3.552c-0.97,0-1.872,0.36-2.546,1.038 c-0.656,0.631-1.027,1.487-1.027,2.322v3.438v-0.011c-0.372-0.42-0.732-1.041-0.981-1.682c-0.102-0.248-0.315-0.202-0.607-0.113 c-0.135,0.035-0.519,0.157-0.44,0.439C5.372,12.799,5.577,13.164,5.633,13.287z"/></svg>'
        });
    }
    if (typeof window !== "undefined" && window.UIkit) window.UIkit.use(plugin);
    return plugin;
});



var $ih19M = parcelRequire("ih19M");
function $166b5ea8e7baa644$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            className: "uk-container-expand uk-flex uk-flex-middle uk-flex-center uk-flex-column uk-background-primary",
            "data-uk-height-viewport": "offset-top: true",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("h2", {
                    className: "uk-h1 uk-text-center uk-margin-remove",
                    children: "Loading..."
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                    className: "uk-text-lead uk-text-center uk-margin-remove",
                    children: "please be patient"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                    className: "uk-heading-line uk-text-center uk-width-1-1",
                    children: /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        "data-uk-icon": "icon:happy"
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: "uk-margin uk-padding",
                    "data-uk-spinner": true
                })
            ]
        })
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $10WBQ = parcelRequire("10WBQ");

var $4HWKL = parcelRequire("4HWKL");
var $0633614ea846c24f$exports = {};

$0633614ea846c24f$exports = new URL((parcelRequire("kyEFX")).resolve("1QxV8"), import.meta.url).toString();


var $93f799fd18b8e7f7$exports = {};

$93f799fd18b8e7f7$exports = new URL((parcelRequire("kyEFX")).resolve("5ZmBd"), import.meta.url).toString();


var $b2491010d7491ec3$exports = {};

$b2491010d7491ec3$exports = new URL((parcelRequire("kyEFX")).resolve("js7XL"), import.meta.url).toString();


var $1176f4cd51904525$exports = {};

$1176f4cd51904525$exports = new URL((parcelRequire("kyEFX")).resolve("4l9lu"), import.meta.url).toString();


var $0b11226a3d0a1638$exports = {};

$0b11226a3d0a1638$exports = new URL((parcelRequire("kyEFX")).resolve("17j7A"), import.meta.url).toString();


var $c0cea0056de0a1a2$exports = {};

$c0cea0056de0a1a2$exports = new URL((parcelRequire("kyEFX")).resolve("laYfL"), import.meta.url).toString();


var $d4716c315f0f47ac$exports = {};

$d4716c315f0f47ac$exports = new URL((parcelRequire("kyEFX")).resolve("8WyJd"), import.meta.url).toString();


var $c62b6741b524e37f$exports = {};

$c62b6741b524e37f$exports = new URL((parcelRequire("kyEFX")).resolve("2lI50"), import.meta.url).toString();


var $8de054cca7dda777$exports = {};

$8de054cca7dda777$exports = new URL((parcelRequire("kyEFX")).resolve("8XlDr"), import.meta.url).toString();


var $c399abb1da176611$exports = {};

$c399abb1da176611$exports = new URL((parcelRequire("kyEFX")).resolve("2FSpO"), import.meta.url).toString();


var $c90d9d8f875570a4$exports = {};

$c90d9d8f875570a4$exports = new URL((parcelRequire("kyEFX")).resolve("8xZkq"), import.meta.url).toString();


var $6f57efaf48f5bf23$exports = {};

$6f57efaf48f5bf23$exports = new URL((parcelRequire("kyEFX")).resolve("h7hoS"), import.meta.url).toString();


var $8dccb56aa236e4c9$exports = {};

$8dccb56aa236e4c9$exports = new URL((parcelRequire("kyEFX")).resolve("bBWuU"), import.meta.url).toString();


var $00e3648a0bbcafcd$exports = {};

$00e3648a0bbcafcd$exports = new URL((parcelRequire("kyEFX")).resolve("iSjd9"), import.meta.url).toString();


var $ee1b6dee81bfd166$exports = {};

$ee1b6dee81bfd166$exports = new URL((parcelRequire("kyEFX")).resolve("9Kzef"), import.meta.url).toString();


var $0017ff115a2f75c3$exports = {};

$0017ff115a2f75c3$exports = new URL((parcelRequire("kyEFX")).resolve("kYYnC"), import.meta.url).toString();


var $4642cfa1ac0f8bec$exports = {};

$4642cfa1ac0f8bec$exports = new URL((parcelRequire("kyEFX")).resolve("bw1MY"), import.meta.url).toString();


var $f58ad638da00b4c1$exports = {};

$f58ad638da00b4c1$exports = new URL((parcelRequire("kyEFX")).resolve("ivhof"), import.meta.url).toString();


var $5cc020c5e2a8ffc7$exports = {};

$5cc020c5e2a8ffc7$exports = new URL((parcelRequire("kyEFX")).resolve("A5G0e"), import.meta.url).toString();


var $9249b4da0891783f$exports = {};

$9249b4da0891783f$exports = new URL((parcelRequire("kyEFX")).resolve("1Knpv"), import.meta.url).toString();


var $a63cfc6f8774940e$exports = {};

$a63cfc6f8774940e$exports = new URL((parcelRequire("kyEFX")).resolve("h6wB8"), import.meta.url).toString();


var $d6a75550e58c4178$exports = {};

$d6a75550e58c4178$exports = new URL((parcelRequire("kyEFX")).resolve("9bfCI"), import.meta.url).toString();


var $7c4f8fc98acfd3de$exports = {};

$7c4f8fc98acfd3de$exports = new URL((parcelRequire("kyEFX")).resolve("1XiII"), import.meta.url).toString();


var $6793a99d70478dcc$exports = {};

$6793a99d70478dcc$exports = new URL((parcelRequire("kyEFX")).resolve("aWsB1"), import.meta.url).toString();


var $649af06da62c133b$exports = {};

$649af06da62c133b$exports = new URL((parcelRequire("kyEFX")).resolve("H16et"), import.meta.url).toString();


var $f91b773f4a505642$exports = {};

$f91b773f4a505642$exports = new URL((parcelRequire("kyEFX")).resolve("8MCg2"), import.meta.url).toString();


var $23725ab071fe5ba7$exports = {};

$23725ab071fe5ba7$exports = new URL((parcelRequire("kyEFX")).resolve("aBysy"), import.meta.url).toString();


var $59c5a9cddf2c9ba5$exports = {};

$59c5a9cddf2c9ba5$exports = new URL((parcelRequire("kyEFX")).resolve("c9m1A"), import.meta.url).toString();


var $b6f9a75c3f0736ca$exports = {};

$b6f9a75c3f0736ca$exports = new URL((parcelRequire("kyEFX")).resolve("cRiqN"), import.meta.url).toString();


var $5ab1e8a21fd1e1ef$exports = {};

$5ab1e8a21fd1e1ef$exports = new URL((parcelRequire("kyEFX")).resolve("8di5n"), import.meta.url).toString();


var $38d843f09b61fdab$exports = {};

$38d843f09b61fdab$exports = new URL((parcelRequire("kyEFX")).resolve("gKinb"), import.meta.url).toString();


var $86acd36d50cec1aa$exports = {};

$86acd36d50cec1aa$exports = new URL((parcelRequire("kyEFX")).resolve("2OKoX"), import.meta.url).toString();


var $105b580e0d83a783$exports = {};

$105b580e0d83a783$exports = new URL((parcelRequire("kyEFX")).resolve("8o8R0"), import.meta.url).toString();


var $ee99efcb1189f200$exports = {};

$ee99efcb1189f200$exports = new URL((parcelRequire("kyEFX")).resolve("bySrn"), import.meta.url).toString();


var $ca9f68dddcdb9b0b$exports = {};

$ca9f68dddcdb9b0b$exports = new URL((parcelRequire("kyEFX")).resolve("envOf"), import.meta.url).toString();


var $5200708086590981$exports = {};

$5200708086590981$exports = new URL((parcelRequire("kyEFX")).resolve("bKTnN"), import.meta.url).toString();


var $4ad37721a1d39cfa$exports = {};

$4ad37721a1d39cfa$exports = new URL((parcelRequire("kyEFX")).resolve("7KgMA"), import.meta.url).toString();


var $1a0aacd1f09acd5c$exports = {};

$1a0aacd1f09acd5c$exports = new URL((parcelRequire("kyEFX")).resolve("3xbby"), import.meta.url).toString();


var $a5150596ce3131fe$exports = {};

$a5150596ce3131fe$exports = new URL((parcelRequire("kyEFX")).resolve("8ozkc"), import.meta.url).toString();


var $9008a1b62aeb76b2$exports = {};

$9008a1b62aeb76b2$exports = new URL((parcelRequire("kyEFX")).resolve("iNDIQ"), import.meta.url).toString();


var $ae50653e92e5d784$exports = {};

$ae50653e92e5d784$exports = new URL((parcelRequire("kyEFX")).resolve("gsWKW"), import.meta.url).toString();


var $f3244020911a2046$exports = {};

$f3244020911a2046$exports = new URL((parcelRequire("kyEFX")).resolve("cLt6I"), import.meta.url).toString();


var $0c41068362c60529$exports = {};

$0c41068362c60529$exports = new URL((parcelRequire("kyEFX")).resolve("uQiTH"), import.meta.url).toString();


var $a7e280be1578cbf2$exports = {};

$a7e280be1578cbf2$exports = new URL((parcelRequire("kyEFX")).resolve("9dnIb"), import.meta.url).toString();


var $307a2e9304c490c5$exports = {};

$307a2e9304c490c5$exports = new URL((parcelRequire("kyEFX")).resolve("dp9KA"), import.meta.url).toString();


var $979309c4953e6f1c$exports = {};

$979309c4953e6f1c$exports = new URL((parcelRequire("kyEFX")).resolve("2kXRR"), import.meta.url).toString();


var $16fdd5b76a39d6ee$exports = {};

$16fdd5b76a39d6ee$exports = new URL((parcelRequire("kyEFX")).resolve("b7zEN"), import.meta.url).toString();


var $4f4c52b0be9d06f9$exports = {};

$4f4c52b0be9d06f9$exports = new URL((parcelRequire("kyEFX")).resolve("bNJpE"), import.meta.url).toString();


var $dea416448737e843$exports = {};

$dea416448737e843$exports = new URL((parcelRequire("kyEFX")).resolve("asUC4"), import.meta.url).toString();


var $8e450cc885867d2e$exports = {};

$8e450cc885867d2e$exports = new URL((parcelRequire("kyEFX")).resolve("1Hk5R"), import.meta.url).toString();


var $648c3df2fb4bb63b$exports = {};

$648c3df2fb4bb63b$exports = new URL((parcelRequire("kyEFX")).resolve("1newI"), import.meta.url).toString();


var $fefce7d6eaa695c6$exports = {};

$fefce7d6eaa695c6$exports = new URL((parcelRequire("kyEFX")).resolve("fv9ea"), import.meta.url).toString();


var $d8adad43880a3842$exports = {};

$d8adad43880a3842$exports = new URL((parcelRequire("kyEFX")).resolve("g3n8Y"), import.meta.url).toString();


var $79ea8522103edbfc$exports = {};

$79ea8522103edbfc$exports = new URL((parcelRequire("kyEFX")).resolve("1A7ph"), import.meta.url).toString();


function $0f2a17d4f11350d6$export$2e2bcd8739ae039() {
    const [tempUnit, setTempUnit] = (0, $bh6RR.useState)("celsius");
    const [weather, setWeather] = (0, $bh6RR.useState)({});
    const [date, setDate] = (0, $bh6RR.useState)(new Date());
    const getIcon = (is_day, code)=>{
        if (code === 0 && is_day === 1) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($0633614ea846c24f$exports))),
            alt: "Clear",
            width: 30,
            height: 30
        });
        if (code === 0 && is_day === 0) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($59c5a9cddf2c9ba5$exports))),
            alt: "Clear",
            width: 30,
            height: 30
        });
        if (code === 1 && is_day === 1) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($93f799fd18b8e7f7$exports))),
            alt: "Mostly clear",
            width: 30,
            height: 30
        });
        if (code === 1 && is_day === 0) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($b6f9a75c3f0736ca$exports))),
            alt: "Mostly clear",
            width: 30,
            height: 30
        });
        if (code === 2 && is_day === 1) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($b2491010d7491ec3$exports))),
            alt: "Cloudy",
            width: 30,
            height: 30
        });
        if (code === 2 && is_day === 0) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($5ab1e8a21fd1e1ef$exports))),
            alt: "Cloudy",
            width: 30,
            height: 30
        });
        if (code === 3 && is_day === 1) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($1176f4cd51904525$exports))),
            alt: "Overcast",
            width: 30,
            height: 30
        });
        if (code === 3 && is_day === 0) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($38d843f09b61fdab$exports))),
            alt: "Overcast",
            width: 30,
            height: 30
        });
        if (code === 45 && is_day === 1) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($0b11226a3d0a1638$exports))),
            alt: "Fog",
            width: 30,
            height: 30
        });
        if (code === 45 && is_day === 0) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($86acd36d50cec1aa$exports))),
            alt: "Fog",
            width: 30,
            height: 30
        });
        if (code === 48 && is_day === 1) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($c0cea0056de0a1a2$exports))),
            alt: "Rime Fog",
            width: 30,
            height: 30
        });
        if (code === 48 && is_day === 0) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($105b580e0d83a783$exports))),
            alt: "Rime Fog",
            width: 30,
            height: 30
        });
        if (code === 51 && is_day === 1) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($d4716c315f0f47ac$exports))),
            alt: "Drizzle",
            width: 30,
            height: 30
        });
        if (code === 51 && is_day === 0) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($ee99efcb1189f200$exports))),
            alt: "Drizzle",
            width: 30,
            height: 30
        });
        if (code === 53 && is_day === 1) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($c62b6741b524e37f$exports))),
            alt: "Mild Drizzle",
            width: 30,
            height: 30
        });
        if (code === 53 && is_day === 0) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($ca9f68dddcdb9b0b$exports))),
            alt: "Mild Drizzle",
            width: 30,
            height: 30
        });
        if (code === 55 && is_day === 1) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: WI_day_55,
            alt: "Dense Drizzle",
            width: 30,
            height: 30
        });
        if (code === 55 && is_day === 0) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: WI_night_55,
            alt: "Dense Drizzle",
            width: 30,
            height: 30
        });
        if (code === 56 && is_day === 1) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8de054cca7dda777$exports))),
            alt: "Freezing Drizzle",
            width: 30,
            height: 30
        });
        if (code === 56 && is_day === 0) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($5200708086590981$exports))),
            alt: "Freezing Drizzle",
            width: 30,
            height: 30
        });
        if (code === 57 && is_day === 1) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($c399abb1da176611$exports))),
            alt: "Dense Freezing Drizzle",
            width: 30,
            height: 30
        });
        if (code === 57 && is_day === 0) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($4ad37721a1d39cfa$exports))),
            alt: "Dense Freezing Drizzle",
            width: 30,
            height: 30
        });
        if (code === 61 && is_day === 1) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($c90d9d8f875570a4$exports))),
            alt: "Slight Rain",
            width: 30,
            height: 30
        });
        if (code === 61 && is_day === 0) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($1a0aacd1f09acd5c$exports))),
            alt: "Slight Rain",
            width: 30,
            height: 30
        });
        if (code === 63 && is_day === 1) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($6f57efaf48f5bf23$exports))),
            alt: "Moderate Rain",
            width: 30,
            height: 30
        });
        if (code === 63 && is_day === 0) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($a5150596ce3131fe$exports))),
            alt: "Moderate Rain",
            width: 30,
            height: 30
        });
        if (code === 65 && is_day === 1) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8dccb56aa236e4c9$exports))),
            alt: "Heavy Rain",
            width: 30,
            height: 30
        });
        if (code === 65 && is_day === 0) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($9008a1b62aeb76b2$exports))),
            alt: "Heavy Rain",
            width: 30,
            height: 30
        });
        if (code === 66 && is_day === 1) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($00e3648a0bbcafcd$exports))),
            alt: "Freezing Rain",
            width: 30,
            height: 30
        });
        if (code === 66 && is_day === 0) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($ae50653e92e5d784$exports))),
            alt: "Freezing Rain",
            width: 30,
            height: 30
        });
        if (code === 67 && is_day === 1) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($ee1b6dee81bfd166$exports))),
            alt: "Heavy Freezing Rain",
            width: 30,
            height: 30
        });
        if (code === 67 && is_day === 0) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($f3244020911a2046$exports))),
            alt: "Heavy Freezing Rain",
            width: 30,
            height: 30
        });
        if (code === 71 && is_day === 1) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($0017ff115a2f75c3$exports))),
            alt: "Slight Snow",
            width: 30,
            height: 30
        });
        if (code === 71 && is_day === 0) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($0c41068362c60529$exports))),
            alt: "Slight Snow",
            width: 30,
            height: 30
        });
        if (code === 73 && is_day === 1) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($4642cfa1ac0f8bec$exports))),
            alt: "Moderate Snow",
            width: 30,
            height: 30
        });
        if (code === 73 && is_day === 0) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($a7e280be1578cbf2$exports))),
            alt: "Moderate Snow",
            width: 30,
            height: 30
        });
        if (code === 75 && is_day === 1) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($f58ad638da00b4c1$exports))),
            alt: "Heavy Snow",
            width: 30,
            height: 30
        });
        if (code === 75 && is_day === 0) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($307a2e9304c490c5$exports))),
            alt: "Heavy Snow",
            width: 30,
            height: 30
        });
        if (code === 77 && is_day === 1) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($5cc020c5e2a8ffc7$exports))),
            alt: "Snow Grains",
            width: 30,
            height: 30
        });
        if (code === 77 && is_day === 0) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($979309c4953e6f1c$exports))),
            alt: "Snow Grains",
            width: 30,
            height: 30
        });
        if (code === 80 && is_day === 1) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($9249b4da0891783f$exports))),
            alt: "Slight Showers",
            width: 30,
            height: 30
        });
        if (code === 80 && is_day === 0) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($16fdd5b76a39d6ee$exports))),
            alt: "Slight Showers",
            width: 30,
            height: 30
        });
        if (code === 81 && is_day === 1) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($a63cfc6f8774940e$exports))),
            alt: "Moderate Showers",
            width: 30,
            height: 30
        });
        if (code === 81 && is_day === 0) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($4f4c52b0be9d06f9$exports))),
            alt: "Moderate Showers",
            width: 30,
            height: 30
        });
        if (code === 82 && is_day === 1) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($d6a75550e58c4178$exports))),
            alt: "Violent Showers",
            width: 30,
            height: 30
        });
        if (code === 82 && is_day === 0) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($dea416448737e843$exports))),
            alt: "Violent Showers",
            width: 30,
            height: 30
        });
        if (code === 85 && is_day === 1) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($7c4f8fc98acfd3de$exports))),
            alt: "Snow showers",
            width: 30,
            height: 30
        });
        if (code === 85 && is_day === 0) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8e450cc885867d2e$exports))),
            alt: "Snow showers",
            width: 30,
            height: 30
        });
        if (code === 86 && is_day === 1) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($6793a99d70478dcc$exports))),
            alt: "Heavy Snow showers",
            width: 30,
            height: 30
        });
        if (code === 86 && is_day === 0) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($648c3df2fb4bb63b$exports))),
            alt: "Heavy Snow showers",
            width: 30,
            height: 30
        });
        if (code === 95 && is_day === 1) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($649af06da62c133b$exports))),
            alt: "Tunderstorm",
            width: 30,
            height: 30
        });
        if (code === 95 && is_day === 0) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($fefce7d6eaa695c6$exports))),
            alt: "Tunderstorm",
            width: 30,
            height: 30
        });
        if (code === 96 && is_day === 1) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($f91b773f4a505642$exports))),
            alt: "Tunderstorm with slight hail",
            width: 30,
            height: 30
        });
        if (code === 96 && is_day === 0) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($d8adad43880a3842$exports))),
            alt: "Tunderstorm with slight hail",
            width: 30,
            height: 30
        });
        if (code === 99 && is_day === 1) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($23725ab071fe5ba7$exports))),
            alt: "Tunderstorm with heavy hail",
            width: 30,
            height: 30
        });
        if (code === 99 && is_day === 0) return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($79ea8522103edbfc$exports))),
            alt: "Tunderstorm with heavy hail",
            width: 30,
            height: 30
        });
    };
    const getWeather = (temp)=>{
        if (navigator.geolocation) navigator.geolocation.getCurrentPosition(async (position)=>{
            const url = `https://api.open-meteo.com/v1/forecast?latitude=${position.coords.latitude}&longitude=${position.coords.longitude}&current_weather=true&temperature_unit=${temp}`;
            await fetch(url).then(async (response)=>await response.json()).then((weather)=>{
                setTempUnit(temp);
                setWeather(weather.current_weather);
            // console.log(weather.current_weather);
            }).catch((err)=>(0, (/*@__PURE__*/$parcel$interopDefault($4HWKL))).notification(`API Error: ${err}`, {
                    status: "danger",
                    pos: "top-center"
                }));
        }), (err)=>console.log(err);
    };
    (0, $bh6RR.useEffect)(()=>{
        setInterval(()=>setDate(new Date()), 20000);
        if (localStorage.getItem("temp_unit") !== null) {
            setTempUnit(localStorage.getItem("temp_unit"));
            getWeather(localStorage.getItem("temp_unit"));
        }
    }, []);
    const toggleWeather = ()=>{
        let unit = "celsius";
        if (tempUnit != "fahrenheit") unit = "fahrenheit";
        localStorage.setItem("temp_unit", unit);
        setTempUnit(unit);
        getWeather(unit);
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)("nav", {
        className: "uk-navbar-container",
        "data-uk-sticky": true,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
            className: "uk-container uk-container-expand",
            children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                "data-uk-navbar": true,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "uk-navbar-left",
                        children: /*#__PURE__*/ (0, $ih19M.jsx)("ul", {
                            className: "uk-navbar-nav",
                            children: /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $10WBQ.NavLink), {
                                    className: ({ isActive: isActive, isPending: isPending })=>isPending ? "uk-link" : isActive ? "uk-active" : "",
                                    to: "/",
                                    "aria-label": "MyHaus",
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
                                        className: "uk-preserve",
                                        width: "53px",
                                        height: "53px",
                                        strokeWidth: "2",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        color: "#fefefe",
                                        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                                            d: "M9 21H7a4 4 0 01-4-4v-6.292a4 4 0 011.927-3.421l5-3.03a4 4 0 014.146 0l5 3.03A4 4 0 0121 10.707V17a4 4 0 01-4 4h-2m-6 0v-4a3 3 0 013-3v0a3 3 0 013 3v4m-6 0h6",
                                            stroke: "#fefefe",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "uk-navbar-right",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: "uk-navbar-item uk-link",
                                onMouseDownCapture: ()=>toggleWeather(),
                                children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                    className: "uk-flex uk-flex-middle uk-flex-center uk-flex-column uk-border-circle",
                                    style: weather.is_day === 1 ? {
                                        color: "#fefe01"
                                    } : {
                                        color: "#fefefe"
                                    },
                                    children: weather.is_day !== undefined ? /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                                        children: [
                                            getIcon(weather.is_day, weather.weathercode),
                                            /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                                children: [
                                                    weather.temperature,
                                                    "\xb0",
                                                    tempUnit == "fahrenheit" ? "F" : "C"
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
                                        children: /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                            className: "uk-link",
                                            "data-uk-icon": "icon:location",
                                            onPointerDown: (e)=>{
                                                if (e.isPrimary) getWeather(tempUnit);
                                            }
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)("p", {
                                className: "uk-navbar-item uk-text-right uk-margin-remove",
                                children: [
                                    " ",
                                    date.toLocaleDateString("en-US", {
                                        day: "numeric",
                                        month: "long",
                                        year: "numeric"
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("br", {}),
                                    date.toLocaleString("en-US", {
                                        hour: "numeric",
                                        minute: "numeric",
                                        hour12: true
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}


if (!localStorage.getItem("uuid")) localStorage.setItem("uuid", (0, $bEzwx.default)());

const $1f0dc3b9307be026$var$Home = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).lazy(()=>(parcelRequire("6MvbO")));

const $1f0dc3b9307be026$var$Games = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).lazy(()=>(parcelRequire("7MY7w")));

const $1f0dc3b9307be026$var$Apps = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).lazy(()=>(parcelRequire("hh03X")));

const $1f0dc3b9307be026$var$Notes = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).lazy(()=>(parcelRequire("IS0yk")));

const $1f0dc3b9307be026$var$Bookmarks = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).lazy(()=>(parcelRequire("k7827")));

const $1f0dc3b9307be026$var$NotFound = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).lazy(()=>{
    return new Promise((resolve)=>{
        setTimeout(()=>resolve((parcelRequire("4eRKn"))), 2000);
    });
});
var $62675bd066e9f070$exports = {};

$62675bd066e9f070$exports = new URL((parcelRequire("kyEFX")).resolve("dLafk"), import.meta.url).toString();


if ("serviceWorker" in navigator) window.addEventListener("load", ()=>{
    navigator.serviceWorker.register($62675bd066e9f070$exports).then((registration)=>{
        const data = {
            type: "CACHE_URLS",
            payload: [
                location.href,
                ...performance.getEntriesByType("resource").map((r)=>r.name)
            ]
        };
        registration.installing.postMessage(data);
    }).catch((err)=>console.error(`Service Worker Error: ${err}`));
});
else console.log("Service Worker is not supported by browser.");
const $1f0dc3b9307be026$var$App = ()=>{
    const [isOnline, setIsOnline] = (0, $bh6RR.useState)(navigator.onLine);
    (0, $bh6RR.useEffect)(()=>{
        const handleStatusChange = ()=>{
            setIsOnline(navigator.onLine);
            if (!navigator.onLine) (0, (/*@__PURE__*/$parcel$interopDefault($4HWKL))).notification("You are offline!", {
                status: "warning",
                pos: "top-center"
            });
        };
        window.addEventListener("online", handleStatusChange);
        window.addEventListener("offline", handleStatusChange);
        return ()=>{
            window.removeEventListener("online", handleStatusChange);
            window.removeEventListener("offline", handleStatusChange);
        };
    }, [
        isOnline
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $10WBQ.BrowserRouter), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $0f2a17d4f11350d6$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bh6RR.Suspense), {
                fallback: /*#__PURE__*/ (0, $ih19M.jsx)((0, $166b5ea8e7baa644$export$2e2bcd8739ae039), {}),
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $99w1R.Routes), {
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $99w1R.Route), {
                            path: "/",
                            element: /*#__PURE__*/ (0, $ih19M.jsx)($1f0dc3b9307be026$var$Home, {
                                isOnline: isOnline
                            })
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $99w1R.Route), {
                            path: "/games",
                            element: /*#__PURE__*/ (0, $ih19M.jsx)($1f0dc3b9307be026$var$Games, {
                                isOnline: isOnline
                            })
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $99w1R.Route), {
                            path: "/apps",
                            element: /*#__PURE__*/ (0, $ih19M.jsx)($1f0dc3b9307be026$var$Apps, {
                                isOnline: isOnline
                            })
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $99w1R.Route), {
                            path: "/marks",
                            element: /*#__PURE__*/ (0, $ih19M.jsx)($1f0dc3b9307be026$var$Bookmarks, {
                                isOnline: isOnline
                            })
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $99w1R.Route), {
                            path: "/notes",
                            element: /*#__PURE__*/ (0, $ih19M.jsx)($1f0dc3b9307be026$var$Notes, {})
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $99w1R.Route), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $ih19M.jsx)($1f0dc3b9307be026$var$NotFound, {}),
                            status: 404
                        })
                    ]
                })
            })
        ]
    });
};
(0, (/*@__PURE__*/$parcel$interopDefault($4HWKL))).use((0, (/*@__PURE__*/$parcel$interopDefault($93da2243eb9df8d8$exports))));
(0, $6fc264ec92100d3a$export$882461b6382ed46c)(document.getElementById("app")).render(/*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
    children: /*#__PURE__*/ (0, $ih19M.jsx)($1f0dc3b9307be026$var$App, {})
}));


//# sourceMappingURL=index.69b94566.js.map
